/* eslint-disable */
/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
/**  represents accountant approval status  */
export const AccountantStatus = {
  Approved: 'APPROVED',
  Pending: 'PENDING',
  Unapproved: 'UNAPPROVED'
} as const;

export type AccountantStatus = typeof AccountantStatus[keyof typeof AccountantStatus];
/**  Accounting method enum (שיטת חשבונאות)  */
export const AccountingMethod = {
  /** Double-entry (כפולה) */
  DoubleEntry: 'DOUBLE_ENTRY',
  /** Single-entry (חד צידית) */
  SingleEntry: 'SINGLE_ENTRY'
} as const;

export type AccountingMethod = typeof AccountingMethod[keyof typeof AccountingMethod];
/**  Business accounting system enum (הנח''ש של העסק)  */
export const AccountingSystem = {
  /** Computerized (ממוחשב) */
  Computerized: 'COMPUTERIZED',
  /** Manual (ידני) */
  Manual: 'MANUAL'
} as const;

export type AccountingSystem = typeof AccountingSystem[keyof typeof AccountingSystem];
/**  the input for adding a new business trip accommodation expense  */
export type AddBusinessTripAccommodationsExpenseInput = {
  amount?: number | null | undefined;
  attendeesStay?: Array<BusinessTripAttendeeStayInput> | null | undefined;
  businessTripId: string;
  country?: unknown;
  currency?: Currency | null | undefined;
  date?: unknown;
  employeeBusinessId?: string | null | undefined;
  nightsCount?: number | null | undefined;
  valueDate?: unknown;
};

/**  the input for adding a new business trip T&S expense  */
export type AddBusinessTripCarRentalExpenseInput = {
  amount?: number | null | undefined;
  businessTripId: string;
  currency?: Currency | null | undefined;
  date?: unknown;
  days?: number | null | undefined;
  employeeBusinessId?: string | null | undefined;
  isFuelExpense?: boolean | null | undefined;
  valueDate?: unknown;
};

/**  the input for adding a new business trip flights expense  */
export type AddBusinessTripFlightsExpenseInput = {
  amount?: number | null | undefined;
  attendeeIds?: Array<string> | null | undefined;
  businessTripId: string;
  currency?: Currency | null | undefined;
  date?: unknown;
  employeeBusinessId?: string | null | undefined;
  flightClass?: FlightClass | null | undefined;
  path?: Array<string> | null | undefined;
  valueDate?: unknown;
};

/**  the input for adding a new business trip other expense  */
export type AddBusinessTripOtherExpenseInput = {
  amount?: number | null | undefined;
  businessTripId: string;
  currency?: Currency | null | undefined;
  date?: unknown;
  deductibleExpense?: boolean | null | undefined;
  description?: string | null | undefined;
  employeeBusinessId?: string | null | undefined;
  valueDate?: unknown;
};

/**  the input for adding a new business trip T&S expense  */
export type AddBusinessTripTravelAndSubsistenceExpenseInput = {
  amount?: number | null | undefined;
  businessTripId: string;
  currency?: Currency | null | undefined;
  date?: unknown;
  employeeBusinessId?: string | null | undefined;
  expenseType?: string | null | undefined;
  valueDate?: unknown;
};

/**  Input for an American Express credit card transaction  */
export type AmexTransactionInput = {
  adendum?: string | null | undefined;
  card: string;
  cardIndex: number;
  chargingDate?: string | null | undefined;
  city?: string | null | undefined;
  clientIpAddress?: string | null | undefined;
  currencyId?: string | null | undefined;
  currentPaymentCurrency?: string | null | undefined;
  dealSum?: string | null | undefined;
  dealSumOutbound?: string | null | undefined;
  dealSumType?: string | null | undefined;
  dealsInbound?: string | null | undefined;
  displayProperties?: string | null | undefined;
  esbServicesCall?: string | null | undefined;
  fullPaymentDate?: string | null | undefined;
  fullPurchaseDate?: string | null | undefined;
  fullPurchaseDateOutbound?: string | null | undefined;
  fullSupplierNameHeb?: string | null | undefined;
  fullSupplierNameOutbound?: string | null | undefined;
  horaatKeva?: string | null | undefined;
  isButton: string;
  isCaptcha: string;
  isError: string;
  isHoraatKeva: string;
  isShowDealsOutbound?: string | null | undefined;
  isShowLinkForSupplierDetails?: string | null | undefined;
  kodMatbeaMekori?: string | null | undefined;
  message?: string | null | undefined;
  moreInfo?: string | null | undefined;
  paymentDate?: string | null | undefined;
  paymentSum?: string | null | undefined;
  paymentSumOutbound?: string | null | undefined;
  paymentSumSign?: string | null | undefined;
  purchaseDate?: string | null | undefined;
  purchaseDateOutbound?: string | null | undefined;
  returnCode?: string | null | undefined;
  returnMessage?: string | null | undefined;
  siteName?: string | null | undefined;
  solek?: string | null | undefined;
  specificDate?: string | null | undefined;
  stage?: string | null | undefined;
  supplierId?: number | null | undefined;
  supplierName?: string | null | undefined;
  supplierNameOutbound?: string | null | undefined;
  tablePageNum: boolean;
  voucherNumber?: number | null | undefined;
  voucherNumberRatz?: number | null | undefined;
  voucherNumberRatzOutbound?: number | null | undefined;
};

/**  User type classification for annual audit opening balance step  */
export const AnnualAuditOpeningBalanceUserType = {
  Continuing: 'CONTINUING',
  Error: 'ERROR',
  Migrating: 'MIGRATING',
  New: 'NEW'
} as const;

export type AnnualAuditOpeningBalanceUserType = typeof AnnualAuditOpeningBalanceUserType[keyof typeof AnnualAuditOpeningBalanceUserType];
/**  Status values for annual audit steps  */
export const AnnualAuditStepStatus = {
  Blocked: 'BLOCKED',
  Completed: 'COMPLETED',
  InProgress: 'IN_PROGRESS',
  Pending: 'PENDING'
} as const;

export type AnnualAuditStepStatus = typeof AnnualAuditStepStatus[keyof typeof AnnualAuditStepStatus];
/**  Input type representing an annual identifier for tax purposes.  */
export type AnnualIdInput = {
  id: string;
  year: number;
};

/**  annual revenue report filter  */
export type AnnualRevenueReportFilter = {
  adminBusinessId?: string | null | undefined;
  year: number;
};

/**  Audit opinion type enum (חוות דעת)  */
export const AuditOpinionType = {
  /** Adverse opinion (שלילית) */
  Adverse: 'ADVERSE',
  /** Disclaimer of opinion (המנעות) */
  Disclaimer: 'DISCLAIMER',
  /** No audit opinion (אין חוות דעת) */
  None: 'NONE',
  /** Qualified opinion (הסתייגות) */
  Qualified: 'QUALIFIED',
  /** Unqualified opinion (נוסח אחיד (בלתי מסוייג)) */
  Unqualified: 'UNQUALIFIED',
  /** Unqualified opinion with emphasis on going concern (בנוסח אחיד עם הפניית תשומת לב להערת עסק חי) */
  UnqualifiedWithGoingConcern: 'UNQUALIFIED_WITH_GOING_CONCERN',
  /** Unqualified opinion with other emphases (בנוסח אחיד עם הפניות תשומת לב אחרת) */
  UnqualifiedWithOtherEmphases: 'UNQUALIFIED_WITH_OTHER_EMPHASES'
} as const;

export type AuditOpinionType = typeof AuditOpinionType[keyof typeof AuditOpinionType];
/**  input type for creating a bank account  */
export type BankAccountInsertInput = {
  accountAgreementOpeningDate?: number | null | undefined;
  accountClosingReasonCode?: number | null | undefined;
  accountDealDate?: number | null | undefined;
  accountUpdateDate?: number | null | undefined;
  bankNumber: number;
  branchNumber: number;
  branchTypeCode?: number | null | undefined;
  extendedBankNumber?: number | null | undefined;
  iban?: string | null | undefined;
  kodHarshaatPeilut?: number | null | undefined;
  metegDoarNet?: number | null | undefined;
  mymailEntitlementSwitch?: number | null | undefined;
  partyAccountInvolvementCode?: number | null | undefined;
  partyPreferredIndication?: number | null | undefined;
  productLabel?: string | null | undefined;
  serviceAuthorizationDesc?: string | null | undefined;
  swiftCode?: string | null | undefined;
};

/**  input type for updating a bank account  */
export type BankAccountUpdateInput = {
  accountAgreementOpeningDate?: number | null | undefined;
  accountClosingReasonCode?: number | null | undefined;
  accountDealDate?: number | null | undefined;
  accountUpdateDate?: number | null | undefined;
  bankNumber?: number | null | undefined;
  branchNumber?: number | null | undefined;
  branchTypeCode?: number | null | undefined;
  extendedBankNumber?: number | null | undefined;
  iban?: string | null | undefined;
  kodHarshaatPeilut?: number | null | undefined;
  metegDoarNet?: number | null | undefined;
  mymailEntitlementSwitch?: number | null | undefined;
  partyAccountInvolvementCode?: number | null | undefined;
  partyPreferredIndication?: number | null | undefined;
  productLabel?: string | null | undefined;
  serviceAuthorizationDesc?: string | null | undefined;
  swiftCode?: string | null | undefined;
};

/**  input for batchUpdateBusinesses: the subset of business fields that is safe to apply to many businesses at once  */
export type BatchUpdateBusinessInput = {
  city?: string | null | undefined;
  country?: unknown;
  exemptDealer?: boolean | null | undefined;
  irsCode?: number | null | undefined;
  isActive?: boolean | null | undefined;
  isDocumentsOptional?: boolean | null | undefined;
  isReceiptEnough?: boolean | null | undefined;
  optionalVAT?: boolean | null | undefined;
  pcn874RecordType?: Pcn874RecordType | null | undefined;
  sortCode?: number | null | undefined;
  suggestions?: SuggestionsInput | null | undefined;
  taxCategory?: string | null | undefined;
  zipCode?: string | null | undefined;
};

/**  contract billing cycle  */
export const BillingCycle = {
  Annual: 'ANNUAL',
  Monthly: 'MONTHLY'
} as const;

export type BillingCycle = typeof BillingCycle[keyof typeof BillingCycle];
/**  input variables for businessTransactions  */
export type BusinessTransactionsFilter = {
  businessIDs?: Array<string> | null | undefined;
  fromDate?: unknown;
  includeRevaluation?: boolean | null | undefined;
  ownerIds?: Array<string> | null | undefined;
  toDate?: unknown;
  type?: FinancialEntityType | null | undefined;
};

/**  the input for attendee accommodation stay info  */
export type BusinessTripAttendeeStayInput = {
  attendeeId: string;
  nightsCount: number;
};

/**  the input for updating a business trip attendee  */
export type BusinessTripAttendeeUpdateInput = {
  arrivalDate?: unknown;
  attendeeId: string;
  businessTripId: string;
  departureDate?: unknown;
};

/**  represent category type of business trip summary  */
export const BusinessTripExpenseCategories = {
  Accommodation: 'ACCOMMODATION',
  CarRental: 'CAR_RENTAL',
  Flight: 'FLIGHT',
  Other: 'OTHER',
  TravelAndSubsistence: 'TRAVEL_AND_SUBSISTENCE'
} as const;

export type BusinessTripExpenseCategories = typeof BusinessTripExpenseCategories[keyof typeof BusinessTripExpenseCategories];
/**  represent category type of business trip summary  */
export const BusinessTripSummaryCategories = {
  Accommodation: 'ACCOMMODATION',
  CarRental: 'CAR_RENTAL',
  Flight: 'FLIGHT',
  Other: 'OTHER',
  Total: 'TOTAL',
  TravelAndSubsistence: 'TRAVEL_AND_SUBSISTENCE'
} as const;

export type BusinessTripSummaryCategories = typeof BusinessTripSummaryCategories[keyof typeof BusinessTripSummaryCategories];
/**  Business type enum (סוג עסק)  */
export const BusinessType = {
  /** Combination (שילוב) */
  Combination: 'COMBINATION',
  /** Commercial (מסחרי) */
  Commercial: 'COMMERCIAL',
  /** Industrial (תעשייתי) */
  Industrial: 'INDUSTRIAL',
  /** Report includes more than one business (הדוח כולל יותר מעסק אחד) */
  Multiple: 'MULTIPLE',
  /** Service providers (נותני שירותים) */
  Service: 'SERVICE'
} as const;

export type BusinessType = typeof BusinessType[keyof typeof BusinessType];
/**  Input for a Cal (Visa Cal) credit card transaction  */
export type CalTransactionInput = {
  amtBeforeConvAndIndex?: string | null | undefined;
  branchCodeDesc?: string | null | undefined;
  card: number;
  cashAccountTrnAmt?: string | null | undefined;
  chargeExternalToCardComment?: string | null | undefined;
  crdExtIdNumTypeCode?: string | null | undefined;
  curPaymentNum?: number | null | undefined;
  debCrdCurrencySymbol?: string | null | undefined;
  debCrdDate?: string | null | undefined;
  debitSpreadInd?: boolean | null | undefined;
  earlyPaymentInd?: boolean | null | undefined;
  isAbroadTransaction?: boolean | null | undefined;
  isImmediateCommentInd?: boolean | null | undefined;
  isImmediateHhkInd?: boolean | null | undefined;
  isMargarita?: boolean | null | undefined;
  isSpreadPaymenstAbroad?: boolean | null | undefined;
  merchantAddress?: string | null | undefined;
  merchantId?: string | null | undefined;
  merchantName?: string | null | undefined;
  merchantPhoneNo?: string | null | undefined;
  numOfPayments?: number | null | undefined;
  onGoingTransactionsComment?: string | null | undefined;
  refundInd?: boolean | null | undefined;
  tokenInd?: number | null | undefined;
  tokenNumberPart4?: string | null | undefined;
  transCardPresentInd?: boolean | null | undefined;
  transSource?: string | null | undefined;
  trnAmt?: string | null | undefined;
  trnCurrencySymbol?: string | null | undefined;
  trnExacWay?: number | null | undefined;
  trnIntId?: string | null | undefined;
  trnNumaretor?: number | null | undefined;
  trnPurchaseDate?: string | null | undefined;
  trnType?: string | null | undefined;
  trnTypeCode?: string | null | undefined;
  walletProviderCode?: number | null | undefined;
  walletProviderDesc?: string | null | undefined;
};

/**  the input for categorizing a business trip expense  */
export type CategorizeBusinessTripExpenseInput = {
  amount?: number | null | undefined;
  businessTripId: string;
  category?: BusinessTripExpenseCategories | null | undefined;
  transactionId: string;
};

/**  the input for categorizing into an existing business trip expense  */
export type CategorizeIntoExistingBusinessTripExpenseInput = {
  amount?: number | null | undefined;
  businessTripExpenseId: string;
  transactionId: string;
};

/**  input variables for charge filtering  */
export type ChargeFilter = {
  accountantStatus?: Array<AccountantStatus> | null | undefined;
  /**  filter by business trip (should be later in business trip module?)  */
  businessTrip?: string | null | undefined;
  /**  Include only charges tied to one of these business trips  */
  byBusinessTrips?: Array<string> | null | undefined;
  /**  Include only charges including specific business  */
  byBusinesses?: Array<string> | null | undefined;
  /**  Include only charges resolved to one of these concrete types (by __typename)  */
  byChargeTypes?: Array<ChargeType> | null | undefined;
  /**  Include only charges related to specific financial accounts  */
  byFinancialAccounts?: Array<string> | null | undefined;
  /**  Include only charges related to specific owners financial entities  */
  byOwners?: Array<string> | null | undefined;
  /**  Include only charges with those tags  */
  byTags?: Array<string> | null | undefined;
  chargesType?: ChargeFilterType | null | undefined;
  /**  Include only charges with user description | transactions description / reference | documents description / remarks / serial that contains this text  */
  freeText?: string | null | undefined;
  /**  Include only charges with any doc/transaction date occurred after this date  */
  fromAnyDate?: unknown;
  /**  Include only charges with main date occurred after this date  */
  fromDate?: unknown;
  sortBy?: ChargeSortBy | null | undefined;
  /**  Include only charges with any doc/transaction date occurred before this date  */
  toAnyDate?: unknown;
  /**  Include only charges with main date  occurred before this date  */
  toDate?: unknown;
  /**  Include only charges that are not balances  */
  unbalanced?: boolean | null | undefined;
  /**  Include only charges with a missing counterparty: a transaction without a business, or a document without a creditor / debtor  */
  withMissingCounterparty?: boolean | null | undefined;
  withOpenDocuments?: boolean | null | undefined;
  /**  Include only charges that doesn't have documents linked  */
  withoutDocuments?: boolean | null | undefined;
  /**  Include only charges that doesn't have invoice document linked  */
  withoutInvoice?: boolean | null | undefined;
  /**  Include only charges that doesn't have ledger records linked  */
  withoutLedger?: boolean | null | undefined;
  /**  Include only charges that doesn't have receipt document linked  */
  withoutReceipt?: boolean | null | undefined;
  /**  Include only charges that doesn't have transactions linked  */
  withoutTransactions?: boolean | null | undefined;
};

/**  filter charges by income / expense flow  */
export const ChargeFilterType = {
  All: 'ALL',
  Expense: 'EXPENSE',
  Income: 'INCOME'
} as const;

export type ChargeFilterType = typeof ChargeFilterType[keyof typeof ChargeFilterType];
/**  Kind of base charge to include in the awaiting-match queue  */
export const ChargeMatchQueueMode = {
  /**  Base charges built from documents (e.g. invoices from email ingestion)  */
  DocBase: 'DOC_BASE',
  /**  Base charges built from transactions (e.g. bank feed scraper)  */
  TransactionBase: 'TRANSACTION_BASE'
} as const;

export type ChargeMatchQueueMode = typeof ChargeMatchQueueMode[keyof typeof ChargeMatchQueueMode];
/**  Ordering options for the awaiting-match queue  */
export const ChargeMatchQueueSortBy = {
  /**  Order by the base charge's date, newest first (default)  */
  ByDate: 'BY_DATE',
  /**  Order by top match confidence score, highest first. Evaluates only the 100 most recent unmatched charges  */
  ByScore: 'BY_SCORE'
} as const;

export type ChargeMatchQueueSortBy = typeof ChargeMatchQueueSortBy[keyof typeof ChargeMatchQueueSortBy];
/**  input variables for sorting charges  */
export type ChargeSortBy = {
  asc?: boolean | null | undefined;
  field: ChargeSortByField;
};

/**  fields that can be used to sort charges  */
export const ChargeSortByField = {
  AbsAmount: 'ABS_AMOUNT',
  Amount: 'AMOUNT',
  Date: 'DATE'
} as const;

export type ChargeSortByField = typeof ChargeSortByField[keyof typeof ChargeSortByField];
/**  Charge type enum  */
export const ChargeType = {
  BankDeposit: 'BANK_DEPOSIT',
  BusinessTrip: 'BUSINESS_TRIP',
  Common: 'COMMON',
  Conversion: 'CONVERSION',
  CreditcardBank: 'CREDITCARD_BANK',
  Dividend: 'DIVIDEND',
  Financial: 'FINANCIAL',
  ForeignSecurities: 'FOREIGN_SECURITIES',
  Internal: 'INTERNAL',
  Payroll: 'PAYROLL',
  Vat: 'VAT'
} as const;

export type ChargeType = typeof ChargeType[keyof typeof ChargeType];
/**  fields for inserting a new client  */
export type ClientInsertInput = {
  businessId: string;
  emails?: Array<string> | null | undefined;
  generatedDocumentType: DocumentType;
  integrations?: ClientIntegrationsInput | null | undefined;
};

/**  integrations input for client insert/update  */
export type ClientIntegrationsInput = {
  greenInvoiceId?: string | null | undefined;
  hiveId?: string | null | undefined;
  linearId?: string | null | undefined;
  notionId?: string | null | undefined;
  slackChannelKey?: string | null | undefined;
  workflowyUrl?: string | null | undefined;
};

/**  fields for updating an existing client  */
export type ClientUpdateInput = {
  emails?: Array<string> | null | undefined;
  generatedDocumentType?: DocumentType | null | undefined;
  integrations?: ClientIntegrationsInput | null | undefined;
  newBusinessId?: string | null | undefined;
};

/**  input for creating a new contract  */
export type CreateContractInput = {
  amount: FinancialAmountInput;
  billingCycle: BillingCycle;
  clientId: string;
  deactivateContracts?: Array<string> | null | undefined;
  documentType: DocumentType;
  endDate: unknown;
  isActive: boolean;
  msCloud?: unknown;
  operationsLimit?: unknown;
  plan?: SubscriptionPlan | null | undefined;
  product?: Product | null | undefined;
  purchaseOrders: Array<string>;
  remarks?: string | null | undefined;
  startDate: unknown;
};

/**  input type for creating a financial account  */
export type CreateFinancialAccountInput = {
  bankAccountDetails?: BankAccountInsertInput | null | undefined;
  currencies?: Array<FinancialAccountCurrencyInput> | null | undefined;
  name: string;
  number: string;
  ownerId: string;
  privateOrBusiness: PrivateOrBusinessType;
  type: FinancialAccountType;
};

/**  All possible currencies  */
export const Currency = {
  /**  FIAT currencies  */
  Aud: 'AUD',
  Cad: 'CAD',
  /**  Crypto currencies  */
  Eth: 'ETH',
  Eur: 'EUR',
  Gbp: 'GBP',
  Grt: 'GRT',
  Ils: 'ILS',
  Jpy: 'JPY',
  Sek: 'SEK',
  Usd: 'USD',
  Usdc: 'USDC'
} as const;

export type Currency = typeof Currency[keyof typeof Currency];
/**  Input for daily currency exchange rates  */
export type CurrencyRateInput = {
  aud?: number | null | undefined;
  cad?: number | null | undefined;
  eur?: number | null | undefined;
  exchangeDate: unknown;
  gbp?: number | null | undefined;
  jpy?: number | null | undefined;
  sek?: number | null | undefined;
  usd?: number | null | undefined;
};

/**  Currency reporting type enum (דיווח מטבע)  */
export const CurrencyType = {
  /** Amounts in dollars (הסכומים בדולרים) */
  Dollars: 'DOLLARS',
  /** Amounts in shekels (הסכומים בשקלים) */
  Shekels: 'SHEKELS'
} as const;

export type CurrencyType = typeof CurrencyType[keyof typeof CurrencyType];
/**  the input for removing a business trip attendee  */
export type DeleteBusinessTripAttendeeInput = {
  attendeeId: string;
  businessTripId: string;
};

/**  input variables for depreciationReport  */
export type DepreciationReportFilter = {
  financialEntityId?: string | null | undefined;
  year: number;
};

/**  depreciation type  */
export const DepreciationType = {
  GeneralAndManagement: 'GENERAL_AND_MANAGEMENT',
  Marketing: 'MARKETING',
  ResearchAndDevelopment: 'RESEARCH_AND_DEVELOPMENT'
} as const;

export type DepreciationType = typeof DepreciationType[keyof typeof DepreciationType];
/**  Input for a Discount Bank account transaction  */
export type DiscountTransactionInput = {
  accountNumber?: string | null | undefined;
  balanceAfterOperation?: string | null | undefined;
  branchTreasuryNumber?: string | null | undefined;
  businessDayDate?: string | null | undefined;
  categoryCode?: number | null | undefined;
  categoryDescCode?: number | null | undefined;
  categoryDescription?: string | null | undefined;
  channel?: string | null | undefined;
  channelName?: string | null | undefined;
  checkNumber?: number | null | undefined;
  commissionChannelCode?: string | null | undefined;
  commissionChannelName?: string | null | undefined;
  commissionTypeName?: string | null | undefined;
  eventName?: string | null | undefined;
  instituteCode?: string | null | undefined;
  isLastSeen?: boolean | null | undefined;
  operationAmount?: string | null | undefined;
  operationBank?: number | null | undefined;
  operationBranch?: number | null | undefined;
  operationCode?: string | null | undefined;
  operationDate?: string | null | undefined;
  operationDescription?: string | null | undefined;
  operationDescription2?: string | null | undefined;
  operationDescription3?: string | null | undefined;
  operationDescriptionToDisplay?: string | null | undefined;
  operationDetailsServiceName?: string | null | undefined;
  operationNumber?: number | null | undefined;
  operationOrder?: number | null | undefined;
  urn?: string | null | undefined;
  valueDate?: string | null | undefined;
};

/**  client input  */
export type DocumentClientInput = {
  add?: boolean | null | undefined;
  address?: string | null | undefined;
  city?: string | null | undefined;
  country?: unknown;
  emails?: Array<string> | null | undefined;
  fax?: string | null | undefined;
  id: string;
  mobile?: string | null | undefined;
  name?: string | null | undefined;
  phone?: string | null | undefined;
  self?: boolean | null | undefined;
  taxId?: string | null | undefined;
  zipCode?: string | null | undefined;
};

/**  discount input  */
export type DocumentDiscountInput = {
  amount: number;
  type: DocumentDiscountType;
};

/**  discount type enum  */
export const DocumentDiscountType = {
  Percentage: 'PERCENTAGE',
  Sum: 'SUM'
} as const;

export type DocumentDiscountType = typeof DocumentDiscountType[keyof typeof DocumentDiscountType];
/**  income input  */
export type DocumentIncomeRecordInput = {
  amount?: number | null | undefined;
  amountTotal?: number | null | undefined;
  catalogNum?: string | null | undefined;
  currency: Currency;
  currencyRate?: number | null | undefined;
  description: string;
  itemId?: string | null | undefined;
  price: number;
  quantity: number;
  vat?: number | null | undefined;
  vatRate?: number | null | undefined;
  vatType: DocumentVatType;
};

/**  input for issuing or previewing document  */
export type DocumentIssueInput = {
  client?: DocumentClientInput | null | undefined;
  currency: Currency;
  date?: string | null | undefined;
  description?: string | null | undefined;
  discount?: DocumentDiscountInput | null | undefined;
  dueDate?: string | null | undefined;
  footer?: string | null | undefined;
  income?: Array<DocumentIncomeRecordInput> | null | undefined;
  language: DocumentLanguage;
  linkType?: DocumentLinkType | null | undefined;
  linkedDocumentIds?: Array<string> | null | undefined;
  linkedPaymentId?: string | null | undefined;
  maxPayments?: number | null | undefined;
  payment?: Array<DocumentPaymentRecordInput> | null | undefined;
  remarks?: string | null | undefined;
  rounding?: boolean | null | undefined;
  signed?: boolean | null | undefined;
  type: DocumentType;
  vatType: DocumentVatType;
};

/**  document language enum  */
export const DocumentLanguage = {
  English: 'ENGLISH',
  Hebrew: 'HEBREW'
} as const;

export type DocumentLanguage = typeof DocumentLanguage[keyof typeof DocumentLanguage];
/**  link type enum  */
export const DocumentLinkType = {
  Cancel: 'CANCEL',
  Link: 'LINK'
} as const;

export type DocumentLinkType = typeof DocumentLinkType[keyof typeof DocumentLinkType];
/**  card type enum  */
export const DocumentPaymentRecordCardType = {
  AmericanExpress: 'AMERICAN_EXPRESS',
  Diners: 'DINERS',
  Isracard: 'ISRACARD',
  Mastercard: 'MASTERCARD',
  Unknown: 'UNKNOWN',
  Visa: 'VISA'
} as const;

export type DocumentPaymentRecordCardType = typeof DocumentPaymentRecordCardType[keyof typeof DocumentPaymentRecordCardType];
/**  payment input  */
export type DocumentPaymentRecordInput = {
  accountId?: string | null | undefined;
  bankAccount?: string | null | undefined;
  bankBranch?: string | null | undefined;
  bankName?: string | null | undefined;
  cardNum?: string | null | undefined;
  cardType?: DocumentPaymentRecordCardType | null | undefined;
  chequeNum?: string | null | undefined;
  currency: Currency;
  currencyRate?: number | null | undefined;
  date?: string | null | undefined;
  firstPayment?: number | null | undefined;
  numPayments?: number | null | undefined;
  price: number;
  transactionId?: string | null | undefined;
  type: PaymentType;
};

/**  Document status  */
export const DocumentStatus = {
  Cancelled: 'CANCELLED',
  CancelledByOtherDoc: 'CANCELLED_BY_OTHER_DOC',
  Closed: 'CLOSED',
  ManuallyClosed: 'MANUALLY_CLOSED',
  Open: 'OPEN'
} as const;

export type DocumentStatus = typeof DocumentStatus[keyof typeof DocumentStatus];
/**  All possible document types  */
export const DocumentType = {
  CreditInvoice: 'CREDIT_INVOICE',
  Invoice: 'INVOICE',
  InvoiceReceipt: 'INVOICE_RECEIPT',
  Other: 'OTHER',
  Proforma: 'PROFORMA',
  Receipt: 'RECEIPT',
  Unprocessed: 'UNPROCESSED'
} as const;

export type DocumentType = typeof DocumentType[keyof typeof DocumentType];
/**  VAT type enum  */
export const DocumentVatType = {
  Default: 'DEFAULT',
  Exempt: 'EXEMPT',
  Mixed: 'MIXED'
} as const;

export type DocumentVatType = typeof DocumentVatType[keyof typeof DocumentVatType];
/**  input variables for documents filtering  */
export type DocumentsFilters = {
  businessIDs?: Array<string> | null | undefined;
  fromDate?: unknown;
  ownerIDs?: Array<string> | null | undefined;
  toDate?: unknown;
  /**  Include only documents without matching transactions  */
  unmatched?: boolean | null | undefined;
};

/**  types of email attachments that can be parsed  */
export const EmailAttachmentType = {
  Jpeg: 'JPEG',
  Pdf: 'PDF',
  Png: 'PNG'
} as const;

export type EmailAttachmentType = typeof EmailAttachmentType[keyof typeof EmailAttachmentType];
/**  Metadata for a single document extracted from the email  */
export type ExtractedDocumentInput = {
  /**  Base64-encoded document bytes (inline transport, Option B); omitted = metadata only  */
  content?: string | null | undefined;
  /**  Optional filename  */
  filename?: string | null | undefined;
  /**  SHA-256 hash of the document content  */
  hash: string;
  /**  MIME type  */
  mimeType: string;
  /**  Document size in bytes  */
  sizeBytes: number;
};

/**  input type for financial account currency and tax category  */
export type FinancialAccountCurrencyInput = {
  currency: Currency;
  taxCategoryId: string;
};

/**  general types of financial accounts  */
export const FinancialAccountType = {
  BankAccount: 'BANK_ACCOUNT',
  BankDepositAccount: 'BANK_DEPOSIT_ACCOUNT',
  CreditCard: 'CREDIT_CARD',
  CryptoWallet: 'CRYPTO_WALLET',
  ForeignSecurities: 'FOREIGN_SECURITIES'
} as const;

export type FinancialAccountType = typeof FinancialAccountType[keyof typeof FinancialAccountType];
/**  input variables for updateCharge.FinancialAmount */
export type FinancialAmountInput = {
  currency: Currency;
  raw: number;
};

/**  represent financial entity type  */
export const FinancialEntityType = {
  Business: 'BUSINESS',
  TaxCategory: 'TAX_CATEGORY'
} as const;

export type FinancialEntityType = typeof FinancialEntityType[keyof typeof FinancialEntityType];
/**  represent flight classes  */
export const FlightClass = {
  Business: 'BUSINESS',
  Economy: 'ECONOMY',
  FirstClass: 'FIRST_CLASS',
  PremiumEconomy: 'PREMIUM_ECONOMY'
} as const;

export type FlightClass = typeof FlightClass[keyof typeof FlightClass];
/**  IFRS reporting option enum (דווח בחלופה - יישום תקני חשבונאות)  */
export const IfrsReportingOption = {
  /** No IFRS implementation (במידה ואין יישום תקני חשבונאות) */
  None: 'NONE',
  /** Option 1 (חלופה 1) */
  Option_1: 'OPTION_1',
  /** Accounting adjustments for those who implemented Option 2 per directive 7/2010 (התאמות חשבונאיות למי שיישם את חלופה 2 בהוראת ביצוע 7/2010) */
  Option_2Adjustments: 'OPTION_2_ADJUSTMENTS',
  /** Accounting adjustments for those who implemented Option 3 per directive 7/2010 (התאמות חשבונאיות למי שיישם את חלופה 3 בהוראת ביצוע 7/2010) */
  Option_3Adjustments: 'OPTION_3_ADJUSTMENTS'
} as const;

export type IfrsReportingOption = typeof IfrsReportingOption[keyof typeof IfrsReportingOption];
/**  input variables for incomeExpenseChart filters  */
export type IncomeExpenseChartFilters = {
  currency?: Currency | null | undefined;
  fromDate: unknown;
  toDate: unknown;
};

/**  Input for requesting a short-lived ingest control grant  */
export type IngestControlInput = {
  /**  Optional correlation ID for distributed tracing  */
  correlationId?: string | null | undefined;
  /**  RFC 2822 Message-ID header  */
  messageId: string;
  /**  SHA-256 hex hash of the raw MIME message  */
  rawMessageHash: string;
  /**  ISO-8601 timestamp the message was received (reserved for future replay-window validation)  */
  receivedAt?: string | null | undefined;
  /**  Recipient alias the message was delivered to  */
  recipientAlias: string;
  /**  Sender evidence used to recognize the issuing business (issuer-selection runs server-side)  */
  senderEvidence?: SenderEvidenceInput | null | undefined;
};

/**  Input for the v2 ingest endpoint  */
export type IngestEmailInput = {
  /**  Optional correlation ID for distributed tracing  */
  correlationId?: string | null | undefined;
  /**  Extracted document metadata from MIME parsing  */
  extractedDocuments: Array<ExtractedDocumentInput>;
  /**  JTI of the ingest grant from requestIngestControl  */
  grantJti: string;
  /**  Gateway-supplied idempotency key  */
  idempotencyKey: string;
  /**  RFC 2822 Message-ID header  */
  messageId: string;
  /**  SHA-256 hex hash of the raw MIME message  */
  rawMessageHash: string;
  /**  ISO-8601 timestamp the message was received, used in the charge description  */
  receivedAt?: string | null | undefined;
  /**  Sender (From header) address, used in the charge description  */
  sender?: string | null | undefined;
  /**  Subject header of the email, used to build a human-readable charge description  */
  subject?: string | null | undefined;
  /**  Tenant ID from the grant (validated server-side)  */
  tenantId: string;
};

/**  Outcome of a v2 ingest operation  */
export const IngestOutcome = {
  Duplicate: 'DUPLICATE',
  Inserted: 'INSERTED',
  Quarantined: 'QUARANTINED',
  Rejected: 'REJECTED'
} as const;

export type IngestOutcome = typeof IngestOutcome[keyof typeof IngestOutcome];
/**  the input for adding an attendee to a business trip  */
export type InsertBusinessTripAttendeeInput = {
  arrivalDate?: unknown;
  attendeeId: string;
  businessTripId: string;
  departureDate?: unknown;
};

/**  the input for creating a business trip  */
export type InsertBusinessTripInput = {
  destinationCode?: string | null | undefined;
  fromDate?: unknown;
  name: string;
  toDate?: unknown;
  tripPurpose?: string | null | undefined;
};

/**  input variables for insertDepreciationRecord  */
export type InsertDepreciationRecordInput = {
  activationDate: unknown;
  amount?: number | null | undefined;
  categoryId: string;
  chargeId: string;
  currency?: Currency | null | undefined;
  type?: DepreciationType | null | undefined;
};

/**  input variables for insertDocument  */
export type InsertDocumentInput = {
  allocationNumber?: string | null | undefined;
  amount?: FinancialAmountInput | null | undefined;
  chargeId?: string | null | undefined;
  creditorId?: string | null | undefined;
  date?: unknown;
  debtorId?: string | null | undefined;
  description?: string | null | undefined;
  documentType?: DocumentType | null | undefined;
  exchangeRateOverride?: number | null | undefined;
  file?: unknown;
  image?: unknown;
  noVatAmount?: number | null | undefined;
  remarks?: string | null | undefined;
  serialNumber?: string | null | undefined;
  vat?: FinancialAmountInput | null | undefined;
  vatReportDateOverride?: unknown;
};

/**  input variables for insertMiscExpense  */
export type InsertMiscExpenseInput = {
  amount: number;
  creditorId: string;
  currency: Currency;
  debtorId: string;
  description?: string | null | undefined;
  invoiceDate: unknown;
  valueDate: unknown;
};

/**  input for insertNewBusiness  */
export type InsertNewBusinessInput = {
  address?: string | null | undefined;
  city?: string | null | undefined;
  country?: unknown;
  email?: string | null | undefined;
  exemptDealer?: boolean | null | undefined;
  governmentId?: string | null | undefined;
  hebrewName?: string | null | undefined;
  irsCode?: number | null | undefined;
  isActive?: boolean | null | undefined;
  isDocumentsOptional?: boolean | null | undefined;
  isReceiptEnough?: boolean | null | undefined;
  name: string;
  optionalVAT?: boolean | null | undefined;
  pcn874RecordType?: Pcn874RecordType | null | undefined;
  phoneNumber?: string | null | undefined;
  sortCode?: number | null | undefined;
  suggestions?: SuggestionsInput | null | undefined;
  taxCategory?: string | null | undefined;
  website?: string | null | undefined;
  zipCode?: string | null | undefined;
};

/**  input for insertTaxCategory  */
export type InsertTaxCategoryInput = {
  hashavshevetName?: string | null | undefined;
  irsCode?: number | null | undefined;
  isActive?: boolean | null | undefined;
  name: string;
  sortCode?: number | null | undefined;
  taxExcluded?: boolean | null | undefined;
};

/**  Input for an Isracard credit card transaction  */
export type IsracardTransactionInput = {
  adendum?: string | null | undefined;
  card: string;
  cardIndex: number;
  chargingDate?: string | null | undefined;
  city?: string | null | undefined;
  clientIpAddress?: string | null | undefined;
  currencyId?: string | null | undefined;
  currentPaymentCurrency?: string | null | undefined;
  dealSum?: string | null | undefined;
  dealSumOutbound?: string | null | undefined;
  dealSumType?: string | null | undefined;
  dealsInbound?: string | null | undefined;
  displayProperties?: string | null | undefined;
  esbServicesCall?: string | null | undefined;
  fullPaymentDate?: string | null | undefined;
  fullPurchaseDate?: string | null | undefined;
  fullPurchaseDateOutbound?: string | null | undefined;
  fullSupplierNameHeb?: string | null | undefined;
  fullSupplierNameOutbound?: string | null | undefined;
  horaatKeva?: string | null | undefined;
  isButton: string;
  isCaptcha: string;
  isError: string;
  isHoraatKeva: string;
  isShowDealsOutbound?: string | null | undefined;
  isShowLinkForSupplierDetails?: string | null | undefined;
  kodMatbeaMekori?: string | null | undefined;
  message?: string | null | undefined;
  moreInfo?: string | null | undefined;
  paymentDate?: string | null | undefined;
  paymentSum?: string | null | undefined;
  paymentSumOutbound?: string | null | undefined;
  paymentSumSign?: string | null | undefined;
  purchaseDate?: string | null | undefined;
  purchaseDateOutbound?: string | null | undefined;
  returnCode?: string | null | undefined;
  returnMessage?: string | null | undefined;
  siteName?: string | null | undefined;
  solek?: string | null | undefined;
  specificDate?: string | null | undefined;
  stage?: string | null | undefined;
  supplierId?: number | null | undefined;
  supplierName?: string | null | undefined;
  supplierNameOutbound?: string | null | undefined;
  tablePageNum: boolean;
  voucherNumber?: number | null | undefined;
  voucherNumberRatz?: number | null | undefined;
  voucherNumberRatzOutbound?: number | null | undefined;
};

/**  represent charge's metadata ledger validation status  */
export const LedgerValidationStatus = {
  Diff: 'DIFF',
  Invalid: 'INVALID',
  Valid: 'VALID'
} as const;

export type LedgerValidationStatus = typeof LedgerValidationStatus[keyof typeof LedgerValidationStatus];
/**  Input for a Max (formerly Leumi Card) credit card transaction  */
export type MaxTransactionInput = {
  actualPaymentAmount: string;
  arn: string;
  cardIndex: number;
  categoryId: number;
  comments: string;
  dealDataAcq: string;
  dealDataAdjustmentAmount?: string | null | undefined;
  dealDataAdjustmentType: string;
  dealDataAmount: string;
  dealDataAmountIls: string;
  dealDataAmountLeft: string;
  dealDataArn: string;
  dealDataAuthorizationNumber: string;
  dealDataCardName?: string | null | undefined;
  dealDataCardToken?: string | null | undefined;
  dealDataCommissionVat: string;
  dealDataDirectExchange?: string | null | undefined;
  dealDataExchangeCommissionAmount?: string | null | undefined;
  dealDataExchangeCommissionMaam?: string | null | undefined;
  dealDataExchangeCommissionType?: string | null | undefined;
  dealDataExchangeDirect: string;
  dealDataExchangeRate: string;
  dealDataIndexRateBase?: string | null | undefined;
  dealDataIndexRatePmt?: string | null | undefined;
  dealDataInterestAmount: string;
  dealDataIsAllowedSpreadWithBenefit: boolean;
  dealDataIssuerCurrency: string;
  dealDataIssuerExchangeRate?: string | null | undefined;
  dealDataOriginalTerm?: string | null | undefined;
  dealDataPercentMaam?: string | null | undefined;
  dealDataPlan: string;
  dealDataPosEntryEmv: string;
  dealDataProcessingDate: string;
  dealDataPurchaseAmount?: string | null | undefined;
  dealDataPurchaseTime?: string | null | undefined;
  dealDataRefNbr: string;
  dealDataShowCancelDebit: boolean;
  dealDataShowSpread: boolean;
  dealDataShowSpreadBenefitButton: boolean;
  dealDataShowSpreadButton: boolean;
  dealDataShowSpreadForLeumi: boolean;
  dealDataTdmCardToken: string;
  dealDataTdmTransactionType: number;
  dealDataTransactionType: number;
  dealDataTxnCode: number;
  dealDataUserName: string;
  dealDataWithdrawalCommissionAmount?: string | null | undefined;
  discountKeyAmount?: string | null | undefined;
  discountKeyRecType?: string | null | undefined;
  ethocaInd: boolean;
  fundsTransferComment?: string | null | undefined;
  fundsTransferReceiverOrTransfer?: string | null | undefined;
  isRegisterCh: boolean;
  isSpreadingAutorizationAllowed: boolean;
  issuerId: number;
  merchant: string;
  merchantAddress?: string | null | undefined;
  merchantCommercialName?: string | null | undefined;
  merchantCoordinates?: string | null | undefined;
  merchantMaxPhone: boolean;
  merchantName: string;
  merchantNumber: string;
  merchantPhone: string;
  merchantTaxId: string;
  originalAmount: string;
  originalCurrency: string;
  paymentCurrency?: number | null | undefined;
  paymentDate: string;
  planName: string;
  planTypeId: number;
  promotionAmount?: string | null | undefined;
  promotionClub: string;
  promotionType?: string | null | undefined;
  purchaseDate: string;
  receiptPDF?: string | null | undefined;
  refIndex: number;
  runtimeReferenceId?: string | null | undefined;
  runtimeReferenceInternalId: string;
  runtimeReferenceType: number;
  shortCardNumber?: string | null | undefined;
  spreadTransactionByCampainInd: boolean;
  spreadTransactionByCampainNumber?: number | null | undefined;
  tableType: number;
  tag?: string | null | undefined;
  uid: string;
  upSaleForTransactionResult?: string | null | undefined;
  userIndex: number;
};

/**  represent a missing info attributes for a charge */
export const MissingChargeInfo = {
  Counterparty: 'COUNTERPARTY',
  Description: 'DESCRIPTION',
  Documents: 'DOCUMENTS',
  Tags: 'TAGS',
  TaxCategory: 'TAX_CATEGORY',
  Transactions: 'TRANSACTIONS',
  Vat: 'VAT'
} as const;

export type MissingChargeInfo = typeof MissingChargeInfo[keyof typeof MissingChargeInfo];
/**  Input for an Otsar HaHayal credit card transaction  */
export type OtsarHahayalCreditCardTransactionInput = {
  /**  Card type code (from CreditCardsResponse)  */
  cardType: number;
  /**  Charged amount in charge currency  */
  chargeAmount: number;
  /**  Currency the charge is made in  */
  chargeCurrency: string;
  /**  Charge date  */
  chargeDate: string;
  /**  Counter for deduplicating identical transactions in the same billing period  */
  counter: number;
  /**  Transaction date  */
  date: string;
  /**  Original deal amount in deal currency  */
  dealAmount: number;
  /**  Currency of the original deal  */
  dealCurrency: string;
  /**  Deal group key (e.g. localDeals, euroDeals)  */
  dealGroup: string;
  /**  Masked PAN of the card (from CreditCardsResponse)  */
  maskedPan: string;
  /**  Merchant / transaction name  */
  name: string;
  /**  Additional notes  */
  notes: string;
  /**  UUID of the card resource (from CreditCardsResponse)  */
  resourceId: string;
  /**  Wallet type code  */
  walletType: number;
};

/**  Input for an Otsar HaHayal foreign currency bank account transaction  */
export type OtsarHahayalForeignTransactionInput = {
  account: number;
  accountType: string;
  balance?: number | null | undefined;
  branch: number;
  credit: number;
  currency: string;
  date: string;
  debit: number;
  description: string;
  openingBalance: number;
  reference: string;
  sp?: number | null | undefined;
  subTransactions: string;
  valueDate: string;
};

/**  Input for an Otsar HaHayal ILS (NIS) bank account transaction  */
export type OtsarHahayalIlsTransactionInput = {
  accountNumber: number;
  accountType: number;
  actionCode: number;
  bfbSource: string;
  branchNumber: number;
  closingBalance: number;
  correspondentAccount: number;
  correspondentAccountType: number;
  correspondentBank: number;
  correspondentBranch: number;
  creditAmount: number;
  customerName: string;
  dateOfBusinessDay: string;
  dateOfRegistration: string;
  debitAmount: number;
  depositorId: number;
  description: string;
  drillDownData?: string | null | undefined;
  drillDownUrl: string;
  firstTransactionOfDay: boolean;
  lastTransactionOfDay: boolean;
  name: string;
  openingBalance: number;
  operationSource: string;
  originReference?: string | null | undefined;
  reference: number;
  salaryInd: number;
  transactionReason: string;
  transactionSource: string;
};

/**  payment type enum  */
export const PaymentType = {
  Cash: 'CASH',
  Cheque: 'CHEQUE',
  CreditCard: 'CREDIT_CARD',
  Other: 'OTHER',
  OtherDeduction: 'OTHER_DEDUCTION',
  PaymentApp: 'PAYMENT_APP',
  Paypal: 'PAYPAL',
  TaxDeduction: 'TAX_DEDUCTION',
  WireTransfer: 'WIRE_TRANSFER'
} as const;

export type PaymentType = typeof PaymentType[keyof typeof PaymentType];
/**  record type of PCN874 report  */
export const Pcn874RecordType = {
  C: 'C',
  H: 'H',
  I: 'I',
  K: 'K',
  L1: 'L1',
  L2: 'L2',
  M: 'M',
  P: 'P',
  R: 'R',
  S1: 'S1',
  S2: 'S2',
  T: 'T',
  Y: 'Y'
} as const;

export type Pcn874RecordType = typeof Pcn874RecordType[keyof typeof Pcn874RecordType];
/**  Input for a Poalim foreign currency bank account transaction  */
export type PoalimForeignTransactionInput = {
  accountName?: string | null | undefined;
  accountNumber: number;
  activityDescription: string;
  activityTypeCode: number;
  bankNumber: number;
  branchNumber: number;
  commentExistenceSwitch: boolean;
  comments?: string | null | undefined;
  contraAccountFieldNameLable?: string | null | undefined;
  contraAccountNumber: number;
  contraBankNumber: number;
  contraBranchNumber: number;
  contraCurrencyCode: number;
  currency: Currency;
  currencyLongDescription: string;
  currencyRate: number;
  currencySwiftCode: string;
  currentBalance: number;
  dataGroupCode: boolean;
  eventActivityTypeCode: number;
  eventAmount: number;
  eventDetails?: string | null | undefined;
  eventNumber: number;
  executingDate: string;
  formattedExecutingDate: string;
  formattedValueDate?: string | null | undefined;
  metadataAttributesContraAccountFieldNameLable?: string | null | undefined;
  metadataAttributesContraAccountNumber?: string | null | undefined;
  metadataAttributesContraBankNumber?: string | null | undefined;
  metadataAttributesContraBranchNumber?: string | null | undefined;
  metadataAttributesContraCurrencyCode?: string | null | undefined;
  metadataAttributesCurrencyRate?: string | null | undefined;
  metadataAttributesDataGroupCode?: string | null | undefined;
  metadataAttributesOriginalEventKey?: string | null | undefined;
  metadataAttributesRateFixingCode?: string | null | undefined;
  originalEventKey: boolean;
  originalSystemId: number;
  rateFixingCode: number;
  rateFixingDescription?: string | null | undefined;
  rateFixingShortDescription: string;
  referenceCatenatedNumber: number;
  referenceNumber: string;
  transactionType: string;
  urlAddress?: string | null | undefined;
  urlAddressNiar?: string | null | undefined;
  validityDate: string;
  valueDate: string;
};

/**  Input for a Poalim ILS (NIS) bank account transaction  */
export type PoalimIlsTransactionInput = {
  accountNumber: number;
  activityDescription: string;
  activityDescriptionIncludeValueDate?: string | null | undefined;
  activityTypeCode: number;
  bankNumber: number;
  beneficiaryDetailsData?: string | null | undefined;
  beneficiaryDetailsDataMessageDetail?: string | null | undefined;
  beneficiaryDetailsDataMessageHeadline?: string | null | undefined;
  beneficiaryDetailsDataPartyHeadline?: string | null | undefined;
  beneficiaryDetailsDataPartyName?: string | null | undefined;
  beneficiaryDetailsDataRecordNumber?: number | null | undefined;
  beneficiaryDetailsDataTableNumber?: number | null | undefined;
  branchNumber: number;
  comment?: string | null | undefined;
  commentExistenceSwitch: boolean;
  contraAccountNumber: number;
  contraAccountTypeCode: number;
  contraBankNumber: number;
  contraBranchNumber: number;
  currentBalance: number;
  dataGroupCode: number;
  details?: string | null | undefined;
  differentDateIndication: string;
  englishActionDesc?: string | null | undefined;
  eventActivityTypeCode: number;
  eventAmount: number;
  eventDate: string;
  eventId: string;
  executingBranchNumber: number;
  expandedEventDate: string;
  fieldDescDisplaySwitch: boolean;
  formattedEventDate: string;
  formattedOriginalEventCreateDate?: string | null | undefined;
  formattedValueDate?: string | null | undefined;
  internalLinkCode: number;
  marketingOfferContext: boolean;
  offerActivityContext?: string | null | undefined;
  originalEventCreateDate: number;
  pfmDetails?: string | null | undefined;
  recordNumber: number;
  referenceCatenatedNumber: number;
  referenceNumber: string;
  rejectedDataEventPertainingIndication?: string | null | undefined;
  serialNumber: number;
  tableNumber: number;
  textCode: number;
  transactionType: string;
  urlAddressNiar?: string | null | undefined;
  valueDate: string;
};

/**  Input for a Poalim SWIFT international wire transfer  */
export type PoalimSwiftTransactionInput = {
  accountNumber?: number | null | undefined;
  amount?: number | null | undefined;
  bankNumber?: number | null | undefined;
  beneficiaryEnglishCityName?: string | null | undefined;
  beneficiaryEnglishCountryName?: string | null | undefined;
  beneficiaryEnglishStreetName?: string | null | undefined;
  branchNumber?: number | null | undefined;
  chargePartyName?: string | null | undefined;
  currencyCodeCatenatedKey?: string | null | undefined;
  currencyLongDescription?: string | null | undefined;
  dataOriginCode?: string | null | undefined;
  formattedStartDate?: string | null | undefined;
  orderCustomerName?: string | null | undefined;
  referenceNumber?: string | null | undefined;
  startDate?: string | null | undefined;
  swiftAccountWithInstitution57?: string | null | undefined;
  swiftBankCode?: string | null | undefined;
  swiftBankOperationCode23B?: string | null | undefined;
  swiftBeneficiaryCustomer59?: string | null | undefined;
  swiftCurrencyInstructedAmount33B?: string | null | undefined;
  swiftDetailsOfCharges71A?: string | null | undefined;
  swiftExchangeRate36?: string | null | undefined;
  swiftInstructionCode23E?: string | null | undefined;
  swiftIsnSerialNumber?: string | null | undefined;
  swiftOrderingCustomer50K?: string | null | undefined;
  swiftOrderingInstitution52A?: string | null | undefined;
  swiftOrderingInstitution52D?: string | null | undefined;
  swiftReceiversCorrespondent54A?: string | null | undefined;
  swiftRegulatoryReporting77B?: string | null | undefined;
  swiftRemittanceInformation70?: string | null | undefined;
  swiftSendersCharges71F?: string | null | undefined;
  swiftSendersCorrespondent53A?: string | null | undefined;
  swiftSendersReference20?: string | null | undefined;
  swiftSendersToReceiverInformation72?: string | null | undefined;
  swiftStatusCode?: string | null | undefined;
  swiftStatusDesc?: string | null | undefined;
  swiftValueDateCurrencyAmount32A?: string | null | undefined;
  transferCatenatedId?: string | null | undefined;
};

/**  private or business account type  */
export const PrivateOrBusinessType = {
  Business: 'BUSINESS',
  Private: 'PRIVATE'
} as const;

export type PrivateOrBusinessType = typeof PrivateOrBusinessType[keyof typeof PrivateOrBusinessType];
/**  contract products  */
export const Product = {
  Hive: 'HIVE',
  Stellate: 'STELLATE'
} as const;

export type Product = typeof Product[keyof typeof Product];
/** Supported third-party provider integrations */
export const ProviderKey = {
  /** Deel global payroll platform */
  Deel: 'DEEL',
  /** Green Invoice billing platform */
  GreenInvoice: 'GREEN_INVOICE'
} as const;

export type ProviderKey = typeof ProviderKey[keyof typeof ProviderKey];
/**  Reporting method enum (שיטת דיווח)  */
export const ReportingMethod = {
  /** Accrual basis (מצטבר) */
  Accrual: 'ACCRUAL',
  /** Cash basis (מזומן) */
  Cash: 'CASH',
  /** According to dollar regulations (לפי תקנות דולריות) */
  DollarRegulations: 'DOLLAR_REGULATIONS'
} as const;

export type ReportingMethod = typeof ReportingMethod[keyof typeof ReportingMethod];
/**  input variables for update salary records  */
export type SalaryRecordEditInput = {
  addedVacationDays?: number | null | undefined;
  baseSalary?: number | null | undefined;
  bonus?: number | null | undefined;
  chargeId?: string | null | undefined;
  compensationsEmployerAmount?: number | null | undefined;
  compensationsEmployerPercentage?: number | null | undefined;
  directPaymentAmount?: number | null | undefined;
  employeeId: string;
  employer?: string | null | undefined;
  gift?: number | null | undefined;
  globalAdditionalHours?: number | null | undefined;
  healthPaymentAmount?: number | null | undefined;
  hourlyRate?: number | null | undefined;
  hours?: number | null | undefined;
  month: string;
  pensionEmployeeAmount?: number | null | undefined;
  pensionEmployeePercentage?: number | null | undefined;
  pensionEmployerAmount?: number | null | undefined;
  pensionEmployerPercentage?: number | null | undefined;
  pensionFundId?: string | null | undefined;
  recovery?: number | null | undefined;
  sicknessDaysBalance?: number | null | undefined;
  socialSecurityAmountEmployee?: number | null | undefined;
  socialSecurityAmountEmployer?: number | null | undefined;
  taxAmount?: number | null | undefined;
  trainingFundEmployeeAmount?: number | null | undefined;
  trainingFundEmployeePercentage?: number | null | undefined;
  trainingFundEmployerAmount?: number | null | undefined;
  trainingFundEmployerPercentage?: number | null | undefined;
  trainingFundId?: string | null | undefined;
  travelAndSubsistence?: number | null | undefined;
  vacationDaysBalance?: number | null | undefined;
  vacationTakeout?: number | null | undefined;
  workDays?: number | null | undefined;
  zkufot?: number | null | undefined;
};

/**  input variables for insert salary records  */
export type SalaryRecordInput = {
  addedVacationDays?: number | null | undefined;
  baseSalary?: number | null | undefined;
  bonus?: number | null | undefined;
  chargeId?: string | null | undefined;
  compensationsEmployerAmount?: number | null | undefined;
  compensationsEmployerPercentage?: number | null | undefined;
  directPaymentAmount: number;
  employee?: string | null | undefined;
  employeeId: string;
  employer: string;
  gift?: number | null | undefined;
  globalAdditionalHours?: number | null | undefined;
  healthPaymentAmount?: number | null | undefined;
  hourlyRate?: number | null | undefined;
  hours?: number | null | undefined;
  jobPercentage?: number | null | undefined;
  month: string;
  pensionEmployeeAmount?: number | null | undefined;
  pensionEmployeePercentage?: number | null | undefined;
  pensionEmployerAmount?: number | null | undefined;
  pensionEmployerPercentage?: number | null | undefined;
  pensionFundId?: string | null | undefined;
  recovery?: number | null | undefined;
  sicknessDaysBalance?: number | null | undefined;
  socialSecurityAmountEmployee?: number | null | undefined;
  socialSecurityAmountEmployer?: number | null | undefined;
  taxAmount?: number | null | undefined;
  trainingFundEmployeeAmount?: number | null | undefined;
  trainingFundEmployeePercentage?: number | null | undefined;
  trainingFundEmployerAmount?: number | null | undefined;
  trainingFundEmployerPercentage?: number | null | undefined;
  trainingFundId?: string | null | undefined;
  travelAndSubsistence?: number | null | undefined;
  vacationDaysBalance?: number | null | undefined;
  vacationTakeout?: number | null | undefined;
  workDays?: number | null | undefined;
  zkufot?: number | null | undefined;
};

/**  Candidate sender addresses extracted by the gateway, used for business recognition  */
export type SenderEvidenceInput = {
  /**  X-Forwarded-To / Envelope-To address  */
  forwardedTo?: string | null | undefined;
  /**  From header address  */
  from?: string | null | undefined;
  /**  Sender addresses parsed from mailto links in the email body, in document order  */
  issuerCandidates?: Array<string> | null | undefined;
  /**  X-Original-From / X-Original-Sender address  */
  originalFrom?: string | null | undefined;
  /**  Reply-To header address  */
  replyTo?: string | null | undefined;
};

/**  Input for setting Step 03 (opening balance) manual status  */
export type SetAnnualAuditStep03StatusInput = {
  notes?: string | null | undefined;
  ownerId: string;
  status: AnnualAuditStepStatus;
  year: number;
};

/**  Input for setting Step 09 (save final dynamic report template) status  */
export type SetAnnualAuditStep09StatusInput = {
  ownerId: string;
  /**  The name of the dynamic report template to lock as the final draft  */
  templateName: string;
  year: number;
};

/**  Generic input for manually setting any annual audit step status  */
export type SetAnnualAuditStepStatusInput = {
  notes?: string | null | undefined;
  ownerId: string;
  status: AnnualAuditStepStatus;
  stepId: string;
  year: number;
};

/**  contract subscription plans  */
export const SubscriptionPlan = {
  Enterprise: 'ENTERPRISE',
  Pro: 'PRO'
} as const;

export type SubscriptionPlan = typeof SubscriptionPlan[keyof typeof SubscriptionPlan];
/**  input for business suggestions email listener config  */
export type SuggestionsEmailListenerConfigInput = {
  attachments?: Array<EmailAttachmentType> | null | undefined;
  emailBody?: boolean | null | undefined;
  internalEmailLinks?: Array<string> | null | undefined;
};

/**  input for business suggestions  */
export type SuggestionsInput = {
  description?: string | null | undefined;
  emailListener?: SuggestionsEmailListenerConfigInput | null | undefined;
  emails?: Array<string> | null | undefined;
  phrases?: Array<string> | null | undefined;
  priority?: number | null | undefined;
  tags?: Array<TagInput> | null | undefined;
};

/**  input variables for Tag */
export type TagInput = {
  id: string;
};

/**  Input type representing the tax advance rate for a specific date.  */
export type TaxAdvancesRateInput = {
  date: unknown;
  rate: number;
};

/**  Input type for updating admin business details.  */
export type UpdateAdminBusinessInput = {
  governmentId?: string | null | undefined;
  name?: string | null | undefined;
  registrationDate?: unknown;
  /**  Social Security Info  */
  socialSecurityEmployerIds?: Array<AnnualIdInput> | null | undefined;
  /**  Tax Advances Info  */
  taxAdvancesAnnualIds?: Array<AnnualIdInput> | null | undefined;
  taxAdvancesRates?: Array<TaxAdvancesRateInput> | null | undefined;
  withholdingTaxAnnualIds?: Array<AnnualIdInput> | null | undefined;
  /**  Withholding Tax Info  */
  withholdingTaxCompanyId?: string | null | undefined;
};

/**  input for updateBusiness  */
export type UpdateBusinessInput = {
  address?: string | null | undefined;
  city?: string | null | undefined;
  country?: unknown;
  email?: string | null | undefined;
  exemptDealer?: boolean | null | undefined;
  governmentId?: string | null | undefined;
  hebrewName?: string | null | undefined;
  irsCode?: number | null | undefined;
  isActive?: boolean | null | undefined;
  isDocumentsOptional?: boolean | null | undefined;
  isReceiptEnough?: boolean | null | undefined;
  name?: string | null | undefined;
  optionalVAT?: boolean | null | undefined;
  pcn874RecordType?: Pcn874RecordType | null | undefined;
  phoneNumber?: string | null | undefined;
  sortCode?: number | null | undefined;
  suggestions?: SuggestionsInput | null | undefined;
  taxCategory?: string | null | undefined;
  website?: string | null | undefined;
  zipCode?: string | null | undefined;
};

/**  the input for updating a business trip accommodation expense  */
export type UpdateBusinessTripAccommodationsExpenseInput = {
  amount?: number | null | undefined;
  attendeesStay: Array<BusinessTripAttendeeStayInput>;
  businessTripId: string;
  country?: unknown;
  currency?: Currency | null | undefined;
  date?: unknown;
  employeeBusinessId?: string | null | undefined;
  id: string;
  nightsCount?: number | null | undefined;
  valueDate?: unknown;
};

/**  the input for updating a business trip car rental expense  */
export type UpdateBusinessTripCarRentalExpenseInput = {
  amount?: number | null | undefined;
  businessTripId: string;
  currency?: Currency | null | undefined;
  date?: unknown;
  days?: number | null | undefined;
  employeeBusinessId?: string | null | undefined;
  id: string;
  isFuelExpense?: boolean | null | undefined;
  valueDate?: unknown;
};

/**  the input for updating a business trip flights expense  */
export type UpdateBusinessTripFlightsExpenseInput = {
  amount?: number | null | undefined;
  attendeeIds?: Array<string> | null | undefined;
  businessTripId: string;
  currency?: Currency | null | undefined;
  date?: unknown;
  employeeBusinessId?: string | null | undefined;
  flightClass?: FlightClass | null | undefined;
  id: string;
  path?: Array<string> | null | undefined;
  valueDate?: unknown;
};

/**  the input for updating a business trip other expense  */
export type UpdateBusinessTripOtherExpenseInput = {
  amount?: number | null | undefined;
  businessTripId: string;
  currency?: Currency | null | undefined;
  date?: unknown;
  deductibleExpense?: boolean | null | undefined;
  description?: string | null | undefined;
  employeeBusinessId?: string | null | undefined;
  id: string;
  valueDate?: unknown;
};

/**  the input for updating a business trip T&S expense  */
export type UpdateBusinessTripTravelAndSubsistenceExpenseInput = {
  amount?: number | null | undefined;
  businessTripId: string;
  currency?: Currency | null | undefined;
  date?: unknown;
  employeeBusinessId?: string | null | undefined;
  expenseType?: string | null | undefined;
  id: string;
  valueDate?: unknown;
};

/**  input variables for updateCharge  */
export type UpdateChargeInput = {
  accountantApproval?: AccountantStatus | null | undefined;
  businessTripID?: string | null | undefined;
  counterpartyId?: string | null | undefined;
  defaultTaxCategoryID?: string | null | undefined;
  isDecreasedVAT?: boolean | null | undefined;
  isInvoicePaymentDifferentCurrency?: boolean | null | undefined;
  optionalDocuments?: boolean | null | undefined;
  optionalVAT?: boolean | null | undefined;
  tags?: Array<TagInput> | null | undefined;
  type?: ChargeType | null | undefined;
  /**  user custom description  */
  userDescription?: string | null | undefined;
  yearsOfRelevance?: Array<YearOfRelevanceInput> | null | undefined;
};

/**  input for updating a contract  */
export type UpdateContractInput = {
  amount?: FinancialAmountInput | null | undefined;
  billingCycle?: BillingCycle | null | undefined;
  clientId?: string | null | undefined;
  documentType?: DocumentType | null | undefined;
  endDate?: unknown;
  isActive?: boolean | null | undefined;
  msCloud?: unknown;
  operationsLimit?: unknown;
  plan?: SubscriptionPlan | null | undefined;
  product?: Product | null | undefined;
  purchaseOrders?: Array<string> | null | undefined;
  remarks?: string | null | undefined;
  startDate?: unknown;
};

/**  input variables for updateDepreciationRecord  */
export type UpdateDepreciationRecordInput = {
  activationDate?: unknown;
  amount?: number | null | undefined;
  categoryId?: string | null | undefined;
  chargeId?: string | null | undefined;
  currency?: Currency | null | undefined;
  id: string;
  type?: DepreciationType | null | undefined;
};

/**  input variables for updateDocument  */
export type UpdateDocumentFieldsInput = {
  allocationNumber?: string | null | undefined;
  amount?: FinancialAmountInput | null | undefined;
  chargeId?: string | null | undefined;
  creditorId?: string | null | undefined;
  date?: unknown;
  debtorId?: string | null | undefined;
  description?: string | null | undefined;
  documentType?: DocumentType | null | undefined;
  exchangeRateOverride?: number | null | undefined;
  file?: unknown;
  image?: unknown;
  noVatAmount?: number | null | undefined;
  remarks?: string | null | undefined;
  serialNumber?: string | null | undefined;
  vat?: FinancialAmountInput | null | undefined;
  vatReportDateOverride?: unknown;
};

/**  input type for updating a financial account  */
export type UpdateFinancialAccountInput = {
  bankAccountDetails?: BankAccountUpdateInput | null | undefined;
  currencies?: Array<FinancialAccountCurrencyInput> | null | undefined;
  name?: string | null | undefined;
  number?: string | null | undefined;
  ownerId?: string | null | undefined;
  privateOrBusiness?: PrivateOrBusinessType | null | undefined;
  type?: FinancialAccountType | null | undefined;
};

/**  input variables for updateMiscExpense  */
export type UpdateMiscExpenseInput = {
  amount?: number | null | undefined;
  chargeId?: string | null | undefined;
  creditorId?: string | null | undefined;
  currency?: Currency | null | undefined;
  debtorId?: string | null | undefined;
  description?: string | null | undefined;
  invoiceDate?: unknown;
  valueDate?: unknown;
};

/**  input variables for updateSortCode  */
export type UpdateSortCodeFieldsInput = {
  defaultIrsCode?: number | null | undefined;
  name?: string | null | undefined;
};

/**  input variables for updateTag  */
export type UpdateTagFieldsInput = {
  name?: string | null | undefined;
  parentId?: string | null | undefined;
};

/**  input for updateTaxCategory  */
export type UpdateTaxCategoryInput = {
  hashavshevetName?: string | null | undefined;
  irsCode?: number | null | undefined;
  isActive?: boolean | null | undefined;
  name?: string | null | undefined;
  sortCode?: number | null | undefined;
  taxExcluded?: boolean | null | undefined;
};

/**  input variables for updateTransaction  */
export type UpdateTransactionInput = {
  chargeId?: string | null | undefined;
  counterpartyId?: string | null | undefined;
  effectiveDate?: unknown;
  isFee?: boolean | null | undefined;
};

/**  input variables for vatReportRecords  */
export type VatReportFilter = {
  chargesType?: ChargeFilterType | null | undefined;
  financialEntityId: string;
  monthDate: unknown;
};

/**  input variables for charge spread  */
export type YearOfRelevanceInput = {
  amount?: number | null | undefined;
  year: unknown;
};

export type ListApiKeysQueryVariables = Exact<{ [key: string]: never; }>;


export type ListApiKeysQuery = { listApiKeys: Array<{ id: string, name: string, roleId: string, lastUsedAt: unknown, createdAt: unknown }> };

export type ListBusinessUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type ListBusinessUsersQuery = { listBusinessUsers: Array<{ id: string, email: string, name: string | null, roleId: string, createdAt: unknown }> };

export type ListInvitationsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListInvitationsQuery = { listInvitations: Array<{ id: string, email: string, roleId: string, expiresAt: unknown }> };

type DepositTransactionFields_CommonTransaction_Fragment = { id: string, eventDate: unknown, chargeId: string, amount: { raw: number, formatted: string, currency: Currency }, debitExchangeRates: { aud: number | null, cad: number | null, eur: number | null, gbp: number | null, jpy: number | null, sek: number | null, usd: number | null, date: unknown } | null, eventExchangeRates: { aud: number | null, cad: number | null, eur: number | null, gbp: number | null, jpy: number | null, sek: number | null, usd: number | null, date: unknown } | null } & { ' $fragmentName'?: 'DepositTransactionFields_CommonTransaction_Fragment' };

type DepositTransactionFields_ConversionTransaction_Fragment = { id: string, eventDate: unknown, chargeId: string, amount: { raw: number, formatted: string, currency: Currency }, debitExchangeRates: { aud: number | null, cad: number | null, eur: number | null, gbp: number | null, jpy: number | null, sek: number | null, usd: number | null, date: unknown } | null, eventExchangeRates: { aud: number | null, cad: number | null, eur: number | null, gbp: number | null, jpy: number | null, sek: number | null, usd: number | null, date: unknown } | null } & { ' $fragmentName'?: 'DepositTransactionFields_ConversionTransaction_Fragment' };

export type DepositTransactionFieldsFragment =
  | DepositTransactionFields_CommonTransaction_Fragment
  | DepositTransactionFields_ConversionTransaction_Fragment
;

export type SharedDepositTransactionsQueryVariables = Exact<{
  depositId: string;
}>;


export type SharedDepositTransactionsQuery = { deposit: { id: string, currency: Currency | null, metadata: { id: string, transactions: Array<
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'DepositTransactionFields_CommonTransaction_Fragment': DepositTransactionFields_CommonTransaction_Fragment } }
        )
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'DepositTransactionFields_ConversionTransaction_Fragment': DepositTransactionFields_ConversionTransaction_Fragment } }
        )
      > } } };

export type BusinessLedgerInfoQueryVariables = Exact<{
  filters?: BusinessTransactionsFilter | null | undefined;
}>;


export type BusinessLedgerInfoQuery = { businessTransactionsFromLedgerRecords:
    | { __typename: 'BusinessTransactionsFromLedgerRecordsSuccessfulResult', businessTransactions: Array<{ invoiceDate: unknown, reference: string | null, details: string | null, chargeId: string, amount: { formatted: string, raw: number }, business:
          | { id: string, name: string }
          | { id: string, name: string }
          | { id: string, name: string }
        , foreignAmount: { formatted: string, raw: number, currency: Currency } | null, counterAccount:
          | { __typename: 'LtdFinancialEntity', id: string, name: string }
          | { __typename: 'PersonalFinancialEntity', id: string, name: string }
          | { __typename: 'TaxCategory', id: string, name: string }
         | null }> }
    | { __typename: 'CommonError', message: string }
   };

export type BusinessLedgerRecordsSummeryQueryVariables = Exact<{
  filters?: BusinessTransactionsFilter | null | undefined;
}>;


export type BusinessLedgerRecordsSummeryQuery = { businessTransactionsSumFromLedgerRecords:
    | { __typename: 'BusinessTransactionsSumFromLedgerRecordsSuccessfulResult', businessTransactionsSum: Array<{ business:
          | { id: string, name: string }
          | { id: string, name: string }
          | { id: string, name: string }
        , credit: { formatted: string }, debit: { formatted: string }, total: { formatted: string, raw: number }, foreignCurrenciesSum: Array<{ currency: Currency, credit: { formatted: string }, debit: { formatted: string }, total: { formatted: string, raw: number } }> }> }
    | { __typename: 'CommonError', message: string }
   };

export type BusinessTripScreenQueryVariables = Exact<{
  businessTripId: string;
}>;


export type BusinessTripScreenQuery = { businessTrip: { id: string, name: string, dates: { start: unknown } | null } | null };

export type BusinessTripsRowFieldsFragment = { id: string, name: string, accountantApproval: AccountantStatus } & { ' $fragmentName'?: 'BusinessTripsRowFieldsFragment' };

export type BusinessTripsRowValidationQueryVariables = Exact<{
  id: string;
}>;


export type BusinessTripsRowValidationQuery = { businessTrip: { id: string, uncategorizedTransactions: Array<{ transaction: Record<PropertyKey, never> } | null>, summary:
      | ({ errors: Array<string> | null } | { errors?: never })
      | Record<PropertyKey, never>
     } | null };

export type EditableBusinessTripQueryVariables = Exact<{
  businessTripId: string;
}>;


export type EditableBusinessTripQuery = { businessTrip: (
    { id: string, uncategorizedTransactions: Array<{ transaction:
        | { id: string }
        | { id: string }
       } | null> }
    & { ' $fragmentRefs'?: { 'BusinessTripReportHeaderFieldsFragment': BusinessTripReportHeaderFieldsFragment;'BusinessTripReportAttendeesFieldsFragment': BusinessTripReportAttendeesFieldsFragment;'BusinessTripUncategorizedTransactionsFieldsFragment': BusinessTripUncategorizedTransactionsFieldsFragment;'BusinessTripReportFlightsFieldsFragment': BusinessTripReportFlightsFieldsFragment;'BusinessTripReportAccommodationsFieldsFragment': BusinessTripReportAccommodationsFieldsFragment;'BusinessTripReportTravelAndSubsistenceFieldsFragment': BusinessTripReportTravelAndSubsistenceFieldsFragment;'BusinessTripReportCarRentalFieldsFragment': BusinessTripReportCarRentalFieldsFragment;'BusinessTripReportOtherFieldsFragment': BusinessTripReportOtherFieldsFragment;'BusinessTripReportSummaryFieldsFragment': BusinessTripReportSummaryFieldsFragment } }
  ) | null };

export type BusinessTripsScreenQueryVariables = Exact<{ [key: string]: never; }>;


export type BusinessTripsScreenQuery = { allBusinessTrips: Array<(
    { id: string, name: string, dates: { start: unknown } | null }
    & { ' $fragmentRefs'?: { 'BusinessTripsRowFieldsFragment': BusinessTripsRowFieldsFragment } }
  )> };

type BusinessAdminSection_LtdFinancialEntity_Fragment = { __typename: 'LtdFinancialEntity', id: string, adminInfo: { id: string, registrationDate: unknown, withholdingTaxCompanyId: string | null, socialSecurityDeductionsId: string | null, withholdingTaxAnnualIds: Array<{ id: string, year: number }>, socialSecurityEmployerIds: Array<{ id: string, year: number }>, taxAdvancesAnnualIds: Array<{ id: string, year: number }>, taxAdvancesRates: Array<{ date: unknown, rate: number }> } | null } & { ' $fragmentName'?: 'BusinessAdminSection_LtdFinancialEntity_Fragment' };

type BusinessAdminSection_PersonalFinancialEntity_Fragment = { __typename: 'PersonalFinancialEntity', id: string } & { ' $fragmentName'?: 'BusinessAdminSection_PersonalFinancialEntity_Fragment' };

export type BusinessAdminSectionFragment =
  | BusinessAdminSection_LtdFinancialEntity_Fragment
  | BusinessAdminSection_PersonalFinancialEntity_Fragment
;

export type AdminFinancialAccountsSectionQueryVariables = Exact<{
  adminId: string;
}>;


export type AdminFinancialAccountsSectionQuery = { financialAccountsByOwner: Array<
    | { __typename: 'BankDepositFinancialAccount', id: string, name: string, number: string, type: FinancialAccountType, privateOrBusiness: PrivateOrBusinessType, accountTaxCategories: Array<{ id: string, currency: Currency, taxCategory: { id: string, name: string } }> }
    | { __typename: 'BankFinancialAccount', bankNumber: number, branchNumber: number, iban: string | null, swiftCode: string | null, extendedBankNumber: number | null, partyPreferredIndication: number | null, partyAccountInvolvementCode: number | null, accountDealDate: number | null, accountUpdateDate: number | null, metegDoarNet: number | null, kodHarshaatPeilut: number | null, accountClosingReasonCode: number | null, accountAgreementOpeningDate: number | null, serviceAuthorizationDesc: string | null, branchTypeCode: number | null, mymailEntitlementSwitch: number | null, productLabel: string | null, id: string, name: string, number: string, type: FinancialAccountType, privateOrBusiness: PrivateOrBusinessType, accountTaxCategories: Array<{ id: string, currency: Currency, taxCategory: { id: string, name: string } }> }
    | { __typename: 'CardFinancialAccount', id: string, name: string, number: string, type: FinancialAccountType, privateOrBusiness: PrivateOrBusinessType, accountTaxCategories: Array<{ id: string, currency: Currency, taxCategory: { id: string, name: string } }> }
    | { __typename: 'CryptoWalletFinancialAccount', id: string, name: string, number: string, type: FinancialAccountType, privateOrBusiness: PrivateOrBusinessType, accountTaxCategories: Array<{ id: string, currency: Currency, taxCategory: { id: string, name: string } }> }
    | { __typename: 'ForeignSecuritiesFinancialAccount', id: string, name: string, number: string, type: FinancialAccountType, privateOrBusiness: PrivateOrBusinessType, accountTaxCategories: Array<{ id: string, currency: Currency, taxCategory: { id: string, name: string } }> }
  > };

type BusinessHeader_LtdFinancialEntity_Fragment = { __typename: 'LtdFinancialEntity', governmentId: string | null, id: string, name: string, createdAt: unknown, isActive: boolean, adminInfo: { id: string } | null, clientInfo: { id: string } | null } & { ' $fragmentName'?: 'BusinessHeader_LtdFinancialEntity_Fragment' };

type BusinessHeader_PersonalFinancialEntity_Fragment = { __typename: 'PersonalFinancialEntity', id: string, name: string, createdAt: unknown, isActive: boolean } & { ' $fragmentName'?: 'BusinessHeader_PersonalFinancialEntity_Fragment' };

export type BusinessHeaderFragment =
  | BusinessHeader_LtdFinancialEntity_Fragment
  | BusinessHeader_PersonalFinancialEntity_Fragment
;

export type BusinessChargesSectionQueryVariables = Exact<{
  page?: number | null | undefined;
  limit?: number | null | undefined;
  filters?: ChargeFilter | null | undefined;
}>;


export type BusinessChargesSectionQuery = { allCharges: { nodes: Array<
      | (
        { id: string }
        & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_BankDepositCharge_Fragment': ChargeForChargesTableFields_BankDepositCharge_Fragment } }
      )
      | (
        { id: string }
        & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_BusinessTripCharge_Fragment': ChargeForChargesTableFields_BusinessTripCharge_Fragment } }
      )
      | (
        { id: string }
        & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_CommonCharge_Fragment': ChargeForChargesTableFields_CommonCharge_Fragment } }
      )
      | (
        { id: string }
        & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_ConversionCharge_Fragment': ChargeForChargesTableFields_ConversionCharge_Fragment } }
      )
      | (
        { id: string }
        & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_CreditcardBankCharge_Fragment': ChargeForChargesTableFields_CreditcardBankCharge_Fragment } }
      )
      | (
        { id: string }
        & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_DividendCharge_Fragment': ChargeForChargesTableFields_DividendCharge_Fragment } }
      )
      | (
        { id: string }
        & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_FinancialCharge_Fragment': ChargeForChargesTableFields_FinancialCharge_Fragment } }
      )
      | (
        { id: string }
        & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_ForeignSecuritiesCharge_Fragment': ChargeForChargesTableFields_ForeignSecuritiesCharge_Fragment } }
      )
      | (
        { id: string }
        & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_InternalTransferCharge_Fragment': ChargeForChargesTableFields_InternalTransferCharge_Fragment } }
      )
      | (
        { id: string }
        & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_MonthlyVatCharge_Fragment': ChargeForChargesTableFields_MonthlyVatCharge_Fragment } }
      )
      | (
        { id: string }
        & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_SalaryCharge_Fragment': ChargeForChargesTableFields_SalaryCharge_Fragment } }
      )
    >, pageInfo: { totalPages: number } } };

export type ClientContractsSectionQueryVariables = Exact<{
  clientId: string;
}>;


export type ClientContractsSectionQuery = { contractsByClient: Array<{ id: string, purchaseOrders: Array<string>, startDate: unknown, endDate: unknown, billingCycle: BillingCycle, isActive: boolean, product: Product | null, documentType: DocumentType, remarks: string | null, plan: SubscriptionPlan | null, msCloud: unknown, operationsLimit: unknown, amount: { raw: number, currency: Currency } }> };

export type ClientIntegrationsSectionFragment = { id: string, clientInfo: { id: string, integrations: { id: string, hiveId: string | null, linearId: string | null, slackChannelKey: string | null, notionId: string | null, workflowyUrl: string | null, greenInvoiceInfo: { businessId: string, greenInvoiceId: string | null } | null } } | null } & { ' $fragmentName'?: 'ClientIntegrationsSectionFragment' };

export type ClientIntegrationsSectionGreenInvoiceQueryVariables = Exact<{
  clientId: string;
}>;


export type ClientIntegrationsSectionGreenInvoiceQuery = { greenInvoiceClient: { businessId: string, greenInvoiceId: string | null, emails: Array<string> | null, name: string | null, phone: string | null, taxId: string | null, address: string | null, city: string | null, zip: string | null, fax: string | null, mobile: string | null, country: { id: string, name: string } | null } };

export type ContractBasedDocumentDraftQueryVariables = Exact<{
  issueMonth: unknown;
  contractId: string;
}>;


export type ContractBasedDocumentDraftQuery = { periodicalDocumentDraftsByContracts: Array<{ ' $fragmentRefs'?: { 'NewDocumentDraftFragment': NewDocumentDraftFragment } }> };

type BusinessConfigurationSection_LtdFinancialEntity_Fragment = { __typename: 'LtdFinancialEntity', optionalVAT: boolean | null, exemptDealer: boolean | null, isReceiptEnough: boolean | null, isDocumentsOptional: boolean | null, id: string, pcn874RecordType: Pcn874RecordType | null, irsCode: number | null, isActive: boolean, ownerId: string | null, sortCode: { id: string, key: number, defaultIrsCode: number | null } | null, taxCategory: { id: string } | null, suggestions: { phrases: Array<string>, emails: Array<string> | null, description: string | null, tags: Array<{ id: string }>, emailListener: { internalEmailLinks: Array<string> | null, emailBody: boolean | null, attachments: Array<EmailAttachmentType> | null } | null } | null, clientInfo: { id: string } | null } & { ' $fragmentName'?: 'BusinessConfigurationSection_LtdFinancialEntity_Fragment' };

type BusinessConfigurationSection_PersonalFinancialEntity_Fragment = { __typename: 'PersonalFinancialEntity', id: string, pcn874RecordType: Pcn874RecordType | null, irsCode: number | null, isActive: boolean, ownerId: string | null } & { ' $fragmentName'?: 'BusinessConfigurationSection_PersonalFinancialEntity_Fragment' };

export type BusinessConfigurationSectionFragment =
  | BusinessConfigurationSection_LtdFinancialEntity_Fragment
  | BusinessConfigurationSection_PersonalFinancialEntity_Fragment
;

type BusinessContactSection_LtdFinancialEntity_Fragment = { __typename: 'LtdFinancialEntity', name: string, hebrewName: string | null, governmentId: string | null, address: string | null, city: string | null, zipCode: string | null, email: string | null, phoneNumber: string | null, website: string | null, id: string, country: { id: string, code: unknown }, clientInfo: { id: string, emails: Array<string> } | null } & { ' $fragmentName'?: 'BusinessContactSection_LtdFinancialEntity_Fragment' };

type BusinessContactSection_PersonalFinancialEntity_Fragment = { __typename: 'PersonalFinancialEntity', id: string } & { ' $fragmentName'?: 'BusinessContactSection_PersonalFinancialEntity_Fragment' };

export type BusinessContactSectionFragment =
  | BusinessContactSection_LtdFinancialEntity_Fragment
  | BusinessContactSection_PersonalFinancialEntity_Fragment
;

type BusinessPage_LtdFinancialEntity_Fragment = (
  { id: string, clientInfo: { id: string } | null, adminInfo: { id: string } | null }
  & { ' $fragmentRefs'?: { 'ClientIntegrationsSectionFragment': ClientIntegrationsSectionFragment;'BusinessHeader_LtdFinancialEntity_Fragment': BusinessHeader_LtdFinancialEntity_Fragment;'BusinessContactSection_LtdFinancialEntity_Fragment': BusinessContactSection_LtdFinancialEntity_Fragment;'BusinessConfigurationSection_LtdFinancialEntity_Fragment': BusinessConfigurationSection_LtdFinancialEntity_Fragment;'BusinessAdminSection_LtdFinancialEntity_Fragment': BusinessAdminSection_LtdFinancialEntity_Fragment } }
) & { ' $fragmentName'?: 'BusinessPage_LtdFinancialEntity_Fragment' };

type BusinessPage_PersonalFinancialEntity_Fragment = (
  { id: string }
  & { ' $fragmentRefs'?: { 'BusinessHeader_PersonalFinancialEntity_Fragment': BusinessHeader_PersonalFinancialEntity_Fragment;'BusinessContactSection_PersonalFinancialEntity_Fragment': BusinessContactSection_PersonalFinancialEntity_Fragment;'BusinessConfigurationSection_PersonalFinancialEntity_Fragment': BusinessConfigurationSection_PersonalFinancialEntity_Fragment;'BusinessAdminSection_PersonalFinancialEntity_Fragment': BusinessAdminSection_PersonalFinancialEntity_Fragment } }
) & { ' $fragmentName'?: 'BusinessPage_PersonalFinancialEntity_Fragment' };

export type BusinessPageFragment =
  | BusinessPage_LtdFinancialEntity_Fragment
  | BusinessPage_PersonalFinancialEntity_Fragment
;

export type BusinessLedgerSectionQueryVariables = Exact<{
  businessId: string;
}>;


export type BusinessLedgerSectionQuery = { ledgerRecordsByFinancialEntity: Array<(
    { id: string }
    & { ' $fragmentRefs'?: { 'LedgerRecordsTableFieldsFragment': LedgerRecordsTableFieldsFragment } }
  )> };

export type BusinessTransactionsSectionQueryVariables = Exact<{
  businessId: string;
}>;


export type BusinessTransactionsSectionQuery = { transactionsByFinancialEntity: Array<
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_CommonTransaction_Fragment': TransactionForTransactionsTableFields_CommonTransaction_Fragment;'TransactionToDownloadForTransactionsTableFields_CommonTransaction_Fragment': TransactionToDownloadForTransactionsTableFields_CommonTransaction_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_ConversionTransaction_Fragment': TransactionForTransactionsTableFields_ConversionTransaction_Fragment;'TransactionToDownloadForTransactionsTableFields_ConversionTransaction_Fragment': TransactionToDownloadForTransactionsTableFields_ConversionTransaction_Fragment } }
    )
  > };

export type AllBusinessesForScreenQueryVariables = Exact<{ [key: string]: never; }>;


export type AllBusinessesForScreenQuery = { allBusinesses: { nodes: Array<
      | { __typename: 'LtdFinancialEntity', hebrewName: string | null, governmentId: string | null, city: string | null, zipCode: string | null, createdAt: unknown, updatedAt: unknown, irsCode: number | null, pcn874RecordType: Pcn874RecordType | null, isClient: boolean, isAdmin: boolean, isActive: boolean, id: string, name: string, country: { id: string, code: unknown }, sortCode: { id: string, key: number, name: string | null } | null, taxCategory: { id: string, name: string } | null, suggestions: { description: string | null, tags: Array<{ id: string, name: string }> } | null }
      | { __typename: 'PersonalFinancialEntity', id: string, name: string }
    > } | null };

export type BusinessesUsageQueryVariables = Exact<{
  ids: Array<string> | string;
}>;


export type BusinessesUsageQuery = { businessesUsage: Array<{ id: string, businessId: string, totalTransactions: number, totalDocuments: number, totalMiscExpenses: number, totalLedgerRecords: number }> };

export type ChargeMatchesTableFieldsFragment = { confidenceScore: number, charge:
    | { __typename: 'BankDepositCharge', id: string, minEventDate: unknown, minDebitDate: unknown, minDocumentsDate: unknown, userDescription: string | null, totalAmount: { raw: number, formatted: string } | null, vat: { raw: number, formatted: string } | null, counterparty:
        | { name: string, id: string }
        | { name: string, id: string }
        | { name: string, id: string }
       | null, tags: Array<{ id: string, name: string, namePath: Array<string> | null }>, taxCategory: { id: string, name: string } | null }
    | { __typename: 'BusinessTripCharge', id: string, minEventDate: unknown, minDebitDate: unknown, minDocumentsDate: unknown, userDescription: string | null, totalAmount: { raw: number, formatted: string } | null, vat: { raw: number, formatted: string } | null, counterparty:
        | { name: string, id: string }
        | { name: string, id: string }
        | { name: string, id: string }
       | null, tags: Array<{ id: string, name: string, namePath: Array<string> | null }>, taxCategory: { id: string, name: string } | null }
    | { __typename: 'CommonCharge', id: string, minEventDate: unknown, minDebitDate: unknown, minDocumentsDate: unknown, userDescription: string | null, totalAmount: { raw: number, formatted: string } | null, vat: { raw: number, formatted: string } | null, counterparty:
        | { name: string, id: string }
        | { name: string, id: string }
        | { name: string, id: string }
       | null, tags: Array<{ id: string, name: string, namePath: Array<string> | null }>, taxCategory: { id: string, name: string } | null }
    | { __typename: 'ConversionCharge', id: string, minEventDate: unknown, minDebitDate: unknown, minDocumentsDate: unknown, userDescription: string | null, totalAmount: { raw: number, formatted: string } | null, vat: { raw: number, formatted: string } | null, counterparty:
        | { name: string, id: string }
        | { name: string, id: string }
        | { name: string, id: string }
       | null, tags: Array<{ id: string, name: string, namePath: Array<string> | null }>, taxCategory: { id: string, name: string } | null }
    | { __typename: 'CreditcardBankCharge', id: string, minEventDate: unknown, minDebitDate: unknown, minDocumentsDate: unknown, userDescription: string | null, totalAmount: { raw: number, formatted: string } | null, vat: { raw: number, formatted: string } | null, counterparty:
        | { name: string, id: string }
        | { name: string, id: string }
        | { name: string, id: string }
       | null, tags: Array<{ id: string, name: string, namePath: Array<string> | null }>, taxCategory: { id: string, name: string } | null }
    | { __typename: 'DividendCharge', id: string, minEventDate: unknown, minDebitDate: unknown, minDocumentsDate: unknown, userDescription: string | null, totalAmount: { raw: number, formatted: string } | null, vat: { raw: number, formatted: string } | null, counterparty:
        | { name: string, id: string }
        | { name: string, id: string }
        | { name: string, id: string }
       | null, tags: Array<{ id: string, name: string, namePath: Array<string> | null }>, taxCategory: { id: string, name: string } | null }
    | { __typename: 'FinancialCharge', id: string, minEventDate: unknown, minDebitDate: unknown, minDocumentsDate: unknown, userDescription: string | null, totalAmount: { raw: number, formatted: string } | null, vat: { raw: number, formatted: string } | null, counterparty:
        | { name: string, id: string }
        | { name: string, id: string }
        | { name: string, id: string }
       | null, tags: Array<{ id: string, name: string, namePath: Array<string> | null }>, taxCategory: { id: string, name: string } | null }
    | { __typename: 'ForeignSecuritiesCharge', id: string, minEventDate: unknown, minDebitDate: unknown, minDocumentsDate: unknown, userDescription: string | null, totalAmount: { raw: number, formatted: string } | null, vat: { raw: number, formatted: string } | null, counterparty:
        | { name: string, id: string }
        | { name: string, id: string }
        | { name: string, id: string }
       | null, tags: Array<{ id: string, name: string, namePath: Array<string> | null }>, taxCategory: { id: string, name: string } | null }
    | { __typename: 'InternalTransferCharge', id: string, minEventDate: unknown, minDebitDate: unknown, minDocumentsDate: unknown, userDescription: string | null, totalAmount: { raw: number, formatted: string } | null, vat: { raw: number, formatted: string } | null, counterparty:
        | { name: string, id: string }
        | { name: string, id: string }
        | { name: string, id: string }
       | null, tags: Array<{ id: string, name: string, namePath: Array<string> | null }>, taxCategory: { id: string, name: string } | null }
    | { __typename: 'MonthlyVatCharge', id: string, minEventDate: unknown, minDebitDate: unknown, minDocumentsDate: unknown, userDescription: string | null, totalAmount: { raw: number, formatted: string } | null, vat: { raw: number, formatted: string } | null, counterparty:
        | { name: string, id: string }
        | { name: string, id: string }
        | { name: string, id: string }
       | null, tags: Array<{ id: string, name: string, namePath: Array<string> | null }>, taxCategory: { id: string, name: string } | null }
    | { __typename: 'SalaryCharge', id: string, minEventDate: unknown, minDebitDate: unknown, minDocumentsDate: unknown, userDescription: string | null, totalAmount: { raw: number, formatted: string } | null, vat: { raw: number, formatted: string } | null, counterparty:
        | { name: string, id: string }
        | { name: string, id: string }
        | { name: string, id: string }
       | null, tags: Array<{ id: string, name: string, namePath: Array<string> | null }>, taxCategory: { id: string, name: string } | null }
   } & { ' $fragmentName'?: 'ChargeMatchesTableFieldsFragment' };

export type ChargeExtendedInfoForChargeMatchesQueryVariables = Exact<{
  chargeId: string;
}>;


export type ChargeExtendedInfoForChargeMatchesQuery = { charge:
    | { id: string, transactions: Array<
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_CommonTransaction_Fragment': TransactionForTransactionsTableFields_CommonTransaction_Fragment } }
        )
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_ConversionTransaction_Fragment': TransactionForTransactionsTableFields_ConversionTransaction_Fragment } }
        )
      >, additionalDocuments: Array<
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_CreditInvoice_Fragment': TableDocumentsRowFields_CreditInvoice_Fragment } }
        )
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Invoice_Fragment': TableDocumentsRowFields_Invoice_Fragment } }
        )
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_InvoiceReceipt_Fragment': TableDocumentsRowFields_InvoiceReceipt_Fragment } }
        )
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_OtherDocument_Fragment': TableDocumentsRowFields_OtherDocument_Fragment } }
        )
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Proforma_Fragment': TableDocumentsRowFields_Proforma_Fragment } }
        )
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Receipt_Fragment': TableDocumentsRowFields_Receipt_Fragment } }
        )
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Unprocessed_Fragment': TableDocumentsRowFields_Unprocessed_Fragment } }
        )
      > }
    | { id: string, transactions: Array<
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_CommonTransaction_Fragment': TransactionForTransactionsTableFields_CommonTransaction_Fragment } }
        )
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_ConversionTransaction_Fragment': TransactionForTransactionsTableFields_ConversionTransaction_Fragment } }
        )
      >, additionalDocuments: Array<
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_CreditInvoice_Fragment': TableDocumentsRowFields_CreditInvoice_Fragment } }
        )
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Invoice_Fragment': TableDocumentsRowFields_Invoice_Fragment } }
        )
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_InvoiceReceipt_Fragment': TableDocumentsRowFields_InvoiceReceipt_Fragment } }
        )
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_OtherDocument_Fragment': TableDocumentsRowFields_OtherDocument_Fragment } }
        )
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Proforma_Fragment': TableDocumentsRowFields_Proforma_Fragment } }
        )
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Receipt_Fragment': TableDocumentsRowFields_Receipt_Fragment } }
        )
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Unprocessed_Fragment': TableDocumentsRowFields_Unprocessed_Fragment } }
        )
      > }
    | { id: string, transactions: Array<
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_CommonTransaction_Fragment': TransactionForTransactionsTableFields_CommonTransaction_Fragment } }
        )
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_ConversionTransaction_Fragment': TransactionForTransactionsTableFields_ConversionTransaction_Fragment } }
        )
      >, additionalDocuments: Array<
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_CreditInvoice_Fragment': TableDocumentsRowFields_CreditInvoice_Fragment } }
        )
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Invoice_Fragment': TableDocumentsRowFields_Invoice_Fragment } }
        )
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_InvoiceReceipt_Fragment': TableDocumentsRowFields_InvoiceReceipt_Fragment } }
        )
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_OtherDocument_Fragment': TableDocumentsRowFields_OtherDocument_Fragment } }
        )
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Proforma_Fragment': TableDocumentsRowFields_Proforma_Fragment } }
        )
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Receipt_Fragment': TableDocumentsRowFields_Receipt_Fragment } }
        )
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Unprocessed_Fragment': TableDocumentsRowFields_Unprocessed_Fragment } }
        )
      > }
    | { id: string, transactions: Array<
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_CommonTransaction_Fragment': TransactionForTransactionsTableFields_CommonTransaction_Fragment } }
        )
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_ConversionTransaction_Fragment': TransactionForTransactionsTableFields_ConversionTransaction_Fragment } }
        )
      >, additionalDocuments: Array<
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_CreditInvoice_Fragment': TableDocumentsRowFields_CreditInvoice_Fragment } }
        )
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Invoice_Fragment': TableDocumentsRowFields_Invoice_Fragment } }
        )
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_InvoiceReceipt_Fragment': TableDocumentsRowFields_InvoiceReceipt_Fragment } }
        )
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_OtherDocument_Fragment': TableDocumentsRowFields_OtherDocument_Fragment } }
        )
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Proforma_Fragment': TableDocumentsRowFields_Proforma_Fragment } }
        )
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Receipt_Fragment': TableDocumentsRowFields_Receipt_Fragment } }
        )
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Unprocessed_Fragment': TableDocumentsRowFields_Unprocessed_Fragment } }
        )
      > }
    | { id: string, transactions: Array<
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_CommonTransaction_Fragment': TransactionForTransactionsTableFields_CommonTransaction_Fragment } }
        )
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_ConversionTransaction_Fragment': TransactionForTransactionsTableFields_ConversionTransaction_Fragment } }
        )
      >, additionalDocuments: Array<
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_CreditInvoice_Fragment': TableDocumentsRowFields_CreditInvoice_Fragment } }
        )
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Invoice_Fragment': TableDocumentsRowFields_Invoice_Fragment } }
        )
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_InvoiceReceipt_Fragment': TableDocumentsRowFields_InvoiceReceipt_Fragment } }
        )
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_OtherDocument_Fragment': TableDocumentsRowFields_OtherDocument_Fragment } }
        )
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Proforma_Fragment': TableDocumentsRowFields_Proforma_Fragment } }
        )
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Receipt_Fragment': TableDocumentsRowFields_Receipt_Fragment } }
        )
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Unprocessed_Fragment': TableDocumentsRowFields_Unprocessed_Fragment } }
        )
      > }
    | { id: string, transactions: Array<
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_CommonTransaction_Fragment': TransactionForTransactionsTableFields_CommonTransaction_Fragment } }
        )
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_ConversionTransaction_Fragment': TransactionForTransactionsTableFields_ConversionTransaction_Fragment } }
        )
      >, additionalDocuments: Array<
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_CreditInvoice_Fragment': TableDocumentsRowFields_CreditInvoice_Fragment } }
        )
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Invoice_Fragment': TableDocumentsRowFields_Invoice_Fragment } }
        )
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_InvoiceReceipt_Fragment': TableDocumentsRowFields_InvoiceReceipt_Fragment } }
        )
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_OtherDocument_Fragment': TableDocumentsRowFields_OtherDocument_Fragment } }
        )
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Proforma_Fragment': TableDocumentsRowFields_Proforma_Fragment } }
        )
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Receipt_Fragment': TableDocumentsRowFields_Receipt_Fragment } }
        )
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Unprocessed_Fragment': TableDocumentsRowFields_Unprocessed_Fragment } }
        )
      > }
    | { id: string, transactions: Array<
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_CommonTransaction_Fragment': TransactionForTransactionsTableFields_CommonTransaction_Fragment } }
        )
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_ConversionTransaction_Fragment': TransactionForTransactionsTableFields_ConversionTransaction_Fragment } }
        )
      >, additionalDocuments: Array<
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_CreditInvoice_Fragment': TableDocumentsRowFields_CreditInvoice_Fragment } }
        )
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Invoice_Fragment': TableDocumentsRowFields_Invoice_Fragment } }
        )
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_InvoiceReceipt_Fragment': TableDocumentsRowFields_InvoiceReceipt_Fragment } }
        )
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_OtherDocument_Fragment': TableDocumentsRowFields_OtherDocument_Fragment } }
        )
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Proforma_Fragment': TableDocumentsRowFields_Proforma_Fragment } }
        )
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Receipt_Fragment': TableDocumentsRowFields_Receipt_Fragment } }
        )
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Unprocessed_Fragment': TableDocumentsRowFields_Unprocessed_Fragment } }
        )
      > }
    | { id: string, transactions: Array<
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_CommonTransaction_Fragment': TransactionForTransactionsTableFields_CommonTransaction_Fragment } }
        )
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_ConversionTransaction_Fragment': TransactionForTransactionsTableFields_ConversionTransaction_Fragment } }
        )
      >, additionalDocuments: Array<
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_CreditInvoice_Fragment': TableDocumentsRowFields_CreditInvoice_Fragment } }
        )
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Invoice_Fragment': TableDocumentsRowFields_Invoice_Fragment } }
        )
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_InvoiceReceipt_Fragment': TableDocumentsRowFields_InvoiceReceipt_Fragment } }
        )
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_OtherDocument_Fragment': TableDocumentsRowFields_OtherDocument_Fragment } }
        )
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Proforma_Fragment': TableDocumentsRowFields_Proforma_Fragment } }
        )
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Receipt_Fragment': TableDocumentsRowFields_Receipt_Fragment } }
        )
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Unprocessed_Fragment': TableDocumentsRowFields_Unprocessed_Fragment } }
        )
      > }
    | { id: string, transactions: Array<
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_CommonTransaction_Fragment': TransactionForTransactionsTableFields_CommonTransaction_Fragment } }
        )
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_ConversionTransaction_Fragment': TransactionForTransactionsTableFields_ConversionTransaction_Fragment } }
        )
      >, additionalDocuments: Array<
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_CreditInvoice_Fragment': TableDocumentsRowFields_CreditInvoice_Fragment } }
        )
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Invoice_Fragment': TableDocumentsRowFields_Invoice_Fragment } }
        )
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_InvoiceReceipt_Fragment': TableDocumentsRowFields_InvoiceReceipt_Fragment } }
        )
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_OtherDocument_Fragment': TableDocumentsRowFields_OtherDocument_Fragment } }
        )
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Proforma_Fragment': TableDocumentsRowFields_Proforma_Fragment } }
        )
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Receipt_Fragment': TableDocumentsRowFields_Receipt_Fragment } }
        )
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Unprocessed_Fragment': TableDocumentsRowFields_Unprocessed_Fragment } }
        )
      > }
    | { id: string, transactions: Array<
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_CommonTransaction_Fragment': TransactionForTransactionsTableFields_CommonTransaction_Fragment } }
        )
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_ConversionTransaction_Fragment': TransactionForTransactionsTableFields_ConversionTransaction_Fragment } }
        )
      >, additionalDocuments: Array<
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_CreditInvoice_Fragment': TableDocumentsRowFields_CreditInvoice_Fragment } }
        )
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Invoice_Fragment': TableDocumentsRowFields_Invoice_Fragment } }
        )
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_InvoiceReceipt_Fragment': TableDocumentsRowFields_InvoiceReceipt_Fragment } }
        )
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_OtherDocument_Fragment': TableDocumentsRowFields_OtherDocument_Fragment } }
        )
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Proforma_Fragment': TableDocumentsRowFields_Proforma_Fragment } }
        )
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Receipt_Fragment': TableDocumentsRowFields_Receipt_Fragment } }
        )
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Unprocessed_Fragment': TableDocumentsRowFields_Unprocessed_Fragment } }
        )
      > }
    | { id: string, transactions: Array<
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_CommonTransaction_Fragment': TransactionForTransactionsTableFields_CommonTransaction_Fragment } }
        )
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_ConversionTransaction_Fragment': TransactionForTransactionsTableFields_ConversionTransaction_Fragment } }
        )
      >, additionalDocuments: Array<
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_CreditInvoice_Fragment': TableDocumentsRowFields_CreditInvoice_Fragment } }
        )
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Invoice_Fragment': TableDocumentsRowFields_Invoice_Fragment } }
        )
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_InvoiceReceipt_Fragment': TableDocumentsRowFields_InvoiceReceipt_Fragment } }
        )
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_OtherDocument_Fragment': TableDocumentsRowFields_OtherDocument_Fragment } }
        )
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Proforma_Fragment': TableDocumentsRowFields_Proforma_Fragment } }
        )
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Receipt_Fragment': TableDocumentsRowFields_Receipt_Fragment } }
        )
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Unprocessed_Fragment': TableDocumentsRowFields_Unprocessed_Fragment } }
        )
      > }
   };

type ChargeMatchCardFields_BankDepositCharge_Fragment = { __typename: 'BankDepositCharge', id: string, minEventDate: unknown, minDebitDate: unknown, minDocumentsDate: unknown, userDescription: string | null, totalAmount: { raw: number, formatted: string, currency: Currency } | null, counterparty:
    | { id: string, name: string }
    | { id: string, name: string }
    | { id: string, name: string }
   | null, additionalDocuments: Array<
    | { id: string, documentType: DocumentType | null, image: unknown, file: unknown }
    | { id: string, documentType: DocumentType | null, image: unknown, file: unknown }
    | { id: string, documentType: DocumentType | null, image: unknown, file: unknown }
    | { id: string, documentType: DocumentType | null, image: unknown, file: unknown }
    | { id: string, documentType: DocumentType | null, image: unknown, file: unknown }
    | { id: string, documentType: DocumentType | null, image: unknown, file: unknown }
    | { id: string, documentType: DocumentType | null, image: unknown, file: unknown }
  >, transactions: Array<
    | { id: string, eventDate: unknown, sourceDescription: string, amount: { raw: number, formatted: string } }
    | { id: string, eventDate: unknown, sourceDescription: string, amount: { raw: number, formatted: string } }
  >, miscExpenses: Array<{ id: string, description: string | null, amount: { formatted: string } }> } & { ' $fragmentName'?: 'ChargeMatchCardFields_BankDepositCharge_Fragment' };

type ChargeMatchCardFields_BusinessTripCharge_Fragment = { __typename: 'BusinessTripCharge', id: string, minEventDate: unknown, minDebitDate: unknown, minDocumentsDate: unknown, userDescription: string | null, totalAmount: { raw: number, formatted: string, currency: Currency } | null, counterparty:
    | { id: string, name: string }
    | { id: string, name: string }
    | { id: string, name: string }
   | null, additionalDocuments: Array<
    | { id: string, documentType: DocumentType | null, image: unknown, file: unknown }
    | { id: string, documentType: DocumentType | null, image: unknown, file: unknown }
    | { id: string, documentType: DocumentType | null, image: unknown, file: unknown }
    | { id: string, documentType: DocumentType | null, image: unknown, file: unknown }
    | { id: string, documentType: DocumentType | null, image: unknown, file: unknown }
    | { id: string, documentType: DocumentType | null, image: unknown, file: unknown }
    | { id: string, documentType: DocumentType | null, image: unknown, file: unknown }
  >, transactions: Array<
    | { id: string, eventDate: unknown, sourceDescription: string, amount: { raw: number, formatted: string } }
    | { id: string, eventDate: unknown, sourceDescription: string, amount: { raw: number, formatted: string } }
  >, miscExpenses: Array<{ id: string, description: string | null, amount: { formatted: string } }> } & { ' $fragmentName'?: 'ChargeMatchCardFields_BusinessTripCharge_Fragment' };

type ChargeMatchCardFields_CommonCharge_Fragment = { __typename: 'CommonCharge', id: string, minEventDate: unknown, minDebitDate: unknown, minDocumentsDate: unknown, userDescription: string | null, totalAmount: { raw: number, formatted: string, currency: Currency } | null, counterparty:
    | { id: string, name: string }
    | { id: string, name: string }
    | { id: string, name: string }
   | null, additionalDocuments: Array<
    | { id: string, documentType: DocumentType | null, image: unknown, file: unknown }
    | { id: string, documentType: DocumentType | null, image: unknown, file: unknown }
    | { id: string, documentType: DocumentType | null, image: unknown, file: unknown }
    | { id: string, documentType: DocumentType | null, image: unknown, file: unknown }
    | { id: string, documentType: DocumentType | null, image: unknown, file: unknown }
    | { id: string, documentType: DocumentType | null, image: unknown, file: unknown }
    | { id: string, documentType: DocumentType | null, image: unknown, file: unknown }
  >, transactions: Array<
    | { id: string, eventDate: unknown, sourceDescription: string, amount: { raw: number, formatted: string } }
    | { id: string, eventDate: unknown, sourceDescription: string, amount: { raw: number, formatted: string } }
  >, miscExpenses: Array<{ id: string, description: string | null, amount: { formatted: string } }> } & { ' $fragmentName'?: 'ChargeMatchCardFields_CommonCharge_Fragment' };

type ChargeMatchCardFields_ConversionCharge_Fragment = { __typename: 'ConversionCharge', id: string, minEventDate: unknown, minDebitDate: unknown, minDocumentsDate: unknown, userDescription: string | null, totalAmount: { raw: number, formatted: string, currency: Currency } | null, counterparty:
    | { id: string, name: string }
    | { id: string, name: string }
    | { id: string, name: string }
   | null, additionalDocuments: Array<
    | { id: string, documentType: DocumentType | null, image: unknown, file: unknown }
    | { id: string, documentType: DocumentType | null, image: unknown, file: unknown }
    | { id: string, documentType: DocumentType | null, image: unknown, file: unknown }
    | { id: string, documentType: DocumentType | null, image: unknown, file: unknown }
    | { id: string, documentType: DocumentType | null, image: unknown, file: unknown }
    | { id: string, documentType: DocumentType | null, image: unknown, file: unknown }
    | { id: string, documentType: DocumentType | null, image: unknown, file: unknown }
  >, transactions: Array<
    | { id: string, eventDate: unknown, sourceDescription: string, amount: { raw: number, formatted: string } }
    | { id: string, eventDate: unknown, sourceDescription: string, amount: { raw: number, formatted: string } }
  >, miscExpenses: Array<{ id: string, description: string | null, amount: { formatted: string } }> } & { ' $fragmentName'?: 'ChargeMatchCardFields_ConversionCharge_Fragment' };

type ChargeMatchCardFields_CreditcardBankCharge_Fragment = { __typename: 'CreditcardBankCharge', id: string, minEventDate: unknown, minDebitDate: unknown, minDocumentsDate: unknown, userDescription: string | null, totalAmount: { raw: number, formatted: string, currency: Currency } | null, counterparty:
    | { id: string, name: string }
    | { id: string, name: string }
    | { id: string, name: string }
   | null, additionalDocuments: Array<
    | { id: string, documentType: DocumentType | null, image: unknown, file: unknown }
    | { id: string, documentType: DocumentType | null, image: unknown, file: unknown }
    | { id: string, documentType: DocumentType | null, image: unknown, file: unknown }
    | { id: string, documentType: DocumentType | null, image: unknown, file: unknown }
    | { id: string, documentType: DocumentType | null, image: unknown, file: unknown }
    | { id: string, documentType: DocumentType | null, image: unknown, file: unknown }
    | { id: string, documentType: DocumentType | null, image: unknown, file: unknown }
  >, transactions: Array<
    | { id: string, eventDate: unknown, sourceDescription: string, amount: { raw: number, formatted: string } }
    | { id: string, eventDate: unknown, sourceDescription: string, amount: { raw: number, formatted: string } }
  >, miscExpenses: Array<{ id: string, description: string | null, amount: { formatted: string } }> } & { ' $fragmentName'?: 'ChargeMatchCardFields_CreditcardBankCharge_Fragment' };

type ChargeMatchCardFields_DividendCharge_Fragment = { __typename: 'DividendCharge', id: string, minEventDate: unknown, minDebitDate: unknown, minDocumentsDate: unknown, userDescription: string | null, totalAmount: { raw: number, formatted: string, currency: Currency } | null, counterparty:
    | { id: string, name: string }
    | { id: string, name: string }
    | { id: string, name: string }
   | null, additionalDocuments: Array<
    | { id: string, documentType: DocumentType | null, image: unknown, file: unknown }
    | { id: string, documentType: DocumentType | null, image: unknown, file: unknown }
    | { id: string, documentType: DocumentType | null, image: unknown, file: unknown }
    | { id: string, documentType: DocumentType | null, image: unknown, file: unknown }
    | { id: string, documentType: DocumentType | null, image: unknown, file: unknown }
    | { id: string, documentType: DocumentType | null, image: unknown, file: unknown }
    | { id: string, documentType: DocumentType | null, image: unknown, file: unknown }
  >, transactions: Array<
    | { id: string, eventDate: unknown, sourceDescription: string, amount: { raw: number, formatted: string } }
    | { id: string, eventDate: unknown, sourceDescription: string, amount: { raw: number, formatted: string } }
  >, miscExpenses: Array<{ id: string, description: string | null, amount: { formatted: string } }> } & { ' $fragmentName'?: 'ChargeMatchCardFields_DividendCharge_Fragment' };

type ChargeMatchCardFields_FinancialCharge_Fragment = { __typename: 'FinancialCharge', id: string, minEventDate: unknown, minDebitDate: unknown, minDocumentsDate: unknown, userDescription: string | null, totalAmount: { raw: number, formatted: string, currency: Currency } | null, counterparty:
    | { id: string, name: string }
    | { id: string, name: string }
    | { id: string, name: string }
   | null, additionalDocuments: Array<
    | { id: string, documentType: DocumentType | null, image: unknown, file: unknown }
    | { id: string, documentType: DocumentType | null, image: unknown, file: unknown }
    | { id: string, documentType: DocumentType | null, image: unknown, file: unknown }
    | { id: string, documentType: DocumentType | null, image: unknown, file: unknown }
    | { id: string, documentType: DocumentType | null, image: unknown, file: unknown }
    | { id: string, documentType: DocumentType | null, image: unknown, file: unknown }
    | { id: string, documentType: DocumentType | null, image: unknown, file: unknown }
  >, transactions: Array<
    | { id: string, eventDate: unknown, sourceDescription: string, amount: { raw: number, formatted: string } }
    | { id: string, eventDate: unknown, sourceDescription: string, amount: { raw: number, formatted: string } }
  >, miscExpenses: Array<{ id: string, description: string | null, amount: { formatted: string } }> } & { ' $fragmentName'?: 'ChargeMatchCardFields_FinancialCharge_Fragment' };

type ChargeMatchCardFields_ForeignSecuritiesCharge_Fragment = { __typename: 'ForeignSecuritiesCharge', id: string, minEventDate: unknown, minDebitDate: unknown, minDocumentsDate: unknown, userDescription: string | null, totalAmount: { raw: number, formatted: string, currency: Currency } | null, counterparty:
    | { id: string, name: string }
    | { id: string, name: string }
    | { id: string, name: string }
   | null, additionalDocuments: Array<
    | { id: string, documentType: DocumentType | null, image: unknown, file: unknown }
    | { id: string, documentType: DocumentType | null, image: unknown, file: unknown }
    | { id: string, documentType: DocumentType | null, image: unknown, file: unknown }
    | { id: string, documentType: DocumentType | null, image: unknown, file: unknown }
    | { id: string, documentType: DocumentType | null, image: unknown, file: unknown }
    | { id: string, documentType: DocumentType | null, image: unknown, file: unknown }
    | { id: string, documentType: DocumentType | null, image: unknown, file: unknown }
  >, transactions: Array<
    | { id: string, eventDate: unknown, sourceDescription: string, amount: { raw: number, formatted: string } }
    | { id: string, eventDate: unknown, sourceDescription: string, amount: { raw: number, formatted: string } }
  >, miscExpenses: Array<{ id: string, description: string | null, amount: { formatted: string } }> } & { ' $fragmentName'?: 'ChargeMatchCardFields_ForeignSecuritiesCharge_Fragment' };

type ChargeMatchCardFields_InternalTransferCharge_Fragment = { __typename: 'InternalTransferCharge', id: string, minEventDate: unknown, minDebitDate: unknown, minDocumentsDate: unknown, userDescription: string | null, totalAmount: { raw: number, formatted: string, currency: Currency } | null, counterparty:
    | { id: string, name: string }
    | { id: string, name: string }
    | { id: string, name: string }
   | null, additionalDocuments: Array<
    | { id: string, documentType: DocumentType | null, image: unknown, file: unknown }
    | { id: string, documentType: DocumentType | null, image: unknown, file: unknown }
    | { id: string, documentType: DocumentType | null, image: unknown, file: unknown }
    | { id: string, documentType: DocumentType | null, image: unknown, file: unknown }
    | { id: string, documentType: DocumentType | null, image: unknown, file: unknown }
    | { id: string, documentType: DocumentType | null, image: unknown, file: unknown }
    | { id: string, documentType: DocumentType | null, image: unknown, file: unknown }
  >, transactions: Array<
    | { id: string, eventDate: unknown, sourceDescription: string, amount: { raw: number, formatted: string } }
    | { id: string, eventDate: unknown, sourceDescription: string, amount: { raw: number, formatted: string } }
  >, miscExpenses: Array<{ id: string, description: string | null, amount: { formatted: string } }> } & { ' $fragmentName'?: 'ChargeMatchCardFields_InternalTransferCharge_Fragment' };

type ChargeMatchCardFields_MonthlyVatCharge_Fragment = { __typename: 'MonthlyVatCharge', id: string, minEventDate: unknown, minDebitDate: unknown, minDocumentsDate: unknown, userDescription: string | null, totalAmount: { raw: number, formatted: string, currency: Currency } | null, counterparty:
    | { id: string, name: string }
    | { id: string, name: string }
    | { id: string, name: string }
   | null, additionalDocuments: Array<
    | { id: string, documentType: DocumentType | null, image: unknown, file: unknown }
    | { id: string, documentType: DocumentType | null, image: unknown, file: unknown }
    | { id: string, documentType: DocumentType | null, image: unknown, file: unknown }
    | { id: string, documentType: DocumentType | null, image: unknown, file: unknown }
    | { id: string, documentType: DocumentType | null, image: unknown, file: unknown }
    | { id: string, documentType: DocumentType | null, image: unknown, file: unknown }
    | { id: string, documentType: DocumentType | null, image: unknown, file: unknown }
  >, transactions: Array<
    | { id: string, eventDate: unknown, sourceDescription: string, amount: { raw: number, formatted: string } }
    | { id: string, eventDate: unknown, sourceDescription: string, amount: { raw: number, formatted: string } }
  >, miscExpenses: Array<{ id: string, description: string | null, amount: { formatted: string } }> } & { ' $fragmentName'?: 'ChargeMatchCardFields_MonthlyVatCharge_Fragment' };

type ChargeMatchCardFields_SalaryCharge_Fragment = { __typename: 'SalaryCharge', id: string, minEventDate: unknown, minDebitDate: unknown, minDocumentsDate: unknown, userDescription: string | null, totalAmount: { raw: number, formatted: string, currency: Currency } | null, counterparty:
    | { id: string, name: string }
    | { id: string, name: string }
    | { id: string, name: string }
   | null, additionalDocuments: Array<
    | { id: string, documentType: DocumentType | null, image: unknown, file: unknown }
    | { id: string, documentType: DocumentType | null, image: unknown, file: unknown }
    | { id: string, documentType: DocumentType | null, image: unknown, file: unknown }
    | { id: string, documentType: DocumentType | null, image: unknown, file: unknown }
    | { id: string, documentType: DocumentType | null, image: unknown, file: unknown }
    | { id: string, documentType: DocumentType | null, image: unknown, file: unknown }
    | { id: string, documentType: DocumentType | null, image: unknown, file: unknown }
  >, transactions: Array<
    | { id: string, eventDate: unknown, sourceDescription: string, amount: { raw: number, formatted: string } }
    | { id: string, eventDate: unknown, sourceDescription: string, amount: { raw: number, formatted: string } }
  >, miscExpenses: Array<{ id: string, description: string | null, amount: { formatted: string } }> } & { ' $fragmentName'?: 'ChargeMatchCardFields_SalaryCharge_Fragment' };

export type ChargeMatchCardFieldsFragment =
  | ChargeMatchCardFields_BankDepositCharge_Fragment
  | ChargeMatchCardFields_BusinessTripCharge_Fragment
  | ChargeMatchCardFields_CommonCharge_Fragment
  | ChargeMatchCardFields_ConversionCharge_Fragment
  | ChargeMatchCardFields_CreditcardBankCharge_Fragment
  | ChargeMatchCardFields_DividendCharge_Fragment
  | ChargeMatchCardFields_FinancialCharge_Fragment
  | ChargeMatchCardFields_ForeignSecuritiesCharge_Fragment
  | ChargeMatchCardFields_InternalTransferCharge_Fragment
  | ChargeMatchCardFields_MonthlyVatCharge_Fragment
  | ChargeMatchCardFields_SalaryCharge_Fragment
;

export type ChargesAwaitingMatchQueueQueryVariables = Exact<{
  limit?: number | null | undefined;
  offset?: number | null | undefined;
  businessId?: string | null | undefined;
  fromDate?: unknown;
  toDate?: unknown;
  mode?: ChargeMatchQueueMode | null | undefined;
  sortBy?: ChargeMatchQueueSortBy | null | undefined;
}>;


export type ChargesAwaitingMatchQueueQuery = { chargesAwaitingMatchQueue: { totalCount: number, baseCharges: Array<{ id: string, baseCharge:
        | { ' $fragmentRefs'?: { 'ChargeMatchCardFields_BankDepositCharge_Fragment': ChargeMatchCardFields_BankDepositCharge_Fragment } }
        | { ' $fragmentRefs'?: { 'ChargeMatchCardFields_BusinessTripCharge_Fragment': ChargeMatchCardFields_BusinessTripCharge_Fragment } }
        | { ' $fragmentRefs'?: { 'ChargeMatchCardFields_CommonCharge_Fragment': ChargeMatchCardFields_CommonCharge_Fragment } }
        | { ' $fragmentRefs'?: { 'ChargeMatchCardFields_ConversionCharge_Fragment': ChargeMatchCardFields_ConversionCharge_Fragment } }
        | { ' $fragmentRefs'?: { 'ChargeMatchCardFields_CreditcardBankCharge_Fragment': ChargeMatchCardFields_CreditcardBankCharge_Fragment } }
        | { ' $fragmentRefs'?: { 'ChargeMatchCardFields_DividendCharge_Fragment': ChargeMatchCardFields_DividendCharge_Fragment } }
        | { ' $fragmentRefs'?: { 'ChargeMatchCardFields_FinancialCharge_Fragment': ChargeMatchCardFields_FinancialCharge_Fragment } }
        | { ' $fragmentRefs'?: { 'ChargeMatchCardFields_ForeignSecuritiesCharge_Fragment': ChargeMatchCardFields_ForeignSecuritiesCharge_Fragment } }
        | { ' $fragmentRefs'?: { 'ChargeMatchCardFields_InternalTransferCharge_Fragment': ChargeMatchCardFields_InternalTransferCharge_Fragment } }
        | { ' $fragmentRefs'?: { 'ChargeMatchCardFields_MonthlyVatCharge_Fragment': ChargeMatchCardFields_MonthlyVatCharge_Fragment } }
        | { ' $fragmentRefs'?: { 'ChargeMatchCardFields_SalaryCharge_Fragment': ChargeMatchCardFields_SalaryCharge_Fragment } }
      , suggestions: Array<{ chargeId: string, confidenceScore: number, charge:
          | { ' $fragmentRefs'?: { 'ChargeMatchCardFields_BankDepositCharge_Fragment': ChargeMatchCardFields_BankDepositCharge_Fragment } }
          | { ' $fragmentRefs'?: { 'ChargeMatchCardFields_BusinessTripCharge_Fragment': ChargeMatchCardFields_BusinessTripCharge_Fragment } }
          | { ' $fragmentRefs'?: { 'ChargeMatchCardFields_CommonCharge_Fragment': ChargeMatchCardFields_CommonCharge_Fragment } }
          | { ' $fragmentRefs'?: { 'ChargeMatchCardFields_ConversionCharge_Fragment': ChargeMatchCardFields_ConversionCharge_Fragment } }
          | { ' $fragmentRefs'?: { 'ChargeMatchCardFields_CreditcardBankCharge_Fragment': ChargeMatchCardFields_CreditcardBankCharge_Fragment } }
          | { ' $fragmentRefs'?: { 'ChargeMatchCardFields_DividendCharge_Fragment': ChargeMatchCardFields_DividendCharge_Fragment } }
          | { ' $fragmentRefs'?: { 'ChargeMatchCardFields_FinancialCharge_Fragment': ChargeMatchCardFields_FinancialCharge_Fragment } }
          | { ' $fragmentRefs'?: { 'ChargeMatchCardFields_ForeignSecuritiesCharge_Fragment': ChargeMatchCardFields_ForeignSecuritiesCharge_Fragment } }
          | { ' $fragmentRefs'?: { 'ChargeMatchCardFields_InternalTransferCharge_Fragment': ChargeMatchCardFields_InternalTransferCharge_Fragment } }
          | { ' $fragmentRefs'?: { 'ChargeMatchCardFields_MonthlyVatCharge_Fragment': ChargeMatchCardFields_MonthlyVatCharge_Fragment } }
          | { ' $fragmentRefs'?: { 'ChargeMatchCardFields_SalaryCharge_Fragment': ChargeMatchCardFields_SalaryCharge_Fragment } }
         }> }> } };

export type ChargesLedgerValidationQueryVariables = Exact<{
  limit?: number | null | undefined;
  filters?: ChargeFilter | null | undefined;
}>;


export type ChargesLedgerValidationQuery = { chargesWithLedgerChanges: Array<{ progress: number, charge:
      | (
        { id: string }
        & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_BankDepositCharge_Fragment': ChargeForChargesTableFields_BankDepositCharge_Fragment } }
      )
      | (
        { id: string }
        & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_BusinessTripCharge_Fragment': ChargeForChargesTableFields_BusinessTripCharge_Fragment } }
      )
      | (
        { id: string }
        & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_CommonCharge_Fragment': ChargeForChargesTableFields_CommonCharge_Fragment } }
      )
      | (
        { id: string }
        & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_ConversionCharge_Fragment': ChargeForChargesTableFields_ConversionCharge_Fragment } }
      )
      | (
        { id: string }
        & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_CreditcardBankCharge_Fragment': ChargeForChargesTableFields_CreditcardBankCharge_Fragment } }
      )
      | (
        { id: string }
        & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_DividendCharge_Fragment': ChargeForChargesTableFields_DividendCharge_Fragment } }
      )
      | (
        { id: string }
        & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_FinancialCharge_Fragment': ChargeForChargesTableFields_FinancialCharge_Fragment } }
      )
      | (
        { id: string }
        & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_ForeignSecuritiesCharge_Fragment': ChargeForChargesTableFields_ForeignSecuritiesCharge_Fragment } }
      )
      | (
        { id: string }
        & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_InternalTransferCharge_Fragment': ChargeForChargesTableFields_InternalTransferCharge_Fragment } }
      )
      | (
        { id: string }
        & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_MonthlyVatCharge_Fragment': ChargeForChargesTableFields_MonthlyVatCharge_Fragment } }
      )
      | (
        { id: string }
        & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_SalaryCharge_Fragment': ChargeForChargesTableFields_SalaryCharge_Fragment } }
      )
     | null }> };

type ChargesTableErrorsFields_BankDepositCharge_Fragment = { id: string, errorsLedger: { validate: { errors: Array<string> } } } & { ' $fragmentName'?: 'ChargesTableErrorsFields_BankDepositCharge_Fragment' };

type ChargesTableErrorsFields_BusinessTripCharge_Fragment = { id: string, errorsLedger: { validate: { errors: Array<string> } } } & { ' $fragmentName'?: 'ChargesTableErrorsFields_BusinessTripCharge_Fragment' };

type ChargesTableErrorsFields_CommonCharge_Fragment = { id: string, errorsLedger: { validate: { errors: Array<string> } } } & { ' $fragmentName'?: 'ChargesTableErrorsFields_CommonCharge_Fragment' };

type ChargesTableErrorsFields_ConversionCharge_Fragment = { id: string, errorsLedger: { validate: { errors: Array<string> } } } & { ' $fragmentName'?: 'ChargesTableErrorsFields_ConversionCharge_Fragment' };

type ChargesTableErrorsFields_CreditcardBankCharge_Fragment = { id: string, errorsLedger: { validate: { errors: Array<string> } } } & { ' $fragmentName'?: 'ChargesTableErrorsFields_CreditcardBankCharge_Fragment' };

type ChargesTableErrorsFields_DividendCharge_Fragment = { id: string, errorsLedger: { validate: { errors: Array<string> } } } & { ' $fragmentName'?: 'ChargesTableErrorsFields_DividendCharge_Fragment' };

type ChargesTableErrorsFields_FinancialCharge_Fragment = { id: string, errorsLedger: { validate: { errors: Array<string> } } } & { ' $fragmentName'?: 'ChargesTableErrorsFields_FinancialCharge_Fragment' };

type ChargesTableErrorsFields_ForeignSecuritiesCharge_Fragment = { id: string, errorsLedger: { validate: { errors: Array<string> } } } & { ' $fragmentName'?: 'ChargesTableErrorsFields_ForeignSecuritiesCharge_Fragment' };

type ChargesTableErrorsFields_InternalTransferCharge_Fragment = { id: string, errorsLedger: { validate: { errors: Array<string> } } } & { ' $fragmentName'?: 'ChargesTableErrorsFields_InternalTransferCharge_Fragment' };

type ChargesTableErrorsFields_MonthlyVatCharge_Fragment = { id: string, errorsLedger: { validate: { errors: Array<string> } } } & { ' $fragmentName'?: 'ChargesTableErrorsFields_MonthlyVatCharge_Fragment' };

type ChargesTableErrorsFields_SalaryCharge_Fragment = { id: string, errorsLedger: { validate: { errors: Array<string> } } } & { ' $fragmentName'?: 'ChargesTableErrorsFields_SalaryCharge_Fragment' };

export type ChargesTableErrorsFieldsFragment =
  | ChargesTableErrorsFields_BankDepositCharge_Fragment
  | ChargesTableErrorsFields_BusinessTripCharge_Fragment
  | ChargesTableErrorsFields_CommonCharge_Fragment
  | ChargesTableErrorsFields_ConversionCharge_Fragment
  | ChargesTableErrorsFields_CreditcardBankCharge_Fragment
  | ChargesTableErrorsFields_DividendCharge_Fragment
  | ChargesTableErrorsFields_FinancialCharge_Fragment
  | ChargesTableErrorsFields_ForeignSecuritiesCharge_Fragment
  | ChargesTableErrorsFields_InternalTransferCharge_Fragment
  | ChargesTableErrorsFields_MonthlyVatCharge_Fragment
  | ChargesTableErrorsFields_SalaryCharge_Fragment
;

export type FetchChargeQueryVariables = Exact<{
  chargeId: string;
}>;


export type FetchChargeQuery = { charge:
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'ChargeExpansionFields_BankDepositCharge_Fragment': ChargeExpansionFields_BankDepositCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'ChargeExpansionFields_BusinessTripCharge_Fragment': ChargeExpansionFields_BusinessTripCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'ChargeExpansionFields_CommonCharge_Fragment': ChargeExpansionFields_CommonCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'ChargeExpansionFields_ConversionCharge_Fragment': ChargeExpansionFields_ConversionCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'ChargeExpansionFields_CreditcardBankCharge_Fragment': ChargeExpansionFields_CreditcardBankCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'ChargeExpansionFields_DividendCharge_Fragment': ChargeExpansionFields_DividendCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'ChargeExpansionFields_FinancialCharge_Fragment': ChargeExpansionFields_FinancialCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'ChargeExpansionFields_ForeignSecuritiesCharge_Fragment': ChargeExpansionFields_ForeignSecuritiesCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'ChargeExpansionFields_InternalTransferCharge_Fragment': ChargeExpansionFields_InternalTransferCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'ChargeExpansionFields_MonthlyVatCharge_Fragment': ChargeExpansionFields_MonthlyVatCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'ChargeExpansionFields_SalaryCharge_Fragment': ChargeExpansionFields_SalaryCharge_Fragment } }
    )
   };

type ChargeExpansionFields_BankDepositCharge_Fragment = { __typename: 'BankDepositCharge', id: string, metadata: { transactionsCount: number, documentsCount: number, receiptsCount: number, invoicesCount: number, ledgerCount: number, miscExpensesCount: number, isLedgerLocked: boolean, openDocuments: boolean } | null, totalAmount: { raw: number } | null } & { ' $fragmentRefs'?: { 'DocumentsGalleryFields_BankDepositCharge_Fragment': Incremental<DocumentsGalleryFields_BankDepositCharge_Fragment> } } & { ' $fragmentRefs'?: { 'TableDocumentsFields_BankDepositCharge_Fragment': Incremental<TableDocumentsFields_BankDepositCharge_Fragment> } } & { ' $fragmentRefs'?: { 'ChargeLedgerRecordsTableFields_BankDepositCharge_Fragment': Incremental<ChargeLedgerRecordsTableFields_BankDepositCharge_Fragment> } } & { ' $fragmentRefs'?: { 'ChargeTableTransactionsFields_BankDepositCharge_Fragment': Incremental<ChargeTableTransactionsFields_BankDepositCharge_Fragment> } } & { ' $fragmentRefs'?: { 'ConversionChargeInfo_BankDepositCharge_Fragment': Incremental<ConversionChargeInfo_BankDepositCharge_Fragment> } } & { ' $fragmentRefs'?: { 'CreditcardBankChargeInfo_BankDepositCharge_Fragment': Incremental<CreditcardBankChargeInfo_BankDepositCharge_Fragment> } } & { ' $fragmentRefs'?: { 'TableSalariesFields_BankDepositCharge_Fragment': Incremental<TableSalariesFields_BankDepositCharge_Fragment> } } & { ' $fragmentRefs'?: { 'ChargesTableErrorsFields_BankDepositCharge_Fragment': Incremental<ChargesTableErrorsFields_BankDepositCharge_Fragment> } } & { ' $fragmentRefs'?: { 'TableMiscExpensesFields_BankDepositCharge_Fragment': Incremental<TableMiscExpensesFields_BankDepositCharge_Fragment> } } & { ' $fragmentRefs'?: { 'ExchangeRatesInfo_BankDepositCharge_Fragment': Incremental<ExchangeRatesInfo_BankDepositCharge_Fragment> } } & { ' $fragmentName'?: 'ChargeExpansionFields_BankDepositCharge_Fragment' };

type ChargeExpansionFields_BusinessTripCharge_Fragment = { __typename: 'BusinessTripCharge', id: string, businessTrip: (
    { id: string }
    & { ' $fragmentRefs'?: { 'BusinessTripReportFieldsFragment': BusinessTripReportFieldsFragment } }
  ) | null, metadata: { transactionsCount: number, documentsCount: number, receiptsCount: number, invoicesCount: number, ledgerCount: number, miscExpensesCount: number, isLedgerLocked: boolean, openDocuments: boolean } | null, totalAmount: { raw: number } | null } & { ' $fragmentRefs'?: { 'DocumentsGalleryFields_BusinessTripCharge_Fragment': Incremental<DocumentsGalleryFields_BusinessTripCharge_Fragment> } } & { ' $fragmentRefs'?: { 'TableDocumentsFields_BusinessTripCharge_Fragment': Incremental<TableDocumentsFields_BusinessTripCharge_Fragment> } } & { ' $fragmentRefs'?: { 'ChargeLedgerRecordsTableFields_BusinessTripCharge_Fragment': Incremental<ChargeLedgerRecordsTableFields_BusinessTripCharge_Fragment> } } & { ' $fragmentRefs'?: { 'ChargeTableTransactionsFields_BusinessTripCharge_Fragment': Incremental<ChargeTableTransactionsFields_BusinessTripCharge_Fragment> } } & { ' $fragmentRefs'?: { 'ConversionChargeInfo_BusinessTripCharge_Fragment': Incremental<ConversionChargeInfo_BusinessTripCharge_Fragment> } } & { ' $fragmentRefs'?: { 'CreditcardBankChargeInfo_BusinessTripCharge_Fragment': Incremental<CreditcardBankChargeInfo_BusinessTripCharge_Fragment> } } & { ' $fragmentRefs'?: { 'TableSalariesFields_BusinessTripCharge_Fragment': Incremental<TableSalariesFields_BusinessTripCharge_Fragment> } } & { ' $fragmentRefs'?: { 'ChargesTableErrorsFields_BusinessTripCharge_Fragment': Incremental<ChargesTableErrorsFields_BusinessTripCharge_Fragment> } } & { ' $fragmentRefs'?: { 'TableMiscExpensesFields_BusinessTripCharge_Fragment': Incremental<TableMiscExpensesFields_BusinessTripCharge_Fragment> } } & { ' $fragmentRefs'?: { 'ExchangeRatesInfo_BusinessTripCharge_Fragment': Incremental<ExchangeRatesInfo_BusinessTripCharge_Fragment> } } & { ' $fragmentName'?: 'ChargeExpansionFields_BusinessTripCharge_Fragment' };

type ChargeExpansionFields_CommonCharge_Fragment = { __typename: 'CommonCharge', id: string, metadata: { transactionsCount: number, documentsCount: number, receiptsCount: number, invoicesCount: number, ledgerCount: number, miscExpensesCount: number, isLedgerLocked: boolean, openDocuments: boolean } | null, totalAmount: { raw: number } | null } & { ' $fragmentRefs'?: { 'DocumentsGalleryFields_CommonCharge_Fragment': Incremental<DocumentsGalleryFields_CommonCharge_Fragment> } } & { ' $fragmentRefs'?: { 'TableDocumentsFields_CommonCharge_Fragment': Incremental<TableDocumentsFields_CommonCharge_Fragment> } } & { ' $fragmentRefs'?: { 'ChargeLedgerRecordsTableFields_CommonCharge_Fragment': Incremental<ChargeLedgerRecordsTableFields_CommonCharge_Fragment> } } & { ' $fragmentRefs'?: { 'ChargeTableTransactionsFields_CommonCharge_Fragment': Incremental<ChargeTableTransactionsFields_CommonCharge_Fragment> } } & { ' $fragmentRefs'?: { 'ConversionChargeInfo_CommonCharge_Fragment': Incremental<ConversionChargeInfo_CommonCharge_Fragment> } } & { ' $fragmentRefs'?: { 'CreditcardBankChargeInfo_CommonCharge_Fragment': Incremental<CreditcardBankChargeInfo_CommonCharge_Fragment> } } & { ' $fragmentRefs'?: { 'TableSalariesFields_CommonCharge_Fragment': Incremental<TableSalariesFields_CommonCharge_Fragment> } } & { ' $fragmentRefs'?: { 'ChargesTableErrorsFields_CommonCharge_Fragment': Incremental<ChargesTableErrorsFields_CommonCharge_Fragment> } } & { ' $fragmentRefs'?: { 'TableMiscExpensesFields_CommonCharge_Fragment': Incremental<TableMiscExpensesFields_CommonCharge_Fragment> } } & { ' $fragmentRefs'?: { 'ExchangeRatesInfo_CommonCharge_Fragment': Incremental<ExchangeRatesInfo_CommonCharge_Fragment> } } & { ' $fragmentName'?: 'ChargeExpansionFields_CommonCharge_Fragment' };

type ChargeExpansionFields_ConversionCharge_Fragment = { __typename: 'ConversionCharge', id: string, metadata: { transactionsCount: number, documentsCount: number, receiptsCount: number, invoicesCount: number, ledgerCount: number, miscExpensesCount: number, isLedgerLocked: boolean, openDocuments: boolean } | null, totalAmount: { raw: number } | null } & { ' $fragmentRefs'?: { 'DocumentsGalleryFields_ConversionCharge_Fragment': Incremental<DocumentsGalleryFields_ConversionCharge_Fragment> } } & { ' $fragmentRefs'?: { 'TableDocumentsFields_ConversionCharge_Fragment': Incremental<TableDocumentsFields_ConversionCharge_Fragment> } } & { ' $fragmentRefs'?: { 'ChargeLedgerRecordsTableFields_ConversionCharge_Fragment': Incremental<ChargeLedgerRecordsTableFields_ConversionCharge_Fragment> } } & { ' $fragmentRefs'?: { 'ChargeTableTransactionsFields_ConversionCharge_Fragment': Incremental<ChargeTableTransactionsFields_ConversionCharge_Fragment> } } & { ' $fragmentRefs'?: { 'ConversionChargeInfo_ConversionCharge_Fragment': Incremental<ConversionChargeInfo_ConversionCharge_Fragment> } } & { ' $fragmentRefs'?: { 'CreditcardBankChargeInfo_ConversionCharge_Fragment': Incremental<CreditcardBankChargeInfo_ConversionCharge_Fragment> } } & { ' $fragmentRefs'?: { 'TableSalariesFields_ConversionCharge_Fragment': Incremental<TableSalariesFields_ConversionCharge_Fragment> } } & { ' $fragmentRefs'?: { 'ChargesTableErrorsFields_ConversionCharge_Fragment': Incremental<ChargesTableErrorsFields_ConversionCharge_Fragment> } } & { ' $fragmentRefs'?: { 'TableMiscExpensesFields_ConversionCharge_Fragment': Incremental<TableMiscExpensesFields_ConversionCharge_Fragment> } } & { ' $fragmentRefs'?: { 'ExchangeRatesInfo_ConversionCharge_Fragment': Incremental<ExchangeRatesInfo_ConversionCharge_Fragment> } } & { ' $fragmentName'?: 'ChargeExpansionFields_ConversionCharge_Fragment' };

type ChargeExpansionFields_CreditcardBankCharge_Fragment = { __typename: 'CreditcardBankCharge', id: string, metadata: { transactionsCount: number, documentsCount: number, receiptsCount: number, invoicesCount: number, ledgerCount: number, miscExpensesCount: number, isLedgerLocked: boolean, openDocuments: boolean } | null, totalAmount: { raw: number } | null } & { ' $fragmentRefs'?: { 'DocumentsGalleryFields_CreditcardBankCharge_Fragment': Incremental<DocumentsGalleryFields_CreditcardBankCharge_Fragment> } } & { ' $fragmentRefs'?: { 'TableDocumentsFields_CreditcardBankCharge_Fragment': Incremental<TableDocumentsFields_CreditcardBankCharge_Fragment> } } & { ' $fragmentRefs'?: { 'ChargeLedgerRecordsTableFields_CreditcardBankCharge_Fragment': Incremental<ChargeLedgerRecordsTableFields_CreditcardBankCharge_Fragment> } } & { ' $fragmentRefs'?: { 'ChargeTableTransactionsFields_CreditcardBankCharge_Fragment': Incremental<ChargeTableTransactionsFields_CreditcardBankCharge_Fragment> } } & { ' $fragmentRefs'?: { 'ConversionChargeInfo_CreditcardBankCharge_Fragment': Incremental<ConversionChargeInfo_CreditcardBankCharge_Fragment> } } & { ' $fragmentRefs'?: { 'CreditcardBankChargeInfo_CreditcardBankCharge_Fragment': Incremental<CreditcardBankChargeInfo_CreditcardBankCharge_Fragment> } } & { ' $fragmentRefs'?: { 'TableSalariesFields_CreditcardBankCharge_Fragment': Incremental<TableSalariesFields_CreditcardBankCharge_Fragment> } } & { ' $fragmentRefs'?: { 'ChargesTableErrorsFields_CreditcardBankCharge_Fragment': Incremental<ChargesTableErrorsFields_CreditcardBankCharge_Fragment> } } & { ' $fragmentRefs'?: { 'TableMiscExpensesFields_CreditcardBankCharge_Fragment': Incremental<TableMiscExpensesFields_CreditcardBankCharge_Fragment> } } & { ' $fragmentRefs'?: { 'ExchangeRatesInfo_CreditcardBankCharge_Fragment': Incremental<ExchangeRatesInfo_CreditcardBankCharge_Fragment> } } & { ' $fragmentName'?: 'ChargeExpansionFields_CreditcardBankCharge_Fragment' };

type ChargeExpansionFields_DividendCharge_Fragment = { __typename: 'DividendCharge', id: string, metadata: { transactionsCount: number, documentsCount: number, receiptsCount: number, invoicesCount: number, ledgerCount: number, miscExpensesCount: number, isLedgerLocked: boolean, openDocuments: boolean } | null, totalAmount: { raw: number } | null } & { ' $fragmentRefs'?: { 'DocumentsGalleryFields_DividendCharge_Fragment': Incremental<DocumentsGalleryFields_DividendCharge_Fragment> } } & { ' $fragmentRefs'?: { 'TableDocumentsFields_DividendCharge_Fragment': Incremental<TableDocumentsFields_DividendCharge_Fragment> } } & { ' $fragmentRefs'?: { 'ChargeLedgerRecordsTableFields_DividendCharge_Fragment': Incremental<ChargeLedgerRecordsTableFields_DividendCharge_Fragment> } } & { ' $fragmentRefs'?: { 'ChargeTableTransactionsFields_DividendCharge_Fragment': Incremental<ChargeTableTransactionsFields_DividendCharge_Fragment> } } & { ' $fragmentRefs'?: { 'ConversionChargeInfo_DividendCharge_Fragment': Incremental<ConversionChargeInfo_DividendCharge_Fragment> } } & { ' $fragmentRefs'?: { 'CreditcardBankChargeInfo_DividendCharge_Fragment': Incremental<CreditcardBankChargeInfo_DividendCharge_Fragment> } } & { ' $fragmentRefs'?: { 'TableSalariesFields_DividendCharge_Fragment': Incremental<TableSalariesFields_DividendCharge_Fragment> } } & { ' $fragmentRefs'?: { 'ChargesTableErrorsFields_DividendCharge_Fragment': Incremental<ChargesTableErrorsFields_DividendCharge_Fragment> } } & { ' $fragmentRefs'?: { 'TableMiscExpensesFields_DividendCharge_Fragment': Incremental<TableMiscExpensesFields_DividendCharge_Fragment> } } & { ' $fragmentRefs'?: { 'ExchangeRatesInfo_DividendCharge_Fragment': Incremental<ExchangeRatesInfo_DividendCharge_Fragment> } } & { ' $fragmentName'?: 'ChargeExpansionFields_DividendCharge_Fragment' };

type ChargeExpansionFields_FinancialCharge_Fragment = { __typename: 'FinancialCharge', id: string, metadata: { transactionsCount: number, documentsCount: number, receiptsCount: number, invoicesCount: number, ledgerCount: number, miscExpensesCount: number, isLedgerLocked: boolean, openDocuments: boolean } | null, totalAmount: { raw: number } | null } & { ' $fragmentRefs'?: { 'DocumentsGalleryFields_FinancialCharge_Fragment': Incremental<DocumentsGalleryFields_FinancialCharge_Fragment> } } & { ' $fragmentRefs'?: { 'TableDocumentsFields_FinancialCharge_Fragment': Incremental<TableDocumentsFields_FinancialCharge_Fragment> } } & { ' $fragmentRefs'?: { 'ChargeLedgerRecordsTableFields_FinancialCharge_Fragment': Incremental<ChargeLedgerRecordsTableFields_FinancialCharge_Fragment> } } & { ' $fragmentRefs'?: { 'ChargeTableTransactionsFields_FinancialCharge_Fragment': Incremental<ChargeTableTransactionsFields_FinancialCharge_Fragment> } } & { ' $fragmentRefs'?: { 'ConversionChargeInfo_FinancialCharge_Fragment': Incremental<ConversionChargeInfo_FinancialCharge_Fragment> } } & { ' $fragmentRefs'?: { 'CreditcardBankChargeInfo_FinancialCharge_Fragment': Incremental<CreditcardBankChargeInfo_FinancialCharge_Fragment> } } & { ' $fragmentRefs'?: { 'TableSalariesFields_FinancialCharge_Fragment': Incremental<TableSalariesFields_FinancialCharge_Fragment> } } & { ' $fragmentRefs'?: { 'ChargesTableErrorsFields_FinancialCharge_Fragment': Incremental<ChargesTableErrorsFields_FinancialCharge_Fragment> } } & { ' $fragmentRefs'?: { 'TableMiscExpensesFields_FinancialCharge_Fragment': Incremental<TableMiscExpensesFields_FinancialCharge_Fragment> } } & { ' $fragmentRefs'?: { 'ExchangeRatesInfo_FinancialCharge_Fragment': Incremental<ExchangeRatesInfo_FinancialCharge_Fragment> } } & { ' $fragmentName'?: 'ChargeExpansionFields_FinancialCharge_Fragment' };

type ChargeExpansionFields_ForeignSecuritiesCharge_Fragment = { __typename: 'ForeignSecuritiesCharge', id: string, metadata: { transactionsCount: number, documentsCount: number, receiptsCount: number, invoicesCount: number, ledgerCount: number, miscExpensesCount: number, isLedgerLocked: boolean, openDocuments: boolean } | null, totalAmount: { raw: number } | null } & { ' $fragmentRefs'?: { 'DocumentsGalleryFields_ForeignSecuritiesCharge_Fragment': Incremental<DocumentsGalleryFields_ForeignSecuritiesCharge_Fragment> } } & { ' $fragmentRefs'?: { 'TableDocumentsFields_ForeignSecuritiesCharge_Fragment': Incremental<TableDocumentsFields_ForeignSecuritiesCharge_Fragment> } } & { ' $fragmentRefs'?: { 'ChargeLedgerRecordsTableFields_ForeignSecuritiesCharge_Fragment': Incremental<ChargeLedgerRecordsTableFields_ForeignSecuritiesCharge_Fragment> } } & { ' $fragmentRefs'?: { 'ChargeTableTransactionsFields_ForeignSecuritiesCharge_Fragment': Incremental<ChargeTableTransactionsFields_ForeignSecuritiesCharge_Fragment> } } & { ' $fragmentRefs'?: { 'ConversionChargeInfo_ForeignSecuritiesCharge_Fragment': Incremental<ConversionChargeInfo_ForeignSecuritiesCharge_Fragment> } } & { ' $fragmentRefs'?: { 'CreditcardBankChargeInfo_ForeignSecuritiesCharge_Fragment': Incremental<CreditcardBankChargeInfo_ForeignSecuritiesCharge_Fragment> } } & { ' $fragmentRefs'?: { 'TableSalariesFields_ForeignSecuritiesCharge_Fragment': Incremental<TableSalariesFields_ForeignSecuritiesCharge_Fragment> } } & { ' $fragmentRefs'?: { 'ChargesTableErrorsFields_ForeignSecuritiesCharge_Fragment': Incremental<ChargesTableErrorsFields_ForeignSecuritiesCharge_Fragment> } } & { ' $fragmentRefs'?: { 'TableMiscExpensesFields_ForeignSecuritiesCharge_Fragment': Incremental<TableMiscExpensesFields_ForeignSecuritiesCharge_Fragment> } } & { ' $fragmentRefs'?: { 'ExchangeRatesInfo_ForeignSecuritiesCharge_Fragment': Incremental<ExchangeRatesInfo_ForeignSecuritiesCharge_Fragment> } } & { ' $fragmentName'?: 'ChargeExpansionFields_ForeignSecuritiesCharge_Fragment' };

type ChargeExpansionFields_InternalTransferCharge_Fragment = { __typename: 'InternalTransferCharge', id: string, metadata: { transactionsCount: number, documentsCount: number, receiptsCount: number, invoicesCount: number, ledgerCount: number, miscExpensesCount: number, isLedgerLocked: boolean, openDocuments: boolean } | null, totalAmount: { raw: number } | null } & { ' $fragmentRefs'?: { 'DocumentsGalleryFields_InternalTransferCharge_Fragment': Incremental<DocumentsGalleryFields_InternalTransferCharge_Fragment> } } & { ' $fragmentRefs'?: { 'TableDocumentsFields_InternalTransferCharge_Fragment': Incremental<TableDocumentsFields_InternalTransferCharge_Fragment> } } & { ' $fragmentRefs'?: { 'ChargeLedgerRecordsTableFields_InternalTransferCharge_Fragment': Incremental<ChargeLedgerRecordsTableFields_InternalTransferCharge_Fragment> } } & { ' $fragmentRefs'?: { 'ChargeTableTransactionsFields_InternalTransferCharge_Fragment': Incremental<ChargeTableTransactionsFields_InternalTransferCharge_Fragment> } } & { ' $fragmentRefs'?: { 'ConversionChargeInfo_InternalTransferCharge_Fragment': Incremental<ConversionChargeInfo_InternalTransferCharge_Fragment> } } & { ' $fragmentRefs'?: { 'CreditcardBankChargeInfo_InternalTransferCharge_Fragment': Incremental<CreditcardBankChargeInfo_InternalTransferCharge_Fragment> } } & { ' $fragmentRefs'?: { 'TableSalariesFields_InternalTransferCharge_Fragment': Incremental<TableSalariesFields_InternalTransferCharge_Fragment> } } & { ' $fragmentRefs'?: { 'ChargesTableErrorsFields_InternalTransferCharge_Fragment': Incremental<ChargesTableErrorsFields_InternalTransferCharge_Fragment> } } & { ' $fragmentRefs'?: { 'TableMiscExpensesFields_InternalTransferCharge_Fragment': Incremental<TableMiscExpensesFields_InternalTransferCharge_Fragment> } } & { ' $fragmentRefs'?: { 'ExchangeRatesInfo_InternalTransferCharge_Fragment': Incremental<ExchangeRatesInfo_InternalTransferCharge_Fragment> } } & { ' $fragmentName'?: 'ChargeExpansionFields_InternalTransferCharge_Fragment' };

type ChargeExpansionFields_MonthlyVatCharge_Fragment = { __typename: 'MonthlyVatCharge', id: string, metadata: { transactionsCount: number, documentsCount: number, receiptsCount: number, invoicesCount: number, ledgerCount: number, miscExpensesCount: number, isLedgerLocked: boolean, openDocuments: boolean } | null, totalAmount: { raw: number } | null } & { ' $fragmentRefs'?: { 'DocumentsGalleryFields_MonthlyVatCharge_Fragment': Incremental<DocumentsGalleryFields_MonthlyVatCharge_Fragment> } } & { ' $fragmentRefs'?: { 'TableDocumentsFields_MonthlyVatCharge_Fragment': Incremental<TableDocumentsFields_MonthlyVatCharge_Fragment> } } & { ' $fragmentRefs'?: { 'ChargeLedgerRecordsTableFields_MonthlyVatCharge_Fragment': Incremental<ChargeLedgerRecordsTableFields_MonthlyVatCharge_Fragment> } } & { ' $fragmentRefs'?: { 'ChargeTableTransactionsFields_MonthlyVatCharge_Fragment': Incremental<ChargeTableTransactionsFields_MonthlyVatCharge_Fragment> } } & { ' $fragmentRefs'?: { 'ConversionChargeInfo_MonthlyVatCharge_Fragment': Incremental<ConversionChargeInfo_MonthlyVatCharge_Fragment> } } & { ' $fragmentRefs'?: { 'CreditcardBankChargeInfo_MonthlyVatCharge_Fragment': Incremental<CreditcardBankChargeInfo_MonthlyVatCharge_Fragment> } } & { ' $fragmentRefs'?: { 'TableSalariesFields_MonthlyVatCharge_Fragment': Incremental<TableSalariesFields_MonthlyVatCharge_Fragment> } } & { ' $fragmentRefs'?: { 'ChargesTableErrorsFields_MonthlyVatCharge_Fragment': Incremental<ChargesTableErrorsFields_MonthlyVatCharge_Fragment> } } & { ' $fragmentRefs'?: { 'TableMiscExpensesFields_MonthlyVatCharge_Fragment': Incremental<TableMiscExpensesFields_MonthlyVatCharge_Fragment> } } & { ' $fragmentRefs'?: { 'ExchangeRatesInfo_MonthlyVatCharge_Fragment': Incremental<ExchangeRatesInfo_MonthlyVatCharge_Fragment> } } & { ' $fragmentName'?: 'ChargeExpansionFields_MonthlyVatCharge_Fragment' };

type ChargeExpansionFields_SalaryCharge_Fragment = { __typename: 'SalaryCharge', id: string, metadata: { transactionsCount: number, documentsCount: number, receiptsCount: number, invoicesCount: number, ledgerCount: number, miscExpensesCount: number, isLedgerLocked: boolean, openDocuments: boolean } | null, totalAmount: { raw: number } | null } & { ' $fragmentRefs'?: { 'DocumentsGalleryFields_SalaryCharge_Fragment': Incremental<DocumentsGalleryFields_SalaryCharge_Fragment> } } & { ' $fragmentRefs'?: { 'TableDocumentsFields_SalaryCharge_Fragment': Incremental<TableDocumentsFields_SalaryCharge_Fragment> } } & { ' $fragmentRefs'?: { 'ChargeLedgerRecordsTableFields_SalaryCharge_Fragment': Incremental<ChargeLedgerRecordsTableFields_SalaryCharge_Fragment> } } & { ' $fragmentRefs'?: { 'ChargeTableTransactionsFields_SalaryCharge_Fragment': Incremental<ChargeTableTransactionsFields_SalaryCharge_Fragment> } } & { ' $fragmentRefs'?: { 'ConversionChargeInfo_SalaryCharge_Fragment': Incremental<ConversionChargeInfo_SalaryCharge_Fragment> } } & { ' $fragmentRefs'?: { 'CreditcardBankChargeInfo_SalaryCharge_Fragment': Incremental<CreditcardBankChargeInfo_SalaryCharge_Fragment> } } & { ' $fragmentRefs'?: { 'TableSalariesFields_SalaryCharge_Fragment': Incremental<TableSalariesFields_SalaryCharge_Fragment> } } & { ' $fragmentRefs'?: { 'ChargesTableErrorsFields_SalaryCharge_Fragment': Incremental<ChargesTableErrorsFields_SalaryCharge_Fragment> } } & { ' $fragmentRefs'?: { 'TableMiscExpensesFields_SalaryCharge_Fragment': Incremental<TableMiscExpensesFields_SalaryCharge_Fragment> } } & { ' $fragmentRefs'?: { 'ExchangeRatesInfo_SalaryCharge_Fragment': Incremental<ExchangeRatesInfo_SalaryCharge_Fragment> } } & { ' $fragmentName'?: 'ChargeExpansionFields_SalaryCharge_Fragment' };

export type ChargeExpansionFieldsFragment =
  | ChargeExpansionFields_BankDepositCharge_Fragment
  | ChargeExpansionFields_BusinessTripCharge_Fragment
  | ChargeExpansionFields_CommonCharge_Fragment
  | ChargeExpansionFields_ConversionCharge_Fragment
  | ChargeExpansionFields_CreditcardBankCharge_Fragment
  | ChargeExpansionFields_DividendCharge_Fragment
  | ChargeExpansionFields_FinancialCharge_Fragment
  | ChargeExpansionFields_ForeignSecuritiesCharge_Fragment
  | ChargeExpansionFields_InternalTransferCharge_Fragment
  | ChargeExpansionFields_MonthlyVatCharge_Fragment
  | ChargeExpansionFields_SalaryCharge_Fragment
;

type TableDocumentsFields_BankDepositCharge_Fragment = { id: string, additionalDocuments: Array<
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_CreditInvoice_Fragment': TableDocumentsRowFields_CreditInvoice_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Invoice_Fragment': TableDocumentsRowFields_Invoice_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_InvoiceReceipt_Fragment': TableDocumentsRowFields_InvoiceReceipt_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_OtherDocument_Fragment': TableDocumentsRowFields_OtherDocument_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Proforma_Fragment': TableDocumentsRowFields_Proforma_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Receipt_Fragment': TableDocumentsRowFields_Receipt_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Unprocessed_Fragment': TableDocumentsRowFields_Unprocessed_Fragment } }
    )
  > } & { ' $fragmentName'?: 'TableDocumentsFields_BankDepositCharge_Fragment' };

type TableDocumentsFields_BusinessTripCharge_Fragment = { id: string, additionalDocuments: Array<
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_CreditInvoice_Fragment': TableDocumentsRowFields_CreditInvoice_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Invoice_Fragment': TableDocumentsRowFields_Invoice_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_InvoiceReceipt_Fragment': TableDocumentsRowFields_InvoiceReceipt_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_OtherDocument_Fragment': TableDocumentsRowFields_OtherDocument_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Proforma_Fragment': TableDocumentsRowFields_Proforma_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Receipt_Fragment': TableDocumentsRowFields_Receipt_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Unprocessed_Fragment': TableDocumentsRowFields_Unprocessed_Fragment } }
    )
  > } & { ' $fragmentName'?: 'TableDocumentsFields_BusinessTripCharge_Fragment' };

type TableDocumentsFields_CommonCharge_Fragment = { id: string, additionalDocuments: Array<
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_CreditInvoice_Fragment': TableDocumentsRowFields_CreditInvoice_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Invoice_Fragment': TableDocumentsRowFields_Invoice_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_InvoiceReceipt_Fragment': TableDocumentsRowFields_InvoiceReceipt_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_OtherDocument_Fragment': TableDocumentsRowFields_OtherDocument_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Proforma_Fragment': TableDocumentsRowFields_Proforma_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Receipt_Fragment': TableDocumentsRowFields_Receipt_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Unprocessed_Fragment': TableDocumentsRowFields_Unprocessed_Fragment } }
    )
  > } & { ' $fragmentName'?: 'TableDocumentsFields_CommonCharge_Fragment' };

type TableDocumentsFields_ConversionCharge_Fragment = { id: string, additionalDocuments: Array<
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_CreditInvoice_Fragment': TableDocumentsRowFields_CreditInvoice_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Invoice_Fragment': TableDocumentsRowFields_Invoice_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_InvoiceReceipt_Fragment': TableDocumentsRowFields_InvoiceReceipt_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_OtherDocument_Fragment': TableDocumentsRowFields_OtherDocument_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Proforma_Fragment': TableDocumentsRowFields_Proforma_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Receipt_Fragment': TableDocumentsRowFields_Receipt_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Unprocessed_Fragment': TableDocumentsRowFields_Unprocessed_Fragment } }
    )
  > } & { ' $fragmentName'?: 'TableDocumentsFields_ConversionCharge_Fragment' };

type TableDocumentsFields_CreditcardBankCharge_Fragment = { id: string, additionalDocuments: Array<
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_CreditInvoice_Fragment': TableDocumentsRowFields_CreditInvoice_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Invoice_Fragment': TableDocumentsRowFields_Invoice_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_InvoiceReceipt_Fragment': TableDocumentsRowFields_InvoiceReceipt_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_OtherDocument_Fragment': TableDocumentsRowFields_OtherDocument_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Proforma_Fragment': TableDocumentsRowFields_Proforma_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Receipt_Fragment': TableDocumentsRowFields_Receipt_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Unprocessed_Fragment': TableDocumentsRowFields_Unprocessed_Fragment } }
    )
  > } & { ' $fragmentName'?: 'TableDocumentsFields_CreditcardBankCharge_Fragment' };

type TableDocumentsFields_DividendCharge_Fragment = { id: string, additionalDocuments: Array<
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_CreditInvoice_Fragment': TableDocumentsRowFields_CreditInvoice_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Invoice_Fragment': TableDocumentsRowFields_Invoice_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_InvoiceReceipt_Fragment': TableDocumentsRowFields_InvoiceReceipt_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_OtherDocument_Fragment': TableDocumentsRowFields_OtherDocument_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Proforma_Fragment': TableDocumentsRowFields_Proforma_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Receipt_Fragment': TableDocumentsRowFields_Receipt_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Unprocessed_Fragment': TableDocumentsRowFields_Unprocessed_Fragment } }
    )
  > } & { ' $fragmentName'?: 'TableDocumentsFields_DividendCharge_Fragment' };

type TableDocumentsFields_FinancialCharge_Fragment = { id: string, additionalDocuments: Array<
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_CreditInvoice_Fragment': TableDocumentsRowFields_CreditInvoice_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Invoice_Fragment': TableDocumentsRowFields_Invoice_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_InvoiceReceipt_Fragment': TableDocumentsRowFields_InvoiceReceipt_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_OtherDocument_Fragment': TableDocumentsRowFields_OtherDocument_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Proforma_Fragment': TableDocumentsRowFields_Proforma_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Receipt_Fragment': TableDocumentsRowFields_Receipt_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Unprocessed_Fragment': TableDocumentsRowFields_Unprocessed_Fragment } }
    )
  > } & { ' $fragmentName'?: 'TableDocumentsFields_FinancialCharge_Fragment' };

type TableDocumentsFields_ForeignSecuritiesCharge_Fragment = { id: string, additionalDocuments: Array<
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_CreditInvoice_Fragment': TableDocumentsRowFields_CreditInvoice_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Invoice_Fragment': TableDocumentsRowFields_Invoice_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_InvoiceReceipt_Fragment': TableDocumentsRowFields_InvoiceReceipt_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_OtherDocument_Fragment': TableDocumentsRowFields_OtherDocument_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Proforma_Fragment': TableDocumentsRowFields_Proforma_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Receipt_Fragment': TableDocumentsRowFields_Receipt_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Unprocessed_Fragment': TableDocumentsRowFields_Unprocessed_Fragment } }
    )
  > } & { ' $fragmentName'?: 'TableDocumentsFields_ForeignSecuritiesCharge_Fragment' };

type TableDocumentsFields_InternalTransferCharge_Fragment = { id: string, additionalDocuments: Array<
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_CreditInvoice_Fragment': TableDocumentsRowFields_CreditInvoice_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Invoice_Fragment': TableDocumentsRowFields_Invoice_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_InvoiceReceipt_Fragment': TableDocumentsRowFields_InvoiceReceipt_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_OtherDocument_Fragment': TableDocumentsRowFields_OtherDocument_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Proforma_Fragment': TableDocumentsRowFields_Proforma_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Receipt_Fragment': TableDocumentsRowFields_Receipt_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Unprocessed_Fragment': TableDocumentsRowFields_Unprocessed_Fragment } }
    )
  > } & { ' $fragmentName'?: 'TableDocumentsFields_InternalTransferCharge_Fragment' };

type TableDocumentsFields_MonthlyVatCharge_Fragment = { id: string, additionalDocuments: Array<
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_CreditInvoice_Fragment': TableDocumentsRowFields_CreditInvoice_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Invoice_Fragment': TableDocumentsRowFields_Invoice_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_InvoiceReceipt_Fragment': TableDocumentsRowFields_InvoiceReceipt_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_OtherDocument_Fragment': TableDocumentsRowFields_OtherDocument_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Proforma_Fragment': TableDocumentsRowFields_Proforma_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Receipt_Fragment': TableDocumentsRowFields_Receipt_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Unprocessed_Fragment': TableDocumentsRowFields_Unprocessed_Fragment } }
    )
  > } & { ' $fragmentName'?: 'TableDocumentsFields_MonthlyVatCharge_Fragment' };

type TableDocumentsFields_SalaryCharge_Fragment = { id: string, additionalDocuments: Array<
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_CreditInvoice_Fragment': TableDocumentsRowFields_CreditInvoice_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Invoice_Fragment': TableDocumentsRowFields_Invoice_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_InvoiceReceipt_Fragment': TableDocumentsRowFields_InvoiceReceipt_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_OtherDocument_Fragment': TableDocumentsRowFields_OtherDocument_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Proforma_Fragment': TableDocumentsRowFields_Proforma_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Receipt_Fragment': TableDocumentsRowFields_Receipt_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Unprocessed_Fragment': TableDocumentsRowFields_Unprocessed_Fragment } }
    )
  > } & { ' $fragmentName'?: 'TableDocumentsFields_SalaryCharge_Fragment' };

export type TableDocumentsFieldsFragment =
  | TableDocumentsFields_BankDepositCharge_Fragment
  | TableDocumentsFields_BusinessTripCharge_Fragment
  | TableDocumentsFields_CommonCharge_Fragment
  | TableDocumentsFields_ConversionCharge_Fragment
  | TableDocumentsFields_CreditcardBankCharge_Fragment
  | TableDocumentsFields_DividendCharge_Fragment
  | TableDocumentsFields_FinancialCharge_Fragment
  | TableDocumentsFields_ForeignSecuritiesCharge_Fragment
  | TableDocumentsFields_InternalTransferCharge_Fragment
  | TableDocumentsFields_MonthlyVatCharge_Fragment
  | TableDocumentsFields_SalaryCharge_Fragment
;

type ChargeLedgerRecordsTableFields_BankDepositCharge_Fragment = { id: string, ledger: { __typename: 'Ledger', records: Array<(
      { id: string }
      & { ' $fragmentRefs'?: { 'LedgerRecordsTableFieldsFragment': LedgerRecordsTableFieldsFragment } }
    )> } & ({ validate:
      | ({ matches: Array<string> } | { matches?: never }) & ({ differences: Array<(
          { id: string }
          & { ' $fragmentRefs'?: { 'LedgerRecordsTableFieldsFragment': LedgerRecordsTableFieldsFragment } }
        )> } | { differences?: never })
      | Record<PropertyKey, never>
     } | { validate?: never }) } & { ' $fragmentName'?: 'ChargeLedgerRecordsTableFields_BankDepositCharge_Fragment' };

type ChargeLedgerRecordsTableFields_BusinessTripCharge_Fragment = { id: string, ledger: { __typename: 'Ledger', records: Array<(
      { id: string }
      & { ' $fragmentRefs'?: { 'LedgerRecordsTableFieldsFragment': LedgerRecordsTableFieldsFragment } }
    )> } & ({ validate:
      | ({ matches: Array<string> } | { matches?: never }) & ({ differences: Array<(
          { id: string }
          & { ' $fragmentRefs'?: { 'LedgerRecordsTableFieldsFragment': LedgerRecordsTableFieldsFragment } }
        )> } | { differences?: never })
      | Record<PropertyKey, never>
     } | { validate?: never }) } & { ' $fragmentName'?: 'ChargeLedgerRecordsTableFields_BusinessTripCharge_Fragment' };

type ChargeLedgerRecordsTableFields_CommonCharge_Fragment = { id: string, ledger: { __typename: 'Ledger', records: Array<(
      { id: string }
      & { ' $fragmentRefs'?: { 'LedgerRecordsTableFieldsFragment': LedgerRecordsTableFieldsFragment } }
    )> } & ({ validate:
      | ({ matches: Array<string> } | { matches?: never }) & ({ differences: Array<(
          { id: string }
          & { ' $fragmentRefs'?: { 'LedgerRecordsTableFieldsFragment': LedgerRecordsTableFieldsFragment } }
        )> } | { differences?: never })
      | Record<PropertyKey, never>
     } | { validate?: never }) } & { ' $fragmentName'?: 'ChargeLedgerRecordsTableFields_CommonCharge_Fragment' };

type ChargeLedgerRecordsTableFields_ConversionCharge_Fragment = { id: string, ledger: { __typename: 'Ledger', records: Array<(
      { id: string }
      & { ' $fragmentRefs'?: { 'LedgerRecordsTableFieldsFragment': LedgerRecordsTableFieldsFragment } }
    )> } & ({ validate:
      | ({ matches: Array<string> } | { matches?: never }) & ({ differences: Array<(
          { id: string }
          & { ' $fragmentRefs'?: { 'LedgerRecordsTableFieldsFragment': LedgerRecordsTableFieldsFragment } }
        )> } | { differences?: never })
      | Record<PropertyKey, never>
     } | { validate?: never }) } & { ' $fragmentName'?: 'ChargeLedgerRecordsTableFields_ConversionCharge_Fragment' };

type ChargeLedgerRecordsTableFields_CreditcardBankCharge_Fragment = { id: string, ledger: { __typename: 'Ledger', records: Array<(
      { id: string }
      & { ' $fragmentRefs'?: { 'LedgerRecordsTableFieldsFragment': LedgerRecordsTableFieldsFragment } }
    )> } & ({ validate:
      | ({ matches: Array<string> } | { matches?: never }) & ({ differences: Array<(
          { id: string }
          & { ' $fragmentRefs'?: { 'LedgerRecordsTableFieldsFragment': LedgerRecordsTableFieldsFragment } }
        )> } | { differences?: never })
      | Record<PropertyKey, never>
     } | { validate?: never }) } & { ' $fragmentName'?: 'ChargeLedgerRecordsTableFields_CreditcardBankCharge_Fragment' };

type ChargeLedgerRecordsTableFields_DividendCharge_Fragment = { id: string, ledger: { __typename: 'Ledger', records: Array<(
      { id: string }
      & { ' $fragmentRefs'?: { 'LedgerRecordsTableFieldsFragment': LedgerRecordsTableFieldsFragment } }
    )> } & ({ validate:
      | ({ matches: Array<string> } | { matches?: never }) & ({ differences: Array<(
          { id: string }
          & { ' $fragmentRefs'?: { 'LedgerRecordsTableFieldsFragment': LedgerRecordsTableFieldsFragment } }
        )> } | { differences?: never })
      | Record<PropertyKey, never>
     } | { validate?: never }) } & { ' $fragmentName'?: 'ChargeLedgerRecordsTableFields_DividendCharge_Fragment' };

type ChargeLedgerRecordsTableFields_FinancialCharge_Fragment = { id: string, ledger: { __typename: 'Ledger', records: Array<(
      { id: string }
      & { ' $fragmentRefs'?: { 'LedgerRecordsTableFieldsFragment': LedgerRecordsTableFieldsFragment } }
    )> } & ({ validate:
      | ({ matches: Array<string> } | { matches?: never }) & ({ differences: Array<(
          { id: string }
          & { ' $fragmentRefs'?: { 'LedgerRecordsTableFieldsFragment': LedgerRecordsTableFieldsFragment } }
        )> } | { differences?: never })
      | Record<PropertyKey, never>
     } | { validate?: never }) } & { ' $fragmentName'?: 'ChargeLedgerRecordsTableFields_FinancialCharge_Fragment' };

type ChargeLedgerRecordsTableFields_ForeignSecuritiesCharge_Fragment = { id: string, ledger: { __typename: 'Ledger', records: Array<(
      { id: string }
      & { ' $fragmentRefs'?: { 'LedgerRecordsTableFieldsFragment': LedgerRecordsTableFieldsFragment } }
    )> } & ({ validate:
      | ({ matches: Array<string> } | { matches?: never }) & ({ differences: Array<(
          { id: string }
          & { ' $fragmentRefs'?: { 'LedgerRecordsTableFieldsFragment': LedgerRecordsTableFieldsFragment } }
        )> } | { differences?: never })
      | Record<PropertyKey, never>
     } | { validate?: never }) } & { ' $fragmentName'?: 'ChargeLedgerRecordsTableFields_ForeignSecuritiesCharge_Fragment' };

type ChargeLedgerRecordsTableFields_InternalTransferCharge_Fragment = { id: string, ledger: { __typename: 'Ledger', records: Array<(
      { id: string }
      & { ' $fragmentRefs'?: { 'LedgerRecordsTableFieldsFragment': LedgerRecordsTableFieldsFragment } }
    )> } & ({ validate:
      | ({ matches: Array<string> } | { matches?: never }) & ({ differences: Array<(
          { id: string }
          & { ' $fragmentRefs'?: { 'LedgerRecordsTableFieldsFragment': LedgerRecordsTableFieldsFragment } }
        )> } | { differences?: never })
      | Record<PropertyKey, never>
     } | { validate?: never }) } & { ' $fragmentName'?: 'ChargeLedgerRecordsTableFields_InternalTransferCharge_Fragment' };

type ChargeLedgerRecordsTableFields_MonthlyVatCharge_Fragment = { id: string, ledger: { __typename: 'Ledger', records: Array<(
      { id: string }
      & { ' $fragmentRefs'?: { 'LedgerRecordsTableFieldsFragment': LedgerRecordsTableFieldsFragment } }
    )> } & ({ validate:
      | ({ matches: Array<string> } | { matches?: never }) & ({ differences: Array<(
          { id: string }
          & { ' $fragmentRefs'?: { 'LedgerRecordsTableFieldsFragment': LedgerRecordsTableFieldsFragment } }
        )> } | { differences?: never })
      | Record<PropertyKey, never>
     } | { validate?: never }) } & { ' $fragmentName'?: 'ChargeLedgerRecordsTableFields_MonthlyVatCharge_Fragment' };

type ChargeLedgerRecordsTableFields_SalaryCharge_Fragment = { id: string, ledger: { __typename: 'Ledger', records: Array<(
      { id: string }
      & { ' $fragmentRefs'?: { 'LedgerRecordsTableFieldsFragment': LedgerRecordsTableFieldsFragment } }
    )> } & ({ validate:
      | ({ matches: Array<string> } | { matches?: never }) & ({ differences: Array<(
          { id: string }
          & { ' $fragmentRefs'?: { 'LedgerRecordsTableFieldsFragment': LedgerRecordsTableFieldsFragment } }
        )> } | { differences?: never })
      | Record<PropertyKey, never>
     } | { validate?: never }) } & { ' $fragmentName'?: 'ChargeLedgerRecordsTableFields_SalaryCharge_Fragment' };

export type ChargeLedgerRecordsTableFieldsFragment =
  | ChargeLedgerRecordsTableFields_BankDepositCharge_Fragment
  | ChargeLedgerRecordsTableFields_BusinessTripCharge_Fragment
  | ChargeLedgerRecordsTableFields_CommonCharge_Fragment
  | ChargeLedgerRecordsTableFields_ConversionCharge_Fragment
  | ChargeLedgerRecordsTableFields_CreditcardBankCharge_Fragment
  | ChargeLedgerRecordsTableFields_DividendCharge_Fragment
  | ChargeLedgerRecordsTableFields_FinancialCharge_Fragment
  | ChargeLedgerRecordsTableFields_ForeignSecuritiesCharge_Fragment
  | ChargeLedgerRecordsTableFields_InternalTransferCharge_Fragment
  | ChargeLedgerRecordsTableFields_MonthlyVatCharge_Fragment
  | ChargeLedgerRecordsTableFields_SalaryCharge_Fragment
;

type ChargeTableTransactionsFields_BankDepositCharge_Fragment = { id: string, transactions: Array<
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_CommonTransaction_Fragment': TransactionForTransactionsTableFields_CommonTransaction_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_ConversionTransaction_Fragment': TransactionForTransactionsTableFields_ConversionTransaction_Fragment } }
    )
  > } & { ' $fragmentName'?: 'ChargeTableTransactionsFields_BankDepositCharge_Fragment' };

type ChargeTableTransactionsFields_BusinessTripCharge_Fragment = { id: string, transactions: Array<
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_CommonTransaction_Fragment': TransactionForTransactionsTableFields_CommonTransaction_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_ConversionTransaction_Fragment': TransactionForTransactionsTableFields_ConversionTransaction_Fragment } }
    )
  > } & { ' $fragmentName'?: 'ChargeTableTransactionsFields_BusinessTripCharge_Fragment' };

type ChargeTableTransactionsFields_CommonCharge_Fragment = { id: string, transactions: Array<
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_CommonTransaction_Fragment': TransactionForTransactionsTableFields_CommonTransaction_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_ConversionTransaction_Fragment': TransactionForTransactionsTableFields_ConversionTransaction_Fragment } }
    )
  > } & { ' $fragmentName'?: 'ChargeTableTransactionsFields_CommonCharge_Fragment' };

type ChargeTableTransactionsFields_ConversionCharge_Fragment = { id: string, transactions: Array<
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_CommonTransaction_Fragment': TransactionForTransactionsTableFields_CommonTransaction_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_ConversionTransaction_Fragment': TransactionForTransactionsTableFields_ConversionTransaction_Fragment } }
    )
  > } & { ' $fragmentName'?: 'ChargeTableTransactionsFields_ConversionCharge_Fragment' };

type ChargeTableTransactionsFields_CreditcardBankCharge_Fragment = { id: string, transactions: Array<
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_CommonTransaction_Fragment': TransactionForTransactionsTableFields_CommonTransaction_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_ConversionTransaction_Fragment': TransactionForTransactionsTableFields_ConversionTransaction_Fragment } }
    )
  > } & { ' $fragmentName'?: 'ChargeTableTransactionsFields_CreditcardBankCharge_Fragment' };

type ChargeTableTransactionsFields_DividendCharge_Fragment = { id: string, transactions: Array<
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_CommonTransaction_Fragment': TransactionForTransactionsTableFields_CommonTransaction_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_ConversionTransaction_Fragment': TransactionForTransactionsTableFields_ConversionTransaction_Fragment } }
    )
  > } & { ' $fragmentName'?: 'ChargeTableTransactionsFields_DividendCharge_Fragment' };

type ChargeTableTransactionsFields_FinancialCharge_Fragment = { id: string, transactions: Array<
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_CommonTransaction_Fragment': TransactionForTransactionsTableFields_CommonTransaction_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_ConversionTransaction_Fragment': TransactionForTransactionsTableFields_ConversionTransaction_Fragment } }
    )
  > } & { ' $fragmentName'?: 'ChargeTableTransactionsFields_FinancialCharge_Fragment' };

type ChargeTableTransactionsFields_ForeignSecuritiesCharge_Fragment = { id: string, transactions: Array<
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_CommonTransaction_Fragment': TransactionForTransactionsTableFields_CommonTransaction_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_ConversionTransaction_Fragment': TransactionForTransactionsTableFields_ConversionTransaction_Fragment } }
    )
  > } & { ' $fragmentName'?: 'ChargeTableTransactionsFields_ForeignSecuritiesCharge_Fragment' };

type ChargeTableTransactionsFields_InternalTransferCharge_Fragment = { id: string, transactions: Array<
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_CommonTransaction_Fragment': TransactionForTransactionsTableFields_CommonTransaction_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_ConversionTransaction_Fragment': TransactionForTransactionsTableFields_ConversionTransaction_Fragment } }
    )
  > } & { ' $fragmentName'?: 'ChargeTableTransactionsFields_InternalTransferCharge_Fragment' };

type ChargeTableTransactionsFields_MonthlyVatCharge_Fragment = { id: string, transactions: Array<
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_CommonTransaction_Fragment': TransactionForTransactionsTableFields_CommonTransaction_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_ConversionTransaction_Fragment': TransactionForTransactionsTableFields_ConversionTransaction_Fragment } }
    )
  > } & { ' $fragmentName'?: 'ChargeTableTransactionsFields_MonthlyVatCharge_Fragment' };

type ChargeTableTransactionsFields_SalaryCharge_Fragment = { id: string, transactions: Array<
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_CommonTransaction_Fragment': TransactionForTransactionsTableFields_CommonTransaction_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_ConversionTransaction_Fragment': TransactionForTransactionsTableFields_ConversionTransaction_Fragment } }
    )
  > } & { ' $fragmentName'?: 'ChargeTableTransactionsFields_SalaryCharge_Fragment' };

export type ChargeTableTransactionsFieldsFragment =
  | ChargeTableTransactionsFields_BankDepositCharge_Fragment
  | ChargeTableTransactionsFields_BusinessTripCharge_Fragment
  | ChargeTableTransactionsFields_CommonCharge_Fragment
  | ChargeTableTransactionsFields_ConversionCharge_Fragment
  | ChargeTableTransactionsFields_CreditcardBankCharge_Fragment
  | ChargeTableTransactionsFields_DividendCharge_Fragment
  | ChargeTableTransactionsFields_FinancialCharge_Fragment
  | ChargeTableTransactionsFields_ForeignSecuritiesCharge_Fragment
  | ChargeTableTransactionsFields_InternalTransferCharge_Fragment
  | ChargeTableTransactionsFields_MonthlyVatCharge_Fragment
  | ChargeTableTransactionsFields_SalaryCharge_Fragment
;

export type ChargesExtendedInfoBatchQueryVariables = Exact<{
  chargeIDs: Array<string> | string;
}>;


export type ChargesExtendedInfoBatchQuery = { chargesByIDs: Array<
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'ChargeExpansionFields_BankDepositCharge_Fragment': ChargeExpansionFields_BankDepositCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'ChargeExpansionFields_BusinessTripCharge_Fragment': ChargeExpansionFields_BusinessTripCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'ChargeExpansionFields_CommonCharge_Fragment': ChargeExpansionFields_CommonCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'ChargeExpansionFields_ConversionCharge_Fragment': ChargeExpansionFields_ConversionCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'ChargeExpansionFields_CreditcardBankCharge_Fragment': ChargeExpansionFields_CreditcardBankCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'ChargeExpansionFields_DividendCharge_Fragment': ChargeExpansionFields_DividendCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'ChargeExpansionFields_FinancialCharge_Fragment': ChargeExpansionFields_FinancialCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'ChargeExpansionFields_ForeignSecuritiesCharge_Fragment': ChargeExpansionFields_ForeignSecuritiesCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'ChargeExpansionFields_InternalTransferCharge_Fragment': ChargeExpansionFields_InternalTransferCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'ChargeExpansionFields_MonthlyVatCharge_Fragment': ChargeExpansionFields_MonthlyVatCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'ChargeExpansionFields_SalaryCharge_Fragment': ChargeExpansionFields_SalaryCharge_Fragment } }
    )
  > };

export type RefetchChargeForChargesTableQueryVariables = Exact<{
  chargeId: string;
}>;


export type RefetchChargeForChargesTableQuery = { charge:
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_BankDepositCharge_Fragment': ChargeForChargesTableFields_BankDepositCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_BusinessTripCharge_Fragment': ChargeForChargesTableFields_BusinessTripCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_CommonCharge_Fragment': ChargeForChargesTableFields_CommonCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_ConversionCharge_Fragment': ChargeForChargesTableFields_ConversionCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_CreditcardBankCharge_Fragment': ChargeForChargesTableFields_CreditcardBankCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_DividendCharge_Fragment': ChargeForChargesTableFields_DividendCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_FinancialCharge_Fragment': ChargeForChargesTableFields_FinancialCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_ForeignSecuritiesCharge_Fragment': ChargeForChargesTableFields_ForeignSecuritiesCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_InternalTransferCharge_Fragment': ChargeForChargesTableFields_InternalTransferCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_MonthlyVatCharge_Fragment': ChargeForChargesTableFields_MonthlyVatCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_SalaryCharge_Fragment': ChargeForChargesTableFields_SalaryCharge_Fragment } }
    )
   };

type ChargeForChargesTableFields_BankDepositCharge_Fragment = { __typename: 'BankDepositCharge', id: string, minEventDate: unknown, minDebitDate: unknown, minDocumentsDate: unknown, maxDebitDate: unknown, maxEventDate: unknown, maxDocumentsDate: unknown, userDescription: string | null, accountantApproval: AccountantStatus, validationData: { missingInfo: Array<MissingChargeInfo> } | null, missingInfoSuggestions: { description: string | null, tags: Array<{ id: string, name: string, namePath: Array<string> | null }> } | null, totalAmount: { raw: number, currency: Currency } | null, vat: { raw: number } | null, counterparty:
    | { name: string, id: string }
    | { name: string, id: string }
    | { name: string, id: string }
   | null, tags: Array<{ id: string, name: string, namePath: Array<string> | null }>, taxCategory: { id: string, name: string } | null, metadata: { transactionsCount: number, documentsCount: number, ledgerCount: number, miscExpensesCount: number } & ({ invalidLedger: LedgerValidationStatus } | { invalidLedger?: never }) | null } & { ' $fragmentName'?: 'ChargeForChargesTableFields_BankDepositCharge_Fragment' };

type ChargeForChargesTableFields_BusinessTripCharge_Fragment = { __typename: 'BusinessTripCharge', id: string, minEventDate: unknown, minDebitDate: unknown, minDocumentsDate: unknown, maxDebitDate: unknown, maxEventDate: unknown, maxDocumentsDate: unknown, userDescription: string | null, accountantApproval: AccountantStatus, businessTrip: { id: string, name: string } | null, validationData: { missingInfo: Array<MissingChargeInfo> } | null, missingInfoSuggestions: { description: string | null, tags: Array<{ id: string, name: string, namePath: Array<string> | null }> } | null, totalAmount: { raw: number, currency: Currency } | null, vat: { raw: number } | null, counterparty:
    | { name: string, id: string }
    | { name: string, id: string }
    | { name: string, id: string }
   | null, tags: Array<{ id: string, name: string, namePath: Array<string> | null }>, taxCategory: { id: string, name: string } | null, metadata: { transactionsCount: number, documentsCount: number, ledgerCount: number, miscExpensesCount: number } & ({ invalidLedger: LedgerValidationStatus } | { invalidLedger?: never }) | null } & { ' $fragmentName'?: 'ChargeForChargesTableFields_BusinessTripCharge_Fragment' };

type ChargeForChargesTableFields_CommonCharge_Fragment = { __typename: 'CommonCharge', id: string, minEventDate: unknown, minDebitDate: unknown, minDocumentsDate: unknown, maxDebitDate: unknown, maxEventDate: unknown, maxDocumentsDate: unknown, userDescription: string | null, accountantApproval: AccountantStatus, validationData: { missingInfo: Array<MissingChargeInfo> } | null, missingInfoSuggestions: { description: string | null, tags: Array<{ id: string, name: string, namePath: Array<string> | null }> } | null, totalAmount: { raw: number, currency: Currency } | null, vat: { raw: number } | null, counterparty:
    | { name: string, id: string }
    | { name: string, id: string }
    | { name: string, id: string }
   | null, tags: Array<{ id: string, name: string, namePath: Array<string> | null }>, taxCategory: { id: string, name: string } | null, metadata: { transactionsCount: number, documentsCount: number, ledgerCount: number, miscExpensesCount: number } & ({ invalidLedger: LedgerValidationStatus } | { invalidLedger?: never }) | null } & { ' $fragmentName'?: 'ChargeForChargesTableFields_CommonCharge_Fragment' };

type ChargeForChargesTableFields_ConversionCharge_Fragment = { __typename: 'ConversionCharge', id: string, minEventDate: unknown, minDebitDate: unknown, minDocumentsDate: unknown, maxDebitDate: unknown, maxEventDate: unknown, maxDocumentsDate: unknown, userDescription: string | null, accountantApproval: AccountantStatus, validationData: { missingInfo: Array<MissingChargeInfo> } | null, missingInfoSuggestions: { description: string | null, tags: Array<{ id: string, name: string, namePath: Array<string> | null }> } | null, totalAmount: { raw: number, currency: Currency } | null, vat: { raw: number } | null, counterparty:
    | { name: string, id: string }
    | { name: string, id: string }
    | { name: string, id: string }
   | null, tags: Array<{ id: string, name: string, namePath: Array<string> | null }>, taxCategory: { id: string, name: string } | null, metadata: { transactionsCount: number, documentsCount: number, ledgerCount: number, miscExpensesCount: number } & ({ invalidLedger: LedgerValidationStatus } | { invalidLedger?: never }) | null } & { ' $fragmentName'?: 'ChargeForChargesTableFields_ConversionCharge_Fragment' };

type ChargeForChargesTableFields_CreditcardBankCharge_Fragment = { __typename: 'CreditcardBankCharge', validCreditCardAmount: boolean, id: string, minEventDate: unknown, minDebitDate: unknown, minDocumentsDate: unknown, maxDebitDate: unknown, maxEventDate: unknown, maxDocumentsDate: unknown, userDescription: string | null, accountantApproval: AccountantStatus, validationData: { missingInfo: Array<MissingChargeInfo> } | null, missingInfoSuggestions: { description: string | null, tags: Array<{ id: string, name: string, namePath: Array<string> | null }> } | null, totalAmount: { raw: number, currency: Currency } | null, vat: { raw: number } | null, counterparty:
    | { name: string, id: string }
    | { name: string, id: string }
    | { name: string, id: string }
   | null, tags: Array<{ id: string, name: string, namePath: Array<string> | null }>, taxCategory: { id: string, name: string } | null, metadata: { transactionsCount: number, documentsCount: number, ledgerCount: number, miscExpensesCount: number } & ({ invalidLedger: LedgerValidationStatus } | { invalidLedger?: never }) | null } & { ' $fragmentName'?: 'ChargeForChargesTableFields_CreditcardBankCharge_Fragment' };

type ChargeForChargesTableFields_DividendCharge_Fragment = { __typename: 'DividendCharge', id: string, minEventDate: unknown, minDebitDate: unknown, minDocumentsDate: unknown, maxDebitDate: unknown, maxEventDate: unknown, maxDocumentsDate: unknown, userDescription: string | null, accountantApproval: AccountantStatus, validationData: { missingInfo: Array<MissingChargeInfo> } | null, missingInfoSuggestions: { description: string | null, tags: Array<{ id: string, name: string, namePath: Array<string> | null }> } | null, totalAmount: { raw: number, currency: Currency } | null, vat: { raw: number } | null, counterparty:
    | { name: string, id: string }
    | { name: string, id: string }
    | { name: string, id: string }
   | null, tags: Array<{ id: string, name: string, namePath: Array<string> | null }>, taxCategory: { id: string, name: string } | null, metadata: { transactionsCount: number, documentsCount: number, ledgerCount: number, miscExpensesCount: number } & ({ invalidLedger: LedgerValidationStatus } | { invalidLedger?: never }) | null } & { ' $fragmentName'?: 'ChargeForChargesTableFields_DividendCharge_Fragment' };

type ChargeForChargesTableFields_FinancialCharge_Fragment = { __typename: 'FinancialCharge', id: string, minEventDate: unknown, minDebitDate: unknown, minDocumentsDate: unknown, maxDebitDate: unknown, maxEventDate: unknown, maxDocumentsDate: unknown, userDescription: string | null, accountantApproval: AccountantStatus, validationData: { missingInfo: Array<MissingChargeInfo> } | null, missingInfoSuggestions: { description: string | null, tags: Array<{ id: string, name: string, namePath: Array<string> | null }> } | null, totalAmount: { raw: number, currency: Currency } | null, vat: { raw: number } | null, counterparty:
    | { name: string, id: string }
    | { name: string, id: string }
    | { name: string, id: string }
   | null, tags: Array<{ id: string, name: string, namePath: Array<string> | null }>, taxCategory: { id: string, name: string } | null, metadata: { transactionsCount: number, documentsCount: number, ledgerCount: number, miscExpensesCount: number } & ({ invalidLedger: LedgerValidationStatus } | { invalidLedger?: never }) | null } & { ' $fragmentName'?: 'ChargeForChargesTableFields_FinancialCharge_Fragment' };

type ChargeForChargesTableFields_ForeignSecuritiesCharge_Fragment = { __typename: 'ForeignSecuritiesCharge', id: string, minEventDate: unknown, minDebitDate: unknown, minDocumentsDate: unknown, maxDebitDate: unknown, maxEventDate: unknown, maxDocumentsDate: unknown, userDescription: string | null, accountantApproval: AccountantStatus, validationData: { missingInfo: Array<MissingChargeInfo> } | null, missingInfoSuggestions: { description: string | null, tags: Array<{ id: string, name: string, namePath: Array<string> | null }> } | null, totalAmount: { raw: number, currency: Currency } | null, vat: { raw: number } | null, counterparty:
    | { name: string, id: string }
    | { name: string, id: string }
    | { name: string, id: string }
   | null, tags: Array<{ id: string, name: string, namePath: Array<string> | null }>, taxCategory: { id: string, name: string } | null, metadata: { transactionsCount: number, documentsCount: number, ledgerCount: number, miscExpensesCount: number } & ({ invalidLedger: LedgerValidationStatus } | { invalidLedger?: never }) | null } & { ' $fragmentName'?: 'ChargeForChargesTableFields_ForeignSecuritiesCharge_Fragment' };

type ChargeForChargesTableFields_InternalTransferCharge_Fragment = { __typename: 'InternalTransferCharge', id: string, minEventDate: unknown, minDebitDate: unknown, minDocumentsDate: unknown, maxDebitDate: unknown, maxEventDate: unknown, maxDocumentsDate: unknown, userDescription: string | null, accountantApproval: AccountantStatus, validationData: { missingInfo: Array<MissingChargeInfo> } | null, missingInfoSuggestions: { description: string | null, tags: Array<{ id: string, name: string, namePath: Array<string> | null }> } | null, totalAmount: { raw: number, currency: Currency } | null, vat: { raw: number } | null, counterparty:
    | { name: string, id: string }
    | { name: string, id: string }
    | { name: string, id: string }
   | null, tags: Array<{ id: string, name: string, namePath: Array<string> | null }>, taxCategory: { id: string, name: string } | null, metadata: { transactionsCount: number, documentsCount: number, ledgerCount: number, miscExpensesCount: number } & ({ invalidLedger: LedgerValidationStatus } | { invalidLedger?: never }) | null } & { ' $fragmentName'?: 'ChargeForChargesTableFields_InternalTransferCharge_Fragment' };

type ChargeForChargesTableFields_MonthlyVatCharge_Fragment = { __typename: 'MonthlyVatCharge', id: string, minEventDate: unknown, minDebitDate: unknown, minDocumentsDate: unknown, maxDebitDate: unknown, maxEventDate: unknown, maxDocumentsDate: unknown, userDescription: string | null, accountantApproval: AccountantStatus, validationData: { missingInfo: Array<MissingChargeInfo> } | null, missingInfoSuggestions: { description: string | null, tags: Array<{ id: string, name: string, namePath: Array<string> | null }> } | null, totalAmount: { raw: number, currency: Currency } | null, vat: { raw: number } | null, counterparty:
    | { name: string, id: string }
    | { name: string, id: string }
    | { name: string, id: string }
   | null, tags: Array<{ id: string, name: string, namePath: Array<string> | null }>, taxCategory: { id: string, name: string } | null, metadata: { transactionsCount: number, documentsCount: number, ledgerCount: number, miscExpensesCount: number } & ({ invalidLedger: LedgerValidationStatus } | { invalidLedger?: never }) | null } & { ' $fragmentName'?: 'ChargeForChargesTableFields_MonthlyVatCharge_Fragment' };

type ChargeForChargesTableFields_SalaryCharge_Fragment = { __typename: 'SalaryCharge', id: string, minEventDate: unknown, minDebitDate: unknown, minDocumentsDate: unknown, maxDebitDate: unknown, maxEventDate: unknown, maxDocumentsDate: unknown, userDescription: string | null, accountantApproval: AccountantStatus, validationData: { missingInfo: Array<MissingChargeInfo> } | null, missingInfoSuggestions: { description: string | null, tags: Array<{ id: string, name: string, namePath: Array<string> | null }> } | null, totalAmount: { raw: number, currency: Currency } | null, vat: { raw: number } | null, counterparty:
    | { name: string, id: string }
    | { name: string, id: string }
    | { name: string, id: string }
   | null, tags: Array<{ id: string, name: string, namePath: Array<string> | null }>, taxCategory: { id: string, name: string } | null, metadata: { transactionsCount: number, documentsCount: number, ledgerCount: number, miscExpensesCount: number } & ({ invalidLedger: LedgerValidationStatus } | { invalidLedger?: never }) | null } & { ' $fragmentName'?: 'ChargeForChargesTableFields_SalaryCharge_Fragment' };

export type ChargeForChargesTableFieldsFragment =
  | ChargeForChargesTableFields_BankDepositCharge_Fragment
  | ChargeForChargesTableFields_BusinessTripCharge_Fragment
  | ChargeForChargesTableFields_CommonCharge_Fragment
  | ChargeForChargesTableFields_ConversionCharge_Fragment
  | ChargeForChargesTableFields_CreditcardBankCharge_Fragment
  | ChargeForChargesTableFields_DividendCharge_Fragment
  | ChargeForChargesTableFields_FinancialCharge_Fragment
  | ChargeForChargesTableFields_ForeignSecuritiesCharge_Fragment
  | ChargeForChargesTableFields_InternalTransferCharge_Fragment
  | ChargeForChargesTableFields_MonthlyVatCharge_Fragment
  | ChargeForChargesTableFields_SalaryCharge_Fragment
;

type ChargeForCsvExportFields_BankDepositCharge_Fragment = { __typename: 'BankDepositCharge', id: string, minEventDate: unknown, minDebitDate: unknown, minDocumentsDate: unknown, userDescription: string | null, accountantApproval: AccountantStatus, totalAmount: { raw: number, currency: Currency } | null, vat: { raw: number } | null, counterparty:
    | { id: string, name: string }
    | { id: string, name: string }
    | { id: string, name: string }
   | null, tags: Array<{ id: string, name: string }>, taxCategory: { id: string, name: string } | null, validationData: { isValid: boolean, missingInfo: Array<MissingChargeInfo> } | null, missingInfoSuggestions: { description: string | null, tags: Array<{ id: string, name: string }> } | null, metadata: { transactionsCount: number, documentsCount: number, invoicesCount: number, receiptsCount: number, ledgerCount: number, miscExpensesCount: number, openDocuments: boolean, invalidLedger: LedgerValidationStatus } | null, ledger: { balance: { isBalanced: boolean } | null, validate: { isValid: boolean, errors: Array<string> } }, transactions: Array<
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_CommonTransaction_Fragment': TransactionForTransactionsTableFields_CommonTransaction_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_ConversionTransaction_Fragment': TransactionForTransactionsTableFields_ConversionTransaction_Fragment } }
    )
  >, additionalDocuments: Array<
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_CreditInvoice_Fragment': TableDocumentsRowFields_CreditInvoice_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Invoice_Fragment': TableDocumentsRowFields_Invoice_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_InvoiceReceipt_Fragment': TableDocumentsRowFields_InvoiceReceipt_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_OtherDocument_Fragment': TableDocumentsRowFields_OtherDocument_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Proforma_Fragment': TableDocumentsRowFields_Proforma_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Receipt_Fragment': TableDocumentsRowFields_Receipt_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Unprocessed_Fragment': TableDocumentsRowFields_Unprocessed_Fragment } }
    )
  > } & { ' $fragmentName'?: 'ChargeForCsvExportFields_BankDepositCharge_Fragment' };

type ChargeForCsvExportFields_BusinessTripCharge_Fragment = { __typename: 'BusinessTripCharge', id: string, minEventDate: unknown, minDebitDate: unknown, minDocumentsDate: unknown, userDescription: string | null, accountantApproval: AccountantStatus, businessTrip: { id: string, name: string } | null, totalAmount: { raw: number, currency: Currency } | null, vat: { raw: number } | null, counterparty:
    | { id: string, name: string }
    | { id: string, name: string }
    | { id: string, name: string }
   | null, tags: Array<{ id: string, name: string }>, taxCategory: { id: string, name: string } | null, validationData: { isValid: boolean, missingInfo: Array<MissingChargeInfo> } | null, missingInfoSuggestions: { description: string | null, tags: Array<{ id: string, name: string }> } | null, metadata: { transactionsCount: number, documentsCount: number, invoicesCount: number, receiptsCount: number, ledgerCount: number, miscExpensesCount: number, openDocuments: boolean, invalidLedger: LedgerValidationStatus } | null, ledger: { balance: { isBalanced: boolean } | null, validate: { isValid: boolean, errors: Array<string> } }, transactions: Array<
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_CommonTransaction_Fragment': TransactionForTransactionsTableFields_CommonTransaction_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_ConversionTransaction_Fragment': TransactionForTransactionsTableFields_ConversionTransaction_Fragment } }
    )
  >, additionalDocuments: Array<
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_CreditInvoice_Fragment': TableDocumentsRowFields_CreditInvoice_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Invoice_Fragment': TableDocumentsRowFields_Invoice_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_InvoiceReceipt_Fragment': TableDocumentsRowFields_InvoiceReceipt_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_OtherDocument_Fragment': TableDocumentsRowFields_OtherDocument_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Proforma_Fragment': TableDocumentsRowFields_Proforma_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Receipt_Fragment': TableDocumentsRowFields_Receipt_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Unprocessed_Fragment': TableDocumentsRowFields_Unprocessed_Fragment } }
    )
  > } & { ' $fragmentName'?: 'ChargeForCsvExportFields_BusinessTripCharge_Fragment' };

type ChargeForCsvExportFields_CommonCharge_Fragment = { __typename: 'CommonCharge', id: string, minEventDate: unknown, minDebitDate: unknown, minDocumentsDate: unknown, userDescription: string | null, accountantApproval: AccountantStatus, totalAmount: { raw: number, currency: Currency } | null, vat: { raw: number } | null, counterparty:
    | { id: string, name: string }
    | { id: string, name: string }
    | { id: string, name: string }
   | null, tags: Array<{ id: string, name: string }>, taxCategory: { id: string, name: string } | null, validationData: { isValid: boolean, missingInfo: Array<MissingChargeInfo> } | null, missingInfoSuggestions: { description: string | null, tags: Array<{ id: string, name: string }> } | null, metadata: { transactionsCount: number, documentsCount: number, invoicesCount: number, receiptsCount: number, ledgerCount: number, miscExpensesCount: number, openDocuments: boolean, invalidLedger: LedgerValidationStatus } | null, ledger: { balance: { isBalanced: boolean } | null, validate: { isValid: boolean, errors: Array<string> } }, transactions: Array<
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_CommonTransaction_Fragment': TransactionForTransactionsTableFields_CommonTransaction_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_ConversionTransaction_Fragment': TransactionForTransactionsTableFields_ConversionTransaction_Fragment } }
    )
  >, additionalDocuments: Array<
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_CreditInvoice_Fragment': TableDocumentsRowFields_CreditInvoice_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Invoice_Fragment': TableDocumentsRowFields_Invoice_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_InvoiceReceipt_Fragment': TableDocumentsRowFields_InvoiceReceipt_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_OtherDocument_Fragment': TableDocumentsRowFields_OtherDocument_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Proforma_Fragment': TableDocumentsRowFields_Proforma_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Receipt_Fragment': TableDocumentsRowFields_Receipt_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Unprocessed_Fragment': TableDocumentsRowFields_Unprocessed_Fragment } }
    )
  > } & { ' $fragmentName'?: 'ChargeForCsvExportFields_CommonCharge_Fragment' };

type ChargeForCsvExportFields_ConversionCharge_Fragment = { __typename: 'ConversionCharge', id: string, minEventDate: unknown, minDebitDate: unknown, minDocumentsDate: unknown, userDescription: string | null, accountantApproval: AccountantStatus, totalAmount: { raw: number, currency: Currency } | null, vat: { raw: number } | null, counterparty:
    | { id: string, name: string }
    | { id: string, name: string }
    | { id: string, name: string }
   | null, tags: Array<{ id: string, name: string }>, taxCategory: { id: string, name: string } | null, validationData: { isValid: boolean, missingInfo: Array<MissingChargeInfo> } | null, missingInfoSuggestions: { description: string | null, tags: Array<{ id: string, name: string }> } | null, metadata: { transactionsCount: number, documentsCount: number, invoicesCount: number, receiptsCount: number, ledgerCount: number, miscExpensesCount: number, openDocuments: boolean, invalidLedger: LedgerValidationStatus } | null, ledger: { balance: { isBalanced: boolean } | null, validate: { isValid: boolean, errors: Array<string> } }, transactions: Array<
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_CommonTransaction_Fragment': TransactionForTransactionsTableFields_CommonTransaction_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_ConversionTransaction_Fragment': TransactionForTransactionsTableFields_ConversionTransaction_Fragment } }
    )
  >, additionalDocuments: Array<
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_CreditInvoice_Fragment': TableDocumentsRowFields_CreditInvoice_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Invoice_Fragment': TableDocumentsRowFields_Invoice_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_InvoiceReceipt_Fragment': TableDocumentsRowFields_InvoiceReceipt_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_OtherDocument_Fragment': TableDocumentsRowFields_OtherDocument_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Proforma_Fragment': TableDocumentsRowFields_Proforma_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Receipt_Fragment': TableDocumentsRowFields_Receipt_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Unprocessed_Fragment': TableDocumentsRowFields_Unprocessed_Fragment } }
    )
  > } & { ' $fragmentName'?: 'ChargeForCsvExportFields_ConversionCharge_Fragment' };

type ChargeForCsvExportFields_CreditcardBankCharge_Fragment = { __typename: 'CreditcardBankCharge', validCreditCardAmount: boolean, id: string, minEventDate: unknown, minDebitDate: unknown, minDocumentsDate: unknown, userDescription: string | null, accountantApproval: AccountantStatus, totalAmount: { raw: number, currency: Currency } | null, vat: { raw: number } | null, counterparty:
    | { id: string, name: string }
    | { id: string, name: string }
    | { id: string, name: string }
   | null, tags: Array<{ id: string, name: string }>, taxCategory: { id: string, name: string } | null, validationData: { isValid: boolean, missingInfo: Array<MissingChargeInfo> } | null, missingInfoSuggestions: { description: string | null, tags: Array<{ id: string, name: string }> } | null, metadata: { transactionsCount: number, documentsCount: number, invoicesCount: number, receiptsCount: number, ledgerCount: number, miscExpensesCount: number, openDocuments: boolean, invalidLedger: LedgerValidationStatus } | null, ledger: { balance: { isBalanced: boolean } | null, validate: { isValid: boolean, errors: Array<string> } }, transactions: Array<
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_CommonTransaction_Fragment': TransactionForTransactionsTableFields_CommonTransaction_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_ConversionTransaction_Fragment': TransactionForTransactionsTableFields_ConversionTransaction_Fragment } }
    )
  >, additionalDocuments: Array<
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_CreditInvoice_Fragment': TableDocumentsRowFields_CreditInvoice_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Invoice_Fragment': TableDocumentsRowFields_Invoice_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_InvoiceReceipt_Fragment': TableDocumentsRowFields_InvoiceReceipt_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_OtherDocument_Fragment': TableDocumentsRowFields_OtherDocument_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Proforma_Fragment': TableDocumentsRowFields_Proforma_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Receipt_Fragment': TableDocumentsRowFields_Receipt_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Unprocessed_Fragment': TableDocumentsRowFields_Unprocessed_Fragment } }
    )
  > } & { ' $fragmentName'?: 'ChargeForCsvExportFields_CreditcardBankCharge_Fragment' };

type ChargeForCsvExportFields_DividendCharge_Fragment = { __typename: 'DividendCharge', id: string, minEventDate: unknown, minDebitDate: unknown, minDocumentsDate: unknown, userDescription: string | null, accountantApproval: AccountantStatus, totalAmount: { raw: number, currency: Currency } | null, vat: { raw: number } | null, counterparty:
    | { id: string, name: string }
    | { id: string, name: string }
    | { id: string, name: string }
   | null, tags: Array<{ id: string, name: string }>, taxCategory: { id: string, name: string } | null, validationData: { isValid: boolean, missingInfo: Array<MissingChargeInfo> } | null, missingInfoSuggestions: { description: string | null, tags: Array<{ id: string, name: string }> } | null, metadata: { transactionsCount: number, documentsCount: number, invoicesCount: number, receiptsCount: number, ledgerCount: number, miscExpensesCount: number, openDocuments: boolean, invalidLedger: LedgerValidationStatus } | null, ledger: { balance: { isBalanced: boolean } | null, validate: { isValid: boolean, errors: Array<string> } }, transactions: Array<
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_CommonTransaction_Fragment': TransactionForTransactionsTableFields_CommonTransaction_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_ConversionTransaction_Fragment': TransactionForTransactionsTableFields_ConversionTransaction_Fragment } }
    )
  >, additionalDocuments: Array<
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_CreditInvoice_Fragment': TableDocumentsRowFields_CreditInvoice_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Invoice_Fragment': TableDocumentsRowFields_Invoice_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_InvoiceReceipt_Fragment': TableDocumentsRowFields_InvoiceReceipt_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_OtherDocument_Fragment': TableDocumentsRowFields_OtherDocument_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Proforma_Fragment': TableDocumentsRowFields_Proforma_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Receipt_Fragment': TableDocumentsRowFields_Receipt_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Unprocessed_Fragment': TableDocumentsRowFields_Unprocessed_Fragment } }
    )
  > } & { ' $fragmentName'?: 'ChargeForCsvExportFields_DividendCharge_Fragment' };

type ChargeForCsvExportFields_FinancialCharge_Fragment = { __typename: 'FinancialCharge', id: string, minEventDate: unknown, minDebitDate: unknown, minDocumentsDate: unknown, userDescription: string | null, accountantApproval: AccountantStatus, totalAmount: { raw: number, currency: Currency } | null, vat: { raw: number } | null, counterparty:
    | { id: string, name: string }
    | { id: string, name: string }
    | { id: string, name: string }
   | null, tags: Array<{ id: string, name: string }>, taxCategory: { id: string, name: string } | null, validationData: { isValid: boolean, missingInfo: Array<MissingChargeInfo> } | null, missingInfoSuggestions: { description: string | null, tags: Array<{ id: string, name: string }> } | null, metadata: { transactionsCount: number, documentsCount: number, invoicesCount: number, receiptsCount: number, ledgerCount: number, miscExpensesCount: number, openDocuments: boolean, invalidLedger: LedgerValidationStatus } | null, ledger: { balance: { isBalanced: boolean } | null, validate: { isValid: boolean, errors: Array<string> } }, transactions: Array<
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_CommonTransaction_Fragment': TransactionForTransactionsTableFields_CommonTransaction_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_ConversionTransaction_Fragment': TransactionForTransactionsTableFields_ConversionTransaction_Fragment } }
    )
  >, additionalDocuments: Array<
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_CreditInvoice_Fragment': TableDocumentsRowFields_CreditInvoice_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Invoice_Fragment': TableDocumentsRowFields_Invoice_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_InvoiceReceipt_Fragment': TableDocumentsRowFields_InvoiceReceipt_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_OtherDocument_Fragment': TableDocumentsRowFields_OtherDocument_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Proforma_Fragment': TableDocumentsRowFields_Proforma_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Receipt_Fragment': TableDocumentsRowFields_Receipt_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Unprocessed_Fragment': TableDocumentsRowFields_Unprocessed_Fragment } }
    )
  > } & { ' $fragmentName'?: 'ChargeForCsvExportFields_FinancialCharge_Fragment' };

type ChargeForCsvExportFields_ForeignSecuritiesCharge_Fragment = { __typename: 'ForeignSecuritiesCharge', id: string, minEventDate: unknown, minDebitDate: unknown, minDocumentsDate: unknown, userDescription: string | null, accountantApproval: AccountantStatus, totalAmount: { raw: number, currency: Currency } | null, vat: { raw: number } | null, counterparty:
    | { id: string, name: string }
    | { id: string, name: string }
    | { id: string, name: string }
   | null, tags: Array<{ id: string, name: string }>, taxCategory: { id: string, name: string } | null, validationData: { isValid: boolean, missingInfo: Array<MissingChargeInfo> } | null, missingInfoSuggestions: { description: string | null, tags: Array<{ id: string, name: string }> } | null, metadata: { transactionsCount: number, documentsCount: number, invoicesCount: number, receiptsCount: number, ledgerCount: number, miscExpensesCount: number, openDocuments: boolean, invalidLedger: LedgerValidationStatus } | null, ledger: { balance: { isBalanced: boolean } | null, validate: { isValid: boolean, errors: Array<string> } }, transactions: Array<
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_CommonTransaction_Fragment': TransactionForTransactionsTableFields_CommonTransaction_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_ConversionTransaction_Fragment': TransactionForTransactionsTableFields_ConversionTransaction_Fragment } }
    )
  >, additionalDocuments: Array<
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_CreditInvoice_Fragment': TableDocumentsRowFields_CreditInvoice_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Invoice_Fragment': TableDocumentsRowFields_Invoice_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_InvoiceReceipt_Fragment': TableDocumentsRowFields_InvoiceReceipt_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_OtherDocument_Fragment': TableDocumentsRowFields_OtherDocument_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Proforma_Fragment': TableDocumentsRowFields_Proforma_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Receipt_Fragment': TableDocumentsRowFields_Receipt_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Unprocessed_Fragment': TableDocumentsRowFields_Unprocessed_Fragment } }
    )
  > } & { ' $fragmentName'?: 'ChargeForCsvExportFields_ForeignSecuritiesCharge_Fragment' };

type ChargeForCsvExportFields_InternalTransferCharge_Fragment = { __typename: 'InternalTransferCharge', id: string, minEventDate: unknown, minDebitDate: unknown, minDocumentsDate: unknown, userDescription: string | null, accountantApproval: AccountantStatus, totalAmount: { raw: number, currency: Currency } | null, vat: { raw: number } | null, counterparty:
    | { id: string, name: string }
    | { id: string, name: string }
    | { id: string, name: string }
   | null, tags: Array<{ id: string, name: string }>, taxCategory: { id: string, name: string } | null, validationData: { isValid: boolean, missingInfo: Array<MissingChargeInfo> } | null, missingInfoSuggestions: { description: string | null, tags: Array<{ id: string, name: string }> } | null, metadata: { transactionsCount: number, documentsCount: number, invoicesCount: number, receiptsCount: number, ledgerCount: number, miscExpensesCount: number, openDocuments: boolean, invalidLedger: LedgerValidationStatus } | null, ledger: { balance: { isBalanced: boolean } | null, validate: { isValid: boolean, errors: Array<string> } }, transactions: Array<
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_CommonTransaction_Fragment': TransactionForTransactionsTableFields_CommonTransaction_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_ConversionTransaction_Fragment': TransactionForTransactionsTableFields_ConversionTransaction_Fragment } }
    )
  >, additionalDocuments: Array<
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_CreditInvoice_Fragment': TableDocumentsRowFields_CreditInvoice_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Invoice_Fragment': TableDocumentsRowFields_Invoice_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_InvoiceReceipt_Fragment': TableDocumentsRowFields_InvoiceReceipt_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_OtherDocument_Fragment': TableDocumentsRowFields_OtherDocument_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Proforma_Fragment': TableDocumentsRowFields_Proforma_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Receipt_Fragment': TableDocumentsRowFields_Receipt_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Unprocessed_Fragment': TableDocumentsRowFields_Unprocessed_Fragment } }
    )
  > } & { ' $fragmentName'?: 'ChargeForCsvExportFields_InternalTransferCharge_Fragment' };

type ChargeForCsvExportFields_MonthlyVatCharge_Fragment = { __typename: 'MonthlyVatCharge', id: string, minEventDate: unknown, minDebitDate: unknown, minDocumentsDate: unknown, userDescription: string | null, accountantApproval: AccountantStatus, totalAmount: { raw: number, currency: Currency } | null, vat: { raw: number } | null, counterparty:
    | { id: string, name: string }
    | { id: string, name: string }
    | { id: string, name: string }
   | null, tags: Array<{ id: string, name: string }>, taxCategory: { id: string, name: string } | null, validationData: { isValid: boolean, missingInfo: Array<MissingChargeInfo> } | null, missingInfoSuggestions: { description: string | null, tags: Array<{ id: string, name: string }> } | null, metadata: { transactionsCount: number, documentsCount: number, invoicesCount: number, receiptsCount: number, ledgerCount: number, miscExpensesCount: number, openDocuments: boolean, invalidLedger: LedgerValidationStatus } | null, ledger: { balance: { isBalanced: boolean } | null, validate: { isValid: boolean, errors: Array<string> } }, transactions: Array<
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_CommonTransaction_Fragment': TransactionForTransactionsTableFields_CommonTransaction_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_ConversionTransaction_Fragment': TransactionForTransactionsTableFields_ConversionTransaction_Fragment } }
    )
  >, additionalDocuments: Array<
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_CreditInvoice_Fragment': TableDocumentsRowFields_CreditInvoice_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Invoice_Fragment': TableDocumentsRowFields_Invoice_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_InvoiceReceipt_Fragment': TableDocumentsRowFields_InvoiceReceipt_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_OtherDocument_Fragment': TableDocumentsRowFields_OtherDocument_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Proforma_Fragment': TableDocumentsRowFields_Proforma_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Receipt_Fragment': TableDocumentsRowFields_Receipt_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Unprocessed_Fragment': TableDocumentsRowFields_Unprocessed_Fragment } }
    )
  > } & { ' $fragmentName'?: 'ChargeForCsvExportFields_MonthlyVatCharge_Fragment' };

type ChargeForCsvExportFields_SalaryCharge_Fragment = { __typename: 'SalaryCharge', id: string, minEventDate: unknown, minDebitDate: unknown, minDocumentsDate: unknown, userDescription: string | null, accountantApproval: AccountantStatus, totalAmount: { raw: number, currency: Currency } | null, vat: { raw: number } | null, counterparty:
    | { id: string, name: string }
    | { id: string, name: string }
    | { id: string, name: string }
   | null, tags: Array<{ id: string, name: string }>, taxCategory: { id: string, name: string } | null, validationData: { isValid: boolean, missingInfo: Array<MissingChargeInfo> } | null, missingInfoSuggestions: { description: string | null, tags: Array<{ id: string, name: string }> } | null, metadata: { transactionsCount: number, documentsCount: number, invoicesCount: number, receiptsCount: number, ledgerCount: number, miscExpensesCount: number, openDocuments: boolean, invalidLedger: LedgerValidationStatus } | null, ledger: { balance: { isBalanced: boolean } | null, validate: { isValid: boolean, errors: Array<string> } }, transactions: Array<
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_CommonTransaction_Fragment': TransactionForTransactionsTableFields_CommonTransaction_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_ConversionTransaction_Fragment': TransactionForTransactionsTableFields_ConversionTransaction_Fragment } }
    )
  >, additionalDocuments: Array<
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_CreditInvoice_Fragment': TableDocumentsRowFields_CreditInvoice_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Invoice_Fragment': TableDocumentsRowFields_Invoice_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_InvoiceReceipt_Fragment': TableDocumentsRowFields_InvoiceReceipt_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_OtherDocument_Fragment': TableDocumentsRowFields_OtherDocument_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Proforma_Fragment': TableDocumentsRowFields_Proforma_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Receipt_Fragment': TableDocumentsRowFields_Receipt_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Unprocessed_Fragment': TableDocumentsRowFields_Unprocessed_Fragment } }
    )
  > } & { ' $fragmentName'?: 'ChargeForCsvExportFields_SalaryCharge_Fragment' };

export type ChargeForCsvExportFieldsFragment =
  | ChargeForCsvExportFields_BankDepositCharge_Fragment
  | ChargeForCsvExportFields_BusinessTripCharge_Fragment
  | ChargeForCsvExportFields_CommonCharge_Fragment
  | ChargeForCsvExportFields_ConversionCharge_Fragment
  | ChargeForCsvExportFields_CreditcardBankCharge_Fragment
  | ChargeForCsvExportFields_DividendCharge_Fragment
  | ChargeForCsvExportFields_FinancialCharge_Fragment
  | ChargeForCsvExportFields_ForeignSecuritiesCharge_Fragment
  | ChargeForCsvExportFields_InternalTransferCharge_Fragment
  | ChargeForCsvExportFields_MonthlyVatCharge_Fragment
  | ChargeForCsvExportFields_SalaryCharge_Fragment
;

export type ChargesForCsvExportQueryVariables = Exact<{
  chargeIDs: Array<string> | string;
}>;


export type ChargesForCsvExportQuery = { chargesByIDs: Array<
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'ChargeForCsvExportFields_BankDepositCharge_Fragment': ChargeForCsvExportFields_BankDepositCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'ChargeForCsvExportFields_BusinessTripCharge_Fragment': ChargeForCsvExportFields_BusinessTripCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'ChargeForCsvExportFields_CommonCharge_Fragment': ChargeForCsvExportFields_CommonCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'ChargeForCsvExportFields_ConversionCharge_Fragment': ChargeForCsvExportFields_ConversionCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'ChargeForCsvExportFields_CreditcardBankCharge_Fragment': ChargeForCsvExportFields_CreditcardBankCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'ChargeForCsvExportFields_DividendCharge_Fragment': ChargeForCsvExportFields_DividendCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'ChargeForCsvExportFields_FinancialCharge_Fragment': ChargeForCsvExportFields_FinancialCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'ChargeForCsvExportFields_ForeignSecuritiesCharge_Fragment': ChargeForCsvExportFields_ForeignSecuritiesCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'ChargeForCsvExportFields_InternalTransferCharge_Fragment': ChargeForCsvExportFields_InternalTransferCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'ChargeForCsvExportFields_MonthlyVatCharge_Fragment': ChargeForCsvExportFields_MonthlyVatCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'ChargeForCsvExportFields_SalaryCharge_Fragment': ChargeForCsvExportFields_SalaryCharge_Fragment } }
    )
  > };

export type BankDepositInfoQueryVariables = Exact<{
  chargeId: string;
}>;


export type BankDepositInfoQuery = { depositByCharge: { id: string, name: string, isOpen: boolean, metadata: { id: string, currentBalance: { formatted: string }, transactions: Array<
        | (
          { id: string, chargeId: string }
          & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_CommonTransaction_Fragment': TransactionForTransactionsTableFields_CommonTransaction_Fragment } }
        )
        | (
          { id: string, chargeId: string }
          & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_ConversionTransaction_Fragment': TransactionForTransactionsTableFields_ConversionTransaction_Fragment } }
        )
      > } } | null };

export type ChargeMatchesQueryVariables = Exact<{
  chargeId: string;
}>;


export type ChargeMatchesQuery = { findChargeMatches: { matches: Array<(
      { chargeId: string }
      & { ' $fragmentRefs'?: { 'ChargeMatchesTableFieldsFragment': ChargeMatchesTableFieldsFragment } }
    )> } };

type ConversionChargeInfo_BankDepositCharge_Fragment = { __typename: 'BankDepositCharge', id: string } & { ' $fragmentName'?: 'ConversionChargeInfo_BankDepositCharge_Fragment' };

type ConversionChargeInfo_BusinessTripCharge_Fragment = { __typename: 'BusinessTripCharge', id: string } & { ' $fragmentName'?: 'ConversionChargeInfo_BusinessTripCharge_Fragment' };

type ConversionChargeInfo_CommonCharge_Fragment = { __typename: 'CommonCharge', id: string } & { ' $fragmentName'?: 'ConversionChargeInfo_CommonCharge_Fragment' };

type ConversionChargeInfo_ConversionCharge_Fragment = { __typename: 'ConversionCharge', id: string, eventRate: { from: Currency, to: Currency, rate: number } | null, officialRate: { from: Currency, to: Currency, rate: number } | null } & { ' $fragmentName'?: 'ConversionChargeInfo_ConversionCharge_Fragment' };

type ConversionChargeInfo_CreditcardBankCharge_Fragment = { __typename: 'CreditcardBankCharge', id: string } & { ' $fragmentName'?: 'ConversionChargeInfo_CreditcardBankCharge_Fragment' };

type ConversionChargeInfo_DividendCharge_Fragment = { __typename: 'DividendCharge', id: string } & { ' $fragmentName'?: 'ConversionChargeInfo_DividendCharge_Fragment' };

type ConversionChargeInfo_FinancialCharge_Fragment = { __typename: 'FinancialCharge', id: string } & { ' $fragmentName'?: 'ConversionChargeInfo_FinancialCharge_Fragment' };

type ConversionChargeInfo_ForeignSecuritiesCharge_Fragment = { __typename: 'ForeignSecuritiesCharge', id: string } & { ' $fragmentName'?: 'ConversionChargeInfo_ForeignSecuritiesCharge_Fragment' };

type ConversionChargeInfo_InternalTransferCharge_Fragment = { __typename: 'InternalTransferCharge', id: string } & { ' $fragmentName'?: 'ConversionChargeInfo_InternalTransferCharge_Fragment' };

type ConversionChargeInfo_MonthlyVatCharge_Fragment = { __typename: 'MonthlyVatCharge', id: string } & { ' $fragmentName'?: 'ConversionChargeInfo_MonthlyVatCharge_Fragment' };

type ConversionChargeInfo_SalaryCharge_Fragment = { __typename: 'SalaryCharge', id: string } & { ' $fragmentName'?: 'ConversionChargeInfo_SalaryCharge_Fragment' };

export type ConversionChargeInfoFragment =
  | ConversionChargeInfo_BankDepositCharge_Fragment
  | ConversionChargeInfo_BusinessTripCharge_Fragment
  | ConversionChargeInfo_CommonCharge_Fragment
  | ConversionChargeInfo_ConversionCharge_Fragment
  | ConversionChargeInfo_CreditcardBankCharge_Fragment
  | ConversionChargeInfo_DividendCharge_Fragment
  | ConversionChargeInfo_FinancialCharge_Fragment
  | ConversionChargeInfo_ForeignSecuritiesCharge_Fragment
  | ConversionChargeInfo_InternalTransferCharge_Fragment
  | ConversionChargeInfo_MonthlyVatCharge_Fragment
  | ConversionChargeInfo_SalaryCharge_Fragment
;

type CreditcardBankChargeInfo_BankDepositCharge_Fragment = { __typename: 'BankDepositCharge', id: string } & { ' $fragmentName'?: 'CreditcardBankChargeInfo_BankDepositCharge_Fragment' };

type CreditcardBankChargeInfo_BusinessTripCharge_Fragment = { __typename: 'BusinessTripCharge', id: string } & { ' $fragmentName'?: 'CreditcardBankChargeInfo_BusinessTripCharge_Fragment' };

type CreditcardBankChargeInfo_CommonCharge_Fragment = { __typename: 'CommonCharge', id: string } & { ' $fragmentName'?: 'CreditcardBankChargeInfo_CommonCharge_Fragment' };

type CreditcardBankChargeInfo_ConversionCharge_Fragment = { __typename: 'ConversionCharge', id: string } & { ' $fragmentName'?: 'CreditcardBankChargeInfo_ConversionCharge_Fragment' };

type CreditcardBankChargeInfo_CreditcardBankCharge_Fragment = { __typename: 'CreditcardBankCharge', id: string, creditCardTransactions: Array<
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_CommonTransaction_Fragment': TransactionForTransactionsTableFields_CommonTransaction_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_ConversionTransaction_Fragment': TransactionForTransactionsTableFields_ConversionTransaction_Fragment } }
    )
  > } & { ' $fragmentName'?: 'CreditcardBankChargeInfo_CreditcardBankCharge_Fragment' };

type CreditcardBankChargeInfo_DividendCharge_Fragment = { __typename: 'DividendCharge', id: string } & { ' $fragmentName'?: 'CreditcardBankChargeInfo_DividendCharge_Fragment' };

type CreditcardBankChargeInfo_FinancialCharge_Fragment = { __typename: 'FinancialCharge', id: string } & { ' $fragmentName'?: 'CreditcardBankChargeInfo_FinancialCharge_Fragment' };

type CreditcardBankChargeInfo_ForeignSecuritiesCharge_Fragment = { __typename: 'ForeignSecuritiesCharge', id: string } & { ' $fragmentName'?: 'CreditcardBankChargeInfo_ForeignSecuritiesCharge_Fragment' };

type CreditcardBankChargeInfo_InternalTransferCharge_Fragment = { __typename: 'InternalTransferCharge', id: string } & { ' $fragmentName'?: 'CreditcardBankChargeInfo_InternalTransferCharge_Fragment' };

type CreditcardBankChargeInfo_MonthlyVatCharge_Fragment = { __typename: 'MonthlyVatCharge', id: string } & { ' $fragmentName'?: 'CreditcardBankChargeInfo_MonthlyVatCharge_Fragment' };

type CreditcardBankChargeInfo_SalaryCharge_Fragment = { __typename: 'SalaryCharge', id: string } & { ' $fragmentName'?: 'CreditcardBankChargeInfo_SalaryCharge_Fragment' };

export type CreditcardBankChargeInfoFragment =
  | CreditcardBankChargeInfo_BankDepositCharge_Fragment
  | CreditcardBankChargeInfo_BusinessTripCharge_Fragment
  | CreditcardBankChargeInfo_CommonCharge_Fragment
  | CreditcardBankChargeInfo_ConversionCharge_Fragment
  | CreditcardBankChargeInfo_CreditcardBankCharge_Fragment
  | CreditcardBankChargeInfo_DividendCharge_Fragment
  | CreditcardBankChargeInfo_FinancialCharge_Fragment
  | CreditcardBankChargeInfo_ForeignSecuritiesCharge_Fragment
  | CreditcardBankChargeInfo_InternalTransferCharge_Fragment
  | CreditcardBankChargeInfo_MonthlyVatCharge_Fragment
  | CreditcardBankChargeInfo_SalaryCharge_Fragment
;

type ExchangeRatesInfo_BankDepositCharge_Fragment = { __typename: 'BankDepositCharge', id: string } & { ' $fragmentName'?: 'ExchangeRatesInfo_BankDepositCharge_Fragment' };

type ExchangeRatesInfo_BusinessTripCharge_Fragment = { __typename: 'BusinessTripCharge', id: string } & { ' $fragmentName'?: 'ExchangeRatesInfo_BusinessTripCharge_Fragment' };

type ExchangeRatesInfo_CommonCharge_Fragment = { __typename: 'CommonCharge', id: string } & { ' $fragmentName'?: 'ExchangeRatesInfo_CommonCharge_Fragment' };

type ExchangeRatesInfo_ConversionCharge_Fragment = { __typename: 'ConversionCharge', id: string } & { ' $fragmentName'?: 'ExchangeRatesInfo_ConversionCharge_Fragment' };

type ExchangeRatesInfo_CreditcardBankCharge_Fragment = { __typename: 'CreditcardBankCharge', id: string } & { ' $fragmentName'?: 'ExchangeRatesInfo_CreditcardBankCharge_Fragment' };

type ExchangeRatesInfo_DividendCharge_Fragment = { __typename: 'DividendCharge', id: string } & { ' $fragmentName'?: 'ExchangeRatesInfo_DividendCharge_Fragment' };

type ExchangeRatesInfo_FinancialCharge_Fragment = { __typename: 'FinancialCharge', id: string, exchangeRates: { aud: number | null, cad: number | null, eur: number | null, gbp: number | null, ils: number | null, jpy: number | null, sek: number | null, usd: number | null, eth: number | null, grt: number | null, usdc: number | null } | null } & { ' $fragmentName'?: 'ExchangeRatesInfo_FinancialCharge_Fragment' };

type ExchangeRatesInfo_ForeignSecuritiesCharge_Fragment = { __typename: 'ForeignSecuritiesCharge', id: string } & { ' $fragmentName'?: 'ExchangeRatesInfo_ForeignSecuritiesCharge_Fragment' };

type ExchangeRatesInfo_InternalTransferCharge_Fragment = { __typename: 'InternalTransferCharge', id: string } & { ' $fragmentName'?: 'ExchangeRatesInfo_InternalTransferCharge_Fragment' };

type ExchangeRatesInfo_MonthlyVatCharge_Fragment = { __typename: 'MonthlyVatCharge', id: string } & { ' $fragmentName'?: 'ExchangeRatesInfo_MonthlyVatCharge_Fragment' };

type ExchangeRatesInfo_SalaryCharge_Fragment = { __typename: 'SalaryCharge', id: string } & { ' $fragmentName'?: 'ExchangeRatesInfo_SalaryCharge_Fragment' };

export type ExchangeRatesInfoFragment =
  | ExchangeRatesInfo_BankDepositCharge_Fragment
  | ExchangeRatesInfo_BusinessTripCharge_Fragment
  | ExchangeRatesInfo_CommonCharge_Fragment
  | ExchangeRatesInfo_ConversionCharge_Fragment
  | ExchangeRatesInfo_CreditcardBankCharge_Fragment
  | ExchangeRatesInfo_DividendCharge_Fragment
  | ExchangeRatesInfo_FinancialCharge_Fragment
  | ExchangeRatesInfo_ForeignSecuritiesCharge_Fragment
  | ExchangeRatesInfo_InternalTransferCharge_Fragment
  | ExchangeRatesInfo_MonthlyVatCharge_Fragment
  | ExchangeRatesInfo_SalaryCharge_Fragment
;

type TableMiscExpensesFields_BankDepositCharge_Fragment = { id: string, miscExpenses: Array<(
    { id: string, description: string | null, invoiceDate: unknown, valueDate: unknown, chargeId: string, amount: { formatted: string }, creditor:
      | { id: string, name: string }
      | { id: string, name: string }
      | { id: string, name: string }
    , debtor:
      | { id: string, name: string }
      | { id: string, name: string }
      | { id: string, name: string }
     }
    & { ' $fragmentRefs'?: { 'EditMiscExpenseFieldsFragment': EditMiscExpenseFieldsFragment } }
  )> } & { ' $fragmentName'?: 'TableMiscExpensesFields_BankDepositCharge_Fragment' };

type TableMiscExpensesFields_BusinessTripCharge_Fragment = { id: string, miscExpenses: Array<(
    { id: string, description: string | null, invoiceDate: unknown, valueDate: unknown, chargeId: string, amount: { formatted: string }, creditor:
      | { id: string, name: string }
      | { id: string, name: string }
      | { id: string, name: string }
    , debtor:
      | { id: string, name: string }
      | { id: string, name: string }
      | { id: string, name: string }
     }
    & { ' $fragmentRefs'?: { 'EditMiscExpenseFieldsFragment': EditMiscExpenseFieldsFragment } }
  )> } & { ' $fragmentName'?: 'TableMiscExpensesFields_BusinessTripCharge_Fragment' };

type TableMiscExpensesFields_CommonCharge_Fragment = { id: string, miscExpenses: Array<(
    { id: string, description: string | null, invoiceDate: unknown, valueDate: unknown, chargeId: string, amount: { formatted: string }, creditor:
      | { id: string, name: string }
      | { id: string, name: string }
      | { id: string, name: string }
    , debtor:
      | { id: string, name: string }
      | { id: string, name: string }
      | { id: string, name: string }
     }
    & { ' $fragmentRefs'?: { 'EditMiscExpenseFieldsFragment': EditMiscExpenseFieldsFragment } }
  )> } & { ' $fragmentName'?: 'TableMiscExpensesFields_CommonCharge_Fragment' };

type TableMiscExpensesFields_ConversionCharge_Fragment = { id: string, miscExpenses: Array<(
    { id: string, description: string | null, invoiceDate: unknown, valueDate: unknown, chargeId: string, amount: { formatted: string }, creditor:
      | { id: string, name: string }
      | { id: string, name: string }
      | { id: string, name: string }
    , debtor:
      | { id: string, name: string }
      | { id: string, name: string }
      | { id: string, name: string }
     }
    & { ' $fragmentRefs'?: { 'EditMiscExpenseFieldsFragment': EditMiscExpenseFieldsFragment } }
  )> } & { ' $fragmentName'?: 'TableMiscExpensesFields_ConversionCharge_Fragment' };

type TableMiscExpensesFields_CreditcardBankCharge_Fragment = { id: string, miscExpenses: Array<(
    { id: string, description: string | null, invoiceDate: unknown, valueDate: unknown, chargeId: string, amount: { formatted: string }, creditor:
      | { id: string, name: string }
      | { id: string, name: string }
      | { id: string, name: string }
    , debtor:
      | { id: string, name: string }
      | { id: string, name: string }
      | { id: string, name: string }
     }
    & { ' $fragmentRefs'?: { 'EditMiscExpenseFieldsFragment': EditMiscExpenseFieldsFragment } }
  )> } & { ' $fragmentName'?: 'TableMiscExpensesFields_CreditcardBankCharge_Fragment' };

type TableMiscExpensesFields_DividendCharge_Fragment = { id: string, miscExpenses: Array<(
    { id: string, description: string | null, invoiceDate: unknown, valueDate: unknown, chargeId: string, amount: { formatted: string }, creditor:
      | { id: string, name: string }
      | { id: string, name: string }
      | { id: string, name: string }
    , debtor:
      | { id: string, name: string }
      | { id: string, name: string }
      | { id: string, name: string }
     }
    & { ' $fragmentRefs'?: { 'EditMiscExpenseFieldsFragment': EditMiscExpenseFieldsFragment } }
  )> } & { ' $fragmentName'?: 'TableMiscExpensesFields_DividendCharge_Fragment' };

type TableMiscExpensesFields_FinancialCharge_Fragment = { id: string, miscExpenses: Array<(
    { id: string, description: string | null, invoiceDate: unknown, valueDate: unknown, chargeId: string, amount: { formatted: string }, creditor:
      | { id: string, name: string }
      | { id: string, name: string }
      | { id: string, name: string }
    , debtor:
      | { id: string, name: string }
      | { id: string, name: string }
      | { id: string, name: string }
     }
    & { ' $fragmentRefs'?: { 'EditMiscExpenseFieldsFragment': EditMiscExpenseFieldsFragment } }
  )> } & { ' $fragmentName'?: 'TableMiscExpensesFields_FinancialCharge_Fragment' };

type TableMiscExpensesFields_ForeignSecuritiesCharge_Fragment = { id: string, miscExpenses: Array<(
    { id: string, description: string | null, invoiceDate: unknown, valueDate: unknown, chargeId: string, amount: { formatted: string }, creditor:
      | { id: string, name: string }
      | { id: string, name: string }
      | { id: string, name: string }
    , debtor:
      | { id: string, name: string }
      | { id: string, name: string }
      | { id: string, name: string }
     }
    & { ' $fragmentRefs'?: { 'EditMiscExpenseFieldsFragment': EditMiscExpenseFieldsFragment } }
  )> } & { ' $fragmentName'?: 'TableMiscExpensesFields_ForeignSecuritiesCharge_Fragment' };

type TableMiscExpensesFields_InternalTransferCharge_Fragment = { id: string, miscExpenses: Array<(
    { id: string, description: string | null, invoiceDate: unknown, valueDate: unknown, chargeId: string, amount: { formatted: string }, creditor:
      | { id: string, name: string }
      | { id: string, name: string }
      | { id: string, name: string }
    , debtor:
      | { id: string, name: string }
      | { id: string, name: string }
      | { id: string, name: string }
     }
    & { ' $fragmentRefs'?: { 'EditMiscExpenseFieldsFragment': EditMiscExpenseFieldsFragment } }
  )> } & { ' $fragmentName'?: 'TableMiscExpensesFields_InternalTransferCharge_Fragment' };

type TableMiscExpensesFields_MonthlyVatCharge_Fragment = { id: string, miscExpenses: Array<(
    { id: string, description: string | null, invoiceDate: unknown, valueDate: unknown, chargeId: string, amount: { formatted: string }, creditor:
      | { id: string, name: string }
      | { id: string, name: string }
      | { id: string, name: string }
    , debtor:
      | { id: string, name: string }
      | { id: string, name: string }
      | { id: string, name: string }
     }
    & { ' $fragmentRefs'?: { 'EditMiscExpenseFieldsFragment': EditMiscExpenseFieldsFragment } }
  )> } & { ' $fragmentName'?: 'TableMiscExpensesFields_MonthlyVatCharge_Fragment' };

type TableMiscExpensesFields_SalaryCharge_Fragment = { id: string, miscExpenses: Array<(
    { id: string, description: string | null, invoiceDate: unknown, valueDate: unknown, chargeId: string, amount: { formatted: string }, creditor:
      | { id: string, name: string }
      | { id: string, name: string }
      | { id: string, name: string }
    , debtor:
      | { id: string, name: string }
      | { id: string, name: string }
      | { id: string, name: string }
     }
    & { ' $fragmentRefs'?: { 'EditMiscExpenseFieldsFragment': EditMiscExpenseFieldsFragment } }
  )> } & { ' $fragmentName'?: 'TableMiscExpensesFields_SalaryCharge_Fragment' };

export type TableMiscExpensesFieldsFragment =
  | TableMiscExpensesFields_BankDepositCharge_Fragment
  | TableMiscExpensesFields_BusinessTripCharge_Fragment
  | TableMiscExpensesFields_CommonCharge_Fragment
  | TableMiscExpensesFields_ConversionCharge_Fragment
  | TableMiscExpensesFields_CreditcardBankCharge_Fragment
  | TableMiscExpensesFields_DividendCharge_Fragment
  | TableMiscExpensesFields_FinancialCharge_Fragment
  | TableMiscExpensesFields_ForeignSecuritiesCharge_Fragment
  | TableMiscExpensesFields_InternalTransferCharge_Fragment
  | TableMiscExpensesFields_MonthlyVatCharge_Fragment
  | TableMiscExpensesFields_SalaryCharge_Fragment
;

type TableSalariesFields_BankDepositCharge_Fragment = { __typename: 'BankDepositCharge', id: string } & { ' $fragmentName'?: 'TableSalariesFields_BankDepositCharge_Fragment' };

type TableSalariesFields_BusinessTripCharge_Fragment = { __typename: 'BusinessTripCharge', id: string } & { ' $fragmentName'?: 'TableSalariesFields_BusinessTripCharge_Fragment' };

type TableSalariesFields_CommonCharge_Fragment = { __typename: 'CommonCharge', id: string } & { ' $fragmentName'?: 'TableSalariesFields_CommonCharge_Fragment' };

type TableSalariesFields_ConversionCharge_Fragment = { __typename: 'ConversionCharge', id: string } & { ' $fragmentName'?: 'TableSalariesFields_ConversionCharge_Fragment' };

type TableSalariesFields_CreditcardBankCharge_Fragment = { __typename: 'CreditcardBankCharge', id: string } & { ' $fragmentName'?: 'TableSalariesFields_CreditcardBankCharge_Fragment' };

type TableSalariesFields_DividendCharge_Fragment = { __typename: 'DividendCharge', id: string } & { ' $fragmentName'?: 'TableSalariesFields_DividendCharge_Fragment' };

type TableSalariesFields_FinancialCharge_Fragment = { __typename: 'FinancialCharge', id: string } & { ' $fragmentName'?: 'TableSalariesFields_FinancialCharge_Fragment' };

type TableSalariesFields_ForeignSecuritiesCharge_Fragment = { __typename: 'ForeignSecuritiesCharge', id: string } & { ' $fragmentName'?: 'TableSalariesFields_ForeignSecuritiesCharge_Fragment' };

type TableSalariesFields_InternalTransferCharge_Fragment = { __typename: 'InternalTransferCharge', id: string } & { ' $fragmentName'?: 'TableSalariesFields_InternalTransferCharge_Fragment' };

type TableSalariesFields_MonthlyVatCharge_Fragment = { __typename: 'MonthlyVatCharge', id: string } & { ' $fragmentName'?: 'TableSalariesFields_MonthlyVatCharge_Fragment' };

type TableSalariesFields_SalaryCharge_Fragment = { __typename: 'SalaryCharge', id: string, salaryRecords: Array<{ directAmount: { formatted: string }, baseAmount: { formatted: string } | null, employee: { id: string, name: string } | null, pensionFund: { id: string, name: string } | null, pensionEmployeeAmount: { formatted: string } | null, pensionEmployerAmount: { formatted: string } | null, compensationsAmount: { formatted: string } | null, trainingFund: { id: string, name: string } | null, trainingFundEmployeeAmount: { formatted: string } | null, trainingFundEmployerAmount: { formatted: string } | null, socialSecurityEmployeeAmount: { formatted: string } | null, socialSecurityEmployerAmount: { formatted: string } | null, incomeTaxAmount: { formatted: string } | null, healthInsuranceAmount: { formatted: string } | null }> } & { ' $fragmentName'?: 'TableSalariesFields_SalaryCharge_Fragment' };

export type TableSalariesFieldsFragment =
  | TableSalariesFields_BankDepositCharge_Fragment
  | TableSalariesFields_BusinessTripCharge_Fragment
  | TableSalariesFields_CommonCharge_Fragment
  | TableSalariesFields_ConversionCharge_Fragment
  | TableSalariesFields_CreditcardBankCharge_Fragment
  | TableSalariesFields_DividendCharge_Fragment
  | TableSalariesFields_FinancialCharge_Fragment
  | TableSalariesFields_ForeignSecuritiesCharge_Fragment
  | TableSalariesFields_InternalTransferCharge_Fragment
  | TableSalariesFields_MonthlyVatCharge_Fragment
  | TableSalariesFields_SalaryCharge_Fragment
;

export type IncomeChargesChartQueryVariables = Exact<{
  filters?: ChargeFilter | null | undefined;
}>;


export type IncomeChargesChartQuery = { allCharges: { nodes: Array<
      | { id: string, transactions: Array<
          | { id: string, eventDate: unknown, effectiveDate: unknown, amount: { currency: Currency, formatted: string, raw: number }, eventExchangeRates: { aud: number | null, cad: number | null, eur: number | null, gbp: number | null, jpy: number | null, sek: number | null, usd: number | null, date: unknown } | null, debitExchangeRates: { aud: number | null, cad: number | null, eur: number | null, gbp: number | null, jpy: number | null, sek: number | null, usd: number | null, date: unknown } | null }
          | { id: string, eventDate: unknown, effectiveDate: unknown, amount: { currency: Currency, formatted: string, raw: number }, eventExchangeRates: { aud: number | null, cad: number | null, eur: number | null, gbp: number | null, jpy: number | null, sek: number | null, usd: number | null, date: unknown } | null, debitExchangeRates: { aud: number | null, cad: number | null, eur: number | null, gbp: number | null, jpy: number | null, sek: number | null, usd: number | null, date: unknown } | null }
        > }
      | { id: string, transactions: Array<
          | { id: string, eventDate: unknown, effectiveDate: unknown, amount: { currency: Currency, formatted: string, raw: number }, eventExchangeRates: { aud: number | null, cad: number | null, eur: number | null, gbp: number | null, jpy: number | null, sek: number | null, usd: number | null, date: unknown } | null, debitExchangeRates: { aud: number | null, cad: number | null, eur: number | null, gbp: number | null, jpy: number | null, sek: number | null, usd: number | null, date: unknown } | null }
          | { id: string, eventDate: unknown, effectiveDate: unknown, amount: { currency: Currency, formatted: string, raw: number }, eventExchangeRates: { aud: number | null, cad: number | null, eur: number | null, gbp: number | null, jpy: number | null, sek: number | null, usd: number | null, date: unknown } | null, debitExchangeRates: { aud: number | null, cad: number | null, eur: number | null, gbp: number | null, jpy: number | null, sek: number | null, usd: number | null, date: unknown } | null }
        > }
      | { id: string, transactions: Array<
          | { id: string, eventDate: unknown, effectiveDate: unknown, amount: { currency: Currency, formatted: string, raw: number }, eventExchangeRates: { aud: number | null, cad: number | null, eur: number | null, gbp: number | null, jpy: number | null, sek: number | null, usd: number | null, date: unknown } | null, debitExchangeRates: { aud: number | null, cad: number | null, eur: number | null, gbp: number | null, jpy: number | null, sek: number | null, usd: number | null, date: unknown } | null }
          | { id: string, eventDate: unknown, effectiveDate: unknown, amount: { currency: Currency, formatted: string, raw: number }, eventExchangeRates: { aud: number | null, cad: number | null, eur: number | null, gbp: number | null, jpy: number | null, sek: number | null, usd: number | null, date: unknown } | null, debitExchangeRates: { aud: number | null, cad: number | null, eur: number | null, gbp: number | null, jpy: number | null, sek: number | null, usd: number | null, date: unknown } | null }
        > }
      | { id: string, transactions: Array<
          | { id: string, eventDate: unknown, effectiveDate: unknown, amount: { currency: Currency, formatted: string, raw: number }, eventExchangeRates: { aud: number | null, cad: number | null, eur: number | null, gbp: number | null, jpy: number | null, sek: number | null, usd: number | null, date: unknown } | null, debitExchangeRates: { aud: number | null, cad: number | null, eur: number | null, gbp: number | null, jpy: number | null, sek: number | null, usd: number | null, date: unknown } | null }
          | { id: string, eventDate: unknown, effectiveDate: unknown, amount: { currency: Currency, formatted: string, raw: number }, eventExchangeRates: { aud: number | null, cad: number | null, eur: number | null, gbp: number | null, jpy: number | null, sek: number | null, usd: number | null, date: unknown } | null, debitExchangeRates: { aud: number | null, cad: number | null, eur: number | null, gbp: number | null, jpy: number | null, sek: number | null, usd: number | null, date: unknown } | null }
        > }
      | { id: string, transactions: Array<
          | { id: string, eventDate: unknown, effectiveDate: unknown, amount: { currency: Currency, formatted: string, raw: number }, eventExchangeRates: { aud: number | null, cad: number | null, eur: number | null, gbp: number | null, jpy: number | null, sek: number | null, usd: number | null, date: unknown } | null, debitExchangeRates: { aud: number | null, cad: number | null, eur: number | null, gbp: number | null, jpy: number | null, sek: number | null, usd: number | null, date: unknown } | null }
          | { id: string, eventDate: unknown, effectiveDate: unknown, amount: { currency: Currency, formatted: string, raw: number }, eventExchangeRates: { aud: number | null, cad: number | null, eur: number | null, gbp: number | null, jpy: number | null, sek: number | null, usd: number | null, date: unknown } | null, debitExchangeRates: { aud: number | null, cad: number | null, eur: number | null, gbp: number | null, jpy: number | null, sek: number | null, usd: number | null, date: unknown } | null }
        > }
      | { id: string, transactions: Array<
          | { id: string, eventDate: unknown, effectiveDate: unknown, amount: { currency: Currency, formatted: string, raw: number }, eventExchangeRates: { aud: number | null, cad: number | null, eur: number | null, gbp: number | null, jpy: number | null, sek: number | null, usd: number | null, date: unknown } | null, debitExchangeRates: { aud: number | null, cad: number | null, eur: number | null, gbp: number | null, jpy: number | null, sek: number | null, usd: number | null, date: unknown } | null }
          | { id: string, eventDate: unknown, effectiveDate: unknown, amount: { currency: Currency, formatted: string, raw: number }, eventExchangeRates: { aud: number | null, cad: number | null, eur: number | null, gbp: number | null, jpy: number | null, sek: number | null, usd: number | null, date: unknown } | null, debitExchangeRates: { aud: number | null, cad: number | null, eur: number | null, gbp: number | null, jpy: number | null, sek: number | null, usd: number | null, date: unknown } | null }
        > }
      | { id: string, transactions: Array<
          | { id: string, eventDate: unknown, effectiveDate: unknown, amount: { currency: Currency, formatted: string, raw: number }, eventExchangeRates: { aud: number | null, cad: number | null, eur: number | null, gbp: number | null, jpy: number | null, sek: number | null, usd: number | null, date: unknown } | null, debitExchangeRates: { aud: number | null, cad: number | null, eur: number | null, gbp: number | null, jpy: number | null, sek: number | null, usd: number | null, date: unknown } | null }
          | { id: string, eventDate: unknown, effectiveDate: unknown, amount: { currency: Currency, formatted: string, raw: number }, eventExchangeRates: { aud: number | null, cad: number | null, eur: number | null, gbp: number | null, jpy: number | null, sek: number | null, usd: number | null, date: unknown } | null, debitExchangeRates: { aud: number | null, cad: number | null, eur: number | null, gbp: number | null, jpy: number | null, sek: number | null, usd: number | null, date: unknown } | null }
        > }
      | { id: string, transactions: Array<
          | { id: string, eventDate: unknown, effectiveDate: unknown, amount: { currency: Currency, formatted: string, raw: number }, eventExchangeRates: { aud: number | null, cad: number | null, eur: number | null, gbp: number | null, jpy: number | null, sek: number | null, usd: number | null, date: unknown } | null, debitExchangeRates: { aud: number | null, cad: number | null, eur: number | null, gbp: number | null, jpy: number | null, sek: number | null, usd: number | null, date: unknown } | null }
          | { id: string, eventDate: unknown, effectiveDate: unknown, amount: { currency: Currency, formatted: string, raw: number }, eventExchangeRates: { aud: number | null, cad: number | null, eur: number | null, gbp: number | null, jpy: number | null, sek: number | null, usd: number | null, date: unknown } | null, debitExchangeRates: { aud: number | null, cad: number | null, eur: number | null, gbp: number | null, jpy: number | null, sek: number | null, usd: number | null, date: unknown } | null }
        > }
      | { id: string, transactions: Array<
          | { id: string, eventDate: unknown, effectiveDate: unknown, amount: { currency: Currency, formatted: string, raw: number }, eventExchangeRates: { aud: number | null, cad: number | null, eur: number | null, gbp: number | null, jpy: number | null, sek: number | null, usd: number | null, date: unknown } | null, debitExchangeRates: { aud: number | null, cad: number | null, eur: number | null, gbp: number | null, jpy: number | null, sek: number | null, usd: number | null, date: unknown } | null }
          | { id: string, eventDate: unknown, effectiveDate: unknown, amount: { currency: Currency, formatted: string, raw: number }, eventExchangeRates: { aud: number | null, cad: number | null, eur: number | null, gbp: number | null, jpy: number | null, sek: number | null, usd: number | null, date: unknown } | null, debitExchangeRates: { aud: number | null, cad: number | null, eur: number | null, gbp: number | null, jpy: number | null, sek: number | null, usd: number | null, date: unknown } | null }
        > }
      | { id: string, transactions: Array<
          | { id: string, eventDate: unknown, effectiveDate: unknown, amount: { currency: Currency, formatted: string, raw: number }, eventExchangeRates: { aud: number | null, cad: number | null, eur: number | null, gbp: number | null, jpy: number | null, sek: number | null, usd: number | null, date: unknown } | null, debitExchangeRates: { aud: number | null, cad: number | null, eur: number | null, gbp: number | null, jpy: number | null, sek: number | null, usd: number | null, date: unknown } | null }
          | { id: string, eventDate: unknown, effectiveDate: unknown, amount: { currency: Currency, formatted: string, raw: number }, eventExchangeRates: { aud: number | null, cad: number | null, eur: number | null, gbp: number | null, jpy: number | null, sek: number | null, usd: number | null, date: unknown } | null, debitExchangeRates: { aud: number | null, cad: number | null, eur: number | null, gbp: number | null, jpy: number | null, sek: number | null, usd: number | null, date: unknown } | null }
        > }
      | { id: string, transactions: Array<
          | { id: string, eventDate: unknown, effectiveDate: unknown, amount: { currency: Currency, formatted: string, raw: number }, eventExchangeRates: { aud: number | null, cad: number | null, eur: number | null, gbp: number | null, jpy: number | null, sek: number | null, usd: number | null, date: unknown } | null, debitExchangeRates: { aud: number | null, cad: number | null, eur: number | null, gbp: number | null, jpy: number | null, sek: number | null, usd: number | null, date: unknown } | null }
          | { id: string, eventDate: unknown, effectiveDate: unknown, amount: { currency: Currency, formatted: string, raw: number }, eventExchangeRates: { aud: number | null, cad: number | null, eur: number | null, gbp: number | null, jpy: number | null, sek: number | null, usd: number | null, date: unknown } | null, debitExchangeRates: { aud: number | null, cad: number | null, eur: number | null, gbp: number | null, jpy: number | null, sek: number | null, usd: number | null, date: unknown } | null }
        > }
    > } };

export type MonthlyIncomeExpenseChartInfoFragment = { monthlyData: Array<{ date: unknown, income: { formatted: string, raw: number }, expense: { formatted: string, raw: number }, balance: { formatted: string, raw: number } }> } & { ' $fragmentName'?: 'MonthlyIncomeExpenseChartInfoFragment' };

export type MonthlyIncomeExpenseChartQueryVariables = Exact<{
  filters: IncomeExpenseChartFilters;
}>;


export type MonthlyIncomeExpenseChartQuery = { incomeExpenseChart: (
    { fromDate: unknown, toDate: unknown, currency: Currency }
    & { ' $fragmentRefs'?: { 'MonthlyIncomeExpenseChartInfoFragment': MonthlyIncomeExpenseChartInfoFragment } }
  ) };

export type ContractsEditModalQueryVariables = Exact<{
  contractId: string;
}>;


export type ContractsEditModalQuery = { contractsById: { id: string, startDate: unknown, endDate: unknown, purchaseOrders: Array<string>, product: Product | null, msCloud: unknown, billingCycle: BillingCycle, plan: SubscriptionPlan | null, isActive: boolean, remarks: string | null, documentType: DocumentType, operationsLimit: unknown, amount: { raw: number, currency: Currency } } };

export type BusinessTripReportFieldsFragment = (
  { id: string }
  & { ' $fragmentRefs'?: { 'BusinessTripReportHeaderFieldsFragment': BusinessTripReportHeaderFieldsFragment;'BusinessTripReportSummaryFieldsFragment': BusinessTripReportSummaryFieldsFragment } }
) & { ' $fragmentName'?: 'BusinessTripReportFieldsFragment' };

export type BusinessTripAccountantApprovalFieldsFragment = { id: string, accountantApproval: AccountantStatus } & { ' $fragmentName'?: 'BusinessTripAccountantApprovalFieldsFragment' };

export type UncategorizedTransactionsByBusinessTripQueryVariables = Exact<{
  businessTripId: string;
}>;


export type UncategorizedTransactionsByBusinessTripQuery = { businessTrip: { id: string, uncategorizedTransactions: Array<{ transaction:
        | { id: string, eventDate: unknown, sourceDescription: string, referenceKey: string | null, counterparty:
            | { id: string, name: string }
            | { id: string, name: string }
            | { id: string, name: string }
           | null, amount: { formatted: string, raw: number } }
        | { id: string, eventDate: unknown, sourceDescription: string, referenceKey: string | null, counterparty:
            | { id: string, name: string }
            | { id: string, name: string }
            | { id: string, name: string }
           | null, amount: { formatted: string, raw: number } }
       } | null> } | null };

export type BusinessTripReportAccommodationsRowFieldsFragment = (
  { id: string, payedByEmployee: boolean | null, nightsCount: number | null, country: { id: string, name: string } | null, attendeesStay: Array<{ id: string, nightsCount: number, attendee: { id: string, name: string } }> }
  & { ' $fragmentRefs'?: { 'BusinessTripReportCoreExpenseRowFields_BusinessTripAccommodationExpense_Fragment': BusinessTripReportCoreExpenseRowFields_BusinessTripAccommodationExpense_Fragment } }
) & { ' $fragmentName'?: 'BusinessTripReportAccommodationsRowFieldsFragment' };

export type BusinessTripReportAccommodationsTableFieldsFragment = (
  { id: string, date: unknown }
  & { ' $fragmentRefs'?: { 'BusinessTripReportAccommodationsRowFieldsFragment': BusinessTripReportAccommodationsRowFieldsFragment } }
) & { ' $fragmentName'?: 'BusinessTripReportAccommodationsTableFieldsFragment' };

export type BusinessTripReportAccommodationsFieldsFragment = { id: string, accommodationExpenses: Array<(
    { id: string }
    & { ' $fragmentRefs'?: { 'BusinessTripReportAccommodationsTableFieldsFragment': BusinessTripReportAccommodationsTableFieldsFragment } }
  )> } & { ' $fragmentName'?: 'BusinessTripReportAccommodationsFieldsFragment' };

export type BusinessTripReportAttendeeRowFieldsFragment = { id: string, name: string, arrivalDate: unknown, departureDate: unknown, flights: Array<(
    { id: string }
    & { ' $fragmentRefs'?: { 'BusinessTripReportFlightsTableFieldsFragment': BusinessTripReportFlightsTableFieldsFragment } }
  )>, accommodations: Array<(
    { id: string }
    & { ' $fragmentRefs'?: { 'BusinessTripReportAccommodationsTableFieldsFragment': BusinessTripReportAccommodationsTableFieldsFragment } }
  )> } & { ' $fragmentName'?: 'BusinessTripReportAttendeeRowFieldsFragment' };

export type BusinessTripReportAttendeesFieldsFragment = { id: string, attendees: Array<(
    { id: string, name: string }
    & { ' $fragmentRefs'?: { 'BusinessTripReportAttendeeRowFieldsFragment': BusinessTripReportAttendeeRowFieldsFragment } }
  )> } & { ' $fragmentName'?: 'BusinessTripReportAttendeesFieldsFragment' };

export type BusinessTripReportCarRentalRowFieldsFragment = (
  { id: string, payedByEmployee: boolean | null, days: number, isFuelExpense: boolean }
  & { ' $fragmentRefs'?: { 'BusinessTripReportCoreExpenseRowFields_BusinessTripCarRentalExpense_Fragment': BusinessTripReportCoreExpenseRowFields_BusinessTripCarRentalExpense_Fragment } }
) & { ' $fragmentName'?: 'BusinessTripReportCarRentalRowFieldsFragment' };

export type BusinessTripReportCarRentalFieldsFragment = { id: string, carRentalExpenses: Array<(
    { id: string, date: unknown }
    & { ' $fragmentRefs'?: { 'BusinessTripReportCarRentalRowFieldsFragment': BusinessTripReportCarRentalRowFieldsFragment } }
  )> } & { ' $fragmentName'?: 'BusinessTripReportCarRentalFieldsFragment' };

type BusinessTripReportCoreExpenseRowFields_BusinessTripAccommodationExpense_Fragment = { id: string, date: unknown, valueDate: unknown, payedByEmployee: boolean | null, amount: { formatted: string, raw: number, currency: Currency } | null, employee:
    | { id: string, name: string }
    | { id: string, name: string }
    | { id: string, name: string }
   | null, charges: Array<
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
  > | null } & { ' $fragmentName'?: 'BusinessTripReportCoreExpenseRowFields_BusinessTripAccommodationExpense_Fragment' };

type BusinessTripReportCoreExpenseRowFields_BusinessTripCarRentalExpense_Fragment = { id: string, date: unknown, valueDate: unknown, payedByEmployee: boolean | null, amount: { formatted: string, raw: number, currency: Currency } | null, employee:
    | { id: string, name: string }
    | { id: string, name: string }
    | { id: string, name: string }
   | null, charges: Array<
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
  > | null } & { ' $fragmentName'?: 'BusinessTripReportCoreExpenseRowFields_BusinessTripCarRentalExpense_Fragment' };

type BusinessTripReportCoreExpenseRowFields_BusinessTripFlightExpense_Fragment = { id: string, date: unknown, valueDate: unknown, payedByEmployee: boolean | null, amount: { formatted: string, raw: number, currency: Currency } | null, employee:
    | { id: string, name: string }
    | { id: string, name: string }
    | { id: string, name: string }
   | null, charges: Array<
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
  > | null } & { ' $fragmentName'?: 'BusinessTripReportCoreExpenseRowFields_BusinessTripFlightExpense_Fragment' };

type BusinessTripReportCoreExpenseRowFields_BusinessTripOtherExpense_Fragment = { id: string, date: unknown, valueDate: unknown, payedByEmployee: boolean | null, amount: { formatted: string, raw: number, currency: Currency } | null, employee:
    | { id: string, name: string }
    | { id: string, name: string }
    | { id: string, name: string }
   | null, charges: Array<
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
  > | null } & { ' $fragmentName'?: 'BusinessTripReportCoreExpenseRowFields_BusinessTripOtherExpense_Fragment' };

type BusinessTripReportCoreExpenseRowFields_BusinessTripTravelAndSubsistenceExpense_Fragment = { id: string, date: unknown, valueDate: unknown, payedByEmployee: boolean | null, amount: { formatted: string, raw: number, currency: Currency } | null, employee:
    | { id: string, name: string }
    | { id: string, name: string }
    | { id: string, name: string }
   | null, charges: Array<
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
  > | null } & { ' $fragmentName'?: 'BusinessTripReportCoreExpenseRowFields_BusinessTripTravelAndSubsistenceExpense_Fragment' };

export type BusinessTripReportCoreExpenseRowFieldsFragment =
  | BusinessTripReportCoreExpenseRowFields_BusinessTripAccommodationExpense_Fragment
  | BusinessTripReportCoreExpenseRowFields_BusinessTripCarRentalExpense_Fragment
  | BusinessTripReportCoreExpenseRowFields_BusinessTripFlightExpense_Fragment
  | BusinessTripReportCoreExpenseRowFields_BusinessTripOtherExpense_Fragment
  | BusinessTripReportCoreExpenseRowFields_BusinessTripTravelAndSubsistenceExpense_Fragment
;

export type BusinessTripReportFlightsRowFieldsFragment = (
  { id: string, payedByEmployee: boolean | null, path: Array<string> | null, class: string | null, attendees: Array<{ id: string, name: string }> }
  & { ' $fragmentRefs'?: { 'BusinessTripReportCoreExpenseRowFields_BusinessTripFlightExpense_Fragment': BusinessTripReportCoreExpenseRowFields_BusinessTripFlightExpense_Fragment } }
) & { ' $fragmentName'?: 'BusinessTripReportFlightsRowFieldsFragment' };

export type BusinessTripReportFlightsTableFieldsFragment = (
  { id: string, date: unknown }
  & { ' $fragmentRefs'?: { 'BusinessTripReportFlightsRowFieldsFragment': BusinessTripReportFlightsRowFieldsFragment } }
) & { ' $fragmentName'?: 'BusinessTripReportFlightsTableFieldsFragment' };

export type BusinessTripReportFlightsFieldsFragment = { id: string, flightExpenses: Array<(
    { id: string }
    & { ' $fragmentRefs'?: { 'BusinessTripReportFlightsTableFieldsFragment': BusinessTripReportFlightsTableFieldsFragment } }
  )>, attendees: Array<{ id: string, name: string }> } & { ' $fragmentName'?: 'BusinessTripReportFlightsFieldsFragment' };

export type BusinessTripReportOtherRowFieldsFragment = (
  { id: string, payedByEmployee: boolean | null, description: string | null, deductibleExpense: boolean | null }
  & { ' $fragmentRefs'?: { 'BusinessTripReportCoreExpenseRowFields_BusinessTripOtherExpense_Fragment': BusinessTripReportCoreExpenseRowFields_BusinessTripOtherExpense_Fragment } }
) & { ' $fragmentName'?: 'BusinessTripReportOtherRowFieldsFragment' };

export type BusinessTripReportOtherFieldsFragment = { id: string, otherExpenses: Array<(
    { id: string, date: unknown }
    & { ' $fragmentRefs'?: { 'BusinessTripReportOtherRowFieldsFragment': BusinessTripReportOtherRowFieldsFragment } }
  )> } & { ' $fragmentName'?: 'BusinessTripReportOtherFieldsFragment' };

export type BusinessTripReportHeaderFieldsFragment = (
  { id: string, name: string, purpose: string | null, dates: { start: unknown, end: unknown } | null, destination: { id: string, name: string } | null }
  & { ' $fragmentRefs'?: { 'BusinessTripAccountantApprovalFieldsFragment': BusinessTripAccountantApprovalFieldsFragment } }
) & { ' $fragmentName'?: 'BusinessTripReportHeaderFieldsFragment' };

export type BusinessTripReportSummaryFieldsFragment = { id: string } & ({ summary: { excessTax: number | null, errors: Array<string> | null, excessExpenditure: { formatted: string } | null, rows: Array<{ type: BusinessTripSummaryCategories, totalForeignCurrency: { formatted: string }, totalLocalCurrency: { formatted: string } | null, taxableForeignCurrency: { formatted: string }, taxableLocalCurrency: { formatted: string } | null, maxTaxableForeignCurrency: { formatted: string }, maxTaxableLocalCurrency: { formatted: string } | null, excessExpenditure: { formatted: string } | null }> } } | { summary?: never }) & { ' $fragmentName'?: 'BusinessTripReportSummaryFieldsFragment' };

export type BusinessTripReportTravelAndSubsistenceRowFieldsFragment = (
  { id: string, payedByEmployee: boolean | null, expenseType: string | null }
  & { ' $fragmentRefs'?: { 'BusinessTripReportCoreExpenseRowFields_BusinessTripTravelAndSubsistenceExpense_Fragment': BusinessTripReportCoreExpenseRowFields_BusinessTripTravelAndSubsistenceExpense_Fragment } }
) & { ' $fragmentName'?: 'BusinessTripReportTravelAndSubsistenceRowFieldsFragment' };

export type BusinessTripReportTravelAndSubsistenceFieldsFragment = { id: string, travelAndSubsistenceExpenses: Array<(
    { id: string, date: unknown }
    & { ' $fragmentRefs'?: { 'BusinessTripReportTravelAndSubsistenceRowFieldsFragment': BusinessTripReportTravelAndSubsistenceRowFieldsFragment } }
  )> } & { ' $fragmentName'?: 'BusinessTripReportTravelAndSubsistenceFieldsFragment' };

export type BusinessTripUncategorizedTransactionsFieldsFragment = { id: string, uncategorizedTransactions: Array<(
    { transaction:
      | (
        { id: string, eventDate: unknown, chargeId: string, amount: { raw: number } }
        & { ' $fragmentRefs'?: { 'TransactionsTableEventDateFields_CommonTransaction_Fragment': TransactionsTableEventDateFields_CommonTransaction_Fragment;'TransactionsTableDebitDateFields_CommonTransaction_Fragment': TransactionsTableDebitDateFields_CommonTransaction_Fragment;'TransactionsTableAccountFields_CommonTransaction_Fragment': TransactionsTableAccountFields_CommonTransaction_Fragment;'TransactionsTableDescriptionFields_CommonTransaction_Fragment': TransactionsTableDescriptionFields_CommonTransaction_Fragment;'TransactionsTableSourceIdFields_CommonTransaction_Fragment': TransactionsTableSourceIdFields_CommonTransaction_Fragment;'TransactionsTableEntityFields_CommonTransaction_Fragment': TransactionsTableEntityFields_CommonTransaction_Fragment } }
      )
      | (
        { id: string, eventDate: unknown, chargeId: string, amount: { raw: number } }
        & { ' $fragmentRefs'?: { 'TransactionsTableEventDateFields_ConversionTransaction_Fragment': TransactionsTableEventDateFields_ConversionTransaction_Fragment;'TransactionsTableDebitDateFields_ConversionTransaction_Fragment': TransactionsTableDebitDateFields_ConversionTransaction_Fragment;'TransactionsTableAccountFields_ConversionTransaction_Fragment': TransactionsTableAccountFields_ConversionTransaction_Fragment;'TransactionsTableDescriptionFields_ConversionTransaction_Fragment': TransactionsTableDescriptionFields_ConversionTransaction_Fragment;'TransactionsTableSourceIdFields_ConversionTransaction_Fragment': TransactionsTableSourceIdFields_ConversionTransaction_Fragment;'TransactionsTableEntityFields_ConversionTransaction_Fragment': TransactionsTableEntityFields_ConversionTransaction_Fragment } }
      )
     }
    & { ' $fragmentRefs'?: { 'UncategorizedTransactionsTableAmountFieldsFragment': UncategorizedTransactionsTableAmountFieldsFragment } }
  ) | null> } & { ' $fragmentName'?: 'BusinessTripUncategorizedTransactionsFieldsFragment' };

export type UncategorizedTransactionsTableAmountFieldsFragment = { errors: Array<string>, transaction:
    | { id: string, amount: { raw: number, formatted: string }, cryptoExchangeRate: { rate: number } | null }
    | { id: string, amount: { raw: number, formatted: string }, cryptoExchangeRate: { rate: number } | null }
  , categorizedAmount: { raw: number, formatted: string } } & { ' $fragmentName'?: 'UncategorizedTransactionsTableAmountFieldsFragment' };

export type DepreciationRecordRowFieldsFragment = { id: string, activationDate: unknown, type: DepreciationType | null, amount: { currency: Currency, formatted: string, raw: number }, category: { id: string, name: string, percentage: number }, charge:
    | { id: string, totalAmount: { currency: Currency, formatted: string, raw: number } | null }
    | { id: string, totalAmount: { currency: Currency, formatted: string, raw: number } | null }
    | { id: string, totalAmount: { currency: Currency, formatted: string, raw: number } | null }
    | { id: string, totalAmount: { currency: Currency, formatted: string, raw: number } | null }
    | { id: string, totalAmount: { currency: Currency, formatted: string, raw: number } | null }
    | { id: string, totalAmount: { currency: Currency, formatted: string, raw: number } | null }
    | { id: string, totalAmount: { currency: Currency, formatted: string, raw: number } | null }
    | { id: string, totalAmount: { currency: Currency, formatted: string, raw: number } | null }
    | { id: string, totalAmount: { currency: Currency, formatted: string, raw: number } | null }
    | { id: string, totalAmount: { currency: Currency, formatted: string, raw: number } | null }
    | { id: string, totalAmount: { currency: Currency, formatted: string, raw: number } | null }
   } & { ' $fragmentName'?: 'DepreciationRecordRowFieldsFragment' };

export type ChargeDepreciationQueryVariables = Exact<{
  chargeId: string;
}>;


export type ChargeDepreciationQuery = { depreciationRecordsByCharge: Array<(
    { id: string }
    & { ' $fragmentRefs'?: { 'DepreciationRecordRowFieldsFragment': DepreciationRecordRowFieldsFragment } }
  )> };

export type RecentBusinessIssuedDocumentsQueryVariables = Exact<{
  businessId: string;
  limit?: number | null | undefined;
}>;


export type RecentBusinessIssuedDocumentsQuery = { recentDocumentsByBusiness: Array<
    | (
      { id: string, issuedDocumentInfo: { id: string, status: DocumentStatus, externalId: string } | null }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_CreditInvoice_Fragment': TableDocumentsRowFields_CreditInvoice_Fragment } }
    )
    | (
      { id: string, issuedDocumentInfo: { id: string, status: DocumentStatus, externalId: string } | null }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Invoice_Fragment': TableDocumentsRowFields_Invoice_Fragment } }
    )
    | (
      { id: string, issuedDocumentInfo: { id: string, status: DocumentStatus, externalId: string } | null }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_InvoiceReceipt_Fragment': TableDocumentsRowFields_InvoiceReceipt_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_OtherDocument_Fragment': TableDocumentsRowFields_OtherDocument_Fragment } }
    )
    | (
      { id: string, issuedDocumentInfo: { id: string, status: DocumentStatus, externalId: string } | null }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Proforma_Fragment': TableDocumentsRowFields_Proforma_Fragment } }
    )
    | (
      { id: string, issuedDocumentInfo: { id: string, status: DocumentStatus, externalId: string } | null }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Receipt_Fragment': TableDocumentsRowFields_Receipt_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Unprocessed_Fragment': TableDocumentsRowFields_Unprocessed_Fragment } }
    )
  > };

export type RecentIssuedDocumentsOfSameTypeQueryVariables = Exact<{
  documentType: DocumentType;
}>;


export type RecentIssuedDocumentsOfSameTypeQuery = { recentIssuedDocumentsByType: Array<
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_CreditInvoice_Fragment': TableDocumentsRowFields_CreditInvoice_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Invoice_Fragment': TableDocumentsRowFields_Invoice_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_InvoiceReceipt_Fragment': TableDocumentsRowFields_InvoiceReceipt_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_OtherDocument_Fragment': TableDocumentsRowFields_OtherDocument_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Proforma_Fragment': TableDocumentsRowFields_Proforma_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Receipt_Fragment': TableDocumentsRowFields_Receipt_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TableDocumentsRowFields_Unprocessed_Fragment': TableDocumentsRowFields_Unprocessed_Fragment } }
    )
  > };

export type EditDocumentQueryVariables = Exact<{
  documentId: string;
}>;


export type EditDocumentQuery = { documentById:
    | { __typename: 'CreditInvoice', serialNumber: string | null, date: unknown, vatReportDateOverride: unknown, noVatAmount: number | null, allocationNumber: string | null, exchangeRateOverride: number | null, id: string, image: unknown, file: unknown, documentType: DocumentType | null, description: string | null, remarks: string | null, vat: { raw: number, currency: Currency } | null, amount: { raw: number, currency: Currency } | null, debtor:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null, creditor:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null }
    | { __typename: 'Invoice', serialNumber: string | null, date: unknown, vatReportDateOverride: unknown, noVatAmount: number | null, allocationNumber: string | null, exchangeRateOverride: number | null, id: string, image: unknown, file: unknown, documentType: DocumentType | null, description: string | null, remarks: string | null, vat: { raw: number, currency: Currency } | null, amount: { raw: number, currency: Currency } | null, debtor:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null, creditor:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null }
    | { __typename: 'InvoiceReceipt', serialNumber: string | null, date: unknown, vatReportDateOverride: unknown, noVatAmount: number | null, allocationNumber: string | null, exchangeRateOverride: number | null, id: string, image: unknown, file: unknown, documentType: DocumentType | null, description: string | null, remarks: string | null, vat: { raw: number, currency: Currency } | null, amount: { raw: number, currency: Currency } | null, debtor:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null, creditor:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null }
    | { __typename: 'OtherDocument', serialNumber: string | null, date: unknown, vatReportDateOverride: unknown, noVatAmount: number | null, allocationNumber: string | null, exchangeRateOverride: number | null, id: string, image: unknown, file: unknown, documentType: DocumentType | null, description: string | null, remarks: string | null, vat: { raw: number, currency: Currency } | null, amount: { raw: number, currency: Currency } | null, debtor:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null, creditor:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null }
    | { __typename: 'Proforma', serialNumber: string | null, date: unknown, vatReportDateOverride: unknown, noVatAmount: number | null, allocationNumber: string | null, exchangeRateOverride: number | null, id: string, image: unknown, file: unknown, documentType: DocumentType | null, description: string | null, remarks: string | null, vat: { raw: number, currency: Currency } | null, amount: { raw: number, currency: Currency } | null, debtor:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null, creditor:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null }
    | { __typename: 'Receipt', serialNumber: string | null, date: unknown, vatReportDateOverride: unknown, noVatAmount: number | null, allocationNumber: string | null, exchangeRateOverride: number | null, id: string, image: unknown, file: unknown, documentType: DocumentType | null, description: string | null, remarks: string | null, vat: { raw: number, currency: Currency } | null, amount: { raw: number, currency: Currency } | null, debtor:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null, creditor:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null }
    | { __typename: 'Unprocessed', serialNumber: string | null, date: unknown, vatReportDateOverride: unknown, noVatAmount: number | null, allocationNumber: string | null, exchangeRateOverride: number | null, id: string, image: unknown, file: unknown, documentType: DocumentType | null, description: string | null, remarks: string | null, vat: { raw: number, currency: Currency } | null, amount: { raw: number, currency: Currency } | null, debtor:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null, creditor:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null }
   | null };

export type EditMiscExpenseFieldsFragment = { id: string, description: string | null, invoiceDate: unknown, valueDate: unknown, amount: { raw: number, currency: Currency }, creditor:
    | { id: string }
    | { id: string }
    | { id: string }
  , debtor:
    | { id: string }
    | { id: string }
    | { id: string }
   } & { ' $fragmentName'?: 'EditMiscExpenseFieldsFragment' };

export type EditTagFieldsFragment = { id: string, name: string, parent: { id: string, name: string } | null } & { ' $fragmentName'?: 'EditTagFieldsFragment' };

export type EditTransactionQueryVariables = Exact<{
  transactionIDs: Array<string> | string;
}>;


export type EditTransactionQuery = { transactionsByIDs: Array<
    | { id: string, effectiveDate: unknown, isFee: boolean | null, counterparty:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null, account:
        | { type: FinancialAccountType, id: string }
        | { type: FinancialAccountType, id: string }
        | { type: FinancialAccountType, id: string }
        | { type: FinancialAccountType, id: string }
        | { type: FinancialAccountType, id: string }
       }
    | { id: string, effectiveDate: unknown, isFee: boolean | null, counterparty:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null, account:
        | { type: FinancialAccountType, id: string }
        | { type: FinancialAccountType, id: string }
        | { type: FinancialAccountType, id: string }
        | { type: FinancialAccountType, id: string }
        | { type: FinancialAccountType, id: string }
       }
  > };

export type ClientInfoForDocumentIssuingQueryVariables = Exact<{
  businessId: string;
}>;


export type ClientInfoForDocumentIssuingQuery = { client: (
    { id: string, integrations: { id: string, greenInvoiceInfo: { greenInvoiceId: string | null, businessId: string, name: string | null } | null } }
    & { ' $fragmentRefs'?: { 'IssueDocumentClientFieldsFragment': IssueDocumentClientFieldsFragment } }
  ) };

export type AllBusinessTripsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllBusinessTripsQuery = { allBusinessTrips: Array<{ id: string, name: string }> };

export type AllDepreciationCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllDepreciationCategoriesQuery = { depreciationCategories: Array<{ id: string, name: string, percentage: number }> };

export type AllEmployeesByEmployerQueryVariables = Exact<{
  employerId: string;
}>;


export type AllEmployeesByEmployerQuery = { employeesByEmployerId: Array<{ id: string, name: string }> };

export type AllPensionFundsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllPensionFundsQuery = { allPensionFunds: Array<{ id: string, name: string }> };

export type AllTrainingFundsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllTrainingFundsQuery = { allTrainingFunds: Array<{ id: string, name: string }> };

export type AttendeesByBusinessTripQueryVariables = Exact<{
  businessTripId: string;
}>;


export type AttendeesByBusinessTripQuery = { businessTrip: { id: string, attendees: Array<{ id: string, name: string }> } | null };

export type FetchMultipleBusinessesQueryVariables = Exact<{
  businessIds: Array<string> | string;
}>;


export type FetchMultipleBusinessesQuery = { businesses: Array<
    | { id: string, name: string }
    | { id: string, name: string }
  > };

export type FetchMultipleChargesQueryVariables = Exact<{
  chargeIds: Array<string> | string;
}>;


export type FetchMultipleChargesQuery = { chargesByIDs: Array<
    | { __typename: 'BankDepositCharge', id: string, decreasedVAT: boolean | null, property: boolean | null, isInvoicePaymentDifferentCurrency: boolean | null, userDescription: string | null, optionalVAT: boolean | null, optionalDocuments: boolean | null, metadata: { transactionsCount: number, invoicesCount: number } | null, owner:
        | { id: string, name: string }
        | { id: string, name: string }
      , tags: Array<{ id: string, name: string, namePath: Array<string> | null }> }
    | { __typename: 'BusinessTripCharge', id: string, decreasedVAT: boolean | null, property: boolean | null, isInvoicePaymentDifferentCurrency: boolean | null, userDescription: string | null, optionalVAT: boolean | null, optionalDocuments: boolean | null, metadata: { transactionsCount: number, invoicesCount: number } | null, owner:
        | { id: string, name: string }
        | { id: string, name: string }
      , tags: Array<{ id: string, name: string, namePath: Array<string> | null }> }
    | { __typename: 'CommonCharge', id: string, decreasedVAT: boolean | null, property: boolean | null, isInvoicePaymentDifferentCurrency: boolean | null, userDescription: string | null, optionalVAT: boolean | null, optionalDocuments: boolean | null, metadata: { transactionsCount: number, invoicesCount: number } | null, owner:
        | { id: string, name: string }
        | { id: string, name: string }
      , tags: Array<{ id: string, name: string, namePath: Array<string> | null }> }
    | { __typename: 'ConversionCharge', id: string, decreasedVAT: boolean | null, property: boolean | null, isInvoicePaymentDifferentCurrency: boolean | null, userDescription: string | null, optionalVAT: boolean | null, optionalDocuments: boolean | null, metadata: { transactionsCount: number, invoicesCount: number } | null, owner:
        | { id: string, name: string }
        | { id: string, name: string }
      , tags: Array<{ id: string, name: string, namePath: Array<string> | null }> }
    | { __typename: 'CreditcardBankCharge', id: string, decreasedVAT: boolean | null, property: boolean | null, isInvoicePaymentDifferentCurrency: boolean | null, userDescription: string | null, optionalVAT: boolean | null, optionalDocuments: boolean | null, metadata: { transactionsCount: number, invoicesCount: number } | null, owner:
        | { id: string, name: string }
        | { id: string, name: string }
      , tags: Array<{ id: string, name: string, namePath: Array<string> | null }> }
    | { __typename: 'DividendCharge', id: string, decreasedVAT: boolean | null, property: boolean | null, isInvoicePaymentDifferentCurrency: boolean | null, userDescription: string | null, optionalVAT: boolean | null, optionalDocuments: boolean | null, metadata: { transactionsCount: number, invoicesCount: number } | null, owner:
        | { id: string, name: string }
        | { id: string, name: string }
      , tags: Array<{ id: string, name: string, namePath: Array<string> | null }> }
    | { __typename: 'FinancialCharge', id: string, decreasedVAT: boolean | null, property: boolean | null, isInvoicePaymentDifferentCurrency: boolean | null, userDescription: string | null, optionalVAT: boolean | null, optionalDocuments: boolean | null, metadata: { transactionsCount: number, invoicesCount: number } | null, owner:
        | { id: string, name: string }
        | { id: string, name: string }
      , tags: Array<{ id: string, name: string, namePath: Array<string> | null }> }
    | { __typename: 'ForeignSecuritiesCharge', id: string, decreasedVAT: boolean | null, property: boolean | null, isInvoicePaymentDifferentCurrency: boolean | null, userDescription: string | null, optionalVAT: boolean | null, optionalDocuments: boolean | null, metadata: { transactionsCount: number, invoicesCount: number } | null, owner:
        | { id: string, name: string }
        | { id: string, name: string }
      , tags: Array<{ id: string, name: string, namePath: Array<string> | null }> }
    | { __typename: 'InternalTransferCharge', id: string, decreasedVAT: boolean | null, property: boolean | null, isInvoicePaymentDifferentCurrency: boolean | null, userDescription: string | null, optionalVAT: boolean | null, optionalDocuments: boolean | null, metadata: { transactionsCount: number, invoicesCount: number } | null, owner:
        | { id: string, name: string }
        | { id: string, name: string }
      , tags: Array<{ id: string, name: string, namePath: Array<string> | null }> }
    | { __typename: 'MonthlyVatCharge', id: string, decreasedVAT: boolean | null, property: boolean | null, isInvoicePaymentDifferentCurrency: boolean | null, userDescription: string | null, optionalVAT: boolean | null, optionalDocuments: boolean | null, metadata: { transactionsCount: number, invoicesCount: number } | null, owner:
        | { id: string, name: string }
        | { id: string, name: string }
      , tags: Array<{ id: string, name: string, namePath: Array<string> | null }> }
    | { __typename: 'SalaryCharge', id: string, decreasedVAT: boolean | null, property: boolean | null, isInvoicePaymentDifferentCurrency: boolean | null, userDescription: string | null, optionalVAT: boolean | null, optionalDocuments: boolean | null, metadata: { transactionsCount: number, invoicesCount: number } | null, owner:
        | { id: string, name: string }
        | { id: string, name: string }
      , tags: Array<{ id: string, name: string, namePath: Array<string> | null }> }
  > };

export type EditChargeQueryVariables = Exact<{
  chargeId: string;
}>;


export type EditChargeQuery = { charge:
    | { __typename: 'BankDepositCharge', id: string, property: boolean | null, decreasedVAT: boolean | null, isInvoicePaymentDifferentCurrency: boolean | null, userDescription: string | null, optionalVAT: boolean | null, optionalDocuments: boolean | null, counterparty:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null, owner:
        | { id: string, name: string }
        | { id: string, name: string }
      , taxCategory: { id: string, name: string } | null, tags: Array<{ id: string }>, missingInfoSuggestions: { tags: Array<{ id: string }> } | null, yearsOfRelevance: Array<{ year: string, amount: number | null }> | null }
    | { __typename: 'BusinessTripCharge', id: string, property: boolean | null, decreasedVAT: boolean | null, isInvoicePaymentDifferentCurrency: boolean | null, userDescription: string | null, optionalVAT: boolean | null, optionalDocuments: boolean | null, businessTrip: { id: string, name: string } | null, counterparty:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null, owner:
        | { id: string, name: string }
        | { id: string, name: string }
      , taxCategory: { id: string, name: string } | null, tags: Array<{ id: string }>, missingInfoSuggestions: { tags: Array<{ id: string }> } | null, yearsOfRelevance: Array<{ year: string, amount: number | null }> | null }
    | { __typename: 'CommonCharge', id: string, property: boolean | null, decreasedVAT: boolean | null, isInvoicePaymentDifferentCurrency: boolean | null, userDescription: string | null, optionalVAT: boolean | null, optionalDocuments: boolean | null, counterparty:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null, owner:
        | { id: string, name: string }
        | { id: string, name: string }
      , taxCategory: { id: string, name: string } | null, tags: Array<{ id: string }>, missingInfoSuggestions: { tags: Array<{ id: string }> } | null, yearsOfRelevance: Array<{ year: string, amount: number | null }> | null }
    | { __typename: 'ConversionCharge', id: string, property: boolean | null, decreasedVAT: boolean | null, isInvoicePaymentDifferentCurrency: boolean | null, userDescription: string | null, optionalVAT: boolean | null, optionalDocuments: boolean | null, counterparty:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null, owner:
        | { id: string, name: string }
        | { id: string, name: string }
      , taxCategory: { id: string, name: string } | null, tags: Array<{ id: string }>, missingInfoSuggestions: { tags: Array<{ id: string }> } | null, yearsOfRelevance: Array<{ year: string, amount: number | null }> | null }
    | { __typename: 'CreditcardBankCharge', id: string, property: boolean | null, decreasedVAT: boolean | null, isInvoicePaymentDifferentCurrency: boolean | null, userDescription: string | null, optionalVAT: boolean | null, optionalDocuments: boolean | null, counterparty:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null, owner:
        | { id: string, name: string }
        | { id: string, name: string }
      , taxCategory: { id: string, name: string } | null, tags: Array<{ id: string }>, missingInfoSuggestions: { tags: Array<{ id: string }> } | null, yearsOfRelevance: Array<{ year: string, amount: number | null }> | null }
    | { __typename: 'DividendCharge', id: string, property: boolean | null, decreasedVAT: boolean | null, isInvoicePaymentDifferentCurrency: boolean | null, userDescription: string | null, optionalVAT: boolean | null, optionalDocuments: boolean | null, counterparty:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null, owner:
        | { id: string, name: string }
        | { id: string, name: string }
      , taxCategory: { id: string, name: string } | null, tags: Array<{ id: string }>, missingInfoSuggestions: { tags: Array<{ id: string }> } | null, yearsOfRelevance: Array<{ year: string, amount: number | null }> | null }
    | { __typename: 'FinancialCharge', id: string, property: boolean | null, decreasedVAT: boolean | null, isInvoicePaymentDifferentCurrency: boolean | null, userDescription: string | null, optionalVAT: boolean | null, optionalDocuments: boolean | null, counterparty:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null, owner:
        | { id: string, name: string }
        | { id: string, name: string }
      , taxCategory: { id: string, name: string } | null, tags: Array<{ id: string }>, missingInfoSuggestions: { tags: Array<{ id: string }> } | null, yearsOfRelevance: Array<{ year: string, amount: number | null }> | null }
    | { __typename: 'ForeignSecuritiesCharge', id: string, property: boolean | null, decreasedVAT: boolean | null, isInvoicePaymentDifferentCurrency: boolean | null, userDescription: string | null, optionalVAT: boolean | null, optionalDocuments: boolean | null, counterparty:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null, owner:
        | { id: string, name: string }
        | { id: string, name: string }
      , taxCategory: { id: string, name: string } | null, tags: Array<{ id: string }>, missingInfoSuggestions: { tags: Array<{ id: string }> } | null, yearsOfRelevance: Array<{ year: string, amount: number | null }> | null }
    | { __typename: 'InternalTransferCharge', id: string, property: boolean | null, decreasedVAT: boolean | null, isInvoicePaymentDifferentCurrency: boolean | null, userDescription: string | null, optionalVAT: boolean | null, optionalDocuments: boolean | null, counterparty:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null, owner:
        | { id: string, name: string }
        | { id: string, name: string }
      , taxCategory: { id: string, name: string } | null, tags: Array<{ id: string }>, missingInfoSuggestions: { tags: Array<{ id: string }> } | null, yearsOfRelevance: Array<{ year: string, amount: number | null }> | null }
    | { __typename: 'MonthlyVatCharge', id: string, property: boolean | null, decreasedVAT: boolean | null, isInvoicePaymentDifferentCurrency: boolean | null, userDescription: string | null, optionalVAT: boolean | null, optionalDocuments: boolean | null, counterparty:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null, owner:
        | { id: string, name: string }
        | { id: string, name: string }
      , taxCategory: { id: string, name: string } | null, tags: Array<{ id: string }>, missingInfoSuggestions: { tags: Array<{ id: string }> } | null, yearsOfRelevance: Array<{ year: string, amount: number | null }> | null }
    | { __typename: 'SalaryCharge', id: string, property: boolean | null, decreasedVAT: boolean | null, isInvoicePaymentDifferentCurrency: boolean | null, userDescription: string | null, optionalVAT: boolean | null, optionalDocuments: boolean | null, counterparty:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null, owner:
        | { id: string, name: string }
        | { id: string, name: string }
      , taxCategory: { id: string, name: string } | null, tags: Array<{ id: string }>, missingInfoSuggestions: { tags: Array<{ id: string }> } | null, yearsOfRelevance: Array<{ year: string, amount: number | null }> | null }
   };

export type EditSalaryRecordQueryVariables = Exact<{
  month: unknown;
  employeeIDs: Array<string> | string;
}>;


export type EditSalaryRecordQuery = { salaryRecordsByDates: Array<{ month: string, pensionEmployeePercentage: number | null, pensionEmployerPercentage: number | null, compensationsPercentage: number | null, trainingFundEmployeePercentage: number | null, trainingFundEmployerPercentage: number | null, workDays: number | null, charge: { id: string } | null, directAmount: { raw: number }, baseAmount: { raw: number } | null, employee: { id: string, name: string } | null, employer: { id: string, name: string } | null, pensionFund: { id: string, name: string } | null, pensionEmployeeAmount: { raw: number } | null, pensionEmployerAmount: { raw: number } | null, compensationsAmount: { raw: number } | null, trainingFund: { id: string, name: string } | null, trainingFundEmployeeAmount: { raw: number } | null, trainingFundEmployerAmount: { raw: number } | null, socialSecurityEmployeeAmount: { raw: number } | null, socialSecurityEmployerAmount: { raw: number } | null, incomeTaxAmount: { raw: number } | null, healthInsuranceAmount: { raw: number } | null, globalAdditionalHoursAmount: { raw: number } | null, bonus: { raw: number } | null, gift: { raw: number } | null, travelAndSubsistence: { raw: number } | null, recovery: { raw: number } | null, notionalExpense: { raw: number } | null, vacationDays: { added: number | null, balance: number | null } | null, vacationTakeout: { raw: number } | null, sicknessDays: { balance: number | null } | null }> };

export type SortCodeToUpdateQueryVariables = Exact<{
  key: number;
  ownerId: string;
}>;


export type SortCodeToUpdateQuery = { sortCode: { id: string, key: number, name: string | null, defaultIrsCode: number | null } | null };

export type TaxCategoryToUpdateQueryVariables = Exact<{
  id: string;
}>;


export type TaxCategoryToUpdateQuery = { taxCategory: { id: string, ownerId: string | null, name: string, irsCode: number | null, sortCode: { id: string, key: number, name: string | null } | null } };

export type MiscExpenseTransactionFieldsQueryVariables = Exact<{
  transactionId: string;
}>;


export type MiscExpenseTransactionFieldsQuery = { transactionsByIDs: Array<
    | { id: string, chargeId: string, eventDate: unknown, effectiveDate: unknown, exactEffectiveDate: unknown, amount: { raw: number, currency: Currency }, counterparty:
        | { id: string }
        | { id: string }
        | { id: string }
       | null }
    | { id: string, chargeId: string, eventDate: unknown, effectiveDate: unknown, exactEffectiveDate: unknown, amount: { raw: number, currency: Currency }, counterparty:
        | { id: string }
        | { id: string }
        | { id: string }
       | null }
  > };

export type IssueDocumentClientFieldsFragment = { id: string, emails: Array<string>, originalBusiness: { id: string, address: string | null, city: string | null, zipCode: string | null, governmentId: string | null, name: string, phoneNumber: string | null, country: { id: string, code: unknown } } } & { ' $fragmentName'?: 'IssueDocumentClientFieldsFragment' };

export type NewDocumentDraftByChargeQueryVariables = Exact<{
  chargeId: string;
}>;


export type NewDocumentDraftByChargeQuery = { newDocumentDraftByCharge: { ' $fragmentRefs'?: { 'NewDocumentDraftFragment': NewDocumentDraftFragment } } };

export type NewDocumentDraftByDocumentQueryVariables = Exact<{
  documentId: string;
}>;


export type NewDocumentDraftByDocumentQuery = { newDocumentDraftByDocument: { ' $fragmentRefs'?: { 'NewDocumentDraftFragment': NewDocumentDraftFragment } } };

export type NewDocumentDraftFragment = { description: string | null, remarks: string | null, footer: string | null, type: DocumentType, date: string | null, dueDate: string | null, language: DocumentLanguage, currency: Currency, vatType: DocumentVatType, rounding: boolean | null, signed: boolean | null, maxPayments: number | null, linkedDocumentIds: Array<string> | null, linkedPaymentId: string | null, discount: { amount: number, type: DocumentDiscountType } | null, client: (
    { id: string, emails: Array<string>, originalBusiness: { id: string, name: string }, integrations: { id: string } }
    & { ' $fragmentRefs'?: { 'IssueDocumentClientFieldsFragment': IssueDocumentClientFieldsFragment } }
  ) | null, income: Array<{ currency: Currency, currencyRate: number | null, description: string, itemId: string | null, price: number, quantity: number, vatRate: number | null, vatType: DocumentVatType }> | null, payment: Array<{ currency: Currency, currencyRate: number | null, date: string | null, price: number, type: PaymentType, bankName: string | null, bankBranch: string | null, bankAccount: string | null, chequeNum: string | null, accountId: string | null, transactionId: string | null, cardType: DocumentPaymentRecordCardType | null, cardNum: string | null, numPayments: number | null, firstPayment: number | null }> | null } & { ' $fragmentName'?: 'NewDocumentDraftFragment' };

export type SimilarChargesByBusinessQueryVariables = Exact<{
  businessId: string;
  tagsDifferentThan?: Array<string> | string | null | undefined;
  descriptionDifferentThan?: string | null | undefined;
}>;


export type SimilarChargesByBusinessQuery = { similarChargesByBusiness: Array<
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'SimilarChargesTable_BankDepositCharge_Fragment': SimilarChargesTable_BankDepositCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'SimilarChargesTable_BusinessTripCharge_Fragment': SimilarChargesTable_BusinessTripCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'SimilarChargesTable_CommonCharge_Fragment': SimilarChargesTable_CommonCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'SimilarChargesTable_ConversionCharge_Fragment': SimilarChargesTable_ConversionCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'SimilarChargesTable_CreditcardBankCharge_Fragment': SimilarChargesTable_CreditcardBankCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'SimilarChargesTable_DividendCharge_Fragment': SimilarChargesTable_DividendCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'SimilarChargesTable_FinancialCharge_Fragment': SimilarChargesTable_FinancialCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'SimilarChargesTable_ForeignSecuritiesCharge_Fragment': SimilarChargesTable_ForeignSecuritiesCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'SimilarChargesTable_InternalTransferCharge_Fragment': SimilarChargesTable_InternalTransferCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'SimilarChargesTable_MonthlyVatCharge_Fragment': SimilarChargesTable_MonthlyVatCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'SimilarChargesTable_SalaryCharge_Fragment': SimilarChargesTable_SalaryCharge_Fragment } }
    )
  > };

export type SimilarChargesQueryVariables = Exact<{
  chargeId: string;
  withMissingTags: boolean;
  withMissingDescription: boolean;
  tagsDifferentThan?: Array<string> | string | null | undefined;
  descriptionDifferentThan?: string | null | undefined;
}>;


export type SimilarChargesQuery = { similarCharges: Array<
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'SimilarChargesTable_BankDepositCharge_Fragment': SimilarChargesTable_BankDepositCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'SimilarChargesTable_BusinessTripCharge_Fragment': SimilarChargesTable_BusinessTripCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'SimilarChargesTable_CommonCharge_Fragment': SimilarChargesTable_CommonCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'SimilarChargesTable_ConversionCharge_Fragment': SimilarChargesTable_ConversionCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'SimilarChargesTable_CreditcardBankCharge_Fragment': SimilarChargesTable_CreditcardBankCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'SimilarChargesTable_DividendCharge_Fragment': SimilarChargesTable_DividendCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'SimilarChargesTable_FinancialCharge_Fragment': SimilarChargesTable_FinancialCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'SimilarChargesTable_ForeignSecuritiesCharge_Fragment': SimilarChargesTable_ForeignSecuritiesCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'SimilarChargesTable_InternalTransferCharge_Fragment': SimilarChargesTable_InternalTransferCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'SimilarChargesTable_MonthlyVatCharge_Fragment': SimilarChargesTable_MonthlyVatCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'SimilarChargesTable_SalaryCharge_Fragment': SimilarChargesTable_SalaryCharge_Fragment } }
    )
  > };

type SimilarChargesTable_BankDepositCharge_Fragment = { __typename: 'BankDepositCharge', id: string, minEventDate: unknown, minDebitDate: unknown, minDocumentsDate: unknown, userDescription: string | null, counterparty:
    | { name: string, id: string }
    | { name: string, id: string }
    | { name: string, id: string }
   | null, totalAmount: { raw: number, formatted: string } | null, vat: { raw: number, formatted: string } | null, tags: Array<{ id: string, name: string }>, taxCategory: { id: string, name: string } | null, metadata: { transactionsCount: number, documentsCount: number, ledgerCount: number, miscExpensesCount: number } | null } & { ' $fragmentName'?: 'SimilarChargesTable_BankDepositCharge_Fragment' };

type SimilarChargesTable_BusinessTripCharge_Fragment = { __typename: 'BusinessTripCharge', id: string, minEventDate: unknown, minDebitDate: unknown, minDocumentsDate: unknown, userDescription: string | null, businessTrip: { id: string, name: string } | null, counterparty:
    | { name: string, id: string }
    | { name: string, id: string }
    | { name: string, id: string }
   | null, totalAmount: { raw: number, formatted: string } | null, vat: { raw: number, formatted: string } | null, tags: Array<{ id: string, name: string }>, taxCategory: { id: string, name: string } | null, metadata: { transactionsCount: number, documentsCount: number, ledgerCount: number, miscExpensesCount: number } | null } & { ' $fragmentName'?: 'SimilarChargesTable_BusinessTripCharge_Fragment' };

type SimilarChargesTable_CommonCharge_Fragment = { __typename: 'CommonCharge', id: string, minEventDate: unknown, minDebitDate: unknown, minDocumentsDate: unknown, userDescription: string | null, counterparty:
    | { name: string, id: string }
    | { name: string, id: string }
    | { name: string, id: string }
   | null, totalAmount: { raw: number, formatted: string } | null, vat: { raw: number, formatted: string } | null, tags: Array<{ id: string, name: string }>, taxCategory: { id: string, name: string } | null, metadata: { transactionsCount: number, documentsCount: number, ledgerCount: number, miscExpensesCount: number } | null } & { ' $fragmentName'?: 'SimilarChargesTable_CommonCharge_Fragment' };

type SimilarChargesTable_ConversionCharge_Fragment = { __typename: 'ConversionCharge', id: string, minEventDate: unknown, minDebitDate: unknown, minDocumentsDate: unknown, userDescription: string | null, counterparty:
    | { name: string, id: string }
    | { name: string, id: string }
    | { name: string, id: string }
   | null, totalAmount: { raw: number, formatted: string } | null, vat: { raw: number, formatted: string } | null, tags: Array<{ id: string, name: string }>, taxCategory: { id: string, name: string } | null, metadata: { transactionsCount: number, documentsCount: number, ledgerCount: number, miscExpensesCount: number } | null } & { ' $fragmentName'?: 'SimilarChargesTable_ConversionCharge_Fragment' };

type SimilarChargesTable_CreditcardBankCharge_Fragment = { __typename: 'CreditcardBankCharge', id: string, minEventDate: unknown, minDebitDate: unknown, minDocumentsDate: unknown, userDescription: string | null, counterparty:
    | { name: string, id: string }
    | { name: string, id: string }
    | { name: string, id: string }
   | null, totalAmount: { raw: number, formatted: string } | null, vat: { raw: number, formatted: string } | null, tags: Array<{ id: string, name: string }>, taxCategory: { id: string, name: string } | null, metadata: { transactionsCount: number, documentsCount: number, ledgerCount: number, miscExpensesCount: number } | null } & { ' $fragmentName'?: 'SimilarChargesTable_CreditcardBankCharge_Fragment' };

type SimilarChargesTable_DividendCharge_Fragment = { __typename: 'DividendCharge', id: string, minEventDate: unknown, minDebitDate: unknown, minDocumentsDate: unknown, userDescription: string | null, counterparty:
    | { name: string, id: string }
    | { name: string, id: string }
    | { name: string, id: string }
   | null, totalAmount: { raw: number, formatted: string } | null, vat: { raw: number, formatted: string } | null, tags: Array<{ id: string, name: string }>, taxCategory: { id: string, name: string } | null, metadata: { transactionsCount: number, documentsCount: number, ledgerCount: number, miscExpensesCount: number } | null } & { ' $fragmentName'?: 'SimilarChargesTable_DividendCharge_Fragment' };

type SimilarChargesTable_FinancialCharge_Fragment = { __typename: 'FinancialCharge', id: string, minEventDate: unknown, minDebitDate: unknown, minDocumentsDate: unknown, userDescription: string | null, counterparty:
    | { name: string, id: string }
    | { name: string, id: string }
    | { name: string, id: string }
   | null, totalAmount: { raw: number, formatted: string } | null, vat: { raw: number, formatted: string } | null, tags: Array<{ id: string, name: string }>, taxCategory: { id: string, name: string } | null, metadata: { transactionsCount: number, documentsCount: number, ledgerCount: number, miscExpensesCount: number } | null } & { ' $fragmentName'?: 'SimilarChargesTable_FinancialCharge_Fragment' };

type SimilarChargesTable_ForeignSecuritiesCharge_Fragment = { __typename: 'ForeignSecuritiesCharge', id: string, minEventDate: unknown, minDebitDate: unknown, minDocumentsDate: unknown, userDescription: string | null, counterparty:
    | { name: string, id: string }
    | { name: string, id: string }
    | { name: string, id: string }
   | null, totalAmount: { raw: number, formatted: string } | null, vat: { raw: number, formatted: string } | null, tags: Array<{ id: string, name: string }>, taxCategory: { id: string, name: string } | null, metadata: { transactionsCount: number, documentsCount: number, ledgerCount: number, miscExpensesCount: number } | null } & { ' $fragmentName'?: 'SimilarChargesTable_ForeignSecuritiesCharge_Fragment' };

type SimilarChargesTable_InternalTransferCharge_Fragment = { __typename: 'InternalTransferCharge', id: string, minEventDate: unknown, minDebitDate: unknown, minDocumentsDate: unknown, userDescription: string | null, counterparty:
    | { name: string, id: string }
    | { name: string, id: string }
    | { name: string, id: string }
   | null, totalAmount: { raw: number, formatted: string } | null, vat: { raw: number, formatted: string } | null, tags: Array<{ id: string, name: string }>, taxCategory: { id: string, name: string } | null, metadata: { transactionsCount: number, documentsCount: number, ledgerCount: number, miscExpensesCount: number } | null } & { ' $fragmentName'?: 'SimilarChargesTable_InternalTransferCharge_Fragment' };

type SimilarChargesTable_MonthlyVatCharge_Fragment = { __typename: 'MonthlyVatCharge', id: string, minEventDate: unknown, minDebitDate: unknown, minDocumentsDate: unknown, userDescription: string | null, counterparty:
    | { name: string, id: string }
    | { name: string, id: string }
    | { name: string, id: string }
   | null, totalAmount: { raw: number, formatted: string } | null, vat: { raw: number, formatted: string } | null, tags: Array<{ id: string, name: string }>, taxCategory: { id: string, name: string } | null, metadata: { transactionsCount: number, documentsCount: number, ledgerCount: number, miscExpensesCount: number } | null } & { ' $fragmentName'?: 'SimilarChargesTable_MonthlyVatCharge_Fragment' };

type SimilarChargesTable_SalaryCharge_Fragment = { __typename: 'SalaryCharge', id: string, minEventDate: unknown, minDebitDate: unknown, minDocumentsDate: unknown, userDescription: string | null, counterparty:
    | { name: string, id: string }
    | { name: string, id: string }
    | { name: string, id: string }
   | null, totalAmount: { raw: number, formatted: string } | null, vat: { raw: number, formatted: string } | null, tags: Array<{ id: string, name: string }>, taxCategory: { id: string, name: string } | null, metadata: { transactionsCount: number, documentsCount: number, ledgerCount: number, miscExpensesCount: number } | null } & { ' $fragmentName'?: 'SimilarChargesTable_SalaryCharge_Fragment' };

export type SimilarChargesTableFragment =
  | SimilarChargesTable_BankDepositCharge_Fragment
  | SimilarChargesTable_BusinessTripCharge_Fragment
  | SimilarChargesTable_CommonCharge_Fragment
  | SimilarChargesTable_ConversionCharge_Fragment
  | SimilarChargesTable_CreditcardBankCharge_Fragment
  | SimilarChargesTable_DividendCharge_Fragment
  | SimilarChargesTable_FinancialCharge_Fragment
  | SimilarChargesTable_ForeignSecuritiesCharge_Fragment
  | SimilarChargesTable_InternalTransferCharge_Fragment
  | SimilarChargesTable_MonthlyVatCharge_Fragment
  | SimilarChargesTable_SalaryCharge_Fragment
;

export type SimilarTransactionsQueryVariables = Exact<{
  transactionId: string;
  withMissingInfo: boolean;
}>;


export type SimilarTransactionsQuery = { similarTransactions: Array<
    | { id: string, effectiveDate: unknown, eventDate: unknown, sourceDescription: string, account:
        | { id: string, name: string, type: FinancialAccountType }
        | { id: string, name: string, type: FinancialAccountType }
        | { id: string, name: string, type: FinancialAccountType }
        | { id: string, name: string, type: FinancialAccountType }
        | { id: string, name: string, type: FinancialAccountType }
      , amount: { formatted: string, raw: number } }
    | { id: string, effectiveDate: unknown, eventDate: unknown, sourceDescription: string, account:
        | { id: string, name: string, type: FinancialAccountType }
        | { id: string, name: string, type: FinancialAccountType }
        | { id: string, name: string, type: FinancialAccountType }
        | { id: string, name: string, type: FinancialAccountType }
        | { id: string, name: string, type: FinancialAccountType }
      , amount: { formatted: string, raw: number } }
  > };

export type UniformFormatQueryVariables = Exact<{
  fromDate: unknown;
  toDate: unknown;
}>;


export type UniformFormatQuery = { uniformFormat: { bkmvdata: string, ini: string } | null };

type NewFetchedDocumentFields_CreditInvoice_Fragment = { id: string, documentType: DocumentType | null, charge:
    | { id: string, userDescription: string | null, counterparty:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null }
    | { id: string, userDescription: string | null, counterparty:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null }
    | { id: string, userDescription: string | null, counterparty:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null }
    | { id: string, userDescription: string | null, counterparty:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null }
    | { id: string, userDescription: string | null, counterparty:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null }
    | { id: string, userDescription: string | null, counterparty:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null }
    | { id: string, userDescription: string | null, counterparty:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null }
    | { id: string, userDescription: string | null, counterparty:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null }
    | { id: string, userDescription: string | null, counterparty:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null }
    | { id: string, userDescription: string | null, counterparty:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null }
    | { id: string, userDescription: string | null, counterparty:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null }
   | null } & { ' $fragmentName'?: 'NewFetchedDocumentFields_CreditInvoice_Fragment' };

type NewFetchedDocumentFields_Invoice_Fragment = { id: string, documentType: DocumentType | null, charge:
    | { id: string, userDescription: string | null, counterparty:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null }
    | { id: string, userDescription: string | null, counterparty:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null }
    | { id: string, userDescription: string | null, counterparty:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null }
    | { id: string, userDescription: string | null, counterparty:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null }
    | { id: string, userDescription: string | null, counterparty:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null }
    | { id: string, userDescription: string | null, counterparty:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null }
    | { id: string, userDescription: string | null, counterparty:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null }
    | { id: string, userDescription: string | null, counterparty:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null }
    | { id: string, userDescription: string | null, counterparty:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null }
    | { id: string, userDescription: string | null, counterparty:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null }
    | { id: string, userDescription: string | null, counterparty:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null }
   | null } & { ' $fragmentName'?: 'NewFetchedDocumentFields_Invoice_Fragment' };

type NewFetchedDocumentFields_InvoiceReceipt_Fragment = { id: string, documentType: DocumentType | null, charge:
    | { id: string, userDescription: string | null, counterparty:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null }
    | { id: string, userDescription: string | null, counterparty:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null }
    | { id: string, userDescription: string | null, counterparty:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null }
    | { id: string, userDescription: string | null, counterparty:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null }
    | { id: string, userDescription: string | null, counterparty:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null }
    | { id: string, userDescription: string | null, counterparty:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null }
    | { id: string, userDescription: string | null, counterparty:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null }
    | { id: string, userDescription: string | null, counterparty:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null }
    | { id: string, userDescription: string | null, counterparty:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null }
    | { id: string, userDescription: string | null, counterparty:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null }
    | { id: string, userDescription: string | null, counterparty:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null }
   | null } & { ' $fragmentName'?: 'NewFetchedDocumentFields_InvoiceReceipt_Fragment' };

type NewFetchedDocumentFields_OtherDocument_Fragment = { id: string, documentType: DocumentType | null, charge:
    | { id: string, userDescription: string | null, counterparty:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null }
    | { id: string, userDescription: string | null, counterparty:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null }
    | { id: string, userDescription: string | null, counterparty:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null }
    | { id: string, userDescription: string | null, counterparty:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null }
    | { id: string, userDescription: string | null, counterparty:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null }
    | { id: string, userDescription: string | null, counterparty:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null }
    | { id: string, userDescription: string | null, counterparty:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null }
    | { id: string, userDescription: string | null, counterparty:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null }
    | { id: string, userDescription: string | null, counterparty:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null }
    | { id: string, userDescription: string | null, counterparty:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null }
    | { id: string, userDescription: string | null, counterparty:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null }
   | null } & { ' $fragmentName'?: 'NewFetchedDocumentFields_OtherDocument_Fragment' };

type NewFetchedDocumentFields_Proforma_Fragment = { id: string, documentType: DocumentType | null, charge:
    | { id: string, userDescription: string | null, counterparty:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null }
    | { id: string, userDescription: string | null, counterparty:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null }
    | { id: string, userDescription: string | null, counterparty:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null }
    | { id: string, userDescription: string | null, counterparty:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null }
    | { id: string, userDescription: string | null, counterparty:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null }
    | { id: string, userDescription: string | null, counterparty:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null }
    | { id: string, userDescription: string | null, counterparty:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null }
    | { id: string, userDescription: string | null, counterparty:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null }
    | { id: string, userDescription: string | null, counterparty:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null }
    | { id: string, userDescription: string | null, counterparty:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null }
    | { id: string, userDescription: string | null, counterparty:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null }
   | null } & { ' $fragmentName'?: 'NewFetchedDocumentFields_Proforma_Fragment' };

type NewFetchedDocumentFields_Receipt_Fragment = { id: string, documentType: DocumentType | null, charge:
    | { id: string, userDescription: string | null, counterparty:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null }
    | { id: string, userDescription: string | null, counterparty:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null }
    | { id: string, userDescription: string | null, counterparty:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null }
    | { id: string, userDescription: string | null, counterparty:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null }
    | { id: string, userDescription: string | null, counterparty:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null }
    | { id: string, userDescription: string | null, counterparty:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null }
    | { id: string, userDescription: string | null, counterparty:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null }
    | { id: string, userDescription: string | null, counterparty:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null }
    | { id: string, userDescription: string | null, counterparty:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null }
    | { id: string, userDescription: string | null, counterparty:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null }
    | { id: string, userDescription: string | null, counterparty:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null }
   | null } & { ' $fragmentName'?: 'NewFetchedDocumentFields_Receipt_Fragment' };

type NewFetchedDocumentFields_Unprocessed_Fragment = { id: string, documentType: DocumentType | null, charge:
    | { id: string, userDescription: string | null, counterparty:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null }
    | { id: string, userDescription: string | null, counterparty:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null }
    | { id: string, userDescription: string | null, counterparty:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null }
    | { id: string, userDescription: string | null, counterparty:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null }
    | { id: string, userDescription: string | null, counterparty:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null }
    | { id: string, userDescription: string | null, counterparty:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null }
    | { id: string, userDescription: string | null, counterparty:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null }
    | { id: string, userDescription: string | null, counterparty:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null }
    | { id: string, userDescription: string | null, counterparty:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null }
    | { id: string, userDescription: string | null, counterparty:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null }
    | { id: string, userDescription: string | null, counterparty:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null }
   | null } & { ' $fragmentName'?: 'NewFetchedDocumentFields_Unprocessed_Fragment' };

export type NewFetchedDocumentFieldsFragment =
  | NewFetchedDocumentFields_CreditInvoice_Fragment
  | NewFetchedDocumentFields_Invoice_Fragment
  | NewFetchedDocumentFields_InvoiceReceipt_Fragment
  | NewFetchedDocumentFields_OtherDocument_Fragment
  | NewFetchedDocumentFields_Proforma_Fragment
  | NewFetchedDocumentFields_Receipt_Fragment
  | NewFetchedDocumentFields_Unprocessed_Fragment
;

export type ContractForContractsTableFieldsFragment = { id: string, isActive: boolean, purchaseOrders: Array<string>, startDate: unknown, endDate: unknown, billingCycle: BillingCycle, product: Product | null, plan: SubscriptionPlan | null, operationsLimit: unknown, msCloud: unknown, client: { id: string, originalBusiness: { id: string, name: string } }, amount: { raw: number, formatted: string } } & { ' $fragmentName'?: 'ContractForContractsTableFieldsFragment' };

export type ContractBasedDocumentDraftsQueryVariables = Exact<{
  issueMonth: unknown;
  contractIds: Array<string> | string;
}>;


export type ContractBasedDocumentDraftsQuery = { periodicalDocumentDraftsByContracts: Array<{ ' $fragmentRefs'?: { 'NewDocumentDraftFragment': NewDocumentDraftFragment } }> };

type TableDocumentsRowFields_CreditInvoice_Fragment = { date: unknown, serialNumber: string | null, allocationNumber: string | null, id: string, documentType: DocumentType | null, image: unknown, file: unknown, description: string | null, remarks: string | null, amount: { raw: number, formatted: string, currency: Currency } | null, missingInfoSuggestions: { isIncome: boolean | null, amount: { raw: number, formatted: string, currency: Currency } | null, counterparty:
      | { id: string, name: string }
      | { id: string, name: string }
      | { id: string, name: string }
     | null, owner:
      | { id: string, name: string }
      | { id: string, name: string }
      | { id: string, name: string }
     | null } | null, vat: { raw: number, formatted: string, currency: Currency } | null, creditor:
    | { id: string, name: string }
    | { id: string, name: string }
    | { id: string, name: string }
   | null, debtor:
    | { id: string, name: string }
    | { id: string, name: string }
    | { id: string, name: string }
   | null, issuedDocumentInfo: { id: string, status: DocumentStatus, originalDocument: { income: Array<{ description: string }> | null } | null } | null, charge:
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
   | null } & { ' $fragmentName'?: 'TableDocumentsRowFields_CreditInvoice_Fragment' };

type TableDocumentsRowFields_Invoice_Fragment = { date: unknown, serialNumber: string | null, allocationNumber: string | null, id: string, documentType: DocumentType | null, image: unknown, file: unknown, description: string | null, remarks: string | null, amount: { raw: number, formatted: string, currency: Currency } | null, missingInfoSuggestions: { isIncome: boolean | null, amount: { raw: number, formatted: string, currency: Currency } | null, counterparty:
      | { id: string, name: string }
      | { id: string, name: string }
      | { id: string, name: string }
     | null, owner:
      | { id: string, name: string }
      | { id: string, name: string }
      | { id: string, name: string }
     | null } | null, vat: { raw: number, formatted: string, currency: Currency } | null, creditor:
    | { id: string, name: string }
    | { id: string, name: string }
    | { id: string, name: string }
   | null, debtor:
    | { id: string, name: string }
    | { id: string, name: string }
    | { id: string, name: string }
   | null, issuedDocumentInfo: { id: string, status: DocumentStatus, originalDocument: { income: Array<{ description: string }> | null } | null } | null, charge:
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
   | null } & { ' $fragmentName'?: 'TableDocumentsRowFields_Invoice_Fragment' };

type TableDocumentsRowFields_InvoiceReceipt_Fragment = { date: unknown, serialNumber: string | null, allocationNumber: string | null, id: string, documentType: DocumentType | null, image: unknown, file: unknown, description: string | null, remarks: string | null, amount: { raw: number, formatted: string, currency: Currency } | null, missingInfoSuggestions: { isIncome: boolean | null, amount: { raw: number, formatted: string, currency: Currency } | null, counterparty:
      | { id: string, name: string }
      | { id: string, name: string }
      | { id: string, name: string }
     | null, owner:
      | { id: string, name: string }
      | { id: string, name: string }
      | { id: string, name: string }
     | null } | null, vat: { raw: number, formatted: string, currency: Currency } | null, creditor:
    | { id: string, name: string }
    | { id: string, name: string }
    | { id: string, name: string }
   | null, debtor:
    | { id: string, name: string }
    | { id: string, name: string }
    | { id: string, name: string }
   | null, issuedDocumentInfo: { id: string, status: DocumentStatus, originalDocument: { income: Array<{ description: string }> | null } | null } | null, charge:
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
   | null } & { ' $fragmentName'?: 'TableDocumentsRowFields_InvoiceReceipt_Fragment' };

type TableDocumentsRowFields_OtherDocument_Fragment = { id: string, documentType: DocumentType | null, image: unknown, file: unknown, description: string | null, remarks: string | null, charge:
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
   | null } & { ' $fragmentName'?: 'TableDocumentsRowFields_OtherDocument_Fragment' };

type TableDocumentsRowFields_Proforma_Fragment = { date: unknown, serialNumber: string | null, allocationNumber: string | null, id: string, documentType: DocumentType | null, image: unknown, file: unknown, description: string | null, remarks: string | null, amount: { raw: number, formatted: string, currency: Currency } | null, missingInfoSuggestions: { isIncome: boolean | null, amount: { raw: number, formatted: string, currency: Currency } | null, counterparty:
      | { id: string, name: string }
      | { id: string, name: string }
      | { id: string, name: string }
     | null, owner:
      | { id: string, name: string }
      | { id: string, name: string }
      | { id: string, name: string }
     | null } | null, vat: { raw: number, formatted: string, currency: Currency } | null, creditor:
    | { id: string, name: string }
    | { id: string, name: string }
    | { id: string, name: string }
   | null, debtor:
    | { id: string, name: string }
    | { id: string, name: string }
    | { id: string, name: string }
   | null, issuedDocumentInfo: { id: string, status: DocumentStatus, originalDocument: { income: Array<{ description: string }> | null } | null } | null, charge:
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
   | null } & { ' $fragmentName'?: 'TableDocumentsRowFields_Proforma_Fragment' };

type TableDocumentsRowFields_Receipt_Fragment = { date: unknown, serialNumber: string | null, allocationNumber: string | null, id: string, documentType: DocumentType | null, image: unknown, file: unknown, description: string | null, remarks: string | null, amount: { raw: number, formatted: string, currency: Currency } | null, missingInfoSuggestions: { isIncome: boolean | null, amount: { raw: number, formatted: string, currency: Currency } | null, counterparty:
      | { id: string, name: string }
      | { id: string, name: string }
      | { id: string, name: string }
     | null, owner:
      | { id: string, name: string }
      | { id: string, name: string }
      | { id: string, name: string }
     | null } | null, vat: { raw: number, formatted: string, currency: Currency } | null, creditor:
    | { id: string, name: string }
    | { id: string, name: string }
    | { id: string, name: string }
   | null, debtor:
    | { id: string, name: string }
    | { id: string, name: string }
    | { id: string, name: string }
   | null, issuedDocumentInfo: { id: string, status: DocumentStatus, originalDocument: { income: Array<{ description: string }> | null } | null } | null, charge:
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
   | null } & { ' $fragmentName'?: 'TableDocumentsRowFields_Receipt_Fragment' };

type TableDocumentsRowFields_Unprocessed_Fragment = { id: string, documentType: DocumentType | null, image: unknown, file: unknown, description: string | null, remarks: string | null, charge:
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
   | null } & { ' $fragmentName'?: 'TableDocumentsRowFields_Unprocessed_Fragment' };

export type TableDocumentsRowFieldsFragment =
  | TableDocumentsRowFields_CreditInvoice_Fragment
  | TableDocumentsRowFields_Invoice_Fragment
  | TableDocumentsRowFields_InvoiceReceipt_Fragment
  | TableDocumentsRowFields_OtherDocument_Fragment
  | TableDocumentsRowFields_Proforma_Fragment
  | TableDocumentsRowFields_Receipt_Fragment
  | TableDocumentsRowFields_Unprocessed_Fragment
;

type DocumentsGalleryFields_BankDepositCharge_Fragment = { id: string, additionalDocuments: Array<
    | { documentType: DocumentType | null, id: string, image: unknown }
    | { documentType: DocumentType | null, id: string, image: unknown }
    | { documentType: DocumentType | null, id: string, image: unknown }
    | { id: string, image: unknown }
    | { documentType: DocumentType | null, id: string, image: unknown }
    | { documentType: DocumentType | null, id: string, image: unknown }
    | { id: string, image: unknown }
  > } & { ' $fragmentName'?: 'DocumentsGalleryFields_BankDepositCharge_Fragment' };

type DocumentsGalleryFields_BusinessTripCharge_Fragment = { id: string, additionalDocuments: Array<
    | { documentType: DocumentType | null, id: string, image: unknown }
    | { documentType: DocumentType | null, id: string, image: unknown }
    | { documentType: DocumentType | null, id: string, image: unknown }
    | { id: string, image: unknown }
    | { documentType: DocumentType | null, id: string, image: unknown }
    | { documentType: DocumentType | null, id: string, image: unknown }
    | { id: string, image: unknown }
  > } & { ' $fragmentName'?: 'DocumentsGalleryFields_BusinessTripCharge_Fragment' };

type DocumentsGalleryFields_CommonCharge_Fragment = { id: string, additionalDocuments: Array<
    | { documentType: DocumentType | null, id: string, image: unknown }
    | { documentType: DocumentType | null, id: string, image: unknown }
    | { documentType: DocumentType | null, id: string, image: unknown }
    | { id: string, image: unknown }
    | { documentType: DocumentType | null, id: string, image: unknown }
    | { documentType: DocumentType | null, id: string, image: unknown }
    | { id: string, image: unknown }
  > } & { ' $fragmentName'?: 'DocumentsGalleryFields_CommonCharge_Fragment' };

type DocumentsGalleryFields_ConversionCharge_Fragment = { id: string, additionalDocuments: Array<
    | { documentType: DocumentType | null, id: string, image: unknown }
    | { documentType: DocumentType | null, id: string, image: unknown }
    | { documentType: DocumentType | null, id: string, image: unknown }
    | { id: string, image: unknown }
    | { documentType: DocumentType | null, id: string, image: unknown }
    | { documentType: DocumentType | null, id: string, image: unknown }
    | { id: string, image: unknown }
  > } & { ' $fragmentName'?: 'DocumentsGalleryFields_ConversionCharge_Fragment' };

type DocumentsGalleryFields_CreditcardBankCharge_Fragment = { id: string, additionalDocuments: Array<
    | { documentType: DocumentType | null, id: string, image: unknown }
    | { documentType: DocumentType | null, id: string, image: unknown }
    | { documentType: DocumentType | null, id: string, image: unknown }
    | { id: string, image: unknown }
    | { documentType: DocumentType | null, id: string, image: unknown }
    | { documentType: DocumentType | null, id: string, image: unknown }
    | { id: string, image: unknown }
  > } & { ' $fragmentName'?: 'DocumentsGalleryFields_CreditcardBankCharge_Fragment' };

type DocumentsGalleryFields_DividendCharge_Fragment = { id: string, additionalDocuments: Array<
    | { documentType: DocumentType | null, id: string, image: unknown }
    | { documentType: DocumentType | null, id: string, image: unknown }
    | { documentType: DocumentType | null, id: string, image: unknown }
    | { id: string, image: unknown }
    | { documentType: DocumentType | null, id: string, image: unknown }
    | { documentType: DocumentType | null, id: string, image: unknown }
    | { id: string, image: unknown }
  > } & { ' $fragmentName'?: 'DocumentsGalleryFields_DividendCharge_Fragment' };

type DocumentsGalleryFields_FinancialCharge_Fragment = { id: string, additionalDocuments: Array<
    | { documentType: DocumentType | null, id: string, image: unknown }
    | { documentType: DocumentType | null, id: string, image: unknown }
    | { documentType: DocumentType | null, id: string, image: unknown }
    | { id: string, image: unknown }
    | { documentType: DocumentType | null, id: string, image: unknown }
    | { documentType: DocumentType | null, id: string, image: unknown }
    | { id: string, image: unknown }
  > } & { ' $fragmentName'?: 'DocumentsGalleryFields_FinancialCharge_Fragment' };

type DocumentsGalleryFields_ForeignSecuritiesCharge_Fragment = { id: string, additionalDocuments: Array<
    | { documentType: DocumentType | null, id: string, image: unknown }
    | { documentType: DocumentType | null, id: string, image: unknown }
    | { documentType: DocumentType | null, id: string, image: unknown }
    | { id: string, image: unknown }
    | { documentType: DocumentType | null, id: string, image: unknown }
    | { documentType: DocumentType | null, id: string, image: unknown }
    | { id: string, image: unknown }
  > } & { ' $fragmentName'?: 'DocumentsGalleryFields_ForeignSecuritiesCharge_Fragment' };

type DocumentsGalleryFields_InternalTransferCharge_Fragment = { id: string, additionalDocuments: Array<
    | { documentType: DocumentType | null, id: string, image: unknown }
    | { documentType: DocumentType | null, id: string, image: unknown }
    | { documentType: DocumentType | null, id: string, image: unknown }
    | { id: string, image: unknown }
    | { documentType: DocumentType | null, id: string, image: unknown }
    | { documentType: DocumentType | null, id: string, image: unknown }
    | { id: string, image: unknown }
  > } & { ' $fragmentName'?: 'DocumentsGalleryFields_InternalTransferCharge_Fragment' };

type DocumentsGalleryFields_MonthlyVatCharge_Fragment = { id: string, additionalDocuments: Array<
    | { documentType: DocumentType | null, id: string, image: unknown }
    | { documentType: DocumentType | null, id: string, image: unknown }
    | { documentType: DocumentType | null, id: string, image: unknown }
    | { id: string, image: unknown }
    | { documentType: DocumentType | null, id: string, image: unknown }
    | { documentType: DocumentType | null, id: string, image: unknown }
    | { id: string, image: unknown }
  > } & { ' $fragmentName'?: 'DocumentsGalleryFields_MonthlyVatCharge_Fragment' };

type DocumentsGalleryFields_SalaryCharge_Fragment = { id: string, additionalDocuments: Array<
    | { documentType: DocumentType | null, id: string, image: unknown }
    | { documentType: DocumentType | null, id: string, image: unknown }
    | { documentType: DocumentType | null, id: string, image: unknown }
    | { id: string, image: unknown }
    | { documentType: DocumentType | null, id: string, image: unknown }
    | { documentType: DocumentType | null, id: string, image: unknown }
    | { id: string, image: unknown }
  > } & { ' $fragmentName'?: 'DocumentsGalleryFields_SalaryCharge_Fragment' };

export type DocumentsGalleryFieldsFragment =
  | DocumentsGalleryFields_BankDepositCharge_Fragment
  | DocumentsGalleryFields_BusinessTripCharge_Fragment
  | DocumentsGalleryFields_CommonCharge_Fragment
  | DocumentsGalleryFields_ConversionCharge_Fragment
  | DocumentsGalleryFields_CreditcardBankCharge_Fragment
  | DocumentsGalleryFields_DividendCharge_Fragment
  | DocumentsGalleryFields_FinancialCharge_Fragment
  | DocumentsGalleryFields_ForeignSecuritiesCharge_Fragment
  | DocumentsGalleryFields_InternalTransferCharge_Fragment
  | DocumentsGalleryFields_MonthlyVatCharge_Fragment
  | DocumentsGalleryFields_SalaryCharge_Fragment
;

export type LedgerRecordsTableFieldsFragment = { id: string, invoiceDate: unknown, valueDate: unknown, description: string | null, reference: string | null, creditAccount1:
    | { __typename: 'LtdFinancialEntity', id: string, name: string }
    | { __typename: 'PersonalFinancialEntity', id: string, name: string }
    | { __typename: 'TaxCategory', id: string, name: string }
   | null, creditAccount2:
    | { __typename: 'LtdFinancialEntity', id: string, name: string }
    | { __typename: 'PersonalFinancialEntity', id: string, name: string }
    | { __typename: 'TaxCategory', id: string, name: string }
   | null, debitAccount1:
    | { __typename: 'LtdFinancialEntity', id: string, name: string }
    | { __typename: 'PersonalFinancialEntity', id: string, name: string }
    | { __typename: 'TaxCategory', id: string, name: string }
   | null, debitAccount2:
    | { __typename: 'LtdFinancialEntity', id: string, name: string }
    | { __typename: 'PersonalFinancialEntity', id: string, name: string }
    | { __typename: 'TaxCategory', id: string, name: string }
   | null, creditAmount1: { formatted: string, currency: Currency } | null, creditAmount2: { formatted: string, currency: Currency } | null, debitAmount1: { formatted: string, currency: Currency } | null, debitAmount2: { formatted: string, currency: Currency } | null, localCurrencyCreditAmount1: { formatted: string, raw: number }, localCurrencyCreditAmount2: { formatted: string, raw: number } | null, localCurrencyDebitAmount1: { formatted: string, raw: number }, localCurrencyDebitAmount2: { formatted: string, raw: number } | null } & { ' $fragmentName'?: 'LedgerRecordsTableFieldsFragment' };

export type AccountantApprovalsChargesTableQueryVariables = Exact<{
  page?: number | null | undefined;
  limit?: number | null | undefined;
  filters?: ChargeFilter | null | undefined;
}>;


export type AccountantApprovalsChargesTableQuery = { allCharges: { nodes: Array<
      | { id: string, accountantApproval: AccountantStatus }
      | { id: string, accountantApproval: AccountantStatus }
      | { id: string, accountantApproval: AccountantStatus }
      | { id: string, accountantApproval: AccountantStatus }
      | { id: string, accountantApproval: AccountantStatus }
      | { id: string, accountantApproval: AccountantStatus }
      | { id: string, accountantApproval: AccountantStatus }
      | { id: string, accountantApproval: AccountantStatus }
      | { id: string, accountantApproval: AccountantStatus }
      | { id: string, accountantApproval: AccountantStatus }
      | { id: string, accountantApproval: AccountantStatus }
    > } };

export type CorporateTaxRulingComplianceReportQueryVariables = Exact<{
  years: Array<number> | number;
}>;


export type CorporateTaxRulingComplianceReportQuery = { corporateTaxRulingComplianceReport: Array<{ id: string, year: number, totalIncome: { formatted: string, raw: number, currency: Currency }, researchAndDevelopmentExpenses: { formatted: string, raw: number, currency: Currency }, rndRelativeToIncome: (
      { rule: string }
      & { ' $fragmentRefs'?: { 'CorporateTaxRulingReportRuleCellFieldsFragment': CorporateTaxRulingReportRuleCellFieldsFragment } }
    ), localDevelopmentExpenses: { formatted: string, raw: number, currency: Currency }, localDevelopmentRelativeToRnd: (
      { rule: string }
      & { ' $fragmentRefs'?: { 'CorporateTaxRulingReportRuleCellFieldsFragment': CorporateTaxRulingReportRuleCellFieldsFragment } }
    ), foreignDevelopmentExpenses: { formatted: string, raw: number, currency: Currency }, foreignDevelopmentRelativeToRnd: (
      { rule: string }
      & { ' $fragmentRefs'?: { 'CorporateTaxRulingReportRuleCellFieldsFragment': CorporateTaxRulingReportRuleCellFieldsFragment } }
    ), businessTripRndExpenses: { formatted: string, raw: number, currency: Currency } } & ({ differences: { id: string, totalIncome: { formatted: string, raw: number, currency: Currency } | null, researchAndDevelopmentExpenses: { formatted: string, raw: number, currency: Currency } | null, rndRelativeToIncome: { ' $fragmentRefs'?: { 'CorporateTaxRulingReportRuleCellFieldsFragment': CorporateTaxRulingReportRuleCellFieldsFragment } } | null, localDevelopmentExpenses: { formatted: string, raw: number, currency: Currency } | null, localDevelopmentRelativeToRnd: { ' $fragmentRefs'?: { 'CorporateTaxRulingReportRuleCellFieldsFragment': CorporateTaxRulingReportRuleCellFieldsFragment } } | null, foreignDevelopmentExpenses: { formatted: string, raw: number, currency: Currency } | null, foreignDevelopmentRelativeToRnd: { ' $fragmentRefs'?: { 'CorporateTaxRulingReportRuleCellFieldsFragment': CorporateTaxRulingReportRuleCellFieldsFragment } } | null, businessTripRndExpenses: { formatted: string, raw: number, currency: Currency } | null } } | { differences?: never })> };

export type CorporateTaxRulingReportRuleCellFieldsFragment = { id: string, rule: string, isCompliant: boolean, percentage: { formatted: string } } & { ' $fragmentName'?: 'CorporateTaxRulingReportRuleCellFieldsFragment' };

export type AllDynamicReportsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllDynamicReportsQuery = { allDynamicReports: Array<{ id: string, name: string, isLocked: boolean, updated: unknown }> };

export type DynamicReportQueryVariables = Exact<{
  filters?: BusinessTransactionsFilter | null | undefined;
}>;


export type DynamicReportQuery = { businessTransactionsSumFromLedgerRecords:
    | { __typename: 'BusinessTransactionsSumFromLedgerRecordsSuccessfulResult', businessTransactionsSum: Array<{ business:
          | { id: string, name: string, sortCode: { id: string, key: number, name: string | null } | null }
          | { id: string, name: string, sortCode: { id: string, key: number, name: string | null } | null }
          | { id: string, name: string, sortCode: { id: string, key: number, name: string | null } | null }
        , credit: { formatted: string, raw: number }, debit: { formatted: string, raw: number }, total: { formatted: string, raw: number } }> }
    | { __typename: 'CommonError' }
   };

export type DynamicReportTemplateQueryVariables = Exact<{
  name: string;
}>;


export type DynamicReportTemplateQuery = { dynamicReport: { id: string, name: string, isLocked: boolean, updated: unknown, template: Array<{ id: string, parent: string, text: string, droppable: boolean, data: { nodeType: string, isOpen: boolean, hebrewText: string | null, sortCode: number | null } }> } };

export type ProfitAndLossReportQueryVariables = Exact<{
  reportYear: number;
  referenceYears: Array<number> | number;
}>;


export type ProfitAndLossReportQuery = { profitAndLossReport: { id: string, report: { id: string, year: number, revenue: (
        { amount: { formatted: string } }
        & { ' $fragmentRefs'?: { 'ReportCommentaryTableFieldsFragment': ReportCommentaryTableFieldsFragment } }
      ), costOfSales: (
        { amount: { formatted: string } }
        & { ' $fragmentRefs'?: { 'ReportCommentaryTableFieldsFragment': ReportCommentaryTableFieldsFragment } }
      ), grossProfit: { formatted: string }, researchAndDevelopmentExpenses: (
        { amount: { formatted: string } }
        & { ' $fragmentRefs'?: { 'ReportCommentaryTableFieldsFragment': ReportCommentaryTableFieldsFragment } }
      ), marketingExpenses: (
        { amount: { formatted: string } }
        & { ' $fragmentRefs'?: { 'ReportCommentaryTableFieldsFragment': ReportCommentaryTableFieldsFragment } }
      ), managementAndGeneralExpenses: (
        { amount: { formatted: string } }
        & { ' $fragmentRefs'?: { 'ReportCommentaryTableFieldsFragment': ReportCommentaryTableFieldsFragment } }
      ), operatingProfit: { formatted: string }, financialExpenses: (
        { amount: { formatted: string } }
        & { ' $fragmentRefs'?: { 'ReportCommentaryTableFieldsFragment': ReportCommentaryTableFieldsFragment } }
      ), otherIncome: (
        { amount: { formatted: string } }
        & { ' $fragmentRefs'?: { 'ReportCommentaryTableFieldsFragment': ReportCommentaryTableFieldsFragment } }
      ), profitBeforeTax: { formatted: string }, tax: { formatted: string }, netProfit: { formatted: string } }, reference: Array<{ id: string, year: number, revenue: { amount: { formatted: string } }, costOfSales: { amount: { formatted: string } }, grossProfit: { formatted: string }, researchAndDevelopmentExpenses: { amount: { formatted: string } }, marketingExpenses: { amount: { formatted: string } }, managementAndGeneralExpenses: { amount: { formatted: string } }, operatingProfit: { formatted: string }, financialExpenses: { amount: { formatted: string } }, otherIncome: { amount: { formatted: string } }, profitBeforeTax: { formatted: string }, tax: { formatted: string }, netProfit: { formatted: string } }> } };

export type ReportCommentaryTableFieldsFragment = { records: Array<{ sortCode: { id: string, key: number, name: string | null }, amount: { formatted: string }, records: Array<{ ' $fragmentRefs'?: { 'ReportSubCommentaryTableFieldsFragment': ReportSubCommentaryTableFieldsFragment } }> }> } & { ' $fragmentName'?: 'ReportCommentaryTableFieldsFragment' };

export type ReportSubCommentaryTableFieldsFragment = { financialEntity:
    | { id: string, name: string }
    | { id: string, name: string }
    | { id: string, name: string }
  , amount: { formatted: string }, ledgerRecords: Array<{ ' $fragmentRefs'?: { 'LedgerRecordsTableFieldsFragment': LedgerRecordsTableFieldsFragment } }> } & { ' $fragmentName'?: 'ReportSubCommentaryTableFieldsFragment' };

export type TaxReportQueryVariables = Exact<{
  reportYear: number;
  referenceYears: Array<number> | number;
}>;


export type TaxReportQuery = { taxReport: { id: string, report: { id: string, year: number, taxRate: number, specialTaxRate: number, profitBeforeTax: (
        { amount: { formatted: string } }
        & { ' $fragmentRefs'?: { 'ReportCommentaryTableFieldsFragment': ReportCommentaryTableFieldsFragment } }
      ), researchAndDevelopmentExpensesByRecords: (
        { amount: { formatted: string } }
        & { ' $fragmentRefs'?: { 'ReportCommentaryTableFieldsFragment': ReportCommentaryTableFieldsFragment } }
      ), researchAndDevelopmentExpensesForTax: { formatted: string }, fines: (
        { amount: { formatted: string } }
        & { ' $fragmentRefs'?: { 'ReportCommentaryTableFieldsFragment': ReportCommentaryTableFieldsFragment } }
      ), untaxableGifts: (
        { amount: { formatted: string } }
        & { ' $fragmentRefs'?: { 'ReportCommentaryTableFieldsFragment': ReportCommentaryTableFieldsFragment } }
      ), businessTripsExcessExpensesAmount: { formatted: string }, salaryExcessExpensesAmount: { formatted: string }, reserves: (
        { amount: { formatted: string } }
        & { ' $fragmentRefs'?: { 'ReportCommentaryTableFieldsFragment': ReportCommentaryTableFieldsFragment } }
      ), nontaxableLinkage: (
        { amount: { formatted: string } }
        & { ' $fragmentRefs'?: { 'ReportCommentaryTableFieldsFragment': ReportCommentaryTableFieldsFragment } }
      ), taxableIncome: { formatted: string }, specialTaxableIncome: (
        { amount: { formatted: string } }
        & { ' $fragmentRefs'?: { 'ReportCommentaryTableFieldsFragment': ReportCommentaryTableFieldsFragment } }
      ), annualTaxExpense: { formatted: string } }, reference: Array<{ id: string, year: number, taxRate: number, specialTaxRate: number, profitBeforeTax: { amount: { formatted: string } }, researchAndDevelopmentExpensesByRecords: { amount: { formatted: string } }, researchAndDevelopmentExpensesForTax: { formatted: string }, fines: { amount: { formatted: string } }, untaxableGifts: { amount: { formatted: string } }, businessTripsExcessExpensesAmount: { formatted: string }, salaryExcessExpensesAmount: { formatted: string }, reserves: { amount: { formatted: string } }, nontaxableLinkage: { amount: { formatted: string } }, taxableIncome: { formatted: string }, specialTaxableIncome: (
        { amount: { formatted: string } }
        & { ' $fragmentRefs'?: { 'ReportCommentaryTableFieldsFragment': ReportCommentaryTableFieldsFragment } }
      ), annualTaxExpense: { formatted: string } }> } };

export type TrialBalanceReportQueryVariables = Exact<{
  filters?: BusinessTransactionsFilter | null | undefined;
}>;


export type TrialBalanceReportQuery = { businessTransactionsSumFromLedgerRecords:
    | (
      { __typename: 'BusinessTransactionsSumFromLedgerRecordsSuccessfulResult' }
      & { ' $fragmentRefs'?: { 'TrialBalanceTableFieldsFragment': TrialBalanceTableFieldsFragment } }
    )
    | { __typename: 'CommonError' }
   };

export type TrialBalanceTableFieldsFragment = { businessTransactionsSum: Array<{ business:
      | { id: string, name: string, sortCode: { id: string, key: number, name: string | null } | null }
      | { id: string, name: string, sortCode: { id: string, key: number, name: string | null } | null }
      | { id: string, name: string, sortCode: { id: string, key: number, name: string | null } | null }
    , credit: { formatted: string, raw: number }, debit: { formatted: string, raw: number }, total: { formatted: string, raw: number } }> } & { ' $fragmentName'?: 'TrialBalanceTableFieldsFragment' };

export type ValidatePcn874ReportsQueryVariables = Exact<{
  businessId?: string | null | undefined;
  fromMonthDate: unknown;
  toMonthDate: unknown;
}>;


export type ValidatePcn874ReportsQuery = { pcnByDate: Array<{ id: string, date: unknown, content: string, diffContent: string | null, business:
      | { id: string, name: string }
      | { id: string, name: string }
     }> };

export type VatReportBusinessTripsFieldsFragment = { businessTrips: Array<
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_BankDepositCharge_Fragment': ChargeForChargesTableFields_BankDepositCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_BusinessTripCharge_Fragment': ChargeForChargesTableFields_BusinessTripCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_CommonCharge_Fragment': ChargeForChargesTableFields_CommonCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_ConversionCharge_Fragment': ChargeForChargesTableFields_ConversionCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_CreditcardBankCharge_Fragment': ChargeForChargesTableFields_CreditcardBankCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_DividendCharge_Fragment': ChargeForChargesTableFields_DividendCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_FinancialCharge_Fragment': ChargeForChargesTableFields_FinancialCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_ForeignSecuritiesCharge_Fragment': ChargeForChargesTableFields_ForeignSecuritiesCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_InternalTransferCharge_Fragment': ChargeForChargesTableFields_InternalTransferCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_MonthlyVatCharge_Fragment': ChargeForChargesTableFields_MonthlyVatCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_SalaryCharge_Fragment': ChargeForChargesTableFields_SalaryCharge_Fragment } }
    )
  > } & { ' $fragmentName'?: 'VatReportBusinessTripsFieldsFragment' };

export type VatReportAccountantApprovalFieldsFragment = { chargeId: string, chargeAccountantStatus: AccountantStatus | null } & { ' $fragmentName'?: 'VatReportAccountantApprovalFieldsFragment' };

export type VatReportExpensesRowFieldsFragment = (
  { vatNumber: string | null, image: string | null, allocationNumber: string | null, documentSerial: string | null, documentDate: unknown, chargeDate: unknown, chargeId: string, recordType: Pcn874RecordType, business:
    | { id: string, name: string }
    | { id: string, name: string }
    | { id: string, name: string }
   | null, amount: { formatted: string, raw: number }, localAmount: { formatted: string, raw: number } | null, localVat: { formatted: string, raw: number } | null, foreignVatAfterDeduction: { formatted: string, raw: number } | null, localVatAfterDeduction: { formatted: string, raw: number } | null, roundedLocalVatAfterDeduction: { formatted: string, raw: number } | null, taxReducedLocalAmount: { formatted: string, raw: number } | null }
  & { ' $fragmentRefs'?: { 'VatReportAccountantApprovalFieldsFragment': VatReportAccountantApprovalFieldsFragment } }
) & { ' $fragmentName'?: 'VatReportExpensesRowFieldsFragment' };

export type VatReportExpensesFieldsFragment = { expenses: Array<(
    { recordType: Pcn874RecordType, roundedLocalVatAfterDeduction: { raw: number } | null, taxReducedLocalAmount: { raw: number } | null }
    & { ' $fragmentRefs'?: { 'VatReportExpensesRowFieldsFragment': VatReportExpensesRowFieldsFragment } }
  )> } & { ' $fragmentName'?: 'VatReportExpensesFieldsFragment' };

export type VatReportIncomeRowFieldsFragment = (
  { chargeId: string, vatNumber: string | null, image: string | null, allocationNumber: string | null, documentSerial: string | null, documentDate: unknown, chargeDate: unknown, recordType: Pcn874RecordType, business:
    | { id: string, name: string }
    | { id: string, name: string }
    | { id: string, name: string }
   | null, taxReducedForeignAmount: { formatted: string, raw: number } | null, taxReducedLocalAmount: { formatted: string, raw: number } | null }
  & { ' $fragmentRefs'?: { 'VatReportAccountantApprovalFieldsFragment': VatReportAccountantApprovalFieldsFragment } }
) & { ' $fragmentName'?: 'VatReportIncomeRowFieldsFragment' };

export type VatReportIncomeFieldsFragment = { income: Array<(
    { recordType: Pcn874RecordType, taxReducedLocalAmount: { raw: number } | null }
    & { ' $fragmentRefs'?: { 'VatReportIncomeRowFieldsFragment': VatReportIncomeRowFieldsFragment } }
  )> } & { ' $fragmentName'?: 'VatReportIncomeFieldsFragment' };

export type VatMonthlyReportQueryVariables = Exact<{
  filters?: VatReportFilter | null | undefined;
}>;


export type VatMonthlyReportQuery = { vatReport: { ' $fragmentRefs'?: { 'VatReportSummaryFieldsFragment': VatReportSummaryFieldsFragment;'VatReportIncomeFieldsFragment': VatReportIncomeFieldsFragment;'VatReportExpensesFieldsFragment': VatReportExpensesFieldsFragment;'VatReportMissingInfoFieldsFragment': VatReportMissingInfoFieldsFragment;'VatReportMiscTableFieldsFragment': VatReportMiscTableFieldsFragment;'VatReportBusinessTripsFieldsFragment': VatReportBusinessTripsFieldsFragment } } };

export type VatReportMiscTableFieldsFragment = { differentMonthDoc: Array<
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_BankDepositCharge_Fragment': ChargeForChargesTableFields_BankDepositCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_BusinessTripCharge_Fragment': ChargeForChargesTableFields_BusinessTripCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_CommonCharge_Fragment': ChargeForChargesTableFields_CommonCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_ConversionCharge_Fragment': ChargeForChargesTableFields_ConversionCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_CreditcardBankCharge_Fragment': ChargeForChargesTableFields_CreditcardBankCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_DividendCharge_Fragment': ChargeForChargesTableFields_DividendCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_FinancialCharge_Fragment': ChargeForChargesTableFields_FinancialCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_ForeignSecuritiesCharge_Fragment': ChargeForChargesTableFields_ForeignSecuritiesCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_InternalTransferCharge_Fragment': ChargeForChargesTableFields_InternalTransferCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_MonthlyVatCharge_Fragment': ChargeForChargesTableFields_MonthlyVatCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_SalaryCharge_Fragment': ChargeForChargesTableFields_SalaryCharge_Fragment } }
    )
  > } & { ' $fragmentName'?: 'VatReportMiscTableFieldsFragment' };

export type VatReportMissingInfoFieldsFragment = { missingInfo: Array<
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_BankDepositCharge_Fragment': ChargeForChargesTableFields_BankDepositCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_BusinessTripCharge_Fragment': ChargeForChargesTableFields_BusinessTripCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_CommonCharge_Fragment': ChargeForChargesTableFields_CommonCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_ConversionCharge_Fragment': ChargeForChargesTableFields_ConversionCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_CreditcardBankCharge_Fragment': ChargeForChargesTableFields_CreditcardBankCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_DividendCharge_Fragment': ChargeForChargesTableFields_DividendCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_FinancialCharge_Fragment': ChargeForChargesTableFields_FinancialCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_ForeignSecuritiesCharge_Fragment': ChargeForChargesTableFields_ForeignSecuritiesCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_InternalTransferCharge_Fragment': ChargeForChargesTableFields_InternalTransferCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_MonthlyVatCharge_Fragment': ChargeForChargesTableFields_MonthlyVatCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_SalaryCharge_Fragment': ChargeForChargesTableFields_SalaryCharge_Fragment } }
    )
  > } & { ' $fragmentName'?: 'VatReportMissingInfoFieldsFragment' };

export type GeneratePcnQueryVariables = Exact<{
  monthDate: unknown;
  financialEntityId: string;
}>;


export type GeneratePcnQuery = { pcnFile: { reportContent: string, fileName: string } };

export type VatReportSummaryFieldsFragment = { expenses: Array<{ recordType: Pcn874RecordType, isProperty: boolean, roundedLocalVatAfterDeduction: { raw: number } | null, taxReducedLocalAmount: { raw: number } | null }>, income: Array<{ recordType: Pcn874RecordType, roundedLocalVatAfterDeduction: { raw: number } | null, taxReducedLocalAmount: { raw: number } | null }> } & { ' $fragmentName'?: 'VatReportSummaryFieldsFragment' };

export type LedgerCsvFieldsFragment = { id: string, year: number, financialEntitiesInfo: Array<{ entity:
      | { id: string, name: string, sortCode: { id: string, key: number } | null }
      | { id: string, name: string, sortCode: { id: string, key: number } | null }
      | { id: string, name: string, sortCode: { id: string, key: number } | null }
    , openingBalance: { raw: number }, totalCredit: { raw: number }, totalDebit: { raw: number }, closingBalance: { raw: number }, records: Array<{ id: string, invoiceDate: unknown, valueDate: unknown, description: string | null, reference: string | null, balance: number, amount: { raw: number, formatted: string }, counterParty:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null }> }> } & { ' $fragmentName'?: 'LedgerCsvFieldsFragment' };

export type YearlyLedgerQueryVariables = Exact<{
  year: number;
}>;


export type YearlyLedgerQuery = { yearlyLedgerReport: (
    { id: string, year: number, financialEntitiesInfo: Array<{ entity:
        | { id: string, name: string, sortCode: { id: string, key: number } | null }
        | { id: string, name: string, sortCode: { id: string, key: number } | null }
        | { id: string, name: string, sortCode: { id: string, key: number } | null }
      , openingBalance: { raw: number }, totalCredit: { raw: number }, totalDebit: { raw: number }, closingBalance: { raw: number }, records: Array<{ id: string, invoiceDate: unknown, valueDate: unknown, description: string | null, reference: string | null, balance: number, amount: { raw: number, formatted: string }, counterParty:
          | { id: string, name: string }
          | { id: string, name: string }
          | { id: string, name: string }
         | null }> }> }
    & { ' $fragmentRefs'?: { 'LedgerCsvFieldsFragment': LedgerCsvFieldsFragment } }
  ) };

export type SalaryScreenRecordsQueryVariables = Exact<{
  fromDate: unknown;
  toDate: unknown;
  employeeIDs?: Array<string> | string | null | undefined;
}>;


export type SalaryScreenRecordsQuery = { salaryRecordsByDates: Array<(
    { month: string, employee: { id: string } | null }
    & { ' $fragmentRefs'?: { 'SalariesTableFieldsFragment': SalariesTableFieldsFragment } }
  )> };

export type SalariesRecordEmployeeFieldsFragment = { month: string, employee: { id: string, name: string } | null } & { ' $fragmentName'?: 'SalariesRecordEmployeeFieldsFragment' };

export type SalariesRecordFundsFieldsFragment = { month: string, pensionEmployeePercentage: number | null, pensionEmployerPercentage: number | null, compensationsPercentage: number | null, trainingFundEmployeePercentage: number | null, trainingFundEmployerPercentage: number | null, employee: { id: string } | null, pensionFund: { id: string, name: string } | null, pensionEmployeeAmount: { formatted: string, raw: number } | null, pensionEmployerAmount: { formatted: string, raw: number } | null, compensationsAmount: { formatted: string, raw: number } | null, trainingFund: { id: string, name: string } | null, trainingFundEmployeeAmount: { formatted: string, raw: number } | null, trainingFundEmployerAmount: { formatted: string, raw: number } | null } & { ' $fragmentName'?: 'SalariesRecordFundsFieldsFragment' };

export type SalariesRecordInsurancesAndTaxesFieldsFragment = { month: string, employee: { id: string } | null, healthInsuranceAmount: { formatted: string, raw: number } | null, socialSecurityEmployeeAmount: { formatted: string, raw: number } | null, socialSecurityEmployerAmount: { formatted: string, raw: number } | null, incomeTaxAmount: { formatted: string, raw: number } | null, notionalExpense: { formatted: string, raw: number } | null } & { ' $fragmentName'?: 'SalariesRecordInsurancesAndTaxesFieldsFragment' };

export type SalariesRecordMainSalaryFieldsFragment = { month: string, employee: { id: string } | null, baseAmount: { formatted: string } | null, directAmount: { formatted: string }, globalAdditionalHoursAmount: { formatted: string } | null, bonus: { formatted: string, raw: number } | null, gift: { formatted: string, raw: number } | null, recovery: { formatted: string, raw: number } | null, vacationTakeout: { formatted: string, raw: number } | null } & { ' $fragmentName'?: 'SalariesRecordMainSalaryFieldsFragment' };

export type SalariesRecordWorkFrameFieldsFragment = { month: string, workDays: number | null, employee: { id: string } | null, vacationDays: { added: number | null, taken: number | null, balance: number | null } | null, sicknessDays: { balance: number | null } | null } & { ' $fragmentName'?: 'SalariesRecordWorkFrameFieldsFragment' };

export type SalariesMonthFieldsFragment = (
  { month: string, employee: { id: string } | null }
  & { ' $fragmentRefs'?: { 'SalariesRecordFieldsFragment': SalariesRecordFieldsFragment } }
) & { ' $fragmentName'?: 'SalariesMonthFieldsFragment' };

export type SalariesTableFieldsFragment = (
  { month: string, employee: { id: string } | null }
  & { ' $fragmentRefs'?: { 'SalariesMonthFieldsFragment': SalariesMonthFieldsFragment } }
) & { ' $fragmentName'?: 'SalariesTableFieldsFragment' };

export type SalariesRecordFieldsFragment = (
  { month: string, employee: { id: string } | null }
  & { ' $fragmentRefs'?: { 'SalariesRecordEmployeeFieldsFragment': SalariesRecordEmployeeFieldsFragment;'SalariesRecordMainSalaryFieldsFragment': SalariesRecordMainSalaryFieldsFragment;'SalariesRecordFundsFieldsFragment': SalariesRecordFundsFieldsFragment;'SalariesRecordInsurancesAndTaxesFieldsFragment': SalariesRecordInsurancesAndTaxesFieldsFragment;'SalariesRecordWorkFrameFieldsFragment': SalariesRecordWorkFrameFieldsFragment } }
) & { ' $fragmentName'?: 'SalariesRecordFieldsFragment' };

export type AllDepositsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllDepositsQuery = { allDeposits: Array<{ id: string, name: string, currency: Currency | null, openDate: unknown, closeDate: unknown, isOpen: boolean, metadata: { id: string, currentBalance: { raw: number, formatted: string }, totalDeposit: { raw: number, formatted: string }, totalInterest: { raw: number, formatted: string } } }> };

export type BusinessScreenQueryVariables = Exact<{
  businessId: string;
}>;


export type BusinessScreenQuery = { business:
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'BusinessPage_LtdFinancialEntity_Fragment': BusinessPage_LtdFinancialEntity_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'BusinessPage_PersonalFinancialEntity_Fragment': BusinessPage_PersonalFinancialEntity_Fragment } }
    )
   };

export type ContractsScreenQueryVariables = Exact<{
  adminId: string;
}>;


export type ContractsScreenQuery = { contractsByAdmin: Array<(
    { id: string }
    & { ' $fragmentRefs'?: { 'ContractForContractsTableFieldsFragment': ContractForContractsTableFieldsFragment } }
  )> };

export type AllChargesQueryVariables = Exact<{
  page?: number | null | undefined;
  limit?: number | null | undefined;
  filters?: ChargeFilter | null | undefined;
}>;


export type AllChargesQuery = { allCharges: { nodes: Array<
      | (
        { id: string }
        & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_BankDepositCharge_Fragment': ChargeForChargesTableFields_BankDepositCharge_Fragment } }
      )
      | (
        { id: string }
        & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_BusinessTripCharge_Fragment': ChargeForChargesTableFields_BusinessTripCharge_Fragment } }
      )
      | (
        { id: string }
        & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_CommonCharge_Fragment': ChargeForChargesTableFields_CommonCharge_Fragment } }
      )
      | (
        { id: string }
        & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_ConversionCharge_Fragment': ChargeForChargesTableFields_ConversionCharge_Fragment } }
      )
      | (
        { id: string }
        & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_CreditcardBankCharge_Fragment': ChargeForChargesTableFields_CreditcardBankCharge_Fragment } }
      )
      | (
        { id: string }
        & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_DividendCharge_Fragment': ChargeForChargesTableFields_DividendCharge_Fragment } }
      )
      | (
        { id: string }
        & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_FinancialCharge_Fragment': ChargeForChargesTableFields_FinancialCharge_Fragment } }
      )
      | (
        { id: string }
        & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_ForeignSecuritiesCharge_Fragment': ChargeForChargesTableFields_ForeignSecuritiesCharge_Fragment } }
      )
      | (
        { id: string }
        & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_InternalTransferCharge_Fragment': ChargeForChargesTableFields_InternalTransferCharge_Fragment } }
      )
      | (
        { id: string }
        & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_MonthlyVatCharge_Fragment': ChargeForChargesTableFields_MonthlyVatCharge_Fragment } }
      )
      | (
        { id: string }
        & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_SalaryCharge_Fragment': ChargeForChargesTableFields_SalaryCharge_Fragment } }
      )
    >, pageInfo: { totalPages: number } } };

export type ChargeScreenQueryVariables = Exact<{
  chargeId: string;
}>;


export type ChargeScreenQuery = { charge:
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_BankDepositCharge_Fragment': ChargeForChargesTableFields_BankDepositCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_BusinessTripCharge_Fragment': ChargeForChargesTableFields_BusinessTripCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_CommonCharge_Fragment': ChargeForChargesTableFields_CommonCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_ConversionCharge_Fragment': ChargeForChargesTableFields_ConversionCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_CreditcardBankCharge_Fragment': ChargeForChargesTableFields_CreditcardBankCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_DividendCharge_Fragment': ChargeForChargesTableFields_DividendCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_FinancialCharge_Fragment': ChargeForChargesTableFields_FinancialCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_ForeignSecuritiesCharge_Fragment': ChargeForChargesTableFields_ForeignSecuritiesCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_InternalTransferCharge_Fragment': ChargeForChargesTableFields_InternalTransferCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_MonthlyVatCharge_Fragment': ChargeForChargesTableFields_MonthlyVatCharge_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_SalaryCharge_Fragment': ChargeForChargesTableFields_SalaryCharge_Fragment } }
    )
   };

export type MissingInfoChargesQueryVariables = Exact<{
  page?: number | null | undefined;
  limit?: number | null | undefined;
}>;


export type MissingInfoChargesQuery = { chargesWithMissingRequiredInfo: { nodes: Array<
      | (
        { id: string }
        & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_BankDepositCharge_Fragment': ChargeForChargesTableFields_BankDepositCharge_Fragment } }
      )
      | (
        { id: string }
        & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_BusinessTripCharge_Fragment': ChargeForChargesTableFields_BusinessTripCharge_Fragment } }
      )
      | (
        { id: string }
        & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_CommonCharge_Fragment': ChargeForChargesTableFields_CommonCharge_Fragment } }
      )
      | (
        { id: string }
        & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_ConversionCharge_Fragment': ChargeForChargesTableFields_ConversionCharge_Fragment } }
      )
      | (
        { id: string }
        & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_CreditcardBankCharge_Fragment': ChargeForChargesTableFields_CreditcardBankCharge_Fragment } }
      )
      | (
        { id: string }
        & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_DividendCharge_Fragment': ChargeForChargesTableFields_DividendCharge_Fragment } }
      )
      | (
        { id: string }
        & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_FinancialCharge_Fragment': ChargeForChargesTableFields_FinancialCharge_Fragment } }
      )
      | (
        { id: string }
        & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_ForeignSecuritiesCharge_Fragment': ChargeForChargesTableFields_ForeignSecuritiesCharge_Fragment } }
      )
      | (
        { id: string }
        & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_InternalTransferCharge_Fragment': ChargeForChargesTableFields_InternalTransferCharge_Fragment } }
      )
      | (
        { id: string }
        & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_MonthlyVatCharge_Fragment': ChargeForChargesTableFields_MonthlyVatCharge_Fragment } }
      )
      | (
        { id: string }
        & { ' $fragmentRefs'?: { 'ChargeForChargesTableFields_SalaryCharge_Fragment': ChargeForChargesTableFields_SalaryCharge_Fragment } }
      )
    >, pageInfo: { totalPages: number } } };

export type DocumentsScreenQueryVariables = Exact<{
  filters: DocumentsFilters;
}>;


export type DocumentsScreenQuery = { documentsByFilters: Array<
    | { __typename: 'CreditInvoice', serialNumber: string | null, date: unknown, id: string, image: unknown, file: unknown, creditor:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null, debtor:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null, vat: { raw: number, formatted: string, currency: Currency } | null, amount: { raw: number, formatted: string, currency: Currency } | null, charge:
        | { __typename: 'BankDepositCharge', id: string, userDescription: string | null, vat: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'BusinessTripCharge', id: string, userDescription: string | null, vat: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'CommonCharge', id: string, userDescription: string | null, vat: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'ConversionCharge', id: string, userDescription: string | null, vat: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'CreditcardBankCharge', id: string, userDescription: string | null, vat: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'DividendCharge', id: string, userDescription: string | null, vat: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'FinancialCharge', id: string, userDescription: string | null, vat: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'ForeignSecuritiesCharge', id: string, userDescription: string | null, vat: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'InternalTransferCharge', id: string, userDescription: string | null, vat: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'MonthlyVatCharge', id: string, userDescription: string | null, vat: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'SalaryCharge', id: string, userDescription: string | null, vat: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
       | null }
    | { __typename: 'Invoice', serialNumber: string | null, date: unknown, id: string, image: unknown, file: unknown, creditor:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null, debtor:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null, vat: { raw: number, formatted: string, currency: Currency } | null, amount: { raw: number, formatted: string, currency: Currency } | null, charge:
        | { __typename: 'BankDepositCharge', id: string, userDescription: string | null, vat: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'BusinessTripCharge', id: string, userDescription: string | null, vat: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'CommonCharge', id: string, userDescription: string | null, vat: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'ConversionCharge', id: string, userDescription: string | null, vat: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'CreditcardBankCharge', id: string, userDescription: string | null, vat: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'DividendCharge', id: string, userDescription: string | null, vat: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'FinancialCharge', id: string, userDescription: string | null, vat: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'ForeignSecuritiesCharge', id: string, userDescription: string | null, vat: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'InternalTransferCharge', id: string, userDescription: string | null, vat: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'MonthlyVatCharge', id: string, userDescription: string | null, vat: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'SalaryCharge', id: string, userDescription: string | null, vat: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
       | null }
    | { __typename: 'InvoiceReceipt', serialNumber: string | null, date: unknown, id: string, image: unknown, file: unknown, creditor:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null, debtor:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null, vat: { raw: number, formatted: string, currency: Currency } | null, amount: { raw: number, formatted: string, currency: Currency } | null, charge:
        | { __typename: 'BankDepositCharge', id: string, userDescription: string | null, vat: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'BusinessTripCharge', id: string, userDescription: string | null, vat: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'CommonCharge', id: string, userDescription: string | null, vat: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'ConversionCharge', id: string, userDescription: string | null, vat: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'CreditcardBankCharge', id: string, userDescription: string | null, vat: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'DividendCharge', id: string, userDescription: string | null, vat: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'FinancialCharge', id: string, userDescription: string | null, vat: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'ForeignSecuritiesCharge', id: string, userDescription: string | null, vat: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'InternalTransferCharge', id: string, userDescription: string | null, vat: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'MonthlyVatCharge', id: string, userDescription: string | null, vat: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'SalaryCharge', id: string, userDescription: string | null, vat: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
       | null }
    | { __typename: 'OtherDocument', id: string, image: unknown, file: unknown, charge:
        | { __typename: 'BankDepositCharge', id: string, userDescription: string | null, vat: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'BusinessTripCharge', id: string, userDescription: string | null, vat: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'CommonCharge', id: string, userDescription: string | null, vat: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'ConversionCharge', id: string, userDescription: string | null, vat: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'CreditcardBankCharge', id: string, userDescription: string | null, vat: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'DividendCharge', id: string, userDescription: string | null, vat: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'FinancialCharge', id: string, userDescription: string | null, vat: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'ForeignSecuritiesCharge', id: string, userDescription: string | null, vat: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'InternalTransferCharge', id: string, userDescription: string | null, vat: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'MonthlyVatCharge', id: string, userDescription: string | null, vat: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'SalaryCharge', id: string, userDescription: string | null, vat: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
       | null }
    | { __typename: 'Proforma', serialNumber: string | null, date: unknown, id: string, image: unknown, file: unknown, creditor:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null, debtor:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null, vat: { raw: number, formatted: string, currency: Currency } | null, amount: { raw: number, formatted: string, currency: Currency } | null, charge:
        | { __typename: 'BankDepositCharge', id: string, userDescription: string | null, vat: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'BusinessTripCharge', id: string, userDescription: string | null, vat: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'CommonCharge', id: string, userDescription: string | null, vat: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'ConversionCharge', id: string, userDescription: string | null, vat: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'CreditcardBankCharge', id: string, userDescription: string | null, vat: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'DividendCharge', id: string, userDescription: string | null, vat: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'FinancialCharge', id: string, userDescription: string | null, vat: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'ForeignSecuritiesCharge', id: string, userDescription: string | null, vat: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'InternalTransferCharge', id: string, userDescription: string | null, vat: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'MonthlyVatCharge', id: string, userDescription: string | null, vat: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'SalaryCharge', id: string, userDescription: string | null, vat: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
       | null }
    | { __typename: 'Receipt', serialNumber: string | null, date: unknown, id: string, image: unknown, file: unknown, creditor:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null, debtor:
        | { id: string, name: string }
        | { id: string, name: string }
        | { id: string, name: string }
       | null, vat: { raw: number, formatted: string, currency: Currency } | null, amount: { raw: number, formatted: string, currency: Currency } | null, charge:
        | { __typename: 'BankDepositCharge', id: string, userDescription: string | null, vat: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'BusinessTripCharge', id: string, userDescription: string | null, vat: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'CommonCharge', id: string, userDescription: string | null, vat: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'ConversionCharge', id: string, userDescription: string | null, vat: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'CreditcardBankCharge', id: string, userDescription: string | null, vat: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'DividendCharge', id: string, userDescription: string | null, vat: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'FinancialCharge', id: string, userDescription: string | null, vat: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'ForeignSecuritiesCharge', id: string, userDescription: string | null, vat: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'InternalTransferCharge', id: string, userDescription: string | null, vat: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'MonthlyVatCharge', id: string, userDescription: string | null, vat: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'SalaryCharge', id: string, userDescription: string | null, vat: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
       | null }
    | { __typename: 'Unprocessed', id: string, image: unknown, file: unknown, charge:
        | { __typename: 'BankDepositCharge', id: string, userDescription: string | null, vat: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'BusinessTripCharge', id: string, userDescription: string | null, vat: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'CommonCharge', id: string, userDescription: string | null, vat: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'ConversionCharge', id: string, userDescription: string | null, vat: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'CreditcardBankCharge', id: string, userDescription: string | null, vat: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'DividendCharge', id: string, userDescription: string | null, vat: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'FinancialCharge', id: string, userDescription: string | null, vat: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'ForeignSecuritiesCharge', id: string, userDescription: string | null, vat: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'InternalTransferCharge', id: string, userDescription: string | null, vat: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'MonthlyVatCharge', id: string, userDescription: string | null, vat: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
        | { __typename: 'SalaryCharge', id: string, userDescription: string | null, vat: { __typename: 'FinancialAmount', formatted: string } | null, transactions: Array<
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
            | { id: string, eventDate: unknown, sourceDescription: string, effectiveDate: unknown, amount: { __typename: 'FinancialAmount', formatted: string } }
          > }
       | null }
  > };

export type MonthlyDocumentDraftByClientQueryVariables = Exact<{
  clientId: string;
  issueMonth: unknown;
}>;


export type MonthlyDocumentDraftByClientQuery = { clientMonthlyChargeDraft: { ' $fragmentRefs'?: { 'NewDocumentDraftFragment': NewDocumentDraftFragment } } };

export type MonthlyDocumentsDraftsQueryVariables = Exact<{
  issueMonth: unknown;
}>;


export type MonthlyDocumentsDraftsQuery = { periodicalDocumentDrafts: Array<{ ' $fragmentRefs'?: { 'NewDocumentDraftFragment': NewDocumentDraftFragment } }> };

export type AllOpenContractsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllOpenContractsQuery = { allOpenContracts: Array<{ id: string, billingCycle: BillingCycle, client: { id: string, originalBusiness: { id: string, name: string } } }> };

export type AnnualAuditStepsStatusQueryVariables = Exact<{
  ownerId: string;
  year: number;
}>;


export type AnnualAuditStepsStatusQuery = { annualAuditStepStatuses: Array<{ id: string, stepId: string, status: AnnualAuditStepStatus, notes: string | null }> };

export type AccountantApprovalStatusQueryVariables = Exact<{
  fromDate: unknown;
  toDate: unknown;
}>;


export type AccountantApprovalStatusQuery = { accountantApprovalStatus: { totalCharges: number, approvedCount: number, pendingCount: number, unapprovedCount: number } };

export type LedgerValidationStatusQueryVariables = Exact<{
  limit?: number | null | undefined;
  filters?: ChargeFilter | null | undefined;
}>;


export type LedgerValidationStatusQuery = { chargesWithLedgerChanges: Array<{ charge:
      | { id: string }
      | { id: string }
      | { id: string }
      | { id: string }
      | { id: string }
      | { id: string }
      | { id: string }
      | { id: string }
      | { id: string }
      | { id: string }
      | { id: string }
     | null }> };

export type AnnualAuditOpeningBalanceStatusQueryVariables = Exact<{
  ownerId: string;
  year: number;
}>;


export type AnnualAuditOpeningBalanceStatusQuery = { annualAuditOpeningBalanceStatus: { id: string, userType: AnnualAuditOpeningBalanceUserType, balanceChargeId: string | null, derivedStatus: AnnualAuditStepStatus, errorMessage: string | null } };

export type AnnualFinancialChargesQueryVariables = Exact<{
  ownerId?: string | null | undefined;
  year: unknown;
}>;


export type AnnualFinancialChargesQuery = { annualFinancialCharges: { id: string, revaluationCharge: { id: string } | null, taxExpensesCharge: { id: string } | null, depreciationCharge: { id: string } | null, recoveryReserveCharge: { id: string } | null, vacationReserveCharge: { id: string } | null, bankDepositsRevaluationCharge: { id: string } | null } };

export type Step05PrevYearTemplateQueryVariables = Exact<{
  ownerId: string;
  year: number;
}>;


export type Step05PrevYearTemplateQuery = { annualAuditStepStatuses: Array<{ id: string, stepId: string, status: AnnualAuditStepStatus, evidence: string | null }> };

export type AdminLedgerLockDateQueryVariables = Exact<{
  ownerId?: string | null | undefined;
}>;


export type AdminLedgerLockDateQuery = { adminContext: { id: string, ledgerLock: unknown } };

export type Step09SaveTemplateStatusQueryVariables = Exact<{
  ownerId: string;
  year: number;
}>;


export type Step09SaveTemplateStatusQuery = { annualAuditStepStatuses: Array<{ id: string, stepId: string, status: AnnualAuditStepStatus, evidence: string | null }> };

export type AnnualRevenueReportClientFragment = { id: string, name: string, revenueLocal: { raw: number, formatted: string, currency: Currency }, revenueDefaultForeign: { raw: number, formatted: string, currency: Currency }, records: Array<(
    { id: string, date: unknown }
    & { ' $fragmentRefs'?: { 'AnnualRevenueReportRecordFragment': AnnualRevenueReportRecordFragment } }
  )> } & { ' $fragmentName'?: 'AnnualRevenueReportClientFragment' };

export type AnnualRevenueReportCountryFragment = { id: string, code: string, name: string, revenueLocal: { raw: number, formatted: string, currency: Currency }, revenueDefaultForeign: { raw: number, formatted: string, currency: Currency }, clients: Array<(
    { id: string, revenueDefaultForeign: { raw: number } }
    & { ' $fragmentRefs'?: { 'AnnualRevenueReportClientFragment': AnnualRevenueReportClientFragment } }
  )> } & { ' $fragmentName'?: 'AnnualRevenueReportCountryFragment' };

export type AnnualRevenueReportScreenQueryVariables = Exact<{
  filters: AnnualRevenueReportFilter;
}>;


export type AnnualRevenueReportScreenQuery = { annualRevenueReport: { id: string, year: number, countries: Array<(
      { id: string, name: string, revenueLocal: { raw: number, currency: Currency }, revenueDefaultForeign: { raw: number, currency: Currency }, clients: Array<{ id: string, name: string, revenueLocal: { raw: number }, revenueDefaultForeign: { raw: number }, records: Array<{ id: string, date: unknown, description: string | null, reference: string | null, chargeId: string, revenueLocal: { raw: number }, revenueDefaultForeign: { raw: number } }> }> }
      & { ' $fragmentRefs'?: { 'AnnualRevenueReportCountryFragment': AnnualRevenueReportCountryFragment } }
    )> } };

export type AnnualRevenueReportRecordFragment = { id: string, chargeId: string, date: unknown, description: string | null, reference: string | null, revenueLocal: { raw: number, formatted: string, currency: Currency }, revenueDefaultForeign: { raw: number, formatted: string, currency: Currency }, revenueOriginal: { raw: number, formatted: string, currency: Currency } } & { ' $fragmentName'?: 'AnnualRevenueReportRecordFragment' };

export type BalanceReportExtendedTransactionsQueryVariables = Exact<{
  transactionIDs: Array<string> | string;
}>;


export type BalanceReportExtendedTransactionsQuery = { transactionsByIDs: Array<
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_CommonTransaction_Fragment': TransactionForTransactionsTableFields_CommonTransaction_Fragment;'TransactionToDownloadForTransactionsTableFields_CommonTransaction_Fragment': TransactionToDownloadForTransactionsTableFields_CommonTransaction_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'TransactionForTransactionsTableFields_ConversionTransaction_Fragment': TransactionForTransactionsTableFields_ConversionTransaction_Fragment;'TransactionToDownloadForTransactionsTableFields_ConversionTransaction_Fragment': TransactionToDownloadForTransactionsTableFields_ConversionTransaction_Fragment } }
    )
  > };

export type BalanceReportScreenQueryVariables = Exact<{
  fromDate: unknown;
  toDate: unknown;
  ownerId?: string | null | undefined;
}>;


export type BalanceReportScreenQuery = { transactionsForBalanceReport: Array<{ id: string, date: unknown, month: number, year: number, isFee: boolean, description: string | null, amountUsd: { formatted: string, raw: number }, amount: { currency: Currency, raw: number }, counterparty:
      | { id: string }
      | { id: string }
      | { id: string }
     | null, account:
      | { id: string, name: string }
      | { id: string, name: string }
      | { id: string, name: string }
      | { id: string, name: string }
      | { id: string, name: string }
    , charge:
      | { id: string, tags: Array<{ id: string, name: string }> }
      | { id: string, tags: Array<{ id: string, name: string }> }
      | { id: string, tags: Array<{ id: string, name: string }> }
      | { id: string, tags: Array<{ id: string, name: string }> }
      | { id: string, tags: Array<{ id: string, name: string }> }
      | { id: string, tags: Array<{ id: string, name: string }> }
      | { id: string, tags: Array<{ id: string, name: string }> }
      | { id: string, tags: Array<{ id: string, name: string }> }
      | { id: string, tags: Array<{ id: string, name: string }> }
      | { id: string, tags: Array<{ id: string, name: string }> }
      | { id: string, tags: Array<{ id: string, name: string }> }
     }> };

type DepreciationReportRecordCore_DepreciationReportRecord_Fragment = { id: string, originalCost: number | null, reportYearDelta: number | null, totalDepreciableCosts: number, reportYearClaimedDepreciation: number, pastYearsAccumulatedDepreciation: number, totalDepreciation: number, netValue: number } & { ' $fragmentName'?: 'DepreciationReportRecordCore_DepreciationReportRecord_Fragment' };

type DepreciationReportRecordCore_DepreciationReportSummaryRecord_Fragment = { id: string, originalCost: number | null, reportYearDelta: number | null, totalDepreciableCosts: number, reportYearClaimedDepreciation: number, pastYearsAccumulatedDepreciation: number, totalDepreciation: number, netValue: number } & { ' $fragmentName'?: 'DepreciationReportRecordCore_DepreciationReportSummaryRecord_Fragment' };

export type DepreciationReportRecordCoreFragment =
  | DepreciationReportRecordCore_DepreciationReportRecord_Fragment
  | DepreciationReportRecordCore_DepreciationReportSummaryRecord_Fragment
;

export type DepreciationReportScreenQueryVariables = Exact<{
  filters: DepreciationReportFilter;
}>;


export type DepreciationReportScreenQuery = { depreciationReport: { id: string, year: number, categories: Array<{ id: string, category: { id: string, name: string, percentage: number }, records: Array<(
        { id: string, chargeId: string, description: string | null, purchaseDate: unknown, activationDate: unknown, statutoryDepreciationRate: number, claimedDepreciationRate: number | null }
        & { ' $fragmentRefs'?: { 'DepreciationReportRecordCore_DepreciationReportRecord_Fragment': DepreciationReportRecordCore_DepreciationReportRecord_Fragment } }
      )>, summary: (
        { id: string }
        & { ' $fragmentRefs'?: { 'DepreciationReportRecordCore_DepreciationReportSummaryRecord_Fragment': DepreciationReportRecordCore_DepreciationReportSummaryRecord_Fragment } }
      ) }>, summary: (
      { id: string }
      & { ' $fragmentRefs'?: { 'DepreciationReportRecordCore_DepreciationReportSummaryRecord_Fragment': DepreciationReportRecordCore_DepreciationReportSummaryRecord_Fragment } }
    ) } };

export type Shaam6111DataContentBalanceSheetFragment = { id: string, balanceSheet: Array<{ code: number, amount: number, label: string }> | null } & { ' $fragmentName'?: 'Shaam6111DataContentBalanceSheetFragment' };

export type Shaam6111DataContentHeaderFragment = { id: string, header: { taxYear: string, businessDescription: string | null, taxFileNumber: string, idNumber: string, vatFileNumber: string | null, withholdingTaxFileNumber: string | null, businessType: BusinessType, reportingMethod: ReportingMethod, currencyType: CurrencyType, amountsInThousands: boolean, accountingMethod: AccountingMethod, accountingSystem: AccountingSystem, softwareRegistrationNumber: string | null, isPartnership: boolean | null, partnershipCount: number | null, partnershipProfitShare: number | null, ifrsImplementationYear: string | null, ifrsReportingOption: IfrsReportingOption | null, includesProfitLoss: boolean, includesTaxAdjustment: boolean, includesBalanceSheet: boolean, industryCode: string, auditOpinionType: AuditOpinionType | null } } & { ' $fragmentName'?: 'Shaam6111DataContentHeaderFragment' };

type Shaam6111DataContentHeaderBusiness_LtdFinancialEntity_Fragment = { id: string, name: string } & { ' $fragmentName'?: 'Shaam6111DataContentHeaderBusiness_LtdFinancialEntity_Fragment' };

type Shaam6111DataContentHeaderBusiness_PersonalFinancialEntity_Fragment = { id: string, name: string } & { ' $fragmentName'?: 'Shaam6111DataContentHeaderBusiness_PersonalFinancialEntity_Fragment' };

export type Shaam6111DataContentHeaderBusinessFragment =
  | Shaam6111DataContentHeaderBusiness_LtdFinancialEntity_Fragment
  | Shaam6111DataContentHeaderBusiness_PersonalFinancialEntity_Fragment
;

export type Shaam6111ReportScreenQueryVariables = Exact<{
  year: number;
  businessId?: string | null | undefined;
}>;


export type Shaam6111ReportScreenQuery = { shaam6111: { id: string, year: number, data: (
      { id: string }
      & { ' $fragmentRefs'?: { 'Shaam6111DataContentFragment': Shaam6111DataContentFragment } }
    ), business:
      | (
        { id: string }
        & { ' $fragmentRefs'?: { 'Shaam6111DataContentHeaderBusiness_LtdFinancialEntity_Fragment': Shaam6111DataContentHeaderBusiness_LtdFinancialEntity_Fragment } }
      )
      | (
        { id: string }
        & { ' $fragmentRefs'?: { 'Shaam6111DataContentHeaderBusiness_PersonalFinancialEntity_Fragment': Shaam6111DataContentHeaderBusiness_PersonalFinancialEntity_Fragment } }
      )
     } };

export type Shaam6111DataContentProfitLossFragment = { id: string, profitAndLoss: Array<{ code: number, amount: number, label: string }> } & { ' $fragmentName'?: 'Shaam6111DataContentProfitLossFragment' };

export type Shaam6111DataContentFragment = (
  { id: string }
  & { ' $fragmentRefs'?: { 'Shaam6111DataContentHeaderFragment': Shaam6111DataContentHeaderFragment;'Shaam6111DataContentProfitLossFragment': Shaam6111DataContentProfitLossFragment;'Shaam6111DataContentTaxAdjustmentFragment': Shaam6111DataContentTaxAdjustmentFragment;'Shaam6111DataContentBalanceSheetFragment': Shaam6111DataContentBalanceSheetFragment } }
) & { ' $fragmentName'?: 'Shaam6111DataContentFragment' };

export type Shaam6111DataContentTaxAdjustmentFragment = { id: string, taxAdjustment: Array<{ code: number, amount: number, label: string }> } & { ' $fragmentName'?: 'Shaam6111DataContentTaxAdjustmentFragment' };

export type AllSortCodesForScreenQueryVariables = Exact<{ [key: string]: never; }>;


export type AllSortCodesForScreenQuery = { allSortCodes: Array<{ id: string, ownerId: string, key: number, name: string | null, defaultIrsCode: number | null }> };

export type AllTagsScreenQueryVariables = Exact<{ [key: string]: never; }>;


export type AllTagsScreenQuery = { allTags: Array<(
    { id: string, name: string, namePath: Array<string> | null, parent: { id: string } | null }
    & { ' $fragmentRefs'?: { 'EditTagFieldsFragment': EditTagFieldsFragment } }
  )> };

export type AllTaxCategoriesForScreenQueryVariables = Exact<{ [key: string]: never; }>;


export type AllTaxCategoriesForScreenQuery = { taxCategories: Array<{ id: string, name: string, sortCode: { id: string, key: number, name: string | null } | null }> };

type TransactionsTableAccountFields_CommonTransaction_Fragment = { id: string, account:
    | { id: string, name: string, type: FinancialAccountType }
    | { id: string, name: string, type: FinancialAccountType }
    | { id: string, name: string, type: FinancialAccountType }
    | { id: string, name: string, type: FinancialAccountType }
    | { id: string, name: string, type: FinancialAccountType }
   } & { ' $fragmentName'?: 'TransactionsTableAccountFields_CommonTransaction_Fragment' };

type TransactionsTableAccountFields_ConversionTransaction_Fragment = { id: string, account:
    | { id: string, name: string, type: FinancialAccountType }
    | { id: string, name: string, type: FinancialAccountType }
    | { id: string, name: string, type: FinancialAccountType }
    | { id: string, name: string, type: FinancialAccountType }
    | { id: string, name: string, type: FinancialAccountType }
   } & { ' $fragmentName'?: 'TransactionsTableAccountFields_ConversionTransaction_Fragment' };

export type TransactionsTableAccountFieldsFragment =
  | TransactionsTableAccountFields_CommonTransaction_Fragment
  | TransactionsTableAccountFields_ConversionTransaction_Fragment
;

type TransactionsTableEntityFields_CommonTransaction_Fragment = { id: string, sourceDescription: string, counterparty:
    | { name: string, id: string }
    | { name: string, id: string }
    | { name: string, id: string }
   | null, missingInfoSuggestions: { business:
      | { id: string, name: string }
      | { id: string, name: string }
      | { id: string, name: string }
     } | null } & { ' $fragmentName'?: 'TransactionsTableEntityFields_CommonTransaction_Fragment' };

type TransactionsTableEntityFields_ConversionTransaction_Fragment = { id: string, sourceDescription: string, counterparty:
    | { name: string, id: string }
    | { name: string, id: string }
    | { name: string, id: string }
   | null, missingInfoSuggestions: { business:
      | { id: string, name: string }
      | { id: string, name: string }
      | { id: string, name: string }
     } | null } & { ' $fragmentName'?: 'TransactionsTableEntityFields_ConversionTransaction_Fragment' };

export type TransactionsTableEntityFieldsFragment =
  | TransactionsTableEntityFields_CommonTransaction_Fragment
  | TransactionsTableEntityFields_ConversionTransaction_Fragment
;

type TransactionsTableDebitDateFields_CommonTransaction_Fragment = { id: string, effectiveDate: unknown, sourceEffectiveDate: unknown } & { ' $fragmentName'?: 'TransactionsTableDebitDateFields_CommonTransaction_Fragment' };

type TransactionsTableDebitDateFields_ConversionTransaction_Fragment = { id: string, effectiveDate: unknown, sourceEffectiveDate: unknown } & { ' $fragmentName'?: 'TransactionsTableDebitDateFields_ConversionTransaction_Fragment' };

export type TransactionsTableDebitDateFieldsFragment =
  | TransactionsTableDebitDateFields_CommonTransaction_Fragment
  | TransactionsTableDebitDateFields_ConversionTransaction_Fragment
;

type TransactionsTableDescriptionFields_CommonTransaction_Fragment = { id: string, sourceDescription: string } & { ' $fragmentName'?: 'TransactionsTableDescriptionFields_CommonTransaction_Fragment' };

type TransactionsTableDescriptionFields_ConversionTransaction_Fragment = { id: string, sourceDescription: string } & { ' $fragmentName'?: 'TransactionsTableDescriptionFields_ConversionTransaction_Fragment' };

export type TransactionsTableDescriptionFieldsFragment =
  | TransactionsTableDescriptionFields_CommonTransaction_Fragment
  | TransactionsTableDescriptionFields_ConversionTransaction_Fragment
;

type TransactionsTableEventDateFields_CommonTransaction_Fragment = { id: string, eventDate: unknown } & { ' $fragmentName'?: 'TransactionsTableEventDateFields_CommonTransaction_Fragment' };

type TransactionsTableEventDateFields_ConversionTransaction_Fragment = { id: string, eventDate: unknown } & { ' $fragmentName'?: 'TransactionsTableEventDateFields_ConversionTransaction_Fragment' };

export type TransactionsTableEventDateFieldsFragment =
  | TransactionsTableEventDateFields_CommonTransaction_Fragment
  | TransactionsTableEventDateFields_ConversionTransaction_Fragment
;

type TransactionsTableSourceIdFields_CommonTransaction_Fragment = { id: string, referenceKey: string | null } & { ' $fragmentName'?: 'TransactionsTableSourceIdFields_CommonTransaction_Fragment' };

type TransactionsTableSourceIdFields_ConversionTransaction_Fragment = { id: string, referenceKey: string | null } & { ' $fragmentName'?: 'TransactionsTableSourceIdFields_ConversionTransaction_Fragment' };

export type TransactionsTableSourceIdFieldsFragment =
  | TransactionsTableSourceIdFields_CommonTransaction_Fragment
  | TransactionsTableSourceIdFields_ConversionTransaction_Fragment
;

type TransactionForTransactionsTableFields_CommonTransaction_Fragment = { id: string, isFee: boolean | null, chargeId: string, eventDate: unknown, effectiveDate: unknown, sourceEffectiveDate: unknown, sourceDescription: string, referenceKey: string | null, amount: { raw: number, formatted: string }, cryptoExchangeRate: { rate: number } | null, account:
    | { id: string, name: string, type: FinancialAccountType }
    | { id: string, name: string, type: FinancialAccountType }
    | { id: string, name: string, type: FinancialAccountType }
    | { id: string, name: string, type: FinancialAccountType }
    | { id: string, name: string, type: FinancialAccountType }
  , counterparty:
    | { name: string, id: string }
    | { name: string, id: string }
    | { name: string, id: string }
   | null, missingInfoSuggestions: { business:
      | { id: string, name: string }
      | { id: string, name: string }
      | { id: string, name: string }
     } | null } & { ' $fragmentName'?: 'TransactionForTransactionsTableFields_CommonTransaction_Fragment' };

type TransactionForTransactionsTableFields_ConversionTransaction_Fragment = { id: string, isFee: boolean | null, chargeId: string, eventDate: unknown, effectiveDate: unknown, sourceEffectiveDate: unknown, sourceDescription: string, referenceKey: string | null, amount: { raw: number, formatted: string }, cryptoExchangeRate: { rate: number } | null, account:
    | { id: string, name: string, type: FinancialAccountType }
    | { id: string, name: string, type: FinancialAccountType }
    | { id: string, name: string, type: FinancialAccountType }
    | { id: string, name: string, type: FinancialAccountType }
    | { id: string, name: string, type: FinancialAccountType }
  , counterparty:
    | { name: string, id: string }
    | { name: string, id: string }
    | { name: string, id: string }
   | null, missingInfoSuggestions: { business:
      | { id: string, name: string }
      | { id: string, name: string }
      | { id: string, name: string }
     } | null } & { ' $fragmentName'?: 'TransactionForTransactionsTableFields_ConversionTransaction_Fragment' };

export type TransactionForTransactionsTableFieldsFragment =
  | TransactionForTransactionsTableFields_CommonTransaction_Fragment
  | TransactionForTransactionsTableFields_ConversionTransaction_Fragment
;

type TransactionToDownloadForTransactionsTableFields_CommonTransaction_Fragment = { id: string, effectiveDate: unknown, eventDate: unknown, referenceKey: string | null, sourceDescription: string, account:
    | { id: string, name: string, type: FinancialAccountType }
    | { id: string, name: string, type: FinancialAccountType }
    | { id: string, name: string, type: FinancialAccountType }
    | { id: string, name: string, type: FinancialAccountType }
    | { id: string, name: string, type: FinancialAccountType }
  , amount: { currency: Currency, raw: number }, counterparty:
    | { id: string, name: string }
    | { id: string, name: string }
    | { id: string, name: string }
   | null } & { ' $fragmentName'?: 'TransactionToDownloadForTransactionsTableFields_CommonTransaction_Fragment' };

type TransactionToDownloadForTransactionsTableFields_ConversionTransaction_Fragment = { id: string, effectiveDate: unknown, eventDate: unknown, referenceKey: string | null, sourceDescription: string, account:
    | { id: string, name: string, type: FinancialAccountType }
    | { id: string, name: string, type: FinancialAccountType }
    | { id: string, name: string, type: FinancialAccountType }
    | { id: string, name: string, type: FinancialAccountType }
    | { id: string, name: string, type: FinancialAccountType }
  , amount: { currency: Currency, raw: number }, counterparty:
    | { id: string, name: string }
    | { id: string, name: string }
    | { id: string, name: string }
   | null } & { ' $fragmentName'?: 'TransactionToDownloadForTransactionsTableFields_ConversionTransaction_Fragment' };

export type TransactionToDownloadForTransactionsTableFieldsFragment =
  | TransactionToDownloadForTransactionsTableFields_CommonTransaction_Fragment
  | TransactionToDownloadForTransactionsTableFields_ConversionTransaction_Fragment
;

export type AcceptInvitationMutationVariables = Exact<{
  token: string;
}>;


export type AcceptInvitationMutation = { acceptInvitation: { success: boolean, businessId: string, roleId: string } };

export type AddBusinessTripAccommodationsExpenseMutationVariables = Exact<{
  fields: AddBusinessTripAccommodationsExpenseInput;
}>;


export type AddBusinessTripAccommodationsExpenseMutation = { addBusinessTripAccommodationsExpense: string };

export type AddBusinessTripCarRentalExpenseMutationVariables = Exact<{
  fields: AddBusinessTripCarRentalExpenseInput;
}>;


export type AddBusinessTripCarRentalExpenseMutation = { addBusinessTripCarRentalExpense: string };

export type AddBusinessTripFlightsExpenseMutationVariables = Exact<{
  fields: AddBusinessTripFlightsExpenseInput;
}>;


export type AddBusinessTripFlightsExpenseMutation = { addBusinessTripFlightsExpense: string };

export type AddBusinessTripOtherExpenseMutationVariables = Exact<{
  fields: AddBusinessTripOtherExpenseInput;
}>;


export type AddBusinessTripOtherExpenseMutation = { addBusinessTripOtherExpense: string };

export type AddBusinessTripTravelAndSubsistenceExpenseMutationVariables = Exact<{
  fields: AddBusinessTripTravelAndSubsistenceExpenseInput;
}>;


export type AddBusinessTripTravelAndSubsistenceExpenseMutation = { addBusinessTripTravelAndSubsistenceExpense: string };

export type AddDepreciationRecordMutationVariables = Exact<{
  fields: InsertDepreciationRecordInput;
}>;


export type AddDepreciationRecordMutation = { insertDepreciationRecord:
    | { __typename: 'CommonError', message: string }
    | { __typename: 'DepreciationRecord', id: string }
   };

export type AddSortCodeMutationVariables = Exact<{
  key: number;
  name: string;
  defaultIrsCode?: number | null | undefined;
}>;


export type AddSortCodeMutation = { addSortCode: boolean };

export type AddTagMutationVariables = Exact<{
  tagName: string;
  parentTag?: string | null | undefined;
}>;


export type AddTagMutation = { addTag: boolean };

export type AnnualAuditStepStatusQueryVariables = Exact<{
  ownerId: string;
  year: number;
}>;


export type AnnualAuditStepStatusQuery = { annualAuditStepStatuses: Array<{ id: string, stepId: string, status: AnnualAuditStepStatus }> };

export type AssignChargeToDepositMutationVariables = Exact<{
  chargeId: string;
  depositId: string;
}>;


export type AssignChargeToDepositMutation = { assignChargeToDeposit: { id: string } };

export type GenerateBalanceChargeMutationVariables = Exact<{
  description: string;
  balanceRecords: Array<InsertMiscExpenseInput> | InsertMiscExpenseInput;
}>;


export type GenerateBalanceChargeMutation = { generateBalanceCharge: { id: string } };

export type BatchUpdateBusinessesMutationVariables = Exact<{
  businessIds: Array<string> | string;
  fields: BatchUpdateBusinessInput;
}>;


export type BatchUpdateBusinessesMutation = { batchUpdateBusinesses: Array<
    | { id: string }
    | { id: string }
  > };

export type BatchUpdateChargesMutationVariables = Exact<{
  chargeIds: Array<string> | string;
  fields: UpdateChargeInput;
}>;


export type BatchUpdateChargesMutation = { batchUpdateCharges:
    | { __typename: 'BatchUpdateChargesSuccessfulResult', charges: Array<
        | { id: string }
        | { id: string }
        | { id: string }
        | { id: string }
        | { id: string }
        | { id: string }
        | { id: string }
        | { id: string }
        | { id: string }
        | { id: string }
        | { id: string }
      > }
    | { __typename: 'CommonError', message: string }
   };

export type CategorizeBusinessTripExpenseMutationVariables = Exact<{
  fields: CategorizeBusinessTripExpenseInput;
}>;


export type CategorizeBusinessTripExpenseMutation = { categorizeBusinessTripExpense: string };

export type CategorizeIntoExistingBusinessTripExpenseMutationVariables = Exact<{
  fields: CategorizeIntoExistingBusinessTripExpenseInput;
}>;


export type CategorizeIntoExistingBusinessTripExpenseMutation = { categorizeIntoExistingBusinessTripExpense: string };

export type CloseDocumentMutationVariables = Exact<{
  documentId: string;
}>;


export type CloseDocumentMutation = { closeDocument: boolean };

export type CreateContractMutationVariables = Exact<{
  input: CreateContractInput;
}>;


export type CreateContractMutation = { createContract: { id: string } };

export type CreateDepositFromChargeMutationVariables = Exact<{
  chargeId: string;
  name: string;
}>;


export type CreateDepositFromChargeMutation = { createDepositFromCharge: { id: string, name: string, currency: Currency | null, isOpen: boolean } };

export type CreateDepositMutationVariables = Exact<{
  name: string;
  currency: Currency;
  openDate: unknown;
  accountId?: string | null | undefined;
}>;


export type CreateDepositMutation = { createDeposit: { id: string, currency: Currency | null, isOpen: boolean } };

export type CreateFinancialAccountMutationVariables = Exact<{
  input: CreateFinancialAccountInput;
}>;


export type CreateFinancialAccountMutation = { createFinancialAccount:
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
   };

export type CreateInvitationMutationVariables = Exact<{
  email: string;
  roleId: string;
}>;


export type CreateInvitationMutation = { createInvitation: { id: string, email: string, roleId: string, expiresAt: unknown } };

export type CreditShareholdersBusinessTripTravelAndSubsistenceMutationVariables = Exact<{
  businessTripId: string;
}>;


export type CreditShareholdersBusinessTripTravelAndSubsistenceMutation = { creditShareholdersBusinessTripTravelAndSubsistence: Array<string> };

export type FlagForeignFeeTransactionsMutationVariables = Exact<{ [key: string]: never; }>;


export type FlagForeignFeeTransactionsMutation = { flagForeignFeeTransactions: { success: boolean, errors: Array<string> | null } };

export type MergeChargesByTransactionReferenceMutationVariables = Exact<{
  dryRun?: boolean | null | undefined;
}>;


export type MergeChargesByTransactionReferenceMutation = { mergeChargesByTransactionReference: { success: boolean, errors: Array<string> | null } };

export type CalculateCreditcardTransactionsDebitDateMutationVariables = Exact<{ [key: string]: never; }>;


export type CalculateCreditcardTransactionsDebitDateMutation = { calculateCreditcardTransactionsDebitDate: boolean };

export type DeleteBusinessTripAttendeeMutationVariables = Exact<{
  fields: DeleteBusinessTripAttendeeInput;
}>;


export type DeleteBusinessTripAttendeeMutation = { deleteBusinessTripAttendee: boolean };

export type DeleteBusinessTripExpenseMutationVariables = Exact<{
  businessTripExpenseId: string;
}>;


export type DeleteBusinessTripExpenseMutation = { deleteBusinessTripExpense: boolean };

export type DeleteBusinessMutationVariables = Exact<{
  businessId: string;
}>;


export type DeleteBusinessMutation = { deleteBusiness: boolean };

export type DeleteChargeMutationVariables = Exact<{
  chargeId: string;
}>;


export type DeleteChargeMutation = { deleteCharge: boolean };

export type DeleteContractMutationVariables = Exact<{
  contractId: string;
}>;


export type DeleteContractMutation = { deleteContract: boolean };

export type DeleteDepreciationRecordMutationVariables = Exact<{
  depreciationRecordId: string;
}>;


export type DeleteDepreciationRecordMutation = { deleteDepreciationRecord: boolean };

export type DeleteDocumentMutationVariables = Exact<{
  documentId: string;
}>;


export type DeleteDocumentMutation = { deleteDocument: boolean };

export type DeleteDynamicReportTemplateMutationVariables = Exact<{
  name: string;
}>;


export type DeleteDynamicReportTemplateMutation = { deleteDynamicReportTemplate: string };

export type DeleteMiscExpenseMutationVariables = Exact<{
  id: string;
}>;


export type DeleteMiscExpenseMutation = { deleteMiscExpense: boolean };

export type DeleteProviderCredentialsMutationVariables = Exact<{
  provider: ProviderKey;
}>;


export type DeleteProviderCredentialsMutation = { deleteProviderCredentials:
    | { message: string }
    | { id: string, provider: ProviderKey, success: boolean }
   };

export type DeleteTagMutationVariables = Exact<{
  tagId: string;
}>;


export type DeleteTagMutation = { deleteTag: boolean };

export type FetchDeelDocumentsMutationVariables = Exact<{ [key: string]: never; }>;


export type FetchDeelDocumentsMutation = { fetchDeelDocuments: Array<
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
  > };

export type GenerateApiKeyMutationVariables = Exact<{
  name: string;
  roleId: string;
}>;


export type GenerateApiKeyMutation = { generateApiKey: { apiKey: string, record: { id: string, name: string, roleId: string, lastUsedAt: unknown, createdAt: unknown } } };

export type GenerateRevaluationChargeMutationVariables = Exact<{
  ownerId: string;
  date: unknown;
}>;


export type GenerateRevaluationChargeMutation = { generateRevaluationCharge: { id: string } };

export type GenerateBankDepositsRevaluationChargeMutationVariables = Exact<{
  ownerId: string;
  date: unknown;
}>;


export type GenerateBankDepositsRevaluationChargeMutation = { generateBankDepositsRevaluationCharge: { id: string } };

export type GenerateTaxExpensesChargeMutationVariables = Exact<{
  ownerId: string;
  date: unknown;
}>;


export type GenerateTaxExpensesChargeMutation = { generateTaxExpensesCharge: { id: string } };

export type GenerateDepreciationChargeMutationVariables = Exact<{
  ownerId: string;
  date: unknown;
}>;


export type GenerateDepreciationChargeMutation = { generateDepreciationCharge: { id: string } };

export type GenerateRecoveryReserveChargeMutationVariables = Exact<{
  ownerId: string;
  date: unknown;
}>;


export type GenerateRecoveryReserveChargeMutation = { generateRecoveryReserveCharge: { id: string } };

export type GenerateVacationReserveChargeMutationVariables = Exact<{
  ownerId: string;
  date: unknown;
}>;


export type GenerateVacationReserveChargeMutation = { generateVacationReserveCharge: { id: string } };

export type AllAdminBusinessesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllAdminBusinessesQuery = { allAdminBusinesses: Array<{ id: string, name: string, governmentId: string }> };

export type AllClientsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllClientsQuery = { allClients: Array<{ id: string, originalBusiness: { id: string, name: string } }> };

export type AllBusinessesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllBusinessesQuery = { allBusinesses: { nodes: Array<
      | { id: string, name: string }
      | { id: string, name: string }
    > } | null };

export type AllCountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllCountriesQuery = { allCountries: Array<{ id: string, name: string, code: unknown }> };

export type AllFinancialAccountsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllFinancialAccountsQuery = { allFinancialAccounts: Array<
    | { id: string, name: string }
    | { id: string, name: string }
    | { id: string, name: string }
    | { id: string, name: string }
    | { id: string, name: string }
  > };

export type AllFinancialEntitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllFinancialEntitiesQuery = { allFinancialEntities: { nodes: Array<
      | { id: string, name: string }
      | { id: string, name: string }
      | { id: string, name: string }
    > } | null };

export type AllSortCodesQueryVariables = Exact<{
  ownerId: string;
}>;


export type AllSortCodesQuery = { allSortCodesByBusiness: Array<{ id: string, key: number, name: string | null, defaultIrsCode: number | null }> };

export type AllTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllTagsQuery = { allTags: Array<{ id: string, name: string, namePath: Array<string> | null }> };

export type AllTaxCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllTaxCategoriesQuery = { taxCategories: Array<{ id: string, name: string }> };

export type InsertBusinessTripAttendeeMutationVariables = Exact<{
  fields: InsertBusinessTripAttendeeInput;
}>;


export type InsertBusinessTripAttendeeMutation = { insertBusinessTripAttendee: string };

export type InsertBusinessTripMutationVariables = Exact<{
  fields: InsertBusinessTripInput;
}>;


export type InsertBusinessTripMutation = { insertBusinessTrip: string };

export type InsertBusinessMutationVariables = Exact<{
  fields: InsertNewBusinessInput;
}>;


export type InsertBusinessMutation = { insertNewBusiness:
    | { __typename: 'CommonError', message: string }
    | { __typename: 'LtdFinancialEntity', id: string }
   };

export type InsertClientMutationVariables = Exact<{
  fields: ClientInsertInput;
}>;


export type InsertClientMutation = { insertClient:
    | { __typename: 'Client', id: string }
    | { __typename: 'CommonError', message: string }
   };

export type InsertDocumentMutationVariables = Exact<{
  record: InsertDocumentInput;
}>;


export type InsertDocumentMutation = { insertDocument:
    | { __typename: 'CommonError', message: string }
    | { __typename: 'InsertDocumentSuccessfulResult', document:
        | { id: string }
        | { id: string }
        | { id: string }
        | { id: string }
        | { id: string }
        | { id: string }
        | { id: string }
       | null }
   };

export type InsertDynamicReportTemplateMutationVariables = Exact<{
  name: string;
  template: string;
}>;


export type InsertDynamicReportTemplateMutation = { insertDynamicReportTemplate: { id: string, name: string } };

export type InsertMiscExpenseMutationVariables = Exact<{
  chargeId: string;
  fields: InsertMiscExpenseInput;
}>;


export type InsertMiscExpenseMutation = { insertMiscExpense: { id: string } };

export type InsertMiscExpensesMutationVariables = Exact<{
  chargeId: string;
  expenses: Array<InsertMiscExpenseInput> | InsertMiscExpenseInput;
}>;


export type InsertMiscExpensesMutation = { insertMiscExpenses:
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
   };

export type InsertSalaryRecordMutationVariables = Exact<{
  salaryRecords: Array<SalaryRecordInput> | SalaryRecordInput;
}>;


export type InsertSalaryRecordMutation = { insertSalaryRecords:
    | { __typename: 'CommonError', message: string }
    | { __typename: 'InsertSalaryRecordsSuccessfulResult', salaryRecords: Array<{ month: string, employee: { id: string } | null }> }
   };

export type InsertTaxCategoryMutationVariables = Exact<{
  fields: InsertTaxCategoryInput;
}>;


export type InsertTaxCategoryMutation = { insertTaxCategory: { id: string, name: string } };

export type IssueGreenInvoiceDocumentMutationVariables = Exact<{
  input: DocumentIssueInput;
  emailContent?: string | null | undefined;
  attachment?: boolean | null | undefined;
  chargeId?: string | null | undefined;
}>;


export type IssueGreenInvoiceDocumentMutation = { issueGreenInvoiceDocument:
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
   };

export type IssueMonthlyDocumentsMutationVariables = Exact<{
  generateDocumentsInfo: Array<DocumentIssueInput> | DocumentIssueInput;
}>;


export type IssueMonthlyDocumentsMutation = { issueGreenInvoiceDocuments: { success: boolean, errors: Array<string> | null } };

export type LedgerLockMutationVariables = Exact<{
  date: unknown;
}>;


export type LedgerLockMutation = { lockLedgerRecords: boolean };

export type LockDynamicReportTemplateMutationVariables = Exact<{
  name: string;
}>;


export type LockDynamicReportTemplateMutation = { lockDynamicReportTemplate: { id: string, name: string, isLocked: boolean, updated: unknown } };

export type MergeBusinessesMutationVariables = Exact<{
  targetBusinessId: string;
  businessIdsToMerge: Array<string> | string;
}>;


export type MergeBusinessesMutation = { mergeBusinesses:
    | { __typename: 'LtdFinancialEntity', id: string }
    | { __typename: 'PersonalFinancialEntity', id: string }
   };

export type MergeChargesMutationVariables = Exact<{
  baseChargeID: string;
  chargeIdsToMerge: Array<string> | string;
  fields?: UpdateChargeInput | null | undefined;
}>;


export type MergeChargesMutation = { mergeCharges:
    | { __typename: 'CommonError', message: string }
    | { __typename: 'MergeChargeSuccessfulResult', charge:
        | { id: string }
        | { id: string }
        | { id: string }
        | { id: string }
        | { id: string }
        | { id: string }
        | { id: string }
        | { id: string }
        | { id: string }
        | { id: string }
        | { id: string }
       }
   };

export type PreviewDocumentMutationVariables = Exact<{
  input: DocumentIssueInput;
}>;


export type PreviewDocumentMutation = { previewDocument: string };

export type ProviderCredentialsQueryVariables = Exact<{ [key: string]: never; }>;


export type ProviderCredentialsQuery = { providerCredentials: Array<{ id: string, provider: ProviderKey, configuredAt: unknown }> };

export type RegenerateLedgerMutationVariables = Exact<{
  chargeId: string;
}>;


export type RegenerateLedgerMutation = { regenerateLedgerRecords:
    | { __typename: 'CommonError', message: string }
    | { __typename: 'Ledger', records: Array<{ id: string }> }
   };

export type RelevantDepositsForChargeQueryVariables = Exact<{
  chargeId: string;
}>;


export type RelevantDepositsForChargeQuery = { relevantDepositsForCharge: { id: string, error: string | null, deposits: Array<{ id: string, name: string, currency: Currency | null, isOpen: boolean }> } };

export type RemoveBusinessUserMutationVariables = Exact<{
  userId: string | number;
}>;


export type RemoveBusinessUserMutation = { removeBusinessUser: boolean };

export type RevokeApiKeyMutationVariables = Exact<{
  id: string | number;
}>;


export type RevokeApiKeyMutation = { revokeApiKey: boolean };

export type RevokeInvitationMutationVariables = Exact<{
  id: string | number;
}>;


export type RevokeInvitationMutation = { revokeInvitation: boolean };

export type SetAnnualAuditStepStatusMutationVariables = Exact<{
  input: SetAnnualAuditStepStatusInput;
}>;


export type SetAnnualAuditStepStatusMutation = { setAnnualAuditStepStatus: { id: string, ownerId: string, year: number, stepId: string, status: AnnualAuditStepStatus, notes: string | null, evidence: string | null, updatedAt: unknown, completedAt: unknown } };

export type SetAnnualAuditStep03StatusMutationVariables = Exact<{
  input: SetAnnualAuditStep03StatusInput;
}>;


export type SetAnnualAuditStep03StatusMutation = { setAnnualAuditStep03Status: { id: string, ownerId: string, year: number, stepId: string, status: AnnualAuditStepStatus, notes: string | null, updatedAt: unknown, completedAt: unknown } };

export type SetAnnualAuditStep09StatusMutationVariables = Exact<{
  input: SetAnnualAuditStep09StatusInput;
}>;


export type SetAnnualAuditStep09StatusMutation = { setAnnualAuditStep09Status: { id: string, ownerId: string, year: number, stepId: string, status: AnnualAuditStepStatus, notes: string | null, evidence: string | null, updatedAt: unknown, completedAt: unknown } };

export type SetDeelCredentialsMutationVariables = Exact<{
  apiToken: string;
}>;


export type SetDeelCredentialsMutation = { setDeelCredentials:
    | { message: string }
    | { id: string, provider: ProviderKey, configuredAt: unknown }
   };

export type SetGreenInvoiceCredentialsMutationVariables = Exact<{
  id: string;
  secret: string;
}>;


export type SetGreenInvoiceCredentialsMutation = { setGreenInvoiceCredentials:
    | { message: string }
    | { id: string, provider: ProviderKey, configuredAt: unknown }
   };

export type SyncGreenInvoiceDocumentsMutationVariables = Exact<{
  ownerId: string;
}>;


export type SyncGreenInvoiceDocumentsMutation = { syncGreenInvoiceDocuments: Array<
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'NewFetchedDocumentFields_CreditInvoice_Fragment': NewFetchedDocumentFields_CreditInvoice_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'NewFetchedDocumentFields_Invoice_Fragment': NewFetchedDocumentFields_Invoice_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'NewFetchedDocumentFields_InvoiceReceipt_Fragment': NewFetchedDocumentFields_InvoiceReceipt_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'NewFetchedDocumentFields_OtherDocument_Fragment': NewFetchedDocumentFields_OtherDocument_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'NewFetchedDocumentFields_Proforma_Fragment': NewFetchedDocumentFields_Proforma_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'NewFetchedDocumentFields_Receipt_Fragment': NewFetchedDocumentFields_Receipt_Fragment } }
    )
    | (
      { id: string }
      & { ' $fragmentRefs'?: { 'NewFetchedDocumentFields_Unprocessed_Fragment': NewFetchedDocumentFields_Unprocessed_Fragment } }
    )
  > };

export type UnlockDynamicReportTemplateMutationVariables = Exact<{
  name: string;
}>;


export type UnlockDynamicReportTemplateMutation = { unlockDynamicReportTemplate: { id: string, name: string, isLocked: boolean, updated: unknown } };

export type UpdateAdminBusinessMutationVariables = Exact<{
  adminBusinessId: string;
  fields: UpdateAdminBusinessInput;
}>;


export type UpdateAdminBusinessMutation = { updateAdminBusiness: { id: string } };

export type UpdateBusinessTripAccommodationsExpenseMutationVariables = Exact<{
  fields: UpdateBusinessTripAccommodationsExpenseInput;
}>;


export type UpdateBusinessTripAccommodationsExpenseMutation = { updateBusinessTripAccommodationsExpense: string };

export type UpdateBusinessTripAccountantApprovalMutationVariables = Exact<{
  businessTripId: string;
  status: AccountantStatus;
}>;


export type UpdateBusinessTripAccountantApprovalMutation = { updateBusinessTripAccountantApproval: AccountantStatus };

export type UpdateBusinessTripAttendeeMutationVariables = Exact<{
  fields: BusinessTripAttendeeUpdateInput;
}>;


export type UpdateBusinessTripAttendeeMutation = { updateBusinessTripAttendee: string };

export type UpdateBusinessTripCarRentalExpenseMutationVariables = Exact<{
  fields: UpdateBusinessTripCarRentalExpenseInput;
}>;


export type UpdateBusinessTripCarRentalExpenseMutation = { updateBusinessTripCarRentalExpense: string };

export type UpdateBusinessTripFlightsExpenseMutationVariables = Exact<{
  fields: UpdateBusinessTripFlightsExpenseInput;
}>;


export type UpdateBusinessTripFlightsExpenseMutation = { updateBusinessTripFlightsExpense: string };

export type UpdateBusinessTripOtherExpenseMutationVariables = Exact<{
  fields: UpdateBusinessTripOtherExpenseInput;
}>;


export type UpdateBusinessTripOtherExpenseMutation = { updateBusinessTripOtherExpense: string };

export type UpdateBusinessTripTravelAndSubsistenceExpenseMutationVariables = Exact<{
  fields: UpdateBusinessTripTravelAndSubsistenceExpenseInput;
}>;


export type UpdateBusinessTripTravelAndSubsistenceExpenseMutation = { updateBusinessTripTravelAndSubsistenceExpense: string };

export type UpdateBusinessMutationVariables = Exact<{
  businessId: string;
  ownerId: string;
  fields: UpdateBusinessInput;
}>;


export type UpdateBusinessMutation = { updateBusiness:
    | { __typename: 'CommonError', message: string }
    | { __typename: 'LtdFinancialEntity', id: string, name: string }
   };

export type UpdateChargeAccountantApprovalMutationVariables = Exact<{
  chargeId: string;
  status: AccountantStatus;
}>;


export type UpdateChargeAccountantApprovalMutation = { updateChargeAccountantApproval: AccountantStatus };

export type UpdateChargeMutationVariables = Exact<{
  chargeId: string;
  fields: UpdateChargeInput;
}>;


export type UpdateChargeMutation = { updateCharge:
    | { __typename: 'CommonError', message: string }
    | { __typename: 'UpdateChargeSuccessfulResult', charge:
        | { id: string }
        | { id: string }
        | { id: string }
        | { id: string }
        | { id: string }
        | { id: string }
        | { id: string }
        | { id: string }
        | { id: string }
        | { id: string }
        | { id: string }
       }
   };

export type UpdateClientMutationVariables = Exact<{
  businessId: string;
  fields: ClientUpdateInput;
}>;


export type UpdateClientMutation = { updateClient:
    | { __typename: 'Client', id: string }
    | { __typename: 'CommonError', message: string }
   };

export type UpdateContractMutationVariables = Exact<{
  contractId: string;
  input: UpdateContractInput;
}>;


export type UpdateContractMutation = { updateContract: { id: string } };

export type UpdateDepositMutationVariables = Exact<{
  id: string;
  name?: string | null | undefined;
  openDate?: unknown;
  closeDate?: unknown;
}>;


export type UpdateDepositMutation = { updateDeposit: { id: string, name: string, openDate: unknown, closeDate: unknown, isOpen: boolean } };

export type UpdateDepreciationRecordMutationVariables = Exact<{
  fields: UpdateDepreciationRecordInput;
}>;


export type UpdateDepreciationRecordMutation = { updateDepreciationRecord:
    | { __typename: 'CommonError', message: string }
    | { __typename: 'DepreciationRecord', id: string }
   };

export type UpdateDocumentMutationVariables = Exact<{
  documentId: string;
  fields: UpdateDocumentFieldsInput;
}>;


export type UpdateDocumentMutation = { updateDocument:
    | { __typename: 'CommonError', message: string }
    | { __typename: 'UpdateDocumentSuccessfulResult', document:
        | { id: string }
        | { id: string }
        | { id: string }
        | { id: string }
        | { id: string }
        | { id: string }
        | { id: string }
       | null }
   };

export type UpdateDynamicReportTemplateNameMutationVariables = Exact<{
  name: string;
  newName: string;
}>;


export type UpdateDynamicReportTemplateNameMutation = { updateDynamicReportTemplateName: { id: string, name: string } };

export type UpdateDynamicReportTemplateMutationVariables = Exact<{
  name: string;
  template: string;
}>;


export type UpdateDynamicReportTemplateMutation = { updateDynamicReportTemplate: { id: string, name: string } };

export type UpdateFinancialAccountMutationVariables = Exact<{
  financialAccountId: string;
  fields: UpdateFinancialAccountInput;
}>;


export type UpdateFinancialAccountMutation = { updateFinancialAccount:
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
    | { id: string }
   };

export type UpdateMiscExpenseMutationVariables = Exact<{
  id: string;
  fields: UpdateMiscExpenseInput;
}>;


export type UpdateMiscExpenseMutation = { updateMiscExpense: { id: string } };

export type UpdateOrInsertSalaryRecordsMutationVariables = Exact<{
  salaryRecords: Array<SalaryRecordInput> | SalaryRecordInput;
}>;


export type UpdateOrInsertSalaryRecordsMutation = { insertOrUpdateSalaryRecords:
    | { __typename: 'CommonError', message: string }
    | { __typename: 'InsertSalaryRecordsSuccessfulResult', salaryRecords: Array<{ month: string, employee: { id: string } | null }> }
   };

export type UpdateSalaryRecordMutationVariables = Exact<{
  salaryRecord: SalaryRecordEditInput;
}>;


export type UpdateSalaryRecordMutation = { updateSalaryRecord:
    | { __typename: 'CommonError', message: string }
    | { __typename: 'UpdateSalaryRecordSuccessfulResult', salaryRecord: { month: string, employee: { id: string } | null } }
   };

export type UpdateSortCodeMutationVariables = Exact<{
  key: number;
  fields: UpdateSortCodeFieldsInput;
}>;


export type UpdateSortCodeMutation = { updateSortCode: boolean };

export type UpdateTagMutationVariables = Exact<{
  tagId: string;
  fields: UpdateTagFieldsInput;
}>;


export type UpdateTagMutation = { updateTag: boolean };

export type UpdateTaxCategoryMutationVariables = Exact<{
  taxCategoryId: string;
  fields: UpdateTaxCategoryInput;
}>;


export type UpdateTaxCategoryMutation = { updateTaxCategory:
    | { __typename: 'CommonError', message: string }
    | { __typename: 'TaxCategory', id: string, name: string }
   };

export type UpdateTransactionMutationVariables = Exact<{
  transactionId: string;
  fields: UpdateTransactionInput;
}>;


export type UpdateTransactionMutation = { updateTransaction:
    | { __typename: 'CommonError', message: string }
    | { __typename: 'CommonTransaction', id: string }
    | { __typename: 'ConversionTransaction', id: string }
   };

export type UpdateTransactionsMutationVariables = Exact<{
  transactionIds: Array<string> | string;
  fields: UpdateTransactionInput;
}>;


export type UpdateTransactionsMutation = { updateTransactions:
    | { __typename: 'CommonError', message: string }
    | { __typename: 'UpdatedTransactionsSuccessfulResult', transactions: Array<
        | { id: string }
        | { id: string }
      > }
   };

export type UploadDocumentMutationVariables = Exact<{
  file: File;
  chargeId?: string | null | undefined;
}>;


export type UploadDocumentMutation = { uploadDocument:
    | { __typename: 'CommonError', message: string }
    | { __typename: 'UploadDocumentSuccessfulResult', document:
        | { id: string, charge:
            | { id: string }
            | { id: string }
            | { id: string }
            | { id: string }
            | { id: string }
            | { id: string }
            | { id: string }
            | { id: string }
            | { id: string }
            | { id: string }
            | { id: string }
           | null }
        | { id: string, charge:
            | { id: string }
            | { id: string }
            | { id: string }
            | { id: string }
            | { id: string }
            | { id: string }
            | { id: string }
            | { id: string }
            | { id: string }
            | { id: string }
            | { id: string }
           | null }
        | { id: string, charge:
            | { id: string }
            | { id: string }
            | { id: string }
            | { id: string }
            | { id: string }
            | { id: string }
            | { id: string }
            | { id: string }
            | { id: string }
            | { id: string }
            | { id: string }
           | null }
        | { id: string, charge:
            | { id: string }
            | { id: string }
            | { id: string }
            | { id: string }
            | { id: string }
            | { id: string }
            | { id: string }
            | { id: string }
            | { id: string }
            | { id: string }
            | { id: string }
           | null }
        | { id: string, charge:
            | { id: string }
            | { id: string }
            | { id: string }
            | { id: string }
            | { id: string }
            | { id: string }
            | { id: string }
            | { id: string }
            | { id: string }
            | { id: string }
            | { id: string }
           | null }
        | { id: string, charge:
            | { id: string }
            | { id: string }
            | { id: string }
            | { id: string }
            | { id: string }
            | { id: string }
            | { id: string }
            | { id: string }
            | { id: string }
            | { id: string }
            | { id: string }
           | null }
        | { id: string, charge:
            | { id: string }
            | { id: string }
            | { id: string }
            | { id: string }
            | { id: string }
            | { id: string }
            | { id: string }
            | { id: string }
            | { id: string }
            | { id: string }
            | { id: string }
           | null }
       | null }
   };

export type UploadDocumentsFromGoogleDriveMutationVariables = Exact<{
  sharedFolderUrl: string;
  chargeId?: string | null | undefined;
  isSensitive?: boolean | null | undefined;
}>;


export type UploadDocumentsFromGoogleDriveMutation = { batchUploadDocumentsFromGoogleDrive: Array<
    | { message: string }
    | { document:
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'NewFetchedDocumentFields_CreditInvoice_Fragment': NewFetchedDocumentFields_CreditInvoice_Fragment } }
        )
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'NewFetchedDocumentFields_Invoice_Fragment': NewFetchedDocumentFields_Invoice_Fragment } }
        )
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'NewFetchedDocumentFields_InvoiceReceipt_Fragment': NewFetchedDocumentFields_InvoiceReceipt_Fragment } }
        )
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'NewFetchedDocumentFields_OtherDocument_Fragment': NewFetchedDocumentFields_OtherDocument_Fragment } }
        )
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'NewFetchedDocumentFields_Proforma_Fragment': NewFetchedDocumentFields_Proforma_Fragment } }
        )
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'NewFetchedDocumentFields_Receipt_Fragment': NewFetchedDocumentFields_Receipt_Fragment } }
        )
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'NewFetchedDocumentFields_Unprocessed_Fragment': NewFetchedDocumentFields_Unprocessed_Fragment } }
        )
       | null }
  > };

export type UploadMultipleDocumentsMutationVariables = Exact<{
  documents: Array<File> | File;
  chargeId?: string | null | undefined;
  isSensitive?: boolean | null | undefined;
}>;


export type UploadMultipleDocumentsMutation = { batchUploadDocuments: Array<
    | { message: string }
    | { document:
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'NewFetchedDocumentFields_CreditInvoice_Fragment': NewFetchedDocumentFields_CreditInvoice_Fragment } }
        )
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'NewFetchedDocumentFields_Invoice_Fragment': NewFetchedDocumentFields_Invoice_Fragment } }
        )
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'NewFetchedDocumentFields_InvoiceReceipt_Fragment': NewFetchedDocumentFields_InvoiceReceipt_Fragment } }
        )
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'NewFetchedDocumentFields_OtherDocument_Fragment': NewFetchedDocumentFields_OtherDocument_Fragment } }
        )
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'NewFetchedDocumentFields_Proforma_Fragment': NewFetchedDocumentFields_Proforma_Fragment } }
        )
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'NewFetchedDocumentFields_Receipt_Fragment': NewFetchedDocumentFields_Receipt_Fragment } }
        )
        | (
          { id: string }
          & { ' $fragmentRefs'?: { 'NewFetchedDocumentFields_Unprocessed_Fragment': NewFetchedDocumentFields_Unprocessed_Fragment } }
        )
       | null }
  > };

export type UploadPayrollFileMutationVariables = Exact<{
  file: File;
  chargeId: string;
}>;


export type UploadPayrollFileMutation = { insertSalaryRecordsFromFile: boolean };

export type UserContextQueryVariables = Exact<{ [key: string]: never; }>;


export type UserContextQuery = { userContext: { activeReadScope: Array<string>, defaultLocalCurrency: Currency | null, defaultCryptoConversionFiatCurrency: Currency | null, ledgerLock: unknown, financialAccountsBusinessesIds: Array<string> | null, locality: string | null, memberships: Array<{ businessId: string, role: string, businessName: string | null }> } | null };

export type RequestIngestControlMutationVariables = Exact<{
  input: IngestControlInput;
}>;


export type RequestIngestControlMutation = { requestIngestControl:
    | { __typename: 'CommonError', message: string }
    | { __typename: 'IngestControlDecision', id: string, tenantId: string, decisionId: string, auditId: string, grant: { id: string, jti: string, tenantId: string, action: string, expiresAt: string }, businessEmailConfig: { businessId: string, internalEmailLinks: Array<string> | null, emailBody: boolean | null, attachments: Array<EmailAttachmentType> | null } | null }
   };

export type IngestEmailMutationVariables = Exact<{
  input: IngestEmailInput;
}>;


export type IngestEmailMutation = { ingestEmail:
    | { __typename: 'CommonError', message: string }
    | { __typename: 'IngestEmailSuccess', outcome: IngestOutcome, ingestId: string | null, existingIngestId: string | null, auditId: string, reasonCode: string | null }
   };

export type BusinessEmailConfigQueryVariables = Exact<{
  email: string;
}>;


export type BusinessEmailConfigQuery = { businessEmailConfig: { businessId: string, internalEmailLinks: Array<string> | null, emailBody: boolean | null, attachments: Array<EmailAttachmentType> | null } | null };

export type InsertEmailDocumentsMutationVariables = Exact<{
  documents: Array<File> | File;
  userDescription: string;
  messageId?: string | null | undefined;
  businessId?: string | null | undefined;
}>;


export type InsertEmailDocumentsMutation = { insertEmailDocuments: boolean };

export type UploadPoalimIlsTransactionsMutationVariables = Exact<{
  transactions: Array<PoalimIlsTransactionInput> | PoalimIlsTransactionInput;
}>;


export type UploadPoalimIlsTransactionsMutation = { uploadPoalimIlsTransactions: { inserted: number, skipped: number, insertedIds: Array<string>, insertedTransactions: Array<{ id: string, date: string | null, description: string | null, amount: string | null, account: string | null }>, changedTransactions: Array<{ id: string, changedFields: Array<{ field: string, oldValue: string | null, newValue: string | null }> }> } };

export type UploadPoalimForeignTransactionsMutationVariables = Exact<{
  transactions: Array<PoalimForeignTransactionInput> | PoalimForeignTransactionInput;
}>;


export type UploadPoalimForeignTransactionsMutation = { uploadPoalimForeignTransactions: { inserted: number, skipped: number, insertedIds: Array<string>, insertedTransactions: Array<{ id: string, date: string | null, description: string | null, amount: string | null, account: string | null }>, changedTransactions: Array<{ id: string, changedFields: Array<{ field: string, oldValue: string | null, newValue: string | null }> }> } };

export type UploadPoalimSwiftTransactionsMutationVariables = Exact<{
  swifts: Array<PoalimSwiftTransactionInput> | PoalimSwiftTransactionInput;
}>;


export type UploadPoalimSwiftTransactionsMutation = { uploadPoalimSwiftTransactions: { inserted: number, skipped: number, insertedIds: Array<string>, insertedTransactions: Array<{ id: string, date: string | null, description: string | null, amount: string | null, account: string | null }>, changedTransactions: Array<{ id: string, changedFields: Array<{ field: string, oldValue: string | null, newValue: string | null }> }> } };

export type UploadIsracardTransactionsMutationVariables = Exact<{
  transactions: Array<IsracardTransactionInput> | IsracardTransactionInput;
}>;


export type UploadIsracardTransactionsMutation = { uploadIsracardTransactions: { inserted: number, skipped: number, insertedIds: Array<string>, insertedTransactions: Array<{ id: string, date: string | null, description: string | null, amount: string | null, account: string | null }>, changedTransactions: Array<{ id: string, changedFields: Array<{ field: string, oldValue: string | null, newValue: string | null }> }> } };

export type UploadAmexTransactionsMutationVariables = Exact<{
  transactions: Array<AmexTransactionInput> | AmexTransactionInput;
}>;


export type UploadAmexTransactionsMutation = { uploadAmexTransactions: { inserted: number, skipped: number, insertedIds: Array<string>, insertedTransactions: Array<{ id: string, date: string | null, description: string | null, amount: string | null, account: string | null }>, changedTransactions: Array<{ id: string, changedFields: Array<{ field: string, oldValue: string | null, newValue: string | null }> }> } };

export type UploadCalTransactionsMutationVariables = Exact<{
  transactions: Array<CalTransactionInput> | CalTransactionInput;
}>;


export type UploadCalTransactionsMutation = { uploadCalTransactions: { inserted: number, skipped: number, insertedIds: Array<string>, insertedTransactions: Array<{ id: string, date: string | null, description: string | null, amount: string | null, account: string | null }>, changedTransactions: Array<{ id: string, changedFields: Array<{ field: string, oldValue: string | null, newValue: string | null }> }> } };

export type UploadDiscountTransactionsMutationVariables = Exact<{
  transactions: Array<DiscountTransactionInput> | DiscountTransactionInput;
}>;


export type UploadDiscountTransactionsMutation = { uploadDiscountTransactions: { inserted: number, skipped: number, insertedIds: Array<string>, insertedTransactions: Array<{ id: string, date: string | null, description: string | null, amount: string | null, account: string | null }>, changedTransactions: Array<{ id: string, changedFields: Array<{ field: string, oldValue: string | null, newValue: string | null }> }> } };

export type UploadMaxTransactionsMutationVariables = Exact<{
  transactions: Array<MaxTransactionInput> | MaxTransactionInput;
}>;


export type UploadMaxTransactionsMutation = { uploadMaxTransactions: { inserted: number, skipped: number, insertedIds: Array<string>, insertedTransactions: Array<{ id: string, date: string | null, description: string | null, amount: string | null, account: string | null }>, changedTransactions: Array<{ id: string, changedFields: Array<{ field: string, oldValue: string | null, newValue: string | null }> }> } };

export type UploadCurrencyRatesMutationVariables = Exact<{
  rates: Array<CurrencyRateInput> | CurrencyRateInput;
}>;


export type UploadCurrencyRatesMutation = { uploadCurrencyRates: { inserted: number, skipped: number, insertedIds: Array<string>, insertedTransactions: Array<{ id: string, date: string | null, description: string | null, amount: string | null, account: string | null }>, changedTransactions: Array<{ id: string, changedFields: Array<{ field: string, oldValue: string | null, newValue: string | null }> }> } };

export type UploadOtsarHahayalIlsTransactionsMutationVariables = Exact<{
  transactions: Array<OtsarHahayalIlsTransactionInput> | OtsarHahayalIlsTransactionInput;
}>;


export type UploadOtsarHahayalIlsTransactionsMutation = { uploadOtsarHahayalIlsTransactions: { inserted: number, skipped: number, insertedIds: Array<string>, insertedTransactions: Array<{ id: string, date: string | null, description: string | null, amount: string | null, account: string | null }>, changedTransactions: Array<{ id: string, changedFields: Array<{ field: string, oldValue: string | null, newValue: string | null }> }> } };

export type UploadOtsarHahayalForeignTransactionsMutationVariables = Exact<{
  transactions: Array<OtsarHahayalForeignTransactionInput> | OtsarHahayalForeignTransactionInput;
}>;


export type UploadOtsarHahayalForeignTransactionsMutation = { uploadOtsarHahayalForeignTransactions: { inserted: number, skipped: number, insertedIds: Array<string>, insertedTransactions: Array<{ id: string, date: string | null, description: string | null, amount: string | null, account: string | null }>, changedTransactions: Array<{ id: string, changedFields: Array<{ field: string, oldValue: string | null, newValue: string | null }> }> } };

export type UploadOtsarHahayalCreditCardTransactionsMutationVariables = Exact<{
  transactions: Array<OtsarHahayalCreditCardTransactionInput> | OtsarHahayalCreditCardTransactionInput;
}>;


export type UploadOtsarHahayalCreditCardTransactionsMutation = { uploadOtsarHahayalCreditCardTransactions: { inserted: number, skipped: number, insertedIds: Array<string>, insertedTransactions: Array<{ id: string, date: string | null, description: string | null, amount: string | null, account: string | null }>, changedTransactions: Array<{ id: string, changedFields: Array<{ field: string, oldValue: string | null, newValue: string | null }> }> } };

export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}
export const DepositTransactionFieldsFragmentDoc = new TypedDocumentString(`
    fragment DepositTransactionFields on Transaction {
  id
  eventDate
  chargeId
  amount {
    raw
    formatted
    currency
  }
  debitExchangeRates {
    aud
    cad
    eur
    gbp
    jpy
    sek
    usd
    date
  }
  eventExchangeRates {
    aud
    cad
    eur
    gbp
    jpy
    sek
    usd
    date
  }
}
    `, {"fragmentName":"DepositTransactionFields"}) as unknown as TypedDocumentString<DepositTransactionFieldsFragment, unknown>;
export const BusinessTripsRowFieldsFragmentDoc = new TypedDocumentString(`
    fragment BusinessTripsRowFields on BusinessTrip {
  id
  name
  accountantApproval
}
    `, {"fragmentName":"BusinessTripsRowFields"}) as unknown as TypedDocumentString<BusinessTripsRowFieldsFragment, unknown>;
export const ClientIntegrationsSectionFragmentDoc = new TypedDocumentString(`
    fragment ClientIntegrationsSection on LtdFinancialEntity {
  id
  clientInfo {
    id
    integrations {
      id
      greenInvoiceInfo {
        businessId
        greenInvoiceId
      }
      hiveId
      linearId
      slackChannelKey
      notionId
      workflowyUrl
    }
  }
}
    `, {"fragmentName":"ClientIntegrationsSection"}) as unknown as TypedDocumentString<ClientIntegrationsSectionFragment, unknown>;
export const BusinessHeaderFragmentDoc = new TypedDocumentString(`
    fragment BusinessHeader on Business {
  __typename
  id
  name
  createdAt
  isActive
  ... on LtdFinancialEntity {
    governmentId
    adminInfo {
      id
    }
    clientInfo {
      id
    }
  }
}
    `, {"fragmentName":"BusinessHeader"}) as unknown as TypedDocumentString<BusinessHeaderFragment, unknown>;
export const BusinessContactSectionFragmentDoc = new TypedDocumentString(`
    fragment BusinessContactSection on Business {
  __typename
  id
  ... on LtdFinancialEntity {
    name
    hebrewName
    country {
      id
      code
    }
    governmentId
    address
    city
    zipCode
    email
    phoneNumber
    website
    clientInfo {
      id
      emails
    }
  }
}
    `, {"fragmentName":"BusinessContactSection"}) as unknown as TypedDocumentString<BusinessContactSectionFragment, unknown>;
export const BusinessConfigurationSectionFragmentDoc = new TypedDocumentString(`
    fragment BusinessConfigurationSection on Business {
  __typename
  id
  pcn874RecordType
  irsCode
  isActive
  ownerId
  ... on LtdFinancialEntity {
    optionalVAT
    exemptDealer
    isReceiptEnough
    isDocumentsOptional
    sortCode {
      id
      key
      defaultIrsCode
    }
    taxCategory {
      id
    }
    suggestions {
      phrases
      emails
      tags {
        id
      }
      description
      emailListener {
        internalEmailLinks
        emailBody
        attachments
      }
    }
    clientInfo {
      id
    }
  }
}
    `, {"fragmentName":"BusinessConfigurationSection"}) as unknown as TypedDocumentString<BusinessConfigurationSectionFragment, unknown>;
export const BusinessAdminSectionFragmentDoc = new TypedDocumentString(`
    fragment BusinessAdminSection on Business {
  __typename
  id
  ... on LtdFinancialEntity {
    adminInfo {
      id
      registrationDate
      withholdingTaxAnnualIds {
        id
        year
      }
      withholdingTaxCompanyId
      socialSecurityEmployerIds {
        id
        year
      }
      socialSecurityDeductionsId
      taxAdvancesAnnualIds {
        id
        year
      }
      taxAdvancesRates {
        date
        rate
      }
    }
  }
}
    `, {"fragmentName":"BusinessAdminSection"}) as unknown as TypedDocumentString<BusinessAdminSectionFragment, unknown>;
export const BusinessPageFragmentDoc = new TypedDocumentString(`
    fragment BusinessPage on Business {
  id
  ... on LtdFinancialEntity {
    clientInfo {
      id
    }
    adminInfo {
      id
    }
  }
  ...ClientIntegrationsSection
  ...BusinessHeader
  ...BusinessContactSection
  ...BusinessConfigurationSection
  ...BusinessAdminSection
}
    fragment BusinessAdminSection on Business {
  __typename
  id
  ... on LtdFinancialEntity {
    adminInfo {
      id
      registrationDate
      withholdingTaxAnnualIds {
        id
        year
      }
      withholdingTaxCompanyId
      socialSecurityEmployerIds {
        id
        year
      }
      socialSecurityDeductionsId
      taxAdvancesAnnualIds {
        id
        year
      }
      taxAdvancesRates {
        date
        rate
      }
    }
  }
}
fragment BusinessHeader on Business {
  __typename
  id
  name
  createdAt
  isActive
  ... on LtdFinancialEntity {
    governmentId
    adminInfo {
      id
    }
    clientInfo {
      id
    }
  }
}
fragment ClientIntegrationsSection on LtdFinancialEntity {
  id
  clientInfo {
    id
    integrations {
      id
      greenInvoiceInfo {
        businessId
        greenInvoiceId
      }
      hiveId
      linearId
      slackChannelKey
      notionId
      workflowyUrl
    }
  }
}
fragment BusinessConfigurationSection on Business {
  __typename
  id
  pcn874RecordType
  irsCode
  isActive
  ownerId
  ... on LtdFinancialEntity {
    optionalVAT
    exemptDealer
    isReceiptEnough
    isDocumentsOptional
    sortCode {
      id
      key
      defaultIrsCode
    }
    taxCategory {
      id
    }
    suggestions {
      phrases
      emails
      tags {
        id
      }
      description
      emailListener {
        internalEmailLinks
        emailBody
        attachments
      }
    }
    clientInfo {
      id
    }
  }
}
fragment BusinessContactSection on Business {
  __typename
  id
  ... on LtdFinancialEntity {
    name
    hebrewName
    country {
      id
      code
    }
    governmentId
    address
    city
    zipCode
    email
    phoneNumber
    website
    clientInfo {
      id
      emails
    }
  }
}`, {"fragmentName":"BusinessPage"}) as unknown as TypedDocumentString<BusinessPageFragment, unknown>;
export const ChargeMatchesTableFieldsFragmentDoc = new TypedDocumentString(`
    fragment ChargeMatchesTableFields on ChargeMatch {
  charge {
    id
    __typename
    minEventDate
    minDebitDate
    minDocumentsDate
    totalAmount {
      raw
      formatted
    }
    vat {
      raw
      formatted
    }
    counterparty {
      name
      id
    }
    userDescription
    tags {
      id
      name
      namePath
    }
    taxCategory {
      id
      name
    }
  }
  confidenceScore
}
    `, {"fragmentName":"ChargeMatchesTableFields"}) as unknown as TypedDocumentString<ChargeMatchesTableFieldsFragment, unknown>;
export const ChargeMatchCardFieldsFragmentDoc = new TypedDocumentString(`
    fragment ChargeMatchCardFields on Charge {
  __typename
  id
  minEventDate
  minDebitDate
  minDocumentsDate
  totalAmount {
    raw
    formatted
    currency
  }
  counterparty {
    id
    name
  }
  userDescription
  additionalDocuments {
    id
    documentType
    image
    file
  }
  transactions {
    id
    eventDate
    sourceDescription
    amount {
      raw
      formatted
    }
  }
  miscExpenses {
    id
    description
    amount {
      formatted
    }
  }
}
    `, {"fragmentName":"ChargeMatchCardFields"}) as unknown as TypedDocumentString<ChargeMatchCardFieldsFragment, unknown>;
export const DocumentsGalleryFieldsFragmentDoc = new TypedDocumentString(`
    fragment DocumentsGalleryFields on Charge {
  id
  additionalDocuments {
    id
    image
    ... on FinancialDocument {
      documentType
    }
  }
}
    `, {"fragmentName":"DocumentsGalleryFields"}) as unknown as TypedDocumentString<DocumentsGalleryFieldsFragment, unknown>;
export const TableDocumentsRowFieldsFragmentDoc = new TypedDocumentString(`
    fragment TableDocumentsRowFields on Document {
  id
  documentType
  image
  file
  description
  remarks
  charge {
    id
  }
  ... on FinancialDocument {
    amount {
      raw
      formatted
      currency
    }
    missingInfoSuggestions {
      amount {
        raw
        formatted
        currency
      }
      isIncome
      counterparty {
        id
        name
      }
      owner {
        id
        name
      }
    }
    date
    vat {
      raw
      formatted
      currency
    }
    serialNumber
    allocationNumber
    creditor {
      id
      name
    }
    debtor {
      id
      name
    }
    issuedDocumentInfo {
      id
      status
      originalDocument {
        income {
          description
        }
      }
    }
  }
}
    `, {"fragmentName":"TableDocumentsRowFields"}) as unknown as TypedDocumentString<TableDocumentsRowFieldsFragment, unknown>;
export const TableDocumentsFieldsFragmentDoc = new TypedDocumentString(`
    fragment TableDocumentsFields on Charge {
  id
  additionalDocuments {
    id
    ...TableDocumentsRowFields
  }
}
    fragment TableDocumentsRowFields on Document {
  id
  documentType
  image
  file
  description
  remarks
  charge {
    id
  }
  ... on FinancialDocument {
    amount {
      raw
      formatted
      currency
    }
    missingInfoSuggestions {
      amount {
        raw
        formatted
        currency
      }
      isIncome
      counterparty {
        id
        name
      }
      owner {
        id
        name
      }
    }
    date
    vat {
      raw
      formatted
      currency
    }
    serialNumber
    allocationNumber
    creditor {
      id
      name
    }
    debtor {
      id
      name
    }
    issuedDocumentInfo {
      id
      status
      originalDocument {
        income {
          description
        }
      }
    }
  }
}`, {"fragmentName":"TableDocumentsFields"}) as unknown as TypedDocumentString<TableDocumentsFieldsFragment, unknown>;
export const LedgerRecordsTableFieldsFragmentDoc = new TypedDocumentString(`
    fragment LedgerRecordsTableFields on LedgerRecord {
  id
  creditAccount1 {
    __typename
    id
    name
  }
  creditAccount2 {
    __typename
    id
    name
  }
  debitAccount1 {
    __typename
    id
    name
  }
  debitAccount2 {
    __typename
    id
    name
  }
  creditAmount1 {
    formatted
    currency
  }
  creditAmount2 {
    formatted
    currency
  }
  debitAmount1 {
    formatted
    currency
  }
  debitAmount2 {
    formatted
    currency
  }
  localCurrencyCreditAmount1 {
    formatted
    raw
  }
  localCurrencyCreditAmount2 {
    formatted
    raw
  }
  localCurrencyDebitAmount1 {
    formatted
    raw
  }
  localCurrencyDebitAmount2 {
    formatted
    raw
  }
  invoiceDate
  valueDate
  description
  reference
}
    `, {"fragmentName":"LedgerRecordsTableFields"}) as unknown as TypedDocumentString<LedgerRecordsTableFieldsFragment, unknown>;
export const ChargeLedgerRecordsTableFieldsFragmentDoc = new TypedDocumentString(`
    fragment ChargeLedgerRecordsTableFields on Charge {
  id
  ledger {
    __typename
    records {
      id
      ...LedgerRecordsTableFields
    }
    ... on Ledger @defer {
      validate {
        ... on LedgerValidation @defer {
          matches
          differences {
            id
            ...LedgerRecordsTableFields
          }
        }
      }
    }
  }
}
    fragment LedgerRecordsTableFields on LedgerRecord {
  id
  creditAccount1 {
    __typename
    id
    name
  }
  creditAccount2 {
    __typename
    id
    name
  }
  debitAccount1 {
    __typename
    id
    name
  }
  debitAccount2 {
    __typename
    id
    name
  }
  creditAmount1 {
    formatted
    currency
  }
  creditAmount2 {
    formatted
    currency
  }
  debitAmount1 {
    formatted
    currency
  }
  debitAmount2 {
    formatted
    currency
  }
  localCurrencyCreditAmount1 {
    formatted
    raw
  }
  localCurrencyCreditAmount2 {
    formatted
    raw
  }
  localCurrencyDebitAmount1 {
    formatted
    raw
  }
  localCurrencyDebitAmount2 {
    formatted
    raw
  }
  invoiceDate
  valueDate
  description
  reference
}`, {"fragmentName":"ChargeLedgerRecordsTableFields"}) as unknown as TypedDocumentString<ChargeLedgerRecordsTableFieldsFragment, unknown>;
export const TransactionForTransactionsTableFieldsFragmentDoc = new TypedDocumentString(`
    fragment TransactionForTransactionsTableFields on Transaction {
  id
  isFee
  chargeId
  eventDate
  effectiveDate
  sourceEffectiveDate
  amount {
    raw
    formatted
  }
  cryptoExchangeRate {
    rate
  }
  account {
    id
    name
    type
  }
  sourceDescription
  referenceKey
  counterparty {
    name
    id
  }
  missingInfoSuggestions {
    business {
      id
      name
    }
  }
}
    `, {"fragmentName":"TransactionForTransactionsTableFields"}) as unknown as TypedDocumentString<TransactionForTransactionsTableFieldsFragment, unknown>;
export const ChargeTableTransactionsFieldsFragmentDoc = new TypedDocumentString(`
    fragment ChargeTableTransactionsFields on Charge {
  id
  transactions {
    id
    ...TransactionForTransactionsTableFields
  }
}
    fragment TransactionForTransactionsTableFields on Transaction {
  id
  isFee
  chargeId
  eventDate
  effectiveDate
  sourceEffectiveDate
  amount {
    raw
    formatted
  }
  cryptoExchangeRate {
    rate
  }
  account {
    id
    name
    type
  }
  sourceDescription
  referenceKey
  counterparty {
    name
    id
  }
  missingInfoSuggestions {
    business {
      id
      name
    }
  }
}`, {"fragmentName":"ChargeTableTransactionsFields"}) as unknown as TypedDocumentString<ChargeTableTransactionsFieldsFragment, unknown>;
export const ConversionChargeInfoFragmentDoc = new TypedDocumentString(`
    fragment ConversionChargeInfo on Charge {
  id
  __typename
  ... on ConversionCharge {
    eventRate {
      from
      to
      rate
    }
    officialRate {
      from
      to
      rate
    }
  }
}
    `, {"fragmentName":"ConversionChargeInfo"}) as unknown as TypedDocumentString<ConversionChargeInfoFragment, unknown>;
export const CreditcardBankChargeInfoFragmentDoc = new TypedDocumentString(`
    fragment CreditcardBankChargeInfo on Charge {
  id
  __typename
  ... on CreditcardBankCharge {
    creditCardTransactions {
      id
      ...TransactionForTransactionsTableFields
    }
  }
}
    fragment TransactionForTransactionsTableFields on Transaction {
  id
  isFee
  chargeId
  eventDate
  effectiveDate
  sourceEffectiveDate
  amount {
    raw
    formatted
  }
  cryptoExchangeRate {
    rate
  }
  account {
    id
    name
    type
  }
  sourceDescription
  referenceKey
  counterparty {
    name
    id
  }
  missingInfoSuggestions {
    business {
      id
      name
    }
  }
}`, {"fragmentName":"CreditcardBankChargeInfo"}) as unknown as TypedDocumentString<CreditcardBankChargeInfoFragment, unknown>;
export const TableSalariesFieldsFragmentDoc = new TypedDocumentString(`
    fragment TableSalariesFields on Charge {
  id
  __typename
  ... on SalaryCharge {
    salaryRecords {
      directAmount {
        formatted
      }
      baseAmount {
        formatted
      }
      employee {
        id
        name
      }
      pensionFund {
        id
        name
      }
      pensionEmployeeAmount {
        formatted
      }
      pensionEmployerAmount {
        formatted
      }
      compensationsAmount {
        formatted
      }
      trainingFund {
        id
        name
      }
      trainingFundEmployeeAmount {
        formatted
      }
      trainingFundEmployerAmount {
        formatted
      }
      socialSecurityEmployeeAmount {
        formatted
      }
      socialSecurityEmployerAmount {
        formatted
      }
      incomeTaxAmount {
        formatted
      }
      healthInsuranceAmount {
        formatted
      }
    }
  }
}
    `, {"fragmentName":"TableSalariesFields"}) as unknown as TypedDocumentString<TableSalariesFieldsFragment, unknown>;
export const BusinessTripAccountantApprovalFieldsFragmentDoc = new TypedDocumentString(`
    fragment BusinessTripAccountantApprovalFields on BusinessTrip {
  id
  accountantApproval
}
    `, {"fragmentName":"BusinessTripAccountantApprovalFields"}) as unknown as TypedDocumentString<BusinessTripAccountantApprovalFieldsFragment, unknown>;
export const BusinessTripReportHeaderFieldsFragmentDoc = new TypedDocumentString(`
    fragment BusinessTripReportHeaderFields on BusinessTrip {
  id
  name
  dates {
    start
    end
  }
  purpose
  destination {
    id
    name
  }
  ...BusinessTripAccountantApprovalFields
}
    fragment BusinessTripAccountantApprovalFields on BusinessTrip {
  id
  accountantApproval
}`, {"fragmentName":"BusinessTripReportHeaderFields"}) as unknown as TypedDocumentString<BusinessTripReportHeaderFieldsFragment, unknown>;
export const BusinessTripReportSummaryFieldsFragmentDoc = new TypedDocumentString(`
    fragment BusinessTripReportSummaryFields on BusinessTrip {
  id
  ... on BusinessTrip @defer {
    summary {
      excessExpenditure {
        formatted
      }
      excessTax
      rows {
        type
        totalForeignCurrency {
          formatted
        }
        totalLocalCurrency {
          formatted
        }
        taxableForeignCurrency {
          formatted
        }
        taxableLocalCurrency {
          formatted
        }
        maxTaxableForeignCurrency {
          formatted
        }
        maxTaxableLocalCurrency {
          formatted
        }
        excessExpenditure {
          formatted
        }
      }
      errors
    }
  }
}
    `, {"fragmentName":"BusinessTripReportSummaryFields"}) as unknown as TypedDocumentString<BusinessTripReportSummaryFieldsFragment, unknown>;
export const BusinessTripReportFieldsFragmentDoc = new TypedDocumentString(`
    fragment BusinessTripReportFields on BusinessTrip {
  id
  ...BusinessTripReportHeaderFields
  ...BusinessTripReportSummaryFields
}
    fragment BusinessTripAccountantApprovalFields on BusinessTrip {
  id
  accountantApproval
}
fragment BusinessTripReportHeaderFields on BusinessTrip {
  id
  name
  dates {
    start
    end
  }
  purpose
  destination {
    id
    name
  }
  ...BusinessTripAccountantApprovalFields
}
fragment BusinessTripReportSummaryFields on BusinessTrip {
  id
  ... on BusinessTrip @defer {
    summary {
      excessExpenditure {
        formatted
      }
      excessTax
      rows {
        type
        totalForeignCurrency {
          formatted
        }
        totalLocalCurrency {
          formatted
        }
        taxableForeignCurrency {
          formatted
        }
        taxableLocalCurrency {
          formatted
        }
        maxTaxableForeignCurrency {
          formatted
        }
        maxTaxableLocalCurrency {
          formatted
        }
        excessExpenditure {
          formatted
        }
      }
      errors
    }
  }
}`, {"fragmentName":"BusinessTripReportFields"}) as unknown as TypedDocumentString<BusinessTripReportFieldsFragment, unknown>;
export const ChargesTableErrorsFieldsFragmentDoc = new TypedDocumentString(`
    fragment ChargesTableErrorsFields on Charge {
  id
  errorsLedger: ledger {
    validate {
      errors
    }
  }
}
    `, {"fragmentName":"ChargesTableErrorsFields"}) as unknown as TypedDocumentString<ChargesTableErrorsFieldsFragment, unknown>;
export const EditMiscExpenseFieldsFragmentDoc = new TypedDocumentString(`
    fragment EditMiscExpenseFields on MiscExpense {
  id
  amount {
    raw
    currency
  }
  description
  invoiceDate
  valueDate
  creditor {
    id
  }
  debtor {
    id
  }
}
    `, {"fragmentName":"EditMiscExpenseFields"}) as unknown as TypedDocumentString<EditMiscExpenseFieldsFragment, unknown>;
export const TableMiscExpensesFieldsFragmentDoc = new TypedDocumentString(`
    fragment TableMiscExpensesFields on Charge {
  id
  miscExpenses {
    id
    amount {
      formatted
    }
    description
    invoiceDate
    valueDate
    creditor {
      id
      name
    }
    debtor {
      id
      name
    }
    chargeId
    ...EditMiscExpenseFields
  }
}
    fragment EditMiscExpenseFields on MiscExpense {
  id
  amount {
    raw
    currency
  }
  description
  invoiceDate
  valueDate
  creditor {
    id
  }
  debtor {
    id
  }
}`, {"fragmentName":"TableMiscExpensesFields"}) as unknown as TypedDocumentString<TableMiscExpensesFieldsFragment, unknown>;
export const ExchangeRatesInfoFragmentDoc = new TypedDocumentString(`
    fragment ExchangeRatesInfo on Charge {
  id
  __typename
  ... on FinancialCharge {
    exchangeRates {
      aud
      cad
      eur
      gbp
      ils
      jpy
      sek
      usd
      eth
      grt
      usdc
    }
  }
}
    `, {"fragmentName":"ExchangeRatesInfo"}) as unknown as TypedDocumentString<ExchangeRatesInfoFragment, unknown>;
export const ChargeExpansionFieldsFragmentDoc = new TypedDocumentString(`
    fragment ChargeExpansionFields on Charge {
  id
  __typename
  metadata {
    transactionsCount
    documentsCount
    receiptsCount
    invoicesCount
    ledgerCount
    miscExpensesCount
    isLedgerLocked
    openDocuments
  }
  totalAmount {
    raw
  }
  ...DocumentsGalleryFields @defer
  ...TableDocumentsFields @defer
  ...ChargeLedgerRecordsTableFields @defer
  ...ChargeTableTransactionsFields @defer
  ...ConversionChargeInfo @defer
  ...CreditcardBankChargeInfo @defer
  ...TableSalariesFields @defer
  ... on BusinessTripCharge {
    businessTrip {
      id
      ...BusinessTripReportFields
    }
  }
  ...ChargesTableErrorsFields @defer
  ...TableMiscExpensesFields @defer
  ...ExchangeRatesInfo @defer
}
    fragment ChargesTableErrorsFields on Charge {
  id
  errorsLedger: ledger {
    validate {
      errors
    }
  }
}
fragment TableDocumentsFields on Charge {
  id
  additionalDocuments {
    id
    ...TableDocumentsRowFields
  }
}
fragment ChargeLedgerRecordsTableFields on Charge {
  id
  ledger {
    __typename
    records {
      id
      ...LedgerRecordsTableFields
    }
    ... on Ledger @defer {
      validate {
        ... on LedgerValidation @defer {
          matches
          differences {
            id
            ...LedgerRecordsTableFields
          }
        }
      }
    }
  }
}
fragment ChargeTableTransactionsFields on Charge {
  id
  transactions {
    id
    ...TransactionForTransactionsTableFields
  }
}
fragment ConversionChargeInfo on Charge {
  id
  __typename
  ... on ConversionCharge {
    eventRate {
      from
      to
      rate
    }
    officialRate {
      from
      to
      rate
    }
  }
}
fragment CreditcardBankChargeInfo on Charge {
  id
  __typename
  ... on CreditcardBankCharge {
    creditCardTransactions {
      id
      ...TransactionForTransactionsTableFields
    }
  }
}
fragment ExchangeRatesInfo on Charge {
  id
  __typename
  ... on FinancialCharge {
    exchangeRates {
      aud
      cad
      eur
      gbp
      ils
      jpy
      sek
      usd
      eth
      grt
      usdc
    }
  }
}
fragment TableMiscExpensesFields on Charge {
  id
  miscExpenses {
    id
    amount {
      formatted
    }
    description
    invoiceDate
    valueDate
    creditor {
      id
      name
    }
    debtor {
      id
      name
    }
    chargeId
    ...EditMiscExpenseFields
  }
}
fragment TableSalariesFields on Charge {
  id
  __typename
  ... on SalaryCharge {
    salaryRecords {
      directAmount {
        formatted
      }
      baseAmount {
        formatted
      }
      employee {
        id
        name
      }
      pensionFund {
        id
        name
      }
      pensionEmployeeAmount {
        formatted
      }
      pensionEmployerAmount {
        formatted
      }
      compensationsAmount {
        formatted
      }
      trainingFund {
        id
        name
      }
      trainingFundEmployeeAmount {
        formatted
      }
      trainingFundEmployerAmount {
        formatted
      }
      socialSecurityEmployeeAmount {
        formatted
      }
      socialSecurityEmployerAmount {
        formatted
      }
      incomeTaxAmount {
        formatted
      }
      healthInsuranceAmount {
        formatted
      }
    }
  }
}
fragment BusinessTripReportFields on BusinessTrip {
  id
  ...BusinessTripReportHeaderFields
  ...BusinessTripReportSummaryFields
}
fragment BusinessTripAccountantApprovalFields on BusinessTrip {
  id
  accountantApproval
}
fragment BusinessTripReportHeaderFields on BusinessTrip {
  id
  name
  dates {
    start
    end
  }
  purpose
  destination {
    id
    name
  }
  ...BusinessTripAccountantApprovalFields
}
fragment BusinessTripReportSummaryFields on BusinessTrip {
  id
  ... on BusinessTrip @defer {
    summary {
      excessExpenditure {
        formatted
      }
      excessTax
      rows {
        type
        totalForeignCurrency {
          formatted
        }
        totalLocalCurrency {
          formatted
        }
        taxableForeignCurrency {
          formatted
        }
        taxableLocalCurrency {
          formatted
        }
        maxTaxableForeignCurrency {
          formatted
        }
        maxTaxableLocalCurrency {
          formatted
        }
        excessExpenditure {
          formatted
        }
      }
      errors
    }
  }
}
fragment EditMiscExpenseFields on MiscExpense {
  id
  amount {
    raw
    currency
  }
  description
  invoiceDate
  valueDate
  creditor {
    id
  }
  debtor {
    id
  }
}
fragment TableDocumentsRowFields on Document {
  id
  documentType
  image
  file
  description
  remarks
  charge {
    id
  }
  ... on FinancialDocument {
    amount {
      raw
      formatted
      currency
    }
    missingInfoSuggestions {
      amount {
        raw
        formatted
        currency
      }
      isIncome
      counterparty {
        id
        name
      }
      owner {
        id
        name
      }
    }
    date
    vat {
      raw
      formatted
      currency
    }
    serialNumber
    allocationNumber
    creditor {
      id
      name
    }
    debtor {
      id
      name
    }
    issuedDocumentInfo {
      id
      status
      originalDocument {
        income {
          description
        }
      }
    }
  }
}
fragment DocumentsGalleryFields on Charge {
  id
  additionalDocuments {
    id
    image
    ... on FinancialDocument {
      documentType
    }
  }
}
fragment LedgerRecordsTableFields on LedgerRecord {
  id
  creditAccount1 {
    __typename
    id
    name
  }
  creditAccount2 {
    __typename
    id
    name
  }
  debitAccount1 {
    __typename
    id
    name
  }
  debitAccount2 {
    __typename
    id
    name
  }
  creditAmount1 {
    formatted
    currency
  }
  creditAmount2 {
    formatted
    currency
  }
  debitAmount1 {
    formatted
    currency
  }
  debitAmount2 {
    formatted
    currency
  }
  localCurrencyCreditAmount1 {
    formatted
    raw
  }
  localCurrencyCreditAmount2 {
    formatted
    raw
  }
  localCurrencyDebitAmount1 {
    formatted
    raw
  }
  localCurrencyDebitAmount2 {
    formatted
    raw
  }
  invoiceDate
  valueDate
  description
  reference
}
fragment TransactionForTransactionsTableFields on Transaction {
  id
  isFee
  chargeId
  eventDate
  effectiveDate
  sourceEffectiveDate
  amount {
    raw
    formatted
  }
  cryptoExchangeRate {
    rate
  }
  account {
    id
    name
    type
  }
  sourceDescription
  referenceKey
  counterparty {
    name
    id
  }
  missingInfoSuggestions {
    business {
      id
      name
    }
  }
}`, {"fragmentName":"ChargeExpansionFields","deferredFields":{"DocumentsGalleryFields":["id","additionalDocuments"],"TableDocumentsFields":["id","additionalDocuments"],"ChargeLedgerRecordsTableFields":["id","ledger"],"ChargeTableTransactionsFields":["id","transactions"],"ConversionChargeInfo":["id","__typename"],"CreditcardBankChargeInfo":["id","__typename"],"TableSalariesFields":["id","__typename"],"ChargesTableErrorsFields":["id","ledger"],"TableMiscExpensesFields":["id","miscExpenses"],"ExchangeRatesInfo":["id","__typename"]}}) as unknown as TypedDocumentString<ChargeExpansionFieldsFragment, unknown>;
export const ChargeForCsvExportFieldsFragmentDoc = new TypedDocumentString(`
    fragment ChargeForCsvExportFields on Charge {
  id
  __typename
  minEventDate
  minDebitDate
  minDocumentsDate
  totalAmount {
    raw
    currency
  }
  vat {
    raw
  }
  counterparty {
    id
    name
  }
  userDescription
  tags {
    id
    name
  }
  taxCategory {
    id
    name
  }
  accountantApproval
  validationData {
    isValid
    missingInfo
  }
  missingInfoSuggestions {
    description
    tags {
      id
      name
    }
  }
  metadata {
    transactionsCount
    documentsCount
    invoicesCount
    receiptsCount
    ledgerCount
    miscExpensesCount
    openDocuments
    invalidLedger
  }
  ledger {
    balance {
      isBalanced
    }
    validate {
      isValid
      errors
    }
  }
  transactions {
    id
    ...TransactionForTransactionsTableFields
  }
  additionalDocuments {
    id
    ...TableDocumentsRowFields
  }
  ... on BusinessTripCharge {
    businessTrip {
      id
      name
    }
  }
  ... on CreditcardBankCharge {
    validCreditCardAmount
  }
}
    fragment TableDocumentsRowFields on Document {
  id
  documentType
  image
  file
  description
  remarks
  charge {
    id
  }
  ... on FinancialDocument {
    amount {
      raw
      formatted
      currency
    }
    missingInfoSuggestions {
      amount {
        raw
        formatted
        currency
      }
      isIncome
      counterparty {
        id
        name
      }
      owner {
        id
        name
      }
    }
    date
    vat {
      raw
      formatted
      currency
    }
    serialNumber
    allocationNumber
    creditor {
      id
      name
    }
    debtor {
      id
      name
    }
    issuedDocumentInfo {
      id
      status
      originalDocument {
        income {
          description
        }
      }
    }
  }
}
fragment TransactionForTransactionsTableFields on Transaction {
  id
  isFee
  chargeId
  eventDate
  effectiveDate
  sourceEffectiveDate
  amount {
    raw
    formatted
  }
  cryptoExchangeRate {
    rate
  }
  account {
    id
    name
    type
  }
  sourceDescription
  referenceKey
  counterparty {
    name
    id
  }
  missingInfoSuggestions {
    business {
      id
      name
    }
  }
}`, {"fragmentName":"ChargeForCsvExportFields"}) as unknown as TypedDocumentString<ChargeForCsvExportFieldsFragment, unknown>;
export const MonthlyIncomeExpenseChartInfoFragmentDoc = new TypedDocumentString(`
    fragment MonthlyIncomeExpenseChartInfo on IncomeExpenseChart {
  monthlyData {
    income {
      formatted
      raw
    }
    expense {
      formatted
      raw
    }
    balance {
      formatted
      raw
    }
    date
  }
}
    `, {"fragmentName":"MonthlyIncomeExpenseChartInfo"}) as unknown as TypedDocumentString<MonthlyIncomeExpenseChartInfoFragment, unknown>;
export const BusinessTripReportCoreExpenseRowFieldsFragmentDoc = new TypedDocumentString(`
    fragment BusinessTripReportCoreExpenseRowFields on BusinessTripExpense {
  id
  date
  valueDate
  amount {
    formatted
    raw
    currency
  }
  employee {
    id
    name
  }
  payedByEmployee
  charges {
    id
  }
}
    `, {"fragmentName":"BusinessTripReportCoreExpenseRowFields"}) as unknown as TypedDocumentString<BusinessTripReportCoreExpenseRowFieldsFragment, unknown>;
export const BusinessTripReportAccommodationsRowFieldsFragmentDoc = new TypedDocumentString(`
    fragment BusinessTripReportAccommodationsRowFields on BusinessTripAccommodationExpense {
  id
  ...BusinessTripReportCoreExpenseRowFields
  payedByEmployee
  country {
    id
    name
  }
  nightsCount
  attendeesStay {
    id
    attendee {
      id
      name
    }
    nightsCount
  }
}
    fragment BusinessTripReportCoreExpenseRowFields on BusinessTripExpense {
  id
  date
  valueDate
  amount {
    formatted
    raw
    currency
  }
  employee {
    id
    name
  }
  payedByEmployee
  charges {
    id
  }
}`, {"fragmentName":"BusinessTripReportAccommodationsRowFields"}) as unknown as TypedDocumentString<BusinessTripReportAccommodationsRowFieldsFragment, unknown>;
export const BusinessTripReportAccommodationsTableFieldsFragmentDoc = new TypedDocumentString(`
    fragment BusinessTripReportAccommodationsTableFields on BusinessTripAccommodationExpense {
  id
  date
  ...BusinessTripReportAccommodationsRowFields
}
    fragment BusinessTripReportAccommodationsRowFields on BusinessTripAccommodationExpense {
  id
  ...BusinessTripReportCoreExpenseRowFields
  payedByEmployee
  country {
    id
    name
  }
  nightsCount
  attendeesStay {
    id
    attendee {
      id
      name
    }
    nightsCount
  }
}
fragment BusinessTripReportCoreExpenseRowFields on BusinessTripExpense {
  id
  date
  valueDate
  amount {
    formatted
    raw
    currency
  }
  employee {
    id
    name
  }
  payedByEmployee
  charges {
    id
  }
}`, {"fragmentName":"BusinessTripReportAccommodationsTableFields"}) as unknown as TypedDocumentString<BusinessTripReportAccommodationsTableFieldsFragment, unknown>;
export const BusinessTripReportAccommodationsFieldsFragmentDoc = new TypedDocumentString(`
    fragment BusinessTripReportAccommodationsFields on BusinessTrip {
  id
  accommodationExpenses {
    id
    ...BusinessTripReportAccommodationsTableFields
  }
}
    fragment BusinessTripReportAccommodationsRowFields on BusinessTripAccommodationExpense {
  id
  ...BusinessTripReportCoreExpenseRowFields
  payedByEmployee
  country {
    id
    name
  }
  nightsCount
  attendeesStay {
    id
    attendee {
      id
      name
    }
    nightsCount
  }
}
fragment BusinessTripReportAccommodationsTableFields on BusinessTripAccommodationExpense {
  id
  date
  ...BusinessTripReportAccommodationsRowFields
}
fragment BusinessTripReportCoreExpenseRowFields on BusinessTripExpense {
  id
  date
  valueDate
  amount {
    formatted
    raw
    currency
  }
  employee {
    id
    name
  }
  payedByEmployee
  charges {
    id
  }
}`, {"fragmentName":"BusinessTripReportAccommodationsFields"}) as unknown as TypedDocumentString<BusinessTripReportAccommodationsFieldsFragment, unknown>;
export const BusinessTripReportFlightsRowFieldsFragmentDoc = new TypedDocumentString(`
    fragment BusinessTripReportFlightsRowFields on BusinessTripFlightExpense {
  id
  payedByEmployee
  ...BusinessTripReportCoreExpenseRowFields
  path
  class
  attendees {
    id
    name
  }
}
    fragment BusinessTripReportCoreExpenseRowFields on BusinessTripExpense {
  id
  date
  valueDate
  amount {
    formatted
    raw
    currency
  }
  employee {
    id
    name
  }
  payedByEmployee
  charges {
    id
  }
}`, {"fragmentName":"BusinessTripReportFlightsRowFields"}) as unknown as TypedDocumentString<BusinessTripReportFlightsRowFieldsFragment, unknown>;
export const BusinessTripReportFlightsTableFieldsFragmentDoc = new TypedDocumentString(`
    fragment BusinessTripReportFlightsTableFields on BusinessTripFlightExpense {
  id
  date
  ...BusinessTripReportFlightsRowFields
}
    fragment BusinessTripReportCoreExpenseRowFields on BusinessTripExpense {
  id
  date
  valueDate
  amount {
    formatted
    raw
    currency
  }
  employee {
    id
    name
  }
  payedByEmployee
  charges {
    id
  }
}
fragment BusinessTripReportFlightsRowFields on BusinessTripFlightExpense {
  id
  payedByEmployee
  ...BusinessTripReportCoreExpenseRowFields
  path
  class
  attendees {
    id
    name
  }
}`, {"fragmentName":"BusinessTripReportFlightsTableFields"}) as unknown as TypedDocumentString<BusinessTripReportFlightsTableFieldsFragment, unknown>;
export const BusinessTripReportAttendeeRowFieldsFragmentDoc = new TypedDocumentString(`
    fragment BusinessTripReportAttendeeRowFields on BusinessTripAttendee {
  id
  name
  arrivalDate
  departureDate
  flights {
    id
    ...BusinessTripReportFlightsTableFields
  }
  accommodations {
    id
    ...BusinessTripReportAccommodationsTableFields
  }
}
    fragment BusinessTripReportAccommodationsRowFields on BusinessTripAccommodationExpense {
  id
  ...BusinessTripReportCoreExpenseRowFields
  payedByEmployee
  country {
    id
    name
  }
  nightsCount
  attendeesStay {
    id
    attendee {
      id
      name
    }
    nightsCount
  }
}
fragment BusinessTripReportAccommodationsTableFields on BusinessTripAccommodationExpense {
  id
  date
  ...BusinessTripReportAccommodationsRowFields
}
fragment BusinessTripReportCoreExpenseRowFields on BusinessTripExpense {
  id
  date
  valueDate
  amount {
    formatted
    raw
    currency
  }
  employee {
    id
    name
  }
  payedByEmployee
  charges {
    id
  }
}
fragment BusinessTripReportFlightsRowFields on BusinessTripFlightExpense {
  id
  payedByEmployee
  ...BusinessTripReportCoreExpenseRowFields
  path
  class
  attendees {
    id
    name
  }
}
fragment BusinessTripReportFlightsTableFields on BusinessTripFlightExpense {
  id
  date
  ...BusinessTripReportFlightsRowFields
}`, {"fragmentName":"BusinessTripReportAttendeeRowFields"}) as unknown as TypedDocumentString<BusinessTripReportAttendeeRowFieldsFragment, unknown>;
export const BusinessTripReportAttendeesFieldsFragmentDoc = new TypedDocumentString(`
    fragment BusinessTripReportAttendeesFields on BusinessTrip {
  id
  attendees {
    id
    name
    ...BusinessTripReportAttendeeRowFields
  }
}
    fragment BusinessTripReportAccommodationsRowFields on BusinessTripAccommodationExpense {
  id
  ...BusinessTripReportCoreExpenseRowFields
  payedByEmployee
  country {
    id
    name
  }
  nightsCount
  attendeesStay {
    id
    attendee {
      id
      name
    }
    nightsCount
  }
}
fragment BusinessTripReportAccommodationsTableFields on BusinessTripAccommodationExpense {
  id
  date
  ...BusinessTripReportAccommodationsRowFields
}
fragment BusinessTripReportAttendeeRowFields on BusinessTripAttendee {
  id
  name
  arrivalDate
  departureDate
  flights {
    id
    ...BusinessTripReportFlightsTableFields
  }
  accommodations {
    id
    ...BusinessTripReportAccommodationsTableFields
  }
}
fragment BusinessTripReportCoreExpenseRowFields on BusinessTripExpense {
  id
  date
  valueDate
  amount {
    formatted
    raw
    currency
  }
  employee {
    id
    name
  }
  payedByEmployee
  charges {
    id
  }
}
fragment BusinessTripReportFlightsRowFields on BusinessTripFlightExpense {
  id
  payedByEmployee
  ...BusinessTripReportCoreExpenseRowFields
  path
  class
  attendees {
    id
    name
  }
}
fragment BusinessTripReportFlightsTableFields on BusinessTripFlightExpense {
  id
  date
  ...BusinessTripReportFlightsRowFields
}`, {"fragmentName":"BusinessTripReportAttendeesFields"}) as unknown as TypedDocumentString<BusinessTripReportAttendeesFieldsFragment, unknown>;
export const BusinessTripReportCarRentalRowFieldsFragmentDoc = new TypedDocumentString(`
    fragment BusinessTripReportCarRentalRowFields on BusinessTripCarRentalExpense {
  id
  payedByEmployee
  ...BusinessTripReportCoreExpenseRowFields
  days
  isFuelExpense
}
    fragment BusinessTripReportCoreExpenseRowFields on BusinessTripExpense {
  id
  date
  valueDate
  amount {
    formatted
    raw
    currency
  }
  employee {
    id
    name
  }
  payedByEmployee
  charges {
    id
  }
}`, {"fragmentName":"BusinessTripReportCarRentalRowFields"}) as unknown as TypedDocumentString<BusinessTripReportCarRentalRowFieldsFragment, unknown>;
export const BusinessTripReportCarRentalFieldsFragmentDoc = new TypedDocumentString(`
    fragment BusinessTripReportCarRentalFields on BusinessTrip {
  id
  carRentalExpenses {
    id
    date
    ...BusinessTripReportCarRentalRowFields
  }
}
    fragment BusinessTripReportCarRentalRowFields on BusinessTripCarRentalExpense {
  id
  payedByEmployee
  ...BusinessTripReportCoreExpenseRowFields
  days
  isFuelExpense
}
fragment BusinessTripReportCoreExpenseRowFields on BusinessTripExpense {
  id
  date
  valueDate
  amount {
    formatted
    raw
    currency
  }
  employee {
    id
    name
  }
  payedByEmployee
  charges {
    id
  }
}`, {"fragmentName":"BusinessTripReportCarRentalFields"}) as unknown as TypedDocumentString<BusinessTripReportCarRentalFieldsFragment, unknown>;
export const BusinessTripReportFlightsFieldsFragmentDoc = new TypedDocumentString(`
    fragment BusinessTripReportFlightsFields on BusinessTrip {
  id
  flightExpenses {
    id
    ...BusinessTripReportFlightsTableFields
  }
  attendees {
    id
    name
  }
}
    fragment BusinessTripReportCoreExpenseRowFields on BusinessTripExpense {
  id
  date
  valueDate
  amount {
    formatted
    raw
    currency
  }
  employee {
    id
    name
  }
  payedByEmployee
  charges {
    id
  }
}
fragment BusinessTripReportFlightsRowFields on BusinessTripFlightExpense {
  id
  payedByEmployee
  ...BusinessTripReportCoreExpenseRowFields
  path
  class
  attendees {
    id
    name
  }
}
fragment BusinessTripReportFlightsTableFields on BusinessTripFlightExpense {
  id
  date
  ...BusinessTripReportFlightsRowFields
}`, {"fragmentName":"BusinessTripReportFlightsFields"}) as unknown as TypedDocumentString<BusinessTripReportFlightsFieldsFragment, unknown>;
export const BusinessTripReportOtherRowFieldsFragmentDoc = new TypedDocumentString(`
    fragment BusinessTripReportOtherRowFields on BusinessTripOtherExpense {
  id
  ...BusinessTripReportCoreExpenseRowFields
  payedByEmployee
  description
  deductibleExpense
}
    fragment BusinessTripReportCoreExpenseRowFields on BusinessTripExpense {
  id
  date
  valueDate
  amount {
    formatted
    raw
    currency
  }
  employee {
    id
    name
  }
  payedByEmployee
  charges {
    id
  }
}`, {"fragmentName":"BusinessTripReportOtherRowFields"}) as unknown as TypedDocumentString<BusinessTripReportOtherRowFieldsFragment, unknown>;
export const BusinessTripReportOtherFieldsFragmentDoc = new TypedDocumentString(`
    fragment BusinessTripReportOtherFields on BusinessTrip {
  id
  otherExpenses {
    id
    date
    ...BusinessTripReportOtherRowFields
  }
}
    fragment BusinessTripReportCoreExpenseRowFields on BusinessTripExpense {
  id
  date
  valueDate
  amount {
    formatted
    raw
    currency
  }
  employee {
    id
    name
  }
  payedByEmployee
  charges {
    id
  }
}
fragment BusinessTripReportOtherRowFields on BusinessTripOtherExpense {
  id
  ...BusinessTripReportCoreExpenseRowFields
  payedByEmployee
  description
  deductibleExpense
}`, {"fragmentName":"BusinessTripReportOtherFields"}) as unknown as TypedDocumentString<BusinessTripReportOtherFieldsFragment, unknown>;
export const BusinessTripReportTravelAndSubsistenceRowFieldsFragmentDoc = new TypedDocumentString(`
    fragment BusinessTripReportTravelAndSubsistenceRowFields on BusinessTripTravelAndSubsistenceExpense {
  id
  ...BusinessTripReportCoreExpenseRowFields
  payedByEmployee
  expenseType
}
    fragment BusinessTripReportCoreExpenseRowFields on BusinessTripExpense {
  id
  date
  valueDate
  amount {
    formatted
    raw
    currency
  }
  employee {
    id
    name
  }
  payedByEmployee
  charges {
    id
  }
}`, {"fragmentName":"BusinessTripReportTravelAndSubsistenceRowFields"}) as unknown as TypedDocumentString<BusinessTripReportTravelAndSubsistenceRowFieldsFragment, unknown>;
export const BusinessTripReportTravelAndSubsistenceFieldsFragmentDoc = new TypedDocumentString(`
    fragment BusinessTripReportTravelAndSubsistenceFields on BusinessTrip {
  id
  travelAndSubsistenceExpenses {
    id
    date
    ...BusinessTripReportTravelAndSubsistenceRowFields
  }
}
    fragment BusinessTripReportCoreExpenseRowFields on BusinessTripExpense {
  id
  date
  valueDate
  amount {
    formatted
    raw
    currency
  }
  employee {
    id
    name
  }
  payedByEmployee
  charges {
    id
  }
}
fragment BusinessTripReportTravelAndSubsistenceRowFields on BusinessTripTravelAndSubsistenceExpense {
  id
  ...BusinessTripReportCoreExpenseRowFields
  payedByEmployee
  expenseType
}`, {"fragmentName":"BusinessTripReportTravelAndSubsistenceFields"}) as unknown as TypedDocumentString<BusinessTripReportTravelAndSubsistenceFieldsFragment, unknown>;
export const TransactionsTableEventDateFieldsFragmentDoc = new TypedDocumentString(`
    fragment TransactionsTableEventDateFields on Transaction {
  id
  eventDate
}
    `, {"fragmentName":"TransactionsTableEventDateFields"}) as unknown as TypedDocumentString<TransactionsTableEventDateFieldsFragment, unknown>;
export const TransactionsTableDebitDateFieldsFragmentDoc = new TypedDocumentString(`
    fragment TransactionsTableDebitDateFields on Transaction {
  id
  effectiveDate
  sourceEffectiveDate
}
    `, {"fragmentName":"TransactionsTableDebitDateFields"}) as unknown as TypedDocumentString<TransactionsTableDebitDateFieldsFragment, unknown>;
export const TransactionsTableAccountFieldsFragmentDoc = new TypedDocumentString(`
    fragment TransactionsTableAccountFields on Transaction {
  id
  account {
    id
    name
    type
  }
}
    `, {"fragmentName":"TransactionsTableAccountFields"}) as unknown as TypedDocumentString<TransactionsTableAccountFieldsFragment, unknown>;
export const TransactionsTableDescriptionFieldsFragmentDoc = new TypedDocumentString(`
    fragment TransactionsTableDescriptionFields on Transaction {
  id
  sourceDescription
}
    `, {"fragmentName":"TransactionsTableDescriptionFields"}) as unknown as TypedDocumentString<TransactionsTableDescriptionFieldsFragment, unknown>;
export const TransactionsTableSourceIdFieldsFragmentDoc = new TypedDocumentString(`
    fragment TransactionsTableSourceIDFields on Transaction {
  id
  referenceKey
}
    `, {"fragmentName":"TransactionsTableSourceIDFields"}) as unknown as TypedDocumentString<TransactionsTableSourceIdFieldsFragment, unknown>;
export const TransactionsTableEntityFieldsFragmentDoc = new TypedDocumentString(`
    fragment TransactionsTableEntityFields on Transaction {
  id
  counterparty {
    name
    id
  }
  sourceDescription
  missingInfoSuggestions {
    business {
      id
      name
    }
  }
}
    `, {"fragmentName":"TransactionsTableEntityFields"}) as unknown as TypedDocumentString<TransactionsTableEntityFieldsFragment, unknown>;
export const UncategorizedTransactionsTableAmountFieldsFragmentDoc = new TypedDocumentString(`
    fragment UncategorizedTransactionsTableAmountFields on UncategorizedTransaction {
  transaction {
    id
    amount {
      raw
      formatted
    }
    cryptoExchangeRate {
      rate
    }
  }
  categorizedAmount {
    raw
    formatted
  }
  errors
}
    `, {"fragmentName":"UncategorizedTransactionsTableAmountFields"}) as unknown as TypedDocumentString<UncategorizedTransactionsTableAmountFieldsFragment, unknown>;
export const BusinessTripUncategorizedTransactionsFieldsFragmentDoc = new TypedDocumentString(`
    fragment BusinessTripUncategorizedTransactionsFields on BusinessTrip {
  id
  uncategorizedTransactions {
    transaction {
      id
      eventDate
      chargeId
      amount {
        raw
      }
      ...TransactionsTableEventDateFields
      ...TransactionsTableDebitDateFields
      ...TransactionsTableAccountFields
      ...TransactionsTableDescriptionFields
      ...TransactionsTableSourceIDFields
      ...TransactionsTableEntityFields
    }
    ...UncategorizedTransactionsTableAmountFields
  }
}
    fragment UncategorizedTransactionsTableAmountFields on UncategorizedTransaction {
  transaction {
    id
    amount {
      raw
      formatted
    }
    cryptoExchangeRate {
      rate
    }
  }
  categorizedAmount {
    raw
    formatted
  }
  errors
}
fragment TransactionsTableAccountFields on Transaction {
  id
  account {
    id
    name
    type
  }
}
fragment TransactionsTableEntityFields on Transaction {
  id
  counterparty {
    name
    id
  }
  sourceDescription
  missingInfoSuggestions {
    business {
      id
      name
    }
  }
}
fragment TransactionsTableDebitDateFields on Transaction {
  id
  effectiveDate
  sourceEffectiveDate
}
fragment TransactionsTableDescriptionFields on Transaction {
  id
  sourceDescription
}
fragment TransactionsTableEventDateFields on Transaction {
  id
  eventDate
}
fragment TransactionsTableSourceIDFields on Transaction {
  id
  referenceKey
}`, {"fragmentName":"BusinessTripUncategorizedTransactionsFields"}) as unknown as TypedDocumentString<BusinessTripUncategorizedTransactionsFieldsFragment, unknown>;
export const DepreciationRecordRowFieldsFragmentDoc = new TypedDocumentString(`
    fragment DepreciationRecordRowFields on DepreciationRecord {
  id
  amount {
    currency
    formatted
    raw
  }
  activationDate
  category {
    id
    name
    percentage
  }
  type
  charge {
    id
    totalAmount {
      currency
      formatted
      raw
    }
  }
}
    `, {"fragmentName":"DepreciationRecordRowFields"}) as unknown as TypedDocumentString<DepreciationRecordRowFieldsFragment, unknown>;
export const EditTagFieldsFragmentDoc = new TypedDocumentString(`
    fragment EditTagFields on Tag {
  id
  name
  parent {
    id
    name
  }
}
    `, {"fragmentName":"EditTagFields"}) as unknown as TypedDocumentString<EditTagFieldsFragment, unknown>;
export const IssueDocumentClientFieldsFragmentDoc = new TypedDocumentString(`
    fragment IssueDocumentClientFields on Client {
  id
  originalBusiness {
    id
    address
    city
    zipCode
    country {
      id
      code
    }
    governmentId
    name
    phoneNumber
  }
  emails
}
    `, {"fragmentName":"IssueDocumentClientFields"}) as unknown as TypedDocumentString<IssueDocumentClientFieldsFragment, unknown>;
export const NewDocumentDraftFragmentDoc = new TypedDocumentString(`
    fragment NewDocumentDraft on DocumentDraft {
  description
  remarks
  footer
  type
  date
  dueDate
  language
  currency
  vatType
  discount {
    amount
    type
  }
  rounding
  signed
  maxPayments
  client {
    id
    originalBusiness {
      id
      name
    }
    integrations {
      id
    }
    emails
    ...IssueDocumentClientFields
  }
  income {
    currency
    currencyRate
    description
    itemId
    price
    quantity
    vatRate
    vatType
  }
  payment {
    currency
    currencyRate
    date
    price
    type
    bankName
    bankBranch
    bankAccount
    chequeNum
    accountId
    transactionId
    cardType
    cardNum
    numPayments
    firstPayment
  }
  linkedDocumentIds
  linkedPaymentId
}
    fragment IssueDocumentClientFields on Client {
  id
  originalBusiness {
    id
    address
    city
    zipCode
    country {
      id
      code
    }
    governmentId
    name
    phoneNumber
  }
  emails
}`, {"fragmentName":"NewDocumentDraft"}) as unknown as TypedDocumentString<NewDocumentDraftFragment, unknown>;
export const SimilarChargesTableFragmentDoc = new TypedDocumentString(`
    fragment SimilarChargesTable on Charge {
  id
  __typename
  counterparty {
    name
    id
  }
  minEventDate
  minDebitDate
  minDocumentsDate
  totalAmount {
    raw
    formatted
  }
  vat {
    raw
    formatted
  }
  userDescription
  tags {
    id
    name
  }
  taxCategory {
    id
    name
  }
  ... on BusinessTripCharge {
    businessTrip {
      id
      name
    }
  }
  metadata {
    transactionsCount
    documentsCount
    ledgerCount
    miscExpensesCount
  }
}
    `, {"fragmentName":"SimilarChargesTable"}) as unknown as TypedDocumentString<SimilarChargesTableFragment, unknown>;
export const NewFetchedDocumentFieldsFragmentDoc = new TypedDocumentString(`
    fragment NewFetchedDocumentFields on Document {
  id
  documentType
  charge {
    id
    userDescription
    counterparty {
      id
      name
    }
  }
}
    `, {"fragmentName":"NewFetchedDocumentFields"}) as unknown as TypedDocumentString<NewFetchedDocumentFieldsFragment, unknown>;
export const ContractForContractsTableFieldsFragmentDoc = new TypedDocumentString(`
    fragment ContractForContractsTableFields on Contract {
  id
  isActive
  client {
    id
    originalBusiness {
      id
      name
    }
  }
  purchaseOrders
  startDate
  endDate
  amount {
    raw
    formatted
  }
  billingCycle
  product
  plan
  operationsLimit
  msCloud
}
    `, {"fragmentName":"ContractForContractsTableFields"}) as unknown as TypedDocumentString<ContractForContractsTableFieldsFragment, unknown>;
export const CorporateTaxRulingReportRuleCellFieldsFragmentDoc = new TypedDocumentString(`
    fragment CorporateTaxRulingReportRuleCellFields on CorporateTaxRule {
  id
  rule
  percentage {
    formatted
  }
  isCompliant
}
    `, {"fragmentName":"CorporateTaxRulingReportRuleCellFields"}) as unknown as TypedDocumentString<CorporateTaxRulingReportRuleCellFieldsFragment, unknown>;
export const ReportSubCommentaryTableFieldsFragmentDoc = new TypedDocumentString(`
    fragment ReportSubCommentaryTableFields on ReportCommentarySubRecord {
  financialEntity {
    id
    name
  }
  amount {
    formatted
  }
  ledgerRecords {
    ...LedgerRecordsTableFields
  }
}
    fragment LedgerRecordsTableFields on LedgerRecord {
  id
  creditAccount1 {
    __typename
    id
    name
  }
  creditAccount2 {
    __typename
    id
    name
  }
  debitAccount1 {
    __typename
    id
    name
  }
  debitAccount2 {
    __typename
    id
    name
  }
  creditAmount1 {
    formatted
    currency
  }
  creditAmount2 {
    formatted
    currency
  }
  debitAmount1 {
    formatted
    currency
  }
  debitAmount2 {
    formatted
    currency
  }
  localCurrencyCreditAmount1 {
    formatted
    raw
  }
  localCurrencyCreditAmount2 {
    formatted
    raw
  }
  localCurrencyDebitAmount1 {
    formatted
    raw
  }
  localCurrencyDebitAmount2 {
    formatted
    raw
  }
  invoiceDate
  valueDate
  description
  reference
}`, {"fragmentName":"ReportSubCommentaryTableFields"}) as unknown as TypedDocumentString<ReportSubCommentaryTableFieldsFragment, unknown>;
export const ReportCommentaryTableFieldsFragmentDoc = new TypedDocumentString(`
    fragment ReportCommentaryTableFields on ReportCommentary {
  records {
    sortCode {
      id
      key
      name
    }
    amount {
      formatted
    }
    records {
      ...ReportSubCommentaryTableFields
    }
  }
}
    fragment LedgerRecordsTableFields on LedgerRecord {
  id
  creditAccount1 {
    __typename
    id
    name
  }
  creditAccount2 {
    __typename
    id
    name
  }
  debitAccount1 {
    __typename
    id
    name
  }
  debitAccount2 {
    __typename
    id
    name
  }
  creditAmount1 {
    formatted
    currency
  }
  creditAmount2 {
    formatted
    currency
  }
  debitAmount1 {
    formatted
    currency
  }
  debitAmount2 {
    formatted
    currency
  }
  localCurrencyCreditAmount1 {
    formatted
    raw
  }
  localCurrencyCreditAmount2 {
    formatted
    raw
  }
  localCurrencyDebitAmount1 {
    formatted
    raw
  }
  localCurrencyDebitAmount2 {
    formatted
    raw
  }
  invoiceDate
  valueDate
  description
  reference
}
fragment ReportSubCommentaryTableFields on ReportCommentarySubRecord {
  financialEntity {
    id
    name
  }
  amount {
    formatted
  }
  ledgerRecords {
    ...LedgerRecordsTableFields
  }
}`, {"fragmentName":"ReportCommentaryTableFields"}) as unknown as TypedDocumentString<ReportCommentaryTableFieldsFragment, unknown>;
export const TrialBalanceTableFieldsFragmentDoc = new TypedDocumentString(`
    fragment TrialBalanceTableFields on BusinessTransactionsSumFromLedgerRecordsSuccessfulResult {
  businessTransactionsSum {
    business {
      id
      name
      sortCode {
        id
        key
        name
      }
    }
    credit {
      formatted
      raw
    }
    debit {
      formatted
      raw
    }
    total {
      formatted
      raw
    }
  }
}
    `, {"fragmentName":"TrialBalanceTableFields"}) as unknown as TypedDocumentString<TrialBalanceTableFieldsFragment, unknown>;
export const ChargeForChargesTableFieldsFragmentDoc = new TypedDocumentString(`
    fragment ChargeForChargesTableFields on Charge {
  id
  __typename
  minEventDate
  minDebitDate
  minDocumentsDate
  maxDebitDate
  maxEventDate
  maxDocumentsDate
  totalAmount {
    raw
    currency
  }
  vat {
    raw
  }
  counterparty {
    name
    id
  }
  userDescription
  tags {
    id
    name
    namePath
  }
  taxCategory {
    id
    name
  }
  ... on BusinessTripCharge {
    businessTrip {
      id
      name
    }
  }
  metadata {
    transactionsCount
    documentsCount
    ledgerCount
    miscExpensesCount
    ... on ChargeMetadata @defer {
      invalidLedger
    }
  }
  accountantApproval
  ... on CreditcardBankCharge {
    validCreditCardAmount
  }
  ... on Charge {
    validationData {
      missingInfo
    }
  }
  ... on Charge {
    missingInfoSuggestions {
      description
      tags {
        id
        name
        namePath
      }
    }
  }
}
    `, {"fragmentName":"ChargeForChargesTableFields"}) as unknown as TypedDocumentString<ChargeForChargesTableFieldsFragment, unknown>;
export const VatReportBusinessTripsFieldsFragmentDoc = new TypedDocumentString(`
    fragment VatReportBusinessTripsFields on VatReportResult {
  businessTrips {
    id
    ...ChargeForChargesTableFields
  }
}
    fragment ChargeForChargesTableFields on Charge {
  id
  __typename
  minEventDate
  minDebitDate
  minDocumentsDate
  maxDebitDate
  maxEventDate
  maxDocumentsDate
  totalAmount {
    raw
    currency
  }
  vat {
    raw
  }
  counterparty {
    name
    id
  }
  userDescription
  tags {
    id
    name
    namePath
  }
  taxCategory {
    id
    name
  }
  ... on BusinessTripCharge {
    businessTrip {
      id
      name
    }
  }
  metadata {
    transactionsCount
    documentsCount
    ledgerCount
    miscExpensesCount
    ... on ChargeMetadata @defer {
      invalidLedger
    }
  }
  accountantApproval
  ... on CreditcardBankCharge {
    validCreditCardAmount
  }
  ... on Charge {
    validationData {
      missingInfo
    }
  }
  ... on Charge {
    missingInfoSuggestions {
      description
      tags {
        id
        name
        namePath
      }
    }
  }
}`, {"fragmentName":"VatReportBusinessTripsFields"}) as unknown as TypedDocumentString<VatReportBusinessTripsFieldsFragment, unknown>;
export const VatReportAccountantApprovalFieldsFragmentDoc = new TypedDocumentString(`
    fragment VatReportAccountantApprovalFields on VatReportRecord {
  chargeId
  chargeAccountantStatus
}
    `, {"fragmentName":"VatReportAccountantApprovalFields"}) as unknown as TypedDocumentString<VatReportAccountantApprovalFieldsFragment, unknown>;
export const VatReportExpensesRowFieldsFragmentDoc = new TypedDocumentString(`
    fragment VatReportExpensesRowFields on VatReportRecord {
  ...VatReportAccountantApprovalFields
  business {
    id
    name
  }
  vatNumber
  image
  allocationNumber
  documentSerial
  documentDate
  chargeDate
  chargeId
  amount {
    formatted
    raw
  }
  localAmount {
    formatted
    raw
  }
  localVat {
    formatted
    raw
  }
  foreignVatAfterDeduction {
    formatted
    raw
  }
  localVatAfterDeduction {
    formatted
    raw
  }
  roundedLocalVatAfterDeduction {
    formatted
    raw
  }
  taxReducedLocalAmount {
    formatted
    raw
  }
  recordType
}
    fragment VatReportAccountantApprovalFields on VatReportRecord {
  chargeId
  chargeAccountantStatus
}`, {"fragmentName":"VatReportExpensesRowFields"}) as unknown as TypedDocumentString<VatReportExpensesRowFieldsFragment, unknown>;
export const VatReportExpensesFieldsFragmentDoc = new TypedDocumentString(`
    fragment VatReportExpensesFields on VatReportResult {
  expenses {
    ...VatReportExpensesRowFields
    roundedLocalVatAfterDeduction {
      raw
    }
    taxReducedLocalAmount {
      raw
    }
    recordType
  }
}
    fragment VatReportAccountantApprovalFields on VatReportRecord {
  chargeId
  chargeAccountantStatus
}
fragment VatReportExpensesRowFields on VatReportRecord {
  ...VatReportAccountantApprovalFields
  business {
    id
    name
  }
  vatNumber
  image
  allocationNumber
  documentSerial
  documentDate
  chargeDate
  chargeId
  amount {
    formatted
    raw
  }
  localAmount {
    formatted
    raw
  }
  localVat {
    formatted
    raw
  }
  foreignVatAfterDeduction {
    formatted
    raw
  }
  localVatAfterDeduction {
    formatted
    raw
  }
  roundedLocalVatAfterDeduction {
    formatted
    raw
  }
  taxReducedLocalAmount {
    formatted
    raw
  }
  recordType
}`, {"fragmentName":"VatReportExpensesFields"}) as unknown as TypedDocumentString<VatReportExpensesFieldsFragment, unknown>;
export const VatReportIncomeRowFieldsFragmentDoc = new TypedDocumentString(`
    fragment VatReportIncomeRowFields on VatReportRecord {
  ...VatReportAccountantApprovalFields
  chargeId
  business {
    id
    name
  }
  vatNumber
  image
  allocationNumber
  documentSerial
  documentDate
  chargeDate
  taxReducedForeignAmount {
    formatted
    raw
  }
  taxReducedLocalAmount {
    formatted
    raw
  }
  recordType
}
    fragment VatReportAccountantApprovalFields on VatReportRecord {
  chargeId
  chargeAccountantStatus
}`, {"fragmentName":"VatReportIncomeRowFields"}) as unknown as TypedDocumentString<VatReportIncomeRowFieldsFragment, unknown>;
export const VatReportIncomeFieldsFragmentDoc = new TypedDocumentString(`
    fragment VatReportIncomeFields on VatReportResult {
  income {
    ...VatReportIncomeRowFields
    taxReducedLocalAmount {
      raw
    }
    recordType
  }
}
    fragment VatReportAccountantApprovalFields on VatReportRecord {
  chargeId
  chargeAccountantStatus
}
fragment VatReportIncomeRowFields on VatReportRecord {
  ...VatReportAccountantApprovalFields
  chargeId
  business {
    id
    name
  }
  vatNumber
  image
  allocationNumber
  documentSerial
  documentDate
  chargeDate
  taxReducedForeignAmount {
    formatted
    raw
  }
  taxReducedLocalAmount {
    formatted
    raw
  }
  recordType
}`, {"fragmentName":"VatReportIncomeFields"}) as unknown as TypedDocumentString<VatReportIncomeFieldsFragment, unknown>;
export const VatReportMiscTableFieldsFragmentDoc = new TypedDocumentString(`
    fragment VatReportMiscTableFields on VatReportResult {
  differentMonthDoc {
    id
    ...ChargeForChargesTableFields
  }
}
    fragment ChargeForChargesTableFields on Charge {
  id
  __typename
  minEventDate
  minDebitDate
  minDocumentsDate
  maxDebitDate
  maxEventDate
  maxDocumentsDate
  totalAmount {
    raw
    currency
  }
  vat {
    raw
  }
  counterparty {
    name
    id
  }
  userDescription
  tags {
    id
    name
    namePath
  }
  taxCategory {
    id
    name
  }
  ... on BusinessTripCharge {
    businessTrip {
      id
      name
    }
  }
  metadata {
    transactionsCount
    documentsCount
    ledgerCount
    miscExpensesCount
    ... on ChargeMetadata @defer {
      invalidLedger
    }
  }
  accountantApproval
  ... on CreditcardBankCharge {
    validCreditCardAmount
  }
  ... on Charge {
    validationData {
      missingInfo
    }
  }
  ... on Charge {
    missingInfoSuggestions {
      description
      tags {
        id
        name
        namePath
      }
    }
  }
}`, {"fragmentName":"VatReportMiscTableFields"}) as unknown as TypedDocumentString<VatReportMiscTableFieldsFragment, unknown>;
export const VatReportMissingInfoFieldsFragmentDoc = new TypedDocumentString(`
    fragment VatReportMissingInfoFields on VatReportResult {
  missingInfo {
    id
    ...ChargeForChargesTableFields
  }
}
    fragment ChargeForChargesTableFields on Charge {
  id
  __typename
  minEventDate
  minDebitDate
  minDocumentsDate
  maxDebitDate
  maxEventDate
  maxDocumentsDate
  totalAmount {
    raw
    currency
  }
  vat {
    raw
  }
  counterparty {
    name
    id
  }
  userDescription
  tags {
    id
    name
    namePath
  }
  taxCategory {
    id
    name
  }
  ... on BusinessTripCharge {
    businessTrip {
      id
      name
    }
  }
  metadata {
    transactionsCount
    documentsCount
    ledgerCount
    miscExpensesCount
    ... on ChargeMetadata @defer {
      invalidLedger
    }
  }
  accountantApproval
  ... on CreditcardBankCharge {
    validCreditCardAmount
  }
  ... on Charge {
    validationData {
      missingInfo
    }
  }
  ... on Charge {
    missingInfoSuggestions {
      description
      tags {
        id
        name
        namePath
      }
    }
  }
}`, {"fragmentName":"VatReportMissingInfoFields"}) as unknown as TypedDocumentString<VatReportMissingInfoFieldsFragment, unknown>;
export const VatReportSummaryFieldsFragmentDoc = new TypedDocumentString(`
    fragment VatReportSummaryFields on VatReportResult {
  expenses {
    roundedLocalVatAfterDeduction {
      raw
    }
    taxReducedLocalAmount {
      raw
    }
    recordType
    isProperty
  }
  income {
    roundedLocalVatAfterDeduction {
      raw
    }
    taxReducedLocalAmount {
      raw
    }
    recordType
  }
}
    `, {"fragmentName":"VatReportSummaryFields"}) as unknown as TypedDocumentString<VatReportSummaryFieldsFragment, unknown>;
export const LedgerCsvFieldsFragmentDoc = new TypedDocumentString(`
    fragment LedgerCsvFields on YearlyLedgerReport {
  id
  year
  financialEntitiesInfo {
    entity {
      id
      name
      sortCode {
        id
        key
      }
    }
    openingBalance {
      raw
    }
    totalCredit {
      raw
    }
    totalDebit {
      raw
    }
    closingBalance {
      raw
    }
    records {
      id
      amount {
        raw
        formatted
      }
      invoiceDate
      valueDate
      description
      reference
      counterParty {
        id
        name
      }
      balance
    }
  }
}
    `, {"fragmentName":"LedgerCsvFields"}) as unknown as TypedDocumentString<LedgerCsvFieldsFragment, unknown>;
export const SalariesRecordEmployeeFieldsFragmentDoc = new TypedDocumentString(`
    fragment SalariesRecordEmployeeFields on Salary {
  month
  employee {
    id
    name
  }
}
    `, {"fragmentName":"SalariesRecordEmployeeFields"}) as unknown as TypedDocumentString<SalariesRecordEmployeeFieldsFragment, unknown>;
export const SalariesRecordMainSalaryFieldsFragmentDoc = new TypedDocumentString(`
    fragment SalariesRecordMainSalaryFields on Salary {
  month
  employee {
    id
  }
  baseAmount {
    formatted
  }
  directAmount {
    formatted
  }
  globalAdditionalHoursAmount {
    formatted
  }
  bonus {
    formatted
    raw
  }
  gift {
    formatted
    raw
  }
  recovery {
    formatted
    raw
  }
  vacationTakeout {
    formatted
    raw
  }
}
    `, {"fragmentName":"SalariesRecordMainSalaryFields"}) as unknown as TypedDocumentString<SalariesRecordMainSalaryFieldsFragment, unknown>;
export const SalariesRecordFundsFieldsFragmentDoc = new TypedDocumentString(`
    fragment SalariesRecordFundsFields on Salary {
  month
  employee {
    id
  }
  pensionFund {
    id
    name
  }
  pensionEmployeeAmount {
    formatted
    raw
  }
  pensionEmployeePercentage
  pensionEmployerAmount {
    formatted
    raw
  }
  pensionEmployerPercentage
  compensationsAmount {
    formatted
    raw
  }
  compensationsPercentage
  trainingFund {
    id
    name
  }
  trainingFundEmployeeAmount {
    formatted
    raw
  }
  trainingFundEmployeePercentage
  trainingFundEmployerAmount {
    formatted
    raw
  }
  trainingFundEmployerPercentage
}
    `, {"fragmentName":"SalariesRecordFundsFields"}) as unknown as TypedDocumentString<SalariesRecordFundsFieldsFragment, unknown>;
export const SalariesRecordInsurancesAndTaxesFieldsFragmentDoc = new TypedDocumentString(`
    fragment SalariesRecordInsurancesAndTaxesFields on Salary {
  month
  employee {
    id
  }
  healthInsuranceAmount {
    formatted
    raw
  }
  socialSecurityEmployeeAmount {
    formatted
    raw
  }
  socialSecurityEmployerAmount {
    formatted
    raw
  }
  incomeTaxAmount {
    formatted
    raw
  }
  notionalExpense {
    formatted
    raw
  }
}
    `, {"fragmentName":"SalariesRecordInsurancesAndTaxesFields"}) as unknown as TypedDocumentString<SalariesRecordInsurancesAndTaxesFieldsFragment, unknown>;
export const SalariesRecordWorkFrameFieldsFragmentDoc = new TypedDocumentString(`
    fragment SalariesRecordWorkFrameFields on Salary {
  month
  employee {
    id
  }
  vacationDays {
    added
    taken
    balance
  }
  workDays
  sicknessDays {
    balance
  }
}
    `, {"fragmentName":"SalariesRecordWorkFrameFields"}) as unknown as TypedDocumentString<SalariesRecordWorkFrameFieldsFragment, unknown>;
export const SalariesRecordFieldsFragmentDoc = new TypedDocumentString(`
    fragment SalariesRecordFields on Salary {
  month
  employee {
    id
  }
  ...SalariesRecordEmployeeFields
  ...SalariesRecordMainSalaryFields
  ...SalariesRecordFundsFields
  ...SalariesRecordInsurancesAndTaxesFields
  ...SalariesRecordWorkFrameFields
}
    fragment SalariesRecordEmployeeFields on Salary {
  month
  employee {
    id
    name
  }
}
fragment SalariesRecordFundsFields on Salary {
  month
  employee {
    id
  }
  pensionFund {
    id
    name
  }
  pensionEmployeeAmount {
    formatted
    raw
  }
  pensionEmployeePercentage
  pensionEmployerAmount {
    formatted
    raw
  }
  pensionEmployerPercentage
  compensationsAmount {
    formatted
    raw
  }
  compensationsPercentage
  trainingFund {
    id
    name
  }
  trainingFundEmployeeAmount {
    formatted
    raw
  }
  trainingFundEmployeePercentage
  trainingFundEmployerAmount {
    formatted
    raw
  }
  trainingFundEmployerPercentage
}
fragment SalariesRecordInsurancesAndTaxesFields on Salary {
  month
  employee {
    id
  }
  healthInsuranceAmount {
    formatted
    raw
  }
  socialSecurityEmployeeAmount {
    formatted
    raw
  }
  socialSecurityEmployerAmount {
    formatted
    raw
  }
  incomeTaxAmount {
    formatted
    raw
  }
  notionalExpense {
    formatted
    raw
  }
}
fragment SalariesRecordMainSalaryFields on Salary {
  month
  employee {
    id
  }
  baseAmount {
    formatted
  }
  directAmount {
    formatted
  }
  globalAdditionalHoursAmount {
    formatted
  }
  bonus {
    formatted
    raw
  }
  gift {
    formatted
    raw
  }
  recovery {
    formatted
    raw
  }
  vacationTakeout {
    formatted
    raw
  }
}
fragment SalariesRecordWorkFrameFields on Salary {
  month
  employee {
    id
  }
  vacationDays {
    added
    taken
    balance
  }
  workDays
  sicknessDays {
    balance
  }
}`, {"fragmentName":"SalariesRecordFields"}) as unknown as TypedDocumentString<SalariesRecordFieldsFragment, unknown>;
export const SalariesMonthFieldsFragmentDoc = new TypedDocumentString(`
    fragment SalariesMonthFields on Salary {
  month
  employee {
    id
  }
  ...SalariesRecordFields
}
    fragment SalariesRecordEmployeeFields on Salary {
  month
  employee {
    id
    name
  }
}
fragment SalariesRecordFundsFields on Salary {
  month
  employee {
    id
  }
  pensionFund {
    id
    name
  }
  pensionEmployeeAmount {
    formatted
    raw
  }
  pensionEmployeePercentage
  pensionEmployerAmount {
    formatted
    raw
  }
  pensionEmployerPercentage
  compensationsAmount {
    formatted
    raw
  }
  compensationsPercentage
  trainingFund {
    id
    name
  }
  trainingFundEmployeeAmount {
    formatted
    raw
  }
  trainingFundEmployeePercentage
  trainingFundEmployerAmount {
    formatted
    raw
  }
  trainingFundEmployerPercentage
}
fragment SalariesRecordInsurancesAndTaxesFields on Salary {
  month
  employee {
    id
  }
  healthInsuranceAmount {
    formatted
    raw
  }
  socialSecurityEmployeeAmount {
    formatted
    raw
  }
  socialSecurityEmployerAmount {
    formatted
    raw
  }
  incomeTaxAmount {
    formatted
    raw
  }
  notionalExpense {
    formatted
    raw
  }
}
fragment SalariesRecordMainSalaryFields on Salary {
  month
  employee {
    id
  }
  baseAmount {
    formatted
  }
  directAmount {
    formatted
  }
  globalAdditionalHoursAmount {
    formatted
  }
  bonus {
    formatted
    raw
  }
  gift {
    formatted
    raw
  }
  recovery {
    formatted
    raw
  }
  vacationTakeout {
    formatted
    raw
  }
}
fragment SalariesRecordWorkFrameFields on Salary {
  month
  employee {
    id
  }
  vacationDays {
    added
    taken
    balance
  }
  workDays
  sicknessDays {
    balance
  }
}
fragment SalariesRecordFields on Salary {
  month
  employee {
    id
  }
  ...SalariesRecordEmployeeFields
  ...SalariesRecordMainSalaryFields
  ...SalariesRecordFundsFields
  ...SalariesRecordInsurancesAndTaxesFields
  ...SalariesRecordWorkFrameFields
}`, {"fragmentName":"SalariesMonthFields"}) as unknown as TypedDocumentString<SalariesMonthFieldsFragment, unknown>;
export const SalariesTableFieldsFragmentDoc = new TypedDocumentString(`
    fragment SalariesTableFields on Salary {
  month
  employee {
    id
  }
  ...SalariesMonthFields
}
    fragment SalariesRecordEmployeeFields on Salary {
  month
  employee {
    id
    name
  }
}
fragment SalariesRecordFundsFields on Salary {
  month
  employee {
    id
  }
  pensionFund {
    id
    name
  }
  pensionEmployeeAmount {
    formatted
    raw
  }
  pensionEmployeePercentage
  pensionEmployerAmount {
    formatted
    raw
  }
  pensionEmployerPercentage
  compensationsAmount {
    formatted
    raw
  }
  compensationsPercentage
  trainingFund {
    id
    name
  }
  trainingFundEmployeeAmount {
    formatted
    raw
  }
  trainingFundEmployeePercentage
  trainingFundEmployerAmount {
    formatted
    raw
  }
  trainingFundEmployerPercentage
}
fragment SalariesRecordInsurancesAndTaxesFields on Salary {
  month
  employee {
    id
  }
  healthInsuranceAmount {
    formatted
    raw
  }
  socialSecurityEmployeeAmount {
    formatted
    raw
  }
  socialSecurityEmployerAmount {
    formatted
    raw
  }
  incomeTaxAmount {
    formatted
    raw
  }
  notionalExpense {
    formatted
    raw
  }
}
fragment SalariesRecordMainSalaryFields on Salary {
  month
  employee {
    id
  }
  baseAmount {
    formatted
  }
  directAmount {
    formatted
  }
  globalAdditionalHoursAmount {
    formatted
  }
  bonus {
    formatted
    raw
  }
  gift {
    formatted
    raw
  }
  recovery {
    formatted
    raw
  }
  vacationTakeout {
    formatted
    raw
  }
}
fragment SalariesRecordWorkFrameFields on Salary {
  month
  employee {
    id
  }
  vacationDays {
    added
    taken
    balance
  }
  workDays
  sicknessDays {
    balance
  }
}
fragment SalariesMonthFields on Salary {
  month
  employee {
    id
  }
  ...SalariesRecordFields
}
fragment SalariesRecordFields on Salary {
  month
  employee {
    id
  }
  ...SalariesRecordEmployeeFields
  ...SalariesRecordMainSalaryFields
  ...SalariesRecordFundsFields
  ...SalariesRecordInsurancesAndTaxesFields
  ...SalariesRecordWorkFrameFields
}`, {"fragmentName":"SalariesTableFields"}) as unknown as TypedDocumentString<SalariesTableFieldsFragment, unknown>;
export const AnnualRevenueReportRecordFragmentDoc = new TypedDocumentString(`
    fragment AnnualRevenueReportRecord on AnnualRevenueReportClientRecord {
  id
  revenueLocal {
    raw
    formatted
    currency
  }
  revenueDefaultForeign {
    raw
    formatted
    currency
  }
  revenueOriginal {
    raw
    formatted
    currency
  }
  chargeId
  date
  description
  reference
}
    `, {"fragmentName":"AnnualRevenueReportRecord"}) as unknown as TypedDocumentString<AnnualRevenueReportRecordFragment, unknown>;
export const AnnualRevenueReportClientFragmentDoc = new TypedDocumentString(`
    fragment AnnualRevenueReportClient on AnnualRevenueReportCountryClient {
  id
  name
  revenueLocal {
    raw
    formatted
    currency
  }
  revenueDefaultForeign {
    raw
    formatted
    currency
  }
  records {
    id
    date
    ...AnnualRevenueReportRecord
  }
}
    fragment AnnualRevenueReportRecord on AnnualRevenueReportClientRecord {
  id
  revenueLocal {
    raw
    formatted
    currency
  }
  revenueDefaultForeign {
    raw
    formatted
    currency
  }
  revenueOriginal {
    raw
    formatted
    currency
  }
  chargeId
  date
  description
  reference
}`, {"fragmentName":"AnnualRevenueReportClient"}) as unknown as TypedDocumentString<AnnualRevenueReportClientFragment, unknown>;
export const AnnualRevenueReportCountryFragmentDoc = new TypedDocumentString(`
    fragment AnnualRevenueReportCountry on AnnualRevenueReportCountry {
  id
  code
  name
  revenueLocal {
    raw
    formatted
    currency
  }
  revenueDefaultForeign {
    raw
    formatted
    currency
  }
  clients {
    id
    revenueDefaultForeign {
      raw
    }
    ...AnnualRevenueReportClient
  }
}
    fragment AnnualRevenueReportClient on AnnualRevenueReportCountryClient {
  id
  name
  revenueLocal {
    raw
    formatted
    currency
  }
  revenueDefaultForeign {
    raw
    formatted
    currency
  }
  records {
    id
    date
    ...AnnualRevenueReportRecord
  }
}
fragment AnnualRevenueReportRecord on AnnualRevenueReportClientRecord {
  id
  revenueLocal {
    raw
    formatted
    currency
  }
  revenueDefaultForeign {
    raw
    formatted
    currency
  }
  revenueOriginal {
    raw
    formatted
    currency
  }
  chargeId
  date
  description
  reference
}`, {"fragmentName":"AnnualRevenueReportCountry"}) as unknown as TypedDocumentString<AnnualRevenueReportCountryFragment, unknown>;
export const DepreciationReportRecordCoreFragmentDoc = new TypedDocumentString(`
    fragment DepreciationReportRecordCore on DepreciationCoreRecord {
  id
  originalCost
  reportYearDelta
  totalDepreciableCosts
  reportYearClaimedDepreciation
  pastYearsAccumulatedDepreciation
  totalDepreciation
  netValue
}
    `, {"fragmentName":"DepreciationReportRecordCore"}) as unknown as TypedDocumentString<DepreciationReportRecordCoreFragment, unknown>;
export const Shaam6111DataContentHeaderBusinessFragmentDoc = new TypedDocumentString(`
    fragment Shaam6111DataContentHeaderBusiness on Business {
  id
  name
}
    `, {"fragmentName":"Shaam6111DataContentHeaderBusiness"}) as unknown as TypedDocumentString<Shaam6111DataContentHeaderBusinessFragment, unknown>;
export const Shaam6111DataContentHeaderFragmentDoc = new TypedDocumentString(`
    fragment Shaam6111DataContentHeader on Shaam6111Data {
  id
  header {
    taxYear
    businessDescription
    taxFileNumber
    idNumber
    vatFileNumber
    withholdingTaxFileNumber
    businessType
    reportingMethod
    currencyType
    amountsInThousands
    accountingMethod
    accountingSystem
    softwareRegistrationNumber
    isPartnership
    partnershipCount
    partnershipProfitShare
    ifrsImplementationYear
    ifrsReportingOption
    includesProfitLoss
    includesTaxAdjustment
    includesBalanceSheet
    industryCode
    auditOpinionType
  }
}
    `, {"fragmentName":"Shaam6111DataContentHeader"}) as unknown as TypedDocumentString<Shaam6111DataContentHeaderFragment, unknown>;
export const Shaam6111DataContentProfitLossFragmentDoc = new TypedDocumentString(`
    fragment Shaam6111DataContentProfitLoss on Shaam6111Data {
  id
  profitAndLoss {
    code
    amount
    label
  }
}
    `, {"fragmentName":"Shaam6111DataContentProfitLoss"}) as unknown as TypedDocumentString<Shaam6111DataContentProfitLossFragment, unknown>;
export const Shaam6111DataContentTaxAdjustmentFragmentDoc = new TypedDocumentString(`
    fragment Shaam6111DataContentTaxAdjustment on Shaam6111Data {
  id
  taxAdjustment {
    code
    amount
    label
  }
}
    `, {"fragmentName":"Shaam6111DataContentTaxAdjustment"}) as unknown as TypedDocumentString<Shaam6111DataContentTaxAdjustmentFragment, unknown>;
export const Shaam6111DataContentBalanceSheetFragmentDoc = new TypedDocumentString(`
    fragment Shaam6111DataContentBalanceSheet on Shaam6111Data {
  id
  balanceSheet {
    code
    amount
    label
  }
}
    `, {"fragmentName":"Shaam6111DataContentBalanceSheet"}) as unknown as TypedDocumentString<Shaam6111DataContentBalanceSheetFragment, unknown>;
export const Shaam6111DataContentFragmentDoc = new TypedDocumentString(`
    fragment Shaam6111DataContent on Shaam6111Data {
  id
  ...Shaam6111DataContentHeader
  ...Shaam6111DataContentProfitLoss
  ...Shaam6111DataContentTaxAdjustment
  ...Shaam6111DataContentBalanceSheet
}
    fragment Shaam6111DataContentBalanceSheet on Shaam6111Data {
  id
  balanceSheet {
    code
    amount
    label
  }
}
fragment Shaam6111DataContentHeader on Shaam6111Data {
  id
  header {
    taxYear
    businessDescription
    taxFileNumber
    idNumber
    vatFileNumber
    withholdingTaxFileNumber
    businessType
    reportingMethod
    currencyType
    amountsInThousands
    accountingMethod
    accountingSystem
    softwareRegistrationNumber
    isPartnership
    partnershipCount
    partnershipProfitShare
    ifrsImplementationYear
    ifrsReportingOption
    includesProfitLoss
    includesTaxAdjustment
    includesBalanceSheet
    industryCode
    auditOpinionType
  }
}
fragment Shaam6111DataContentProfitLoss on Shaam6111Data {
  id
  profitAndLoss {
    code
    amount
    label
  }
}
fragment Shaam6111DataContentTaxAdjustment on Shaam6111Data {
  id
  taxAdjustment {
    code
    amount
    label
  }
}`, {"fragmentName":"Shaam6111DataContent"}) as unknown as TypedDocumentString<Shaam6111DataContentFragment, unknown>;
export const TransactionToDownloadForTransactionsTableFieldsFragmentDoc = new TypedDocumentString(`
    fragment TransactionToDownloadForTransactionsTableFields on Transaction {
  id
  account {
    id
    name
    type
  }
  amount {
    currency
    raw
  }
  counterparty {
    id
    name
  }
  effectiveDate
  eventDate
  referenceKey
  sourceDescription
}
    `, {"fragmentName":"TransactionToDownloadForTransactionsTableFields"}) as unknown as TypedDocumentString<TransactionToDownloadForTransactionsTableFieldsFragment, unknown>;
export const ListApiKeysDocument = new TypedDocumentString(`
    query ListApiKeys {
  listApiKeys {
    id
    name
    roleId
    lastUsedAt
    createdAt
  }
}
    `) as unknown as TypedDocumentString<ListApiKeysQuery, ListApiKeysQueryVariables>;
export const ListBusinessUsersDocument = new TypedDocumentString(`
    query ListBusinessUsers {
  listBusinessUsers {
    id
    email
    name
    roleId
    createdAt
  }
}
    `) as unknown as TypedDocumentString<ListBusinessUsersQuery, ListBusinessUsersQueryVariables>;
export const ListInvitationsDocument = new TypedDocumentString(`
    query ListInvitations {
  listInvitations {
    id
    email
    roleId
    expiresAt
  }
}
    `) as unknown as TypedDocumentString<ListInvitationsQuery, ListInvitationsQueryVariables>;
export const SharedDepositTransactionsDocument = new TypedDocumentString(`
    query SharedDepositTransactions($depositId: UUID!) {
  deposit(id: $depositId) {
    id
    currency
    metadata {
      id
      transactions {
        id
        ...DepositTransactionFields
      }
    }
  }
}
    fragment DepositTransactionFields on Transaction {
  id
  eventDate
  chargeId
  amount {
    raw
    formatted
    currency
  }
  debitExchangeRates {
    aud
    cad
    eur
    gbp
    jpy
    sek
    usd
    date
  }
  eventExchangeRates {
    aud
    cad
    eur
    gbp
    jpy
    sek
    usd
    date
  }
}`) as unknown as TypedDocumentString<SharedDepositTransactionsQuery, SharedDepositTransactionsQueryVariables>;
export const BusinessLedgerInfoDocument = new TypedDocumentString(`
    query BusinessLedgerInfo($filters: BusinessTransactionsFilter) {
  businessTransactionsFromLedgerRecords(filters: $filters) {
    ... on BusinessTransactionsFromLedgerRecordsSuccessfulResult {
      __typename
      businessTransactions {
        amount {
          formatted
          raw
        }
        business {
          id
          name
        }
        foreignAmount {
          formatted
          raw
          currency
        }
        invoiceDate
        reference
        details
        counterAccount {
          __typename
          id
          name
        }
        chargeId
      }
    }
    ... on CommonError {
      __typename
      message
    }
  }
}
    `) as unknown as TypedDocumentString<BusinessLedgerInfoQuery, BusinessLedgerInfoQueryVariables>;
export const BusinessLedgerRecordsSummeryDocument = new TypedDocumentString(`
    query BusinessLedgerRecordsSummery($filters: BusinessTransactionsFilter) {
  businessTransactionsSumFromLedgerRecords(filters: $filters) {
    ... on BusinessTransactionsSumFromLedgerRecordsSuccessfulResult {
      __typename
      businessTransactionsSum {
        business {
          id
          name
        }
        credit {
          formatted
        }
        debit {
          formatted
        }
        total {
          formatted
          raw
        }
        foreignCurrenciesSum {
          currency
          credit {
            formatted
          }
          debit {
            formatted
          }
          total {
            formatted
            raw
          }
        }
      }
    }
    ... on CommonError {
      __typename
      message
    }
  }
}
    `) as unknown as TypedDocumentString<BusinessLedgerRecordsSummeryQuery, BusinessLedgerRecordsSummeryQueryVariables>;
export const BusinessTripScreenDocument = new TypedDocumentString(`
    query BusinessTripScreen($businessTripId: UUID!) {
  businessTrip(id: $businessTripId) {
    id
    name
    dates {
      start
    }
  }
}
    `) as unknown as TypedDocumentString<BusinessTripScreenQuery, BusinessTripScreenQueryVariables>;
export const BusinessTripsRowValidationDocument = new TypedDocumentString(`
    query BusinessTripsRowValidation($id: UUID!) {
  businessTrip(id: $id) {
    id
    uncategorizedTransactions {
      transaction {
        ... on Transaction @defer {
          id
        }
      }
    }
    summary {
      ... on BusinessTripSummary @defer {
        errors
      }
    }
  }
}
    `) as unknown as TypedDocumentString<BusinessTripsRowValidationQuery, BusinessTripsRowValidationQueryVariables>;
export const EditableBusinessTripDocument = new TypedDocumentString(`
    query EditableBusinessTrip($businessTripId: UUID!) {
  businessTrip(id: $businessTripId) {
    id
    ...BusinessTripReportHeaderFields
    ...BusinessTripReportAttendeesFields
    ...BusinessTripUncategorizedTransactionsFields
    ...BusinessTripReportFlightsFields
    ...BusinessTripReportAccommodationsFields
    ...BusinessTripReportTravelAndSubsistenceFields
    ...BusinessTripReportCarRentalFields
    ...BusinessTripReportOtherFields
    ...BusinessTripReportSummaryFields
    ... on BusinessTrip {
      uncategorizedTransactions {
        transaction {
          id
        }
      }
    }
  }
}
    fragment BusinessTripAccountantApprovalFields on BusinessTrip {
  id
  accountantApproval
}
fragment BusinessTripReportAccommodationsRowFields on BusinessTripAccommodationExpense {
  id
  ...BusinessTripReportCoreExpenseRowFields
  payedByEmployee
  country {
    id
    name
  }
  nightsCount
  attendeesStay {
    id
    attendee {
      id
      name
    }
    nightsCount
  }
}
fragment BusinessTripReportAccommodationsTableFields on BusinessTripAccommodationExpense {
  id
  date
  ...BusinessTripReportAccommodationsRowFields
}
fragment BusinessTripReportAccommodationsFields on BusinessTrip {
  id
  accommodationExpenses {
    id
    ...BusinessTripReportAccommodationsTableFields
  }
}
fragment BusinessTripReportAttendeeRowFields on BusinessTripAttendee {
  id
  name
  arrivalDate
  departureDate
  flights {
    id
    ...BusinessTripReportFlightsTableFields
  }
  accommodations {
    id
    ...BusinessTripReportAccommodationsTableFields
  }
}
fragment BusinessTripReportAttendeesFields on BusinessTrip {
  id
  attendees {
    id
    name
    ...BusinessTripReportAttendeeRowFields
  }
}
fragment BusinessTripReportCarRentalRowFields on BusinessTripCarRentalExpense {
  id
  payedByEmployee
  ...BusinessTripReportCoreExpenseRowFields
  days
  isFuelExpense
}
fragment BusinessTripReportCarRentalFields on BusinessTrip {
  id
  carRentalExpenses {
    id
    date
    ...BusinessTripReportCarRentalRowFields
  }
}
fragment BusinessTripReportCoreExpenseRowFields on BusinessTripExpense {
  id
  date
  valueDate
  amount {
    formatted
    raw
    currency
  }
  employee {
    id
    name
  }
  payedByEmployee
  charges {
    id
  }
}
fragment BusinessTripReportFlightsRowFields on BusinessTripFlightExpense {
  id
  payedByEmployee
  ...BusinessTripReportCoreExpenseRowFields
  path
  class
  attendees {
    id
    name
  }
}
fragment BusinessTripReportFlightsTableFields on BusinessTripFlightExpense {
  id
  date
  ...BusinessTripReportFlightsRowFields
}
fragment BusinessTripReportFlightsFields on BusinessTrip {
  id
  flightExpenses {
    id
    ...BusinessTripReportFlightsTableFields
  }
  attendees {
    id
    name
  }
}
fragment BusinessTripReportOtherRowFields on BusinessTripOtherExpense {
  id
  ...BusinessTripReportCoreExpenseRowFields
  payedByEmployee
  description
  deductibleExpense
}
fragment BusinessTripReportOtherFields on BusinessTrip {
  id
  otherExpenses {
    id
    date
    ...BusinessTripReportOtherRowFields
  }
}
fragment BusinessTripReportHeaderFields on BusinessTrip {
  id
  name
  dates {
    start
    end
  }
  purpose
  destination {
    id
    name
  }
  ...BusinessTripAccountantApprovalFields
}
fragment BusinessTripReportSummaryFields on BusinessTrip {
  id
  ... on BusinessTrip @defer {
    summary {
      excessExpenditure {
        formatted
      }
      excessTax
      rows {
        type
        totalForeignCurrency {
          formatted
        }
        totalLocalCurrency {
          formatted
        }
        taxableForeignCurrency {
          formatted
        }
        taxableLocalCurrency {
          formatted
        }
        maxTaxableForeignCurrency {
          formatted
        }
        maxTaxableLocalCurrency {
          formatted
        }
        excessExpenditure {
          formatted
        }
      }
      errors
    }
  }
}
fragment BusinessTripReportTravelAndSubsistenceRowFields on BusinessTripTravelAndSubsistenceExpense {
  id
  ...BusinessTripReportCoreExpenseRowFields
  payedByEmployee
  expenseType
}
fragment BusinessTripReportTravelAndSubsistenceFields on BusinessTrip {
  id
  travelAndSubsistenceExpenses {
    id
    date
    ...BusinessTripReportTravelAndSubsistenceRowFields
  }
}
fragment BusinessTripUncategorizedTransactionsFields on BusinessTrip {
  id
  uncategorizedTransactions {
    transaction {
      id
      eventDate
      chargeId
      amount {
        raw
      }
      ...TransactionsTableEventDateFields
      ...TransactionsTableDebitDateFields
      ...TransactionsTableAccountFields
      ...TransactionsTableDescriptionFields
      ...TransactionsTableSourceIDFields
      ...TransactionsTableEntityFields
    }
    ...UncategorizedTransactionsTableAmountFields
  }
}
fragment UncategorizedTransactionsTableAmountFields on UncategorizedTransaction {
  transaction {
    id
    amount {
      raw
      formatted
    }
    cryptoExchangeRate {
      rate
    }
  }
  categorizedAmount {
    raw
    formatted
  }
  errors
}
fragment TransactionsTableAccountFields on Transaction {
  id
  account {
    id
    name
    type
  }
}
fragment TransactionsTableEntityFields on Transaction {
  id
  counterparty {
    name
    id
  }
  sourceDescription
  missingInfoSuggestions {
    business {
      id
      name
    }
  }
}
fragment TransactionsTableDebitDateFields on Transaction {
  id
  effectiveDate
  sourceEffectiveDate
}
fragment TransactionsTableDescriptionFields on Transaction {
  id
  sourceDescription
}
fragment TransactionsTableEventDateFields on Transaction {
  id
  eventDate
}
fragment TransactionsTableSourceIDFields on Transaction {
  id
  referenceKey
}`) as unknown as TypedDocumentString<EditableBusinessTripQuery, EditableBusinessTripQueryVariables>;
export const BusinessTripsScreenDocument = new TypedDocumentString(`
    query BusinessTripsScreen {
  allBusinessTrips {
    id
    name
    dates {
      start
    }
    ...BusinessTripsRowFields
  }
}
    fragment BusinessTripsRowFields on BusinessTrip {
  id
  name
  accountantApproval
}`) as unknown as TypedDocumentString<BusinessTripsScreenQuery, BusinessTripsScreenQueryVariables>;
export const AdminFinancialAccountsSectionDocument = new TypedDocumentString(`
    query AdminFinancialAccountsSection($adminId: UUID!) {
  financialAccountsByOwner(ownerId: $adminId) {
    id
    __typename
    name
    number
    type
    privateOrBusiness
    accountTaxCategories {
      id
      currency
      taxCategory {
        id
        name
      }
    }
    ... on BankFinancialAccount {
      bankNumber
      branchNumber
      iban
      swiftCode
      extendedBankNumber
      partyPreferredIndication
      partyAccountInvolvementCode
      accountDealDate
      accountUpdateDate
      metegDoarNet
      kodHarshaatPeilut
      accountClosingReasonCode
      accountAgreementOpeningDate
      serviceAuthorizationDesc
      branchTypeCode
      mymailEntitlementSwitch
      productLabel
    }
  }
}
    `) as unknown as TypedDocumentString<AdminFinancialAccountsSectionQuery, AdminFinancialAccountsSectionQueryVariables>;
export const BusinessChargesSectionDocument = new TypedDocumentString(`
    query BusinessChargesSection($page: Int, $limit: Int, $filters: ChargeFilter) {
  allCharges(page: $page, limit: $limit, filters: $filters) {
    nodes {
      id
      ...ChargeForChargesTableFields
    }
    pageInfo {
      totalPages
    }
  }
}
    fragment ChargeForChargesTableFields on Charge {
  id
  __typename
  minEventDate
  minDebitDate
  minDocumentsDate
  maxDebitDate
  maxEventDate
  maxDocumentsDate
  totalAmount {
    raw
    currency
  }
  vat {
    raw
  }
  counterparty {
    name
    id
  }
  userDescription
  tags {
    id
    name
    namePath
  }
  taxCategory {
    id
    name
  }
  ... on BusinessTripCharge {
    businessTrip {
      id
      name
    }
  }
  metadata {
    transactionsCount
    documentsCount
    ledgerCount
    miscExpensesCount
    ... on ChargeMetadata @defer {
      invalidLedger
    }
  }
  accountantApproval
  ... on CreditcardBankCharge {
    validCreditCardAmount
  }
  ... on Charge {
    validationData {
      missingInfo
    }
  }
  ... on Charge {
    missingInfoSuggestions {
      description
      tags {
        id
        name
        namePath
      }
    }
  }
}`) as unknown as TypedDocumentString<BusinessChargesSectionQuery, BusinessChargesSectionQueryVariables>;
export const ClientContractsSectionDocument = new TypedDocumentString(`
    query ClientContractsSection($clientId: UUID!) {
  contractsByClient(clientId: $clientId) {
    id
    purchaseOrders
    startDate
    endDate
    amount {
      raw
      currency
    }
    billingCycle
    isActive
    product
    documentType
    remarks
    plan
    msCloud
    operationsLimit
  }
}
    `) as unknown as TypedDocumentString<ClientContractsSectionQuery, ClientContractsSectionQueryVariables>;
export const ClientIntegrationsSectionGreenInvoiceDocument = new TypedDocumentString(`
    query ClientIntegrationsSectionGreenInvoice($clientId: UUID!) {
  greenInvoiceClient(clientId: $clientId) {
    businessId
    greenInvoiceId
    country {
      id
      name
    }
    emails
    name
    phone
    taxId
    address
    city
    zip
    fax
    mobile
  }
}
    `) as unknown as TypedDocumentString<ClientIntegrationsSectionGreenInvoiceQuery, ClientIntegrationsSectionGreenInvoiceQueryVariables>;
export const ContractBasedDocumentDraftDocument = new TypedDocumentString(`
    query ContractBasedDocumentDraft($issueMonth: TimelessDate!, $contractId: UUID!) {
  periodicalDocumentDraftsByContracts(
    issueMonth: $issueMonth
    contractIds: [$contractId]
  ) {
    ...NewDocumentDraft
  }
}
    fragment IssueDocumentClientFields on Client {
  id
  originalBusiness {
    id
    address
    city
    zipCode
    country {
      id
      code
    }
    governmentId
    name
    phoneNumber
  }
  emails
}
fragment NewDocumentDraft on DocumentDraft {
  description
  remarks
  footer
  type
  date
  dueDate
  language
  currency
  vatType
  discount {
    amount
    type
  }
  rounding
  signed
  maxPayments
  client {
    id
    originalBusiness {
      id
      name
    }
    integrations {
      id
    }
    emails
    ...IssueDocumentClientFields
  }
  income {
    currency
    currencyRate
    description
    itemId
    price
    quantity
    vatRate
    vatType
  }
  payment {
    currency
    currencyRate
    date
    price
    type
    bankName
    bankBranch
    bankAccount
    chequeNum
    accountId
    transactionId
    cardType
    cardNum
    numPayments
    firstPayment
  }
  linkedDocumentIds
  linkedPaymentId
}`) as unknown as TypedDocumentString<ContractBasedDocumentDraftQuery, ContractBasedDocumentDraftQueryVariables>;
export const BusinessLedgerSectionDocument = new TypedDocumentString(`
    query BusinessLedgerSection($businessId: UUID!) {
  ledgerRecordsByFinancialEntity(financialEntityId: $businessId) {
    id
    ...LedgerRecordsTableFields
  }
}
    fragment LedgerRecordsTableFields on LedgerRecord {
  id
  creditAccount1 {
    __typename
    id
    name
  }
  creditAccount2 {
    __typename
    id
    name
  }
  debitAccount1 {
    __typename
    id
    name
  }
  debitAccount2 {
    __typename
    id
    name
  }
  creditAmount1 {
    formatted
    currency
  }
  creditAmount2 {
    formatted
    currency
  }
  debitAmount1 {
    formatted
    currency
  }
  debitAmount2 {
    formatted
    currency
  }
  localCurrencyCreditAmount1 {
    formatted
    raw
  }
  localCurrencyCreditAmount2 {
    formatted
    raw
  }
  localCurrencyDebitAmount1 {
    formatted
    raw
  }
  localCurrencyDebitAmount2 {
    formatted
    raw
  }
  invoiceDate
  valueDate
  description
  reference
}`) as unknown as TypedDocumentString<BusinessLedgerSectionQuery, BusinessLedgerSectionQueryVariables>;
export const BusinessTransactionsSectionDocument = new TypedDocumentString(`
    query BusinessTransactionsSection($businessId: UUID!) {
  transactionsByFinancialEntity(financialEntityID: $businessId) {
    id
    ...TransactionForTransactionsTableFields
    ...TransactionToDownloadForTransactionsTableFields
  }
}
    fragment TransactionForTransactionsTableFields on Transaction {
  id
  isFee
  chargeId
  eventDate
  effectiveDate
  sourceEffectiveDate
  amount {
    raw
    formatted
  }
  cryptoExchangeRate {
    rate
  }
  account {
    id
    name
    type
  }
  sourceDescription
  referenceKey
  counterparty {
    name
    id
  }
  missingInfoSuggestions {
    business {
      id
      name
    }
  }
}
fragment TransactionToDownloadForTransactionsTableFields on Transaction {
  id
  account {
    id
    name
    type
  }
  amount {
    currency
    raw
  }
  counterparty {
    id
    name
  }
  effectiveDate
  eventDate
  referenceKey
  sourceDescription
}`) as unknown as TypedDocumentString<BusinessTransactionsSectionQuery, BusinessTransactionsSectionQueryVariables>;
export const AllBusinessesForScreenDocument = new TypedDocumentString(`
    query AllBusinessesForScreen {
  allBusinesses {
    nodes {
      __typename
      id
      name
      ... on LtdFinancialEntity {
        hebrewName
        governmentId
        country {
          id
          code
        }
        city
        zipCode
        createdAt
        updatedAt
        sortCode {
          id
          key
          name
        }
        taxCategory {
          id
          name
        }
        irsCode
        pcn874RecordType
        isClient
        isAdmin
        isActive
        suggestions {
          description
          tags {
            id
            name
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<AllBusinessesForScreenQuery, AllBusinessesForScreenQueryVariables>;
export const BusinessesUsageDocument = new TypedDocumentString(`
    query BusinessesUsage($ids: [UUID!]!) {
  businessesUsage(ids: $ids) {
    id
    businessId
    totalTransactions
    totalDocuments
    totalMiscExpenses
    totalLedgerRecords
  }
}
    `) as unknown as TypedDocumentString<BusinessesUsageQuery, BusinessesUsageQueryVariables>;
export const ChargeExtendedInfoForChargeMatchesDocument = new TypedDocumentString(`
    query ChargeExtendedInfoForChargeMatches($chargeId: UUID!) {
  charge(chargeId: $chargeId) {
    id
    transactions {
      id
      ...TransactionForTransactionsTableFields
    }
    additionalDocuments {
      id
      ...TableDocumentsRowFields
    }
  }
}
    fragment TableDocumentsRowFields on Document {
  id
  documentType
  image
  file
  description
  remarks
  charge {
    id
  }
  ... on FinancialDocument {
    amount {
      raw
      formatted
      currency
    }
    missingInfoSuggestions {
      amount {
        raw
        formatted
        currency
      }
      isIncome
      counterparty {
        id
        name
      }
      owner {
        id
        name
      }
    }
    date
    vat {
      raw
      formatted
      currency
    }
    serialNumber
    allocationNumber
    creditor {
      id
      name
    }
    debtor {
      id
      name
    }
    issuedDocumentInfo {
      id
      status
      originalDocument {
        income {
          description
        }
      }
    }
  }
}
fragment TransactionForTransactionsTableFields on Transaction {
  id
  isFee
  chargeId
  eventDate
  effectiveDate
  sourceEffectiveDate
  amount {
    raw
    formatted
  }
  cryptoExchangeRate {
    rate
  }
  account {
    id
    name
    type
  }
  sourceDescription
  referenceKey
  counterparty {
    name
    id
  }
  missingInfoSuggestions {
    business {
      id
      name
    }
  }
}`) as unknown as TypedDocumentString<ChargeExtendedInfoForChargeMatchesQuery, ChargeExtendedInfoForChargeMatchesQueryVariables>;
export const ChargesAwaitingMatchQueueDocument = new TypedDocumentString(`
    query ChargesAwaitingMatchQueue($limit: Int, $offset: Int, $businessId: UUID, $fromDate: TimelessDate, $toDate: TimelessDate, $mode: ChargeMatchQueueMode, $sortBy: ChargeMatchQueueSortBy) {
  chargesAwaitingMatchQueue(
    limit: $limit
    offset: $offset
    businessId: $businessId
    fromDate: $fromDate
    toDate: $toDate
    mode: $mode
    sortBy: $sortBy
  ) {
    totalCount
    baseCharges {
      id
      baseCharge {
        ...ChargeMatchCardFields
      }
      suggestions {
        chargeId
        confidenceScore
        charge {
          ...ChargeMatchCardFields
        }
      }
    }
  }
}
    fragment ChargeMatchCardFields on Charge {
  __typename
  id
  minEventDate
  minDebitDate
  minDocumentsDate
  totalAmount {
    raw
    formatted
    currency
  }
  counterparty {
    id
    name
  }
  userDescription
  additionalDocuments {
    id
    documentType
    image
    file
  }
  transactions {
    id
    eventDate
    sourceDescription
    amount {
      raw
      formatted
    }
  }
  miscExpenses {
    id
    description
    amount {
      formatted
    }
  }
}`) as unknown as TypedDocumentString<ChargesAwaitingMatchQueueQuery, ChargesAwaitingMatchQueueQueryVariables>;
export const ChargesLedgerValidationDocument = new TypedDocumentString(`
    query ChargesLedgerValidation($limit: Int, $filters: ChargeFilter) {
  chargesWithLedgerChanges(limit: $limit, filters: $filters) @stream {
    progress
    charge {
      id
      ...ChargeForChargesTableFields
    }
  }
}
    fragment ChargeForChargesTableFields on Charge {
  id
  __typename
  minEventDate
  minDebitDate
  minDocumentsDate
  maxDebitDate
  maxEventDate
  maxDocumentsDate
  totalAmount {
    raw
    currency
  }
  vat {
    raw
  }
  counterparty {
    name
    id
  }
  userDescription
  tags {
    id
    name
    namePath
  }
  taxCategory {
    id
    name
  }
  ... on BusinessTripCharge {
    businessTrip {
      id
      name
    }
  }
  metadata {
    transactionsCount
    documentsCount
    ledgerCount
    miscExpensesCount
    ... on ChargeMetadata @defer {
      invalidLedger
    }
  }
  accountantApproval
  ... on CreditcardBankCharge {
    validCreditCardAmount
  }
  ... on Charge {
    validationData {
      missingInfo
    }
  }
  ... on Charge {
    missingInfoSuggestions {
      description
      tags {
        id
        name
        namePath
      }
    }
  }
}`) as unknown as TypedDocumentString<ChargesLedgerValidationQuery, ChargesLedgerValidationQueryVariables>;
export const FetchChargeDocument = new TypedDocumentString(`
    query FetchCharge($chargeId: UUID!) {
  charge(chargeId: $chargeId) {
    id
    ...ChargeExpansionFields
  }
}
    fragment ChargesTableErrorsFields on Charge {
  id
  errorsLedger: ledger {
    validate {
      errors
    }
  }
}
fragment ChargeExpansionFields on Charge {
  id
  __typename
  metadata {
    transactionsCount
    documentsCount
    receiptsCount
    invoicesCount
    ledgerCount
    miscExpensesCount
    isLedgerLocked
    openDocuments
  }
  totalAmount {
    raw
  }
  ...DocumentsGalleryFields @defer
  ...TableDocumentsFields @defer
  ...ChargeLedgerRecordsTableFields @defer
  ...ChargeTableTransactionsFields @defer
  ...ConversionChargeInfo @defer
  ...CreditcardBankChargeInfo @defer
  ...TableSalariesFields @defer
  ... on BusinessTripCharge {
    businessTrip {
      id
      ...BusinessTripReportFields
    }
  }
  ...ChargesTableErrorsFields @defer
  ...TableMiscExpensesFields @defer
  ...ExchangeRatesInfo @defer
}
fragment TableDocumentsFields on Charge {
  id
  additionalDocuments {
    id
    ...TableDocumentsRowFields
  }
}
fragment ChargeLedgerRecordsTableFields on Charge {
  id
  ledger {
    __typename
    records {
      id
      ...LedgerRecordsTableFields
    }
    ... on Ledger @defer {
      validate {
        ... on LedgerValidation @defer {
          matches
          differences {
            id
            ...LedgerRecordsTableFields
          }
        }
      }
    }
  }
}
fragment ChargeTableTransactionsFields on Charge {
  id
  transactions {
    id
    ...TransactionForTransactionsTableFields
  }
}
fragment ConversionChargeInfo on Charge {
  id
  __typename
  ... on ConversionCharge {
    eventRate {
      from
      to
      rate
    }
    officialRate {
      from
      to
      rate
    }
  }
}
fragment CreditcardBankChargeInfo on Charge {
  id
  __typename
  ... on CreditcardBankCharge {
    creditCardTransactions {
      id
      ...TransactionForTransactionsTableFields
    }
  }
}
fragment ExchangeRatesInfo on Charge {
  id
  __typename
  ... on FinancialCharge {
    exchangeRates {
      aud
      cad
      eur
      gbp
      ils
      jpy
      sek
      usd
      eth
      grt
      usdc
    }
  }
}
fragment TableMiscExpensesFields on Charge {
  id
  miscExpenses {
    id
    amount {
      formatted
    }
    description
    invoiceDate
    valueDate
    creditor {
      id
      name
    }
    debtor {
      id
      name
    }
    chargeId
    ...EditMiscExpenseFields
  }
}
fragment TableSalariesFields on Charge {
  id
  __typename
  ... on SalaryCharge {
    salaryRecords {
      directAmount {
        formatted
      }
      baseAmount {
        formatted
      }
      employee {
        id
        name
      }
      pensionFund {
        id
        name
      }
      pensionEmployeeAmount {
        formatted
      }
      pensionEmployerAmount {
        formatted
      }
      compensationsAmount {
        formatted
      }
      trainingFund {
        id
        name
      }
      trainingFundEmployeeAmount {
        formatted
      }
      trainingFundEmployerAmount {
        formatted
      }
      socialSecurityEmployeeAmount {
        formatted
      }
      socialSecurityEmployerAmount {
        formatted
      }
      incomeTaxAmount {
        formatted
      }
      healthInsuranceAmount {
        formatted
      }
    }
  }
}
fragment BusinessTripReportFields on BusinessTrip {
  id
  ...BusinessTripReportHeaderFields
  ...BusinessTripReportSummaryFields
}
fragment BusinessTripAccountantApprovalFields on BusinessTrip {
  id
  accountantApproval
}
fragment BusinessTripReportHeaderFields on BusinessTrip {
  id
  name
  dates {
    start
    end
  }
  purpose
  destination {
    id
    name
  }
  ...BusinessTripAccountantApprovalFields
}
fragment BusinessTripReportSummaryFields on BusinessTrip {
  id
  ... on BusinessTrip @defer {
    summary {
      excessExpenditure {
        formatted
      }
      excessTax
      rows {
        type
        totalForeignCurrency {
          formatted
        }
        totalLocalCurrency {
          formatted
        }
        taxableForeignCurrency {
          formatted
        }
        taxableLocalCurrency {
          formatted
        }
        maxTaxableForeignCurrency {
          formatted
        }
        maxTaxableLocalCurrency {
          formatted
        }
        excessExpenditure {
          formatted
        }
      }
      errors
    }
  }
}
fragment EditMiscExpenseFields on MiscExpense {
  id
  amount {
    raw
    currency
  }
  description
  invoiceDate
  valueDate
  creditor {
    id
  }
  debtor {
    id
  }
}
fragment TableDocumentsRowFields on Document {
  id
  documentType
  image
  file
  description
  remarks
  charge {
    id
  }
  ... on FinancialDocument {
    amount {
      raw
      formatted
      currency
    }
    missingInfoSuggestions {
      amount {
        raw
        formatted
        currency
      }
      isIncome
      counterparty {
        id
        name
      }
      owner {
        id
        name
      }
    }
    date
    vat {
      raw
      formatted
      currency
    }
    serialNumber
    allocationNumber
    creditor {
      id
      name
    }
    debtor {
      id
      name
    }
    issuedDocumentInfo {
      id
      status
      originalDocument {
        income {
          description
        }
      }
    }
  }
}
fragment DocumentsGalleryFields on Charge {
  id
  additionalDocuments {
    id
    image
    ... on FinancialDocument {
      documentType
    }
  }
}
fragment LedgerRecordsTableFields on LedgerRecord {
  id
  creditAccount1 {
    __typename
    id
    name
  }
  creditAccount2 {
    __typename
    id
    name
  }
  debitAccount1 {
    __typename
    id
    name
  }
  debitAccount2 {
    __typename
    id
    name
  }
  creditAmount1 {
    formatted
    currency
  }
  creditAmount2 {
    formatted
    currency
  }
  debitAmount1 {
    formatted
    currency
  }
  debitAmount2 {
    formatted
    currency
  }
  localCurrencyCreditAmount1 {
    formatted
    raw
  }
  localCurrencyCreditAmount2 {
    formatted
    raw
  }
  localCurrencyDebitAmount1 {
    formatted
    raw
  }
  localCurrencyDebitAmount2 {
    formatted
    raw
  }
  invoiceDate
  valueDate
  description
  reference
}
fragment TransactionForTransactionsTableFields on Transaction {
  id
  isFee
  chargeId
  eventDate
  effectiveDate
  sourceEffectiveDate
  amount {
    raw
    formatted
  }
  cryptoExchangeRate {
    rate
  }
  account {
    id
    name
    type
  }
  sourceDescription
  referenceKey
  counterparty {
    name
    id
  }
  missingInfoSuggestions {
    business {
      id
      name
    }
  }
}`) as unknown as TypedDocumentString<FetchChargeQuery, FetchChargeQueryVariables>;
export const ChargesExtendedInfoBatchDocument = new TypedDocumentString(`
    query ChargesExtendedInfoBatch($chargeIDs: [UUID!]!) {
  chargesByIDs(chargeIDs: $chargeIDs) {
    id
    ...ChargeExpansionFields
  }
}
    fragment ChargesTableErrorsFields on Charge {
  id
  errorsLedger: ledger {
    validate {
      errors
    }
  }
}
fragment ChargeExpansionFields on Charge {
  id
  __typename
  metadata {
    transactionsCount
    documentsCount
    receiptsCount
    invoicesCount
    ledgerCount
    miscExpensesCount
    isLedgerLocked
    openDocuments
  }
  totalAmount {
    raw
  }
  ...DocumentsGalleryFields @defer
  ...TableDocumentsFields @defer
  ...ChargeLedgerRecordsTableFields @defer
  ...ChargeTableTransactionsFields @defer
  ...ConversionChargeInfo @defer
  ...CreditcardBankChargeInfo @defer
  ...TableSalariesFields @defer
  ... on BusinessTripCharge {
    businessTrip {
      id
      ...BusinessTripReportFields
    }
  }
  ...ChargesTableErrorsFields @defer
  ...TableMiscExpensesFields @defer
  ...ExchangeRatesInfo @defer
}
fragment TableDocumentsFields on Charge {
  id
  additionalDocuments {
    id
    ...TableDocumentsRowFields
  }
}
fragment ChargeLedgerRecordsTableFields on Charge {
  id
  ledger {
    __typename
    records {
      id
      ...LedgerRecordsTableFields
    }
    ... on Ledger @defer {
      validate {
        ... on LedgerValidation @defer {
          matches
          differences {
            id
            ...LedgerRecordsTableFields
          }
        }
      }
    }
  }
}
fragment ChargeTableTransactionsFields on Charge {
  id
  transactions {
    id
    ...TransactionForTransactionsTableFields
  }
}
fragment ConversionChargeInfo on Charge {
  id
  __typename
  ... on ConversionCharge {
    eventRate {
      from
      to
      rate
    }
    officialRate {
      from
      to
      rate
    }
  }
}
fragment CreditcardBankChargeInfo on Charge {
  id
  __typename
  ... on CreditcardBankCharge {
    creditCardTransactions {
      id
      ...TransactionForTransactionsTableFields
    }
  }
}
fragment ExchangeRatesInfo on Charge {
  id
  __typename
  ... on FinancialCharge {
    exchangeRates {
      aud
      cad
      eur
      gbp
      ils
      jpy
      sek
      usd
      eth
      grt
      usdc
    }
  }
}
fragment TableMiscExpensesFields on Charge {
  id
  miscExpenses {
    id
    amount {
      formatted
    }
    description
    invoiceDate
    valueDate
    creditor {
      id
      name
    }
    debtor {
      id
      name
    }
    chargeId
    ...EditMiscExpenseFields
  }
}
fragment TableSalariesFields on Charge {
  id
  __typename
  ... on SalaryCharge {
    salaryRecords {
      directAmount {
        formatted
      }
      baseAmount {
        formatted
      }
      employee {
        id
        name
      }
      pensionFund {
        id
        name
      }
      pensionEmployeeAmount {
        formatted
      }
      pensionEmployerAmount {
        formatted
      }
      compensationsAmount {
        formatted
      }
      trainingFund {
        id
        name
      }
      trainingFundEmployeeAmount {
        formatted
      }
      trainingFundEmployerAmount {
        formatted
      }
      socialSecurityEmployeeAmount {
        formatted
      }
      socialSecurityEmployerAmount {
        formatted
      }
      incomeTaxAmount {
        formatted
      }
      healthInsuranceAmount {
        formatted
      }
    }
  }
}
fragment BusinessTripReportFields on BusinessTrip {
  id
  ...BusinessTripReportHeaderFields
  ...BusinessTripReportSummaryFields
}
fragment BusinessTripAccountantApprovalFields on BusinessTrip {
  id
  accountantApproval
}
fragment BusinessTripReportHeaderFields on BusinessTrip {
  id
  name
  dates {
    start
    end
  }
  purpose
  destination {
    id
    name
  }
  ...BusinessTripAccountantApprovalFields
}
fragment BusinessTripReportSummaryFields on BusinessTrip {
  id
  ... on BusinessTrip @defer {
    summary {
      excessExpenditure {
        formatted
      }
      excessTax
      rows {
        type
        totalForeignCurrency {
          formatted
        }
        totalLocalCurrency {
          formatted
        }
        taxableForeignCurrency {
          formatted
        }
        taxableLocalCurrency {
          formatted
        }
        maxTaxableForeignCurrency {
          formatted
        }
        maxTaxableLocalCurrency {
          formatted
        }
        excessExpenditure {
          formatted
        }
      }
      errors
    }
  }
}
fragment EditMiscExpenseFields on MiscExpense {
  id
  amount {
    raw
    currency
  }
  description
  invoiceDate
  valueDate
  creditor {
    id
  }
  debtor {
    id
  }
}
fragment TableDocumentsRowFields on Document {
  id
  documentType
  image
  file
  description
  remarks
  charge {
    id
  }
  ... on FinancialDocument {
    amount {
      raw
      formatted
      currency
    }
    missingInfoSuggestions {
      amount {
        raw
        formatted
        currency
      }
      isIncome
      counterparty {
        id
        name
      }
      owner {
        id
        name
      }
    }
    date
    vat {
      raw
      formatted
      currency
    }
    serialNumber
    allocationNumber
    creditor {
      id
      name
    }
    debtor {
      id
      name
    }
    issuedDocumentInfo {
      id
      status
      originalDocument {
        income {
          description
        }
      }
    }
  }
}
fragment DocumentsGalleryFields on Charge {
  id
  additionalDocuments {
    id
    image
    ... on FinancialDocument {
      documentType
    }
  }
}
fragment LedgerRecordsTableFields on LedgerRecord {
  id
  creditAccount1 {
    __typename
    id
    name
  }
  creditAccount2 {
    __typename
    id
    name
  }
  debitAccount1 {
    __typename
    id
    name
  }
  debitAccount2 {
    __typename
    id
    name
  }
  creditAmount1 {
    formatted
    currency
  }
  creditAmount2 {
    formatted
    currency
  }
  debitAmount1 {
    formatted
    currency
  }
  debitAmount2 {
    formatted
    currency
  }
  localCurrencyCreditAmount1 {
    formatted
    raw
  }
  localCurrencyCreditAmount2 {
    formatted
    raw
  }
  localCurrencyDebitAmount1 {
    formatted
    raw
  }
  localCurrencyDebitAmount2 {
    formatted
    raw
  }
  invoiceDate
  valueDate
  description
  reference
}
fragment TransactionForTransactionsTableFields on Transaction {
  id
  isFee
  chargeId
  eventDate
  effectiveDate
  sourceEffectiveDate
  amount {
    raw
    formatted
  }
  cryptoExchangeRate {
    rate
  }
  account {
    id
    name
    type
  }
  sourceDescription
  referenceKey
  counterparty {
    name
    id
  }
  missingInfoSuggestions {
    business {
      id
      name
    }
  }
}`) as unknown as TypedDocumentString<ChargesExtendedInfoBatchQuery, ChargesExtendedInfoBatchQueryVariables>;
export const RefetchChargeForChargesTableDocument = new TypedDocumentString(`
    query RefetchChargeForChargesTable($chargeId: UUID!) {
  charge(chargeId: $chargeId) {
    id
    ...ChargeForChargesTableFields
  }
}
    fragment ChargeForChargesTableFields on Charge {
  id
  __typename
  minEventDate
  minDebitDate
  minDocumentsDate
  maxDebitDate
  maxEventDate
  maxDocumentsDate
  totalAmount {
    raw
    currency
  }
  vat {
    raw
  }
  counterparty {
    name
    id
  }
  userDescription
  tags {
    id
    name
    namePath
  }
  taxCategory {
    id
    name
  }
  ... on BusinessTripCharge {
    businessTrip {
      id
      name
    }
  }
  metadata {
    transactionsCount
    documentsCount
    ledgerCount
    miscExpensesCount
    ... on ChargeMetadata @defer {
      invalidLedger
    }
  }
  accountantApproval
  ... on CreditcardBankCharge {
    validCreditCardAmount
  }
  ... on Charge {
    validationData {
      missingInfo
    }
  }
  ... on Charge {
    missingInfoSuggestions {
      description
      tags {
        id
        name
        namePath
      }
    }
  }
}`) as unknown as TypedDocumentString<RefetchChargeForChargesTableQuery, RefetchChargeForChargesTableQueryVariables>;
export const ChargesForCsvExportDocument = new TypedDocumentString(`
    query ChargesForCsvExport($chargeIDs: [UUID!]!) {
  chargesByIDs(chargeIDs: $chargeIDs) {
    id
    ...ChargeForCsvExportFields
  }
}
    fragment ChargeForCsvExportFields on Charge {
  id
  __typename
  minEventDate
  minDebitDate
  minDocumentsDate
  totalAmount {
    raw
    currency
  }
  vat {
    raw
  }
  counterparty {
    id
    name
  }
  userDescription
  tags {
    id
    name
  }
  taxCategory {
    id
    name
  }
  accountantApproval
  validationData {
    isValid
    missingInfo
  }
  missingInfoSuggestions {
    description
    tags {
      id
      name
    }
  }
  metadata {
    transactionsCount
    documentsCount
    invoicesCount
    receiptsCount
    ledgerCount
    miscExpensesCount
    openDocuments
    invalidLedger
  }
  ledger {
    balance {
      isBalanced
    }
    validate {
      isValid
      errors
    }
  }
  transactions {
    id
    ...TransactionForTransactionsTableFields
  }
  additionalDocuments {
    id
    ...TableDocumentsRowFields
  }
  ... on BusinessTripCharge {
    businessTrip {
      id
      name
    }
  }
  ... on CreditcardBankCharge {
    validCreditCardAmount
  }
}
fragment TableDocumentsRowFields on Document {
  id
  documentType
  image
  file
  description
  remarks
  charge {
    id
  }
  ... on FinancialDocument {
    amount {
      raw
      formatted
      currency
    }
    missingInfoSuggestions {
      amount {
        raw
        formatted
        currency
      }
      isIncome
      counterparty {
        id
        name
      }
      owner {
        id
        name
      }
    }
    date
    vat {
      raw
      formatted
      currency
    }
    serialNumber
    allocationNumber
    creditor {
      id
      name
    }
    debtor {
      id
      name
    }
    issuedDocumentInfo {
      id
      status
      originalDocument {
        income {
          description
        }
      }
    }
  }
}
fragment TransactionForTransactionsTableFields on Transaction {
  id
  isFee
  chargeId
  eventDate
  effectiveDate
  sourceEffectiveDate
  amount {
    raw
    formatted
  }
  cryptoExchangeRate {
    rate
  }
  account {
    id
    name
    type
  }
  sourceDescription
  referenceKey
  counterparty {
    name
    id
  }
  missingInfoSuggestions {
    business {
      id
      name
    }
  }
}`) as unknown as TypedDocumentString<ChargesForCsvExportQuery, ChargesForCsvExportQueryVariables>;
export const BankDepositInfoDocument = new TypedDocumentString(`
    query BankDepositInfo($chargeId: UUID!) {
  depositByCharge(chargeId: $chargeId) {
    id
    name
    metadata {
      id
      currentBalance {
        formatted
      }
      transactions {
        id
        chargeId
        ...TransactionForTransactionsTableFields
      }
    }
    isOpen
  }
}
    fragment TransactionForTransactionsTableFields on Transaction {
  id
  isFee
  chargeId
  eventDate
  effectiveDate
  sourceEffectiveDate
  amount {
    raw
    formatted
  }
  cryptoExchangeRate {
    rate
  }
  account {
    id
    name
    type
  }
  sourceDescription
  referenceKey
  counterparty {
    name
    id
  }
  missingInfoSuggestions {
    business {
      id
      name
    }
  }
}`) as unknown as TypedDocumentString<BankDepositInfoQuery, BankDepositInfoQueryVariables>;
export const ChargeMatchesDocument = new TypedDocumentString(`
    query ChargeMatches($chargeId: UUID!) {
  findChargeMatches(chargeId: $chargeId) {
    matches {
      chargeId
      ...ChargeMatchesTableFields
    }
  }
}
    fragment ChargeMatchesTableFields on ChargeMatch {
  charge {
    id
    __typename
    minEventDate
    minDebitDate
    minDocumentsDate
    totalAmount {
      raw
      formatted
    }
    vat {
      raw
      formatted
    }
    counterparty {
      name
      id
    }
    userDescription
    tags {
      id
      name
      namePath
    }
    taxCategory {
      id
      name
    }
  }
  confidenceScore
}`) as unknown as TypedDocumentString<ChargeMatchesQuery, ChargeMatchesQueryVariables>;
export const IncomeChargesChartDocument = new TypedDocumentString(`
    query IncomeChargesChart($filters: ChargeFilter) {
  allCharges(filters: $filters) {
    nodes {
      id
      transactions {
        id
        eventDate
        effectiveDate
        amount {
          currency
          formatted
          raw
        }
        eventExchangeRates {
          aud
          cad
          eur
          gbp
          jpy
          sek
          usd
          date
        }
        debitExchangeRates {
          aud
          cad
          eur
          gbp
          jpy
          sek
          usd
          date
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<IncomeChargesChartQuery, IncomeChargesChartQueryVariables>;
export const MonthlyIncomeExpenseChartDocument = new TypedDocumentString(`
    query MonthlyIncomeExpenseChart($filters: IncomeExpenseChartFilters!) {
  incomeExpenseChart(filters: $filters) {
    fromDate
    toDate
    currency
    ...MonthlyIncomeExpenseChartInfo
  }
}
    fragment MonthlyIncomeExpenseChartInfo on IncomeExpenseChart {
  monthlyData {
    income {
      formatted
      raw
    }
    expense {
      formatted
      raw
    }
    balance {
      formatted
      raw
    }
    date
  }
}`) as unknown as TypedDocumentString<MonthlyIncomeExpenseChartQuery, MonthlyIncomeExpenseChartQueryVariables>;
export const ContractsEditModalDocument = new TypedDocumentString(`
    query ContractsEditModal($contractId: UUID!) {
  contractsById(id: $contractId) {
    id
    startDate
    endDate
    purchaseOrders
    amount {
      raw
      currency
    }
    product
    msCloud
    billingCycle
    plan
    isActive
    remarks
    documentType
    operationsLimit
  }
}
    `) as unknown as TypedDocumentString<ContractsEditModalQuery, ContractsEditModalQueryVariables>;
export const UncategorizedTransactionsByBusinessTripDocument = new TypedDocumentString(`
    query UncategorizedTransactionsByBusinessTrip($businessTripId: UUID!) {
  businessTrip(id: $businessTripId) {
    id
    uncategorizedTransactions {
      transaction {
        id
        eventDate
        sourceDescription
        referenceKey
        counterparty {
          id
          name
        }
        amount {
          formatted
          raw
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<UncategorizedTransactionsByBusinessTripQuery, UncategorizedTransactionsByBusinessTripQueryVariables>;
export const ChargeDepreciationDocument = new TypedDocumentString(`
    query ChargeDepreciation($chargeId: UUID!) {
  depreciationRecordsByCharge(chargeId: $chargeId) {
    id
    ...DepreciationRecordRowFields
  }
}
    fragment DepreciationRecordRowFields on DepreciationRecord {
  id
  amount {
    currency
    formatted
    raw
  }
  activationDate
  category {
    id
    name
    percentage
  }
  type
  charge {
    id
    totalAmount {
      currency
      formatted
      raw
    }
  }
}`) as unknown as TypedDocumentString<ChargeDepreciationQuery, ChargeDepreciationQueryVariables>;
export const RecentBusinessIssuedDocumentsDocument = new TypedDocumentString(`
    query RecentBusinessIssuedDocuments($businessId: UUID!, $limit: Int) {
  recentDocumentsByBusiness(businessId: $businessId, limit: $limit) {
    id
    ... on FinancialDocument {
      issuedDocumentInfo {
        id
        status
        externalId
      }
    }
    ...TableDocumentsRowFields
  }
}
    fragment TableDocumentsRowFields on Document {
  id
  documentType
  image
  file
  description
  remarks
  charge {
    id
  }
  ... on FinancialDocument {
    amount {
      raw
      formatted
      currency
    }
    missingInfoSuggestions {
      amount {
        raw
        formatted
        currency
      }
      isIncome
      counterparty {
        id
        name
      }
      owner {
        id
        name
      }
    }
    date
    vat {
      raw
      formatted
      currency
    }
    serialNumber
    allocationNumber
    creditor {
      id
      name
    }
    debtor {
      id
      name
    }
    issuedDocumentInfo {
      id
      status
      originalDocument {
        income {
          description
        }
      }
    }
  }
}`) as unknown as TypedDocumentString<RecentBusinessIssuedDocumentsQuery, RecentBusinessIssuedDocumentsQueryVariables>;
export const RecentIssuedDocumentsOfSameTypeDocument = new TypedDocumentString(`
    query RecentIssuedDocumentsOfSameType($documentType: DocumentType!) {
  recentIssuedDocumentsByType(documentType: $documentType) {
    id
    ...TableDocumentsRowFields
  }
}
    fragment TableDocumentsRowFields on Document {
  id
  documentType
  image
  file
  description
  remarks
  charge {
    id
  }
  ... on FinancialDocument {
    amount {
      raw
      formatted
      currency
    }
    missingInfoSuggestions {
      amount {
        raw
        formatted
        currency
      }
      isIncome
      counterparty {
        id
        name
      }
      owner {
        id
        name
      }
    }
    date
    vat {
      raw
      formatted
      currency
    }
    serialNumber
    allocationNumber
    creditor {
      id
      name
    }
    debtor {
      id
      name
    }
    issuedDocumentInfo {
      id
      status
      originalDocument {
        income {
          description
        }
      }
    }
  }
}`) as unknown as TypedDocumentString<RecentIssuedDocumentsOfSameTypeQuery, RecentIssuedDocumentsOfSameTypeQueryVariables>;
export const EditDocumentDocument = new TypedDocumentString(`
    query EditDocument($documentId: UUID!) {
  documentById(documentId: $documentId) {
    id
    image
    file
    documentType
    description
    remarks
    __typename
    ... on FinancialDocument {
      vat {
        raw
        currency
      }
      serialNumber
      date
      amount {
        raw
        currency
      }
      debtor {
        id
        name
      }
      creditor {
        id
        name
      }
      vatReportDateOverride
      noVatAmount
      allocationNumber
      exchangeRateOverride
    }
    ... on Unprocessed {
      vat {
        raw
        currency
      }
      serialNumber
      date
      amount {
        raw
        currency
      }
      debtor {
        id
        name
      }
      creditor {
        id
        name
      }
      vatReportDateOverride
      noVatAmount
      allocationNumber
      exchangeRateOverride
    }
    ... on OtherDocument {
      vat {
        raw
        currency
      }
      serialNumber
      date
      amount {
        raw
        currency
      }
      debtor {
        id
        name
      }
      creditor {
        id
        name
      }
      vatReportDateOverride
      noVatAmount
      allocationNumber
      exchangeRateOverride
    }
  }
}
    `) as unknown as TypedDocumentString<EditDocumentQuery, EditDocumentQueryVariables>;
export const EditTransactionDocument = new TypedDocumentString(`
    query EditTransaction($transactionIDs: [UUID!]!) {
  transactionsByIDs(transactionIDs: $transactionIDs) {
    id
    counterparty {
      id
      name
    }
    effectiveDate
    isFee
    account {
      type
      id
    }
  }
}
    `) as unknown as TypedDocumentString<EditTransactionQuery, EditTransactionQueryVariables>;
export const ClientInfoForDocumentIssuingDocument = new TypedDocumentString(`
    query ClientInfoForDocumentIssuing($businessId: UUID!) {
  client(businessId: $businessId) {
    id
    integrations {
      id
      greenInvoiceInfo {
        greenInvoiceId
        businessId
        name
      }
    }
    ...IssueDocumentClientFields
  }
}
    fragment IssueDocumentClientFields on Client {
  id
  originalBusiness {
    id
    address
    city
    zipCode
    country {
      id
      code
    }
    governmentId
    name
    phoneNumber
  }
  emails
}`) as unknown as TypedDocumentString<ClientInfoForDocumentIssuingQuery, ClientInfoForDocumentIssuingQueryVariables>;
export const AllBusinessTripsDocument = new TypedDocumentString(`
    query AllBusinessTrips {
  allBusinessTrips {
    id
    name
  }
}
    `) as unknown as TypedDocumentString<AllBusinessTripsQuery, AllBusinessTripsQueryVariables>;
export const AllDepreciationCategoriesDocument = new TypedDocumentString(`
    query AllDepreciationCategories {
  depreciationCategories {
    id
    name
    percentage
  }
}
    `) as unknown as TypedDocumentString<AllDepreciationCategoriesQuery, AllDepreciationCategoriesQueryVariables>;
export const AllEmployeesByEmployerDocument = new TypedDocumentString(`
    query AllEmployeesByEmployer($employerId: UUID!) {
  employeesByEmployerId(employerId: $employerId) {
    id
    name
  }
}
    `) as unknown as TypedDocumentString<AllEmployeesByEmployerQuery, AllEmployeesByEmployerQueryVariables>;
export const AllPensionFundsDocument = new TypedDocumentString(`
    query AllPensionFunds {
  allPensionFunds {
    id
    name
  }
}
    `) as unknown as TypedDocumentString<AllPensionFundsQuery, AllPensionFundsQueryVariables>;
export const AllTrainingFundsDocument = new TypedDocumentString(`
    query AllTrainingFunds {
  allTrainingFunds {
    id
    name
  }
}
    `) as unknown as TypedDocumentString<AllTrainingFundsQuery, AllTrainingFundsQueryVariables>;
export const AttendeesByBusinessTripDocument = new TypedDocumentString(`
    query AttendeesByBusinessTrip($businessTripId: UUID!) {
  businessTrip(id: $businessTripId) {
    id
    attendees {
      id
      name
    }
  }
}
    `) as unknown as TypedDocumentString<AttendeesByBusinessTripQuery, AttendeesByBusinessTripQueryVariables>;
export const FetchMultipleBusinessesDocument = new TypedDocumentString(`
    query FetchMultipleBusinesses($businessIds: [UUID!]!) {
  businesses(ids: $businessIds) {
    id
    name
  }
}
    `) as unknown as TypedDocumentString<FetchMultipleBusinessesQuery, FetchMultipleBusinessesQueryVariables>;
export const FetchMultipleChargesDocument = new TypedDocumentString(`
    query FetchMultipleCharges($chargeIds: [UUID!]!) {
  chargesByIDs(chargeIDs: $chargeIds) {
    id
    __typename
    metadata {
      transactionsCount
      invoicesCount
    }
    owner {
      id
      name
    }
    tags {
      id
      name
      namePath
    }
    decreasedVAT
    property
    isInvoicePaymentDifferentCurrency
    userDescription
    optionalVAT
    optionalDocuments
  }
}
    `) as unknown as TypedDocumentString<FetchMultipleChargesQuery, FetchMultipleChargesQueryVariables>;
export const EditChargeDocument = new TypedDocumentString(`
    query EditCharge($chargeId: UUID!) {
  charge(chargeId: $chargeId) {
    id
    __typename
    counterparty {
      id
      name
    }
    owner {
      id
      name
    }
    property
    decreasedVAT
    isInvoicePaymentDifferentCurrency
    userDescription
    taxCategory {
      id
      name
    }
    tags {
      id
    }
    missingInfoSuggestions {
      ... on ChargeSuggestions {
        tags {
          id
        }
      }
    }
    optionalVAT
    optionalDocuments
    ... on BusinessTripCharge {
      businessTrip {
        id
        name
      }
    }
    yearsOfRelevance {
      year
      amount
    }
  }
}
    `) as unknown as TypedDocumentString<EditChargeQuery, EditChargeQueryVariables>;
export const EditSalaryRecordDocument = new TypedDocumentString(`
    query EditSalaryRecord($month: TimelessDate!, $employeeIDs: [UUID!]!) {
  salaryRecordsByDates(
    fromDate: $month
    toDate: $month
    employeeIDs: $employeeIDs
  ) {
    month
    charge {
      id
    }
    directAmount {
      raw
    }
    baseAmount {
      raw
    }
    employee {
      id
      name
    }
    employer {
      id
      name
    }
    pensionFund {
      id
      name
    }
    pensionEmployeeAmount {
      raw
    }
    pensionEmployeePercentage
    pensionEmployerAmount {
      raw
    }
    pensionEmployerPercentage
    compensationsAmount {
      raw
    }
    compensationsPercentage
    trainingFund {
      id
      name
    }
    trainingFundEmployeeAmount {
      raw
    }
    trainingFundEmployeePercentage
    trainingFundEmployerAmount {
      raw
    }
    trainingFundEmployerPercentage
    socialSecurityEmployeeAmount {
      raw
    }
    socialSecurityEmployerAmount {
      raw
    }
    incomeTaxAmount {
      raw
    }
    healthInsuranceAmount {
      raw
    }
    globalAdditionalHoursAmount {
      raw
    }
    bonus {
      raw
    }
    gift {
      raw
    }
    travelAndSubsistence {
      raw
    }
    recovery {
      raw
    }
    notionalExpense {
      raw
    }
    vacationDays {
      added
      balance
    }
    vacationTakeout {
      raw
    }
    workDays
    sicknessDays {
      balance
    }
  }
}
    `) as unknown as TypedDocumentString<EditSalaryRecordQuery, EditSalaryRecordQueryVariables>;
export const SortCodeToUpdateDocument = new TypedDocumentString(`
    query SortCodeToUpdate($key: Int!, $ownerId: String!) {
  sortCode(key: $key, ownerId: $ownerId) {
    id
    key
    name
    defaultIrsCode
  }
}
    `) as unknown as TypedDocumentString<SortCodeToUpdateQuery, SortCodeToUpdateQueryVariables>;
export const TaxCategoryToUpdateDocument = new TypedDocumentString(`
    query TaxCategoryToUpdate($id: UUID!) {
  taxCategory(id: $id) {
    id
    ownerId
    name
    sortCode {
      id
      key
      name
    }
    irsCode
  }
}
    `) as unknown as TypedDocumentString<TaxCategoryToUpdateQuery, TaxCategoryToUpdateQueryVariables>;
export const MiscExpenseTransactionFieldsDocument = new TypedDocumentString(`
    query MiscExpenseTransactionFields($transactionId: UUID!) {
  transactionsByIDs(transactionIDs: [$transactionId]) {
    id
    chargeId
    amount {
      raw
      currency
    }
    eventDate
    effectiveDate
    exactEffectiveDate
    counterparty {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<MiscExpenseTransactionFieldsQuery, MiscExpenseTransactionFieldsQueryVariables>;
export const NewDocumentDraftByChargeDocument = new TypedDocumentString(`
    query NewDocumentDraftByCharge($chargeId: UUID!) {
  newDocumentDraftByCharge(chargeId: $chargeId) {
    ...NewDocumentDraft
  }
}
    fragment IssueDocumentClientFields on Client {
  id
  originalBusiness {
    id
    address
    city
    zipCode
    country {
      id
      code
    }
    governmentId
    name
    phoneNumber
  }
  emails
}
fragment NewDocumentDraft on DocumentDraft {
  description
  remarks
  footer
  type
  date
  dueDate
  language
  currency
  vatType
  discount {
    amount
    type
  }
  rounding
  signed
  maxPayments
  client {
    id
    originalBusiness {
      id
      name
    }
    integrations {
      id
    }
    emails
    ...IssueDocumentClientFields
  }
  income {
    currency
    currencyRate
    description
    itemId
    price
    quantity
    vatRate
    vatType
  }
  payment {
    currency
    currencyRate
    date
    price
    type
    bankName
    bankBranch
    bankAccount
    chequeNum
    accountId
    transactionId
    cardType
    cardNum
    numPayments
    firstPayment
  }
  linkedDocumentIds
  linkedPaymentId
}`) as unknown as TypedDocumentString<NewDocumentDraftByChargeQuery, NewDocumentDraftByChargeQueryVariables>;
export const NewDocumentDraftByDocumentDocument = new TypedDocumentString(`
    query NewDocumentDraftByDocument($documentId: UUID!) {
  newDocumentDraftByDocument(documentId: $documentId) {
    ...NewDocumentDraft
  }
}
    fragment IssueDocumentClientFields on Client {
  id
  originalBusiness {
    id
    address
    city
    zipCode
    country {
      id
      code
    }
    governmentId
    name
    phoneNumber
  }
  emails
}
fragment NewDocumentDraft on DocumentDraft {
  description
  remarks
  footer
  type
  date
  dueDate
  language
  currency
  vatType
  discount {
    amount
    type
  }
  rounding
  signed
  maxPayments
  client {
    id
    originalBusiness {
      id
      name
    }
    integrations {
      id
    }
    emails
    ...IssueDocumentClientFields
  }
  income {
    currency
    currencyRate
    description
    itemId
    price
    quantity
    vatRate
    vatType
  }
  payment {
    currency
    currencyRate
    date
    price
    type
    bankName
    bankBranch
    bankAccount
    chequeNum
    accountId
    transactionId
    cardType
    cardNum
    numPayments
    firstPayment
  }
  linkedDocumentIds
  linkedPaymentId
}`) as unknown as TypedDocumentString<NewDocumentDraftByDocumentQuery, NewDocumentDraftByDocumentQueryVariables>;
export const SimilarChargesByBusinessDocument = new TypedDocumentString(`
    query SimilarChargesByBusiness($businessId: UUID!, $tagsDifferentThan: [String!], $descriptionDifferentThan: String) {
  similarChargesByBusiness(
    businessId: $businessId
    tagsDifferentThan: $tagsDifferentThan
    descriptionDifferentThan: $descriptionDifferentThan
  ) {
    id
    ...SimilarChargesTable
  }
}
    fragment SimilarChargesTable on Charge {
  id
  __typename
  counterparty {
    name
    id
  }
  minEventDate
  minDebitDate
  minDocumentsDate
  totalAmount {
    raw
    formatted
  }
  vat {
    raw
    formatted
  }
  userDescription
  tags {
    id
    name
  }
  taxCategory {
    id
    name
  }
  ... on BusinessTripCharge {
    businessTrip {
      id
      name
    }
  }
  metadata {
    transactionsCount
    documentsCount
    ledgerCount
    miscExpensesCount
  }
}`) as unknown as TypedDocumentString<SimilarChargesByBusinessQuery, SimilarChargesByBusinessQueryVariables>;
export const SimilarChargesDocument = new TypedDocumentString(`
    query SimilarCharges($chargeId: UUID!, $withMissingTags: Boolean!, $withMissingDescription: Boolean!, $tagsDifferentThan: [String!], $descriptionDifferentThan: String) {
  similarCharges(
    chargeId: $chargeId
    withMissingTags: $withMissingTags
    withMissingDescription: $withMissingDescription
    tagsDifferentThan: $tagsDifferentThan
    descriptionDifferentThan: $descriptionDifferentThan
  ) {
    id
    ...SimilarChargesTable
  }
}
    fragment SimilarChargesTable on Charge {
  id
  __typename
  counterparty {
    name
    id
  }
  minEventDate
  minDebitDate
  minDocumentsDate
  totalAmount {
    raw
    formatted
  }
  vat {
    raw
    formatted
  }
  userDescription
  tags {
    id
    name
  }
  taxCategory {
    id
    name
  }
  ... on BusinessTripCharge {
    businessTrip {
      id
      name
    }
  }
  metadata {
    transactionsCount
    documentsCount
    ledgerCount
    miscExpensesCount
  }
}`) as unknown as TypedDocumentString<SimilarChargesQuery, SimilarChargesQueryVariables>;
export const SimilarTransactionsDocument = new TypedDocumentString(`
    query SimilarTransactions($transactionId: UUID!, $withMissingInfo: Boolean!) {
  similarTransactions(
    transactionId: $transactionId
    withMissingInfo: $withMissingInfo
  ) {
    id
    account {
      id
      name
      type
    }
    amount {
      formatted
      raw
    }
    effectiveDate
    eventDate
    sourceDescription
  }
}
    `) as unknown as TypedDocumentString<SimilarTransactionsQuery, SimilarTransactionsQueryVariables>;
export const UniformFormatDocument = new TypedDocumentString(`
    query UniformFormat($fromDate: TimelessDate!, $toDate: TimelessDate!) {
  uniformFormat(fromDate: $fromDate, toDate: $toDate) {
    bkmvdata
    ini
  }
}
    `) as unknown as TypedDocumentString<UniformFormatQuery, UniformFormatQueryVariables>;
export const ContractBasedDocumentDraftsDocument = new TypedDocumentString(`
    query ContractBasedDocumentDrafts($issueMonth: TimelessDate!, $contractIds: [UUID!]!) {
  periodicalDocumentDraftsByContracts(
    issueMonth: $issueMonth
    contractIds: $contractIds
  ) {
    ...NewDocumentDraft
  }
}
    fragment IssueDocumentClientFields on Client {
  id
  originalBusiness {
    id
    address
    city
    zipCode
    country {
      id
      code
    }
    governmentId
    name
    phoneNumber
  }
  emails
}
fragment NewDocumentDraft on DocumentDraft {
  description
  remarks
  footer
  type
  date
  dueDate
  language
  currency
  vatType
  discount {
    amount
    type
  }
  rounding
  signed
  maxPayments
  client {
    id
    originalBusiness {
      id
      name
    }
    integrations {
      id
    }
    emails
    ...IssueDocumentClientFields
  }
  income {
    currency
    currencyRate
    description
    itemId
    price
    quantity
    vatRate
    vatType
  }
  payment {
    currency
    currencyRate
    date
    price
    type
    bankName
    bankBranch
    bankAccount
    chequeNum
    accountId
    transactionId
    cardType
    cardNum
    numPayments
    firstPayment
  }
  linkedDocumentIds
  linkedPaymentId
}`) as unknown as TypedDocumentString<ContractBasedDocumentDraftsQuery, ContractBasedDocumentDraftsQueryVariables>;
export const AccountantApprovalsChargesTableDocument = new TypedDocumentString(`
    query AccountantApprovalsChargesTable($page: Int, $limit: Int, $filters: ChargeFilter) {
  allCharges(page: $page, limit: $limit, filters: $filters) {
    nodes {
      id
      accountantApproval
    }
  }
}
    `) as unknown as TypedDocumentString<AccountantApprovalsChargesTableQuery, AccountantApprovalsChargesTableQueryVariables>;
export const CorporateTaxRulingComplianceReportDocument = new TypedDocumentString(`
    query CorporateTaxRulingComplianceReport($years: [Int!]!) {
  corporateTaxRulingComplianceReport(years: $years) {
    id
    year
    totalIncome {
      formatted
      raw
      currency
    }
    researchAndDevelopmentExpenses {
      formatted
      raw
      currency
    }
    rndRelativeToIncome {
      rule
      ...CorporateTaxRulingReportRuleCellFields
    }
    localDevelopmentExpenses {
      formatted
      raw
      currency
    }
    localDevelopmentRelativeToRnd {
      rule
      ...CorporateTaxRulingReportRuleCellFields
    }
    foreignDevelopmentExpenses {
      formatted
      raw
      currency
    }
    foreignDevelopmentRelativeToRnd {
      rule
      ...CorporateTaxRulingReportRuleCellFields
    }
    businessTripRndExpenses {
      formatted
      raw
      currency
    }
    ... on CorporateTaxRulingComplianceReport @defer {
      differences {
        id
        totalIncome {
          formatted
          raw
          currency
        }
        researchAndDevelopmentExpenses {
          formatted
          raw
          currency
        }
        rndRelativeToIncome {
          ...CorporateTaxRulingReportRuleCellFields
        }
        localDevelopmentExpenses {
          formatted
          raw
          currency
        }
        localDevelopmentRelativeToRnd {
          ...CorporateTaxRulingReportRuleCellFields
        }
        foreignDevelopmentExpenses {
          formatted
          raw
          currency
        }
        foreignDevelopmentRelativeToRnd {
          ...CorporateTaxRulingReportRuleCellFields
        }
        businessTripRndExpenses {
          formatted
          raw
          currency
        }
      }
    }
  }
}
    fragment CorporateTaxRulingReportRuleCellFields on CorporateTaxRule {
  id
  rule
  percentage {
    formatted
  }
  isCompliant
}`) as unknown as TypedDocumentString<CorporateTaxRulingComplianceReportQuery, CorporateTaxRulingComplianceReportQueryVariables>;
export const AllDynamicReportsDocument = new TypedDocumentString(`
    query AllDynamicReports {
  allDynamicReports {
    id
    name
    isLocked
    updated
  }
}
    `) as unknown as TypedDocumentString<AllDynamicReportsQuery, AllDynamicReportsQueryVariables>;
export const DynamicReportDocument = new TypedDocumentString(`
    query DynamicReport($filters: BusinessTransactionsFilter) {
  businessTransactionsSumFromLedgerRecords(filters: $filters) {
    __typename
    ... on BusinessTransactionsSumFromLedgerRecordsSuccessfulResult {
      businessTransactionsSum {
        business {
          id
          name
          sortCode {
            id
            key
            name
          }
        }
        credit {
          formatted
          raw
        }
        debit {
          formatted
          raw
        }
        total {
          formatted
          raw
        }
      }
    }
    ... on CommonError {
      __typename
    }
  }
}
    `) as unknown as TypedDocumentString<DynamicReportQuery, DynamicReportQueryVariables>;
export const DynamicReportTemplateDocument = new TypedDocumentString(`
    query DynamicReportTemplate($name: String!) {
  dynamicReport(name: $name) {
    id
    name
    isLocked
    updated
    template {
      id
      parent
      text
      droppable
      data {
        nodeType
        isOpen
        hebrewText
        sortCode
      }
    }
  }
}
    `) as unknown as TypedDocumentString<DynamicReportTemplateQuery, DynamicReportTemplateQueryVariables>;
export const ProfitAndLossReportDocument = new TypedDocumentString(`
    query ProfitAndLossReport($reportYear: Int!, $referenceYears: [Int!]!) {
  profitAndLossReport(reportYear: $reportYear, referenceYears: $referenceYears) {
    id
    report {
      id
      year
      revenue {
        amount {
          formatted
        }
        ...ReportCommentaryTableFields
      }
      costOfSales {
        amount {
          formatted
        }
        ...ReportCommentaryTableFields
      }
      grossProfit {
        formatted
      }
      researchAndDevelopmentExpenses {
        amount {
          formatted
        }
        ...ReportCommentaryTableFields
      }
      marketingExpenses {
        amount {
          formatted
        }
        ...ReportCommentaryTableFields
      }
      managementAndGeneralExpenses {
        amount {
          formatted
        }
        ...ReportCommentaryTableFields
      }
      operatingProfit {
        formatted
      }
      financialExpenses {
        amount {
          formatted
        }
        ...ReportCommentaryTableFields
      }
      otherIncome {
        amount {
          formatted
        }
        ...ReportCommentaryTableFields
      }
      profitBeforeTax {
        formatted
      }
      tax {
        formatted
      }
      netProfit {
        formatted
      }
    }
    reference {
      id
      year
      revenue {
        amount {
          formatted
        }
      }
      costOfSales {
        amount {
          formatted
        }
      }
      grossProfit {
        formatted
      }
      researchAndDevelopmentExpenses {
        amount {
          formatted
        }
      }
      marketingExpenses {
        amount {
          formatted
        }
      }
      managementAndGeneralExpenses {
        amount {
          formatted
        }
      }
      operatingProfit {
        formatted
      }
      financialExpenses {
        amount {
          formatted
        }
      }
      otherIncome {
        amount {
          formatted
        }
      }
      profitBeforeTax {
        formatted
      }
      tax {
        formatted
      }
      netProfit {
        formatted
      }
    }
  }
}
    fragment LedgerRecordsTableFields on LedgerRecord {
  id
  creditAccount1 {
    __typename
    id
    name
  }
  creditAccount2 {
    __typename
    id
    name
  }
  debitAccount1 {
    __typename
    id
    name
  }
  debitAccount2 {
    __typename
    id
    name
  }
  creditAmount1 {
    formatted
    currency
  }
  creditAmount2 {
    formatted
    currency
  }
  debitAmount1 {
    formatted
    currency
  }
  debitAmount2 {
    formatted
    currency
  }
  localCurrencyCreditAmount1 {
    formatted
    raw
  }
  localCurrencyCreditAmount2 {
    formatted
    raw
  }
  localCurrencyDebitAmount1 {
    formatted
    raw
  }
  localCurrencyDebitAmount2 {
    formatted
    raw
  }
  invoiceDate
  valueDate
  description
  reference
}
fragment ReportCommentaryTableFields on ReportCommentary {
  records {
    sortCode {
      id
      key
      name
    }
    amount {
      formatted
    }
    records {
      ...ReportSubCommentaryTableFields
    }
  }
}
fragment ReportSubCommentaryTableFields on ReportCommentarySubRecord {
  financialEntity {
    id
    name
  }
  amount {
    formatted
  }
  ledgerRecords {
    ...LedgerRecordsTableFields
  }
}`) as unknown as TypedDocumentString<ProfitAndLossReportQuery, ProfitAndLossReportQueryVariables>;
export const TaxReportDocument = new TypedDocumentString(`
    query TaxReport($reportYear: Int!, $referenceYears: [Int!]!) {
  taxReport(reportYear: $reportYear, referenceYears: $referenceYears) {
    id
    report {
      id
      year
      profitBeforeTax {
        amount {
          formatted
        }
        ...ReportCommentaryTableFields
      }
      researchAndDevelopmentExpensesByRecords {
        amount {
          formatted
        }
        ...ReportCommentaryTableFields
      }
      researchAndDevelopmentExpensesForTax {
        formatted
      }
      fines {
        amount {
          formatted
        }
        ...ReportCommentaryTableFields
      }
      untaxableGifts {
        amount {
          formatted
        }
        ...ReportCommentaryTableFields
      }
      businessTripsExcessExpensesAmount {
        formatted
      }
      salaryExcessExpensesAmount {
        formatted
      }
      reserves {
        amount {
          formatted
        }
        ...ReportCommentaryTableFields
      }
      nontaxableLinkage {
        amount {
          formatted
        }
        ...ReportCommentaryTableFields
      }
      taxableIncome {
        formatted
      }
      taxRate
      specialTaxableIncome {
        amount {
          formatted
        }
        ...ReportCommentaryTableFields
      }
      specialTaxRate
      annualTaxExpense {
        formatted
      }
    }
    reference {
      id
      year
      profitBeforeTax {
        amount {
          formatted
        }
      }
      researchAndDevelopmentExpensesByRecords {
        amount {
          formatted
        }
      }
      researchAndDevelopmentExpensesForTax {
        formatted
      }
      fines {
        amount {
          formatted
        }
      }
      untaxableGifts {
        amount {
          formatted
        }
      }
      businessTripsExcessExpensesAmount {
        formatted
      }
      salaryExcessExpensesAmount {
        formatted
      }
      reserves {
        amount {
          formatted
        }
      }
      nontaxableLinkage {
        amount {
          formatted
        }
      }
      taxableIncome {
        formatted
      }
      taxRate
      specialTaxableIncome {
        amount {
          formatted
        }
        ...ReportCommentaryTableFields
      }
      specialTaxRate
      annualTaxExpense {
        formatted
      }
    }
  }
}
    fragment LedgerRecordsTableFields on LedgerRecord {
  id
  creditAccount1 {
    __typename
    id
    name
  }
  creditAccount2 {
    __typename
    id
    name
  }
  debitAccount1 {
    __typename
    id
    name
  }
  debitAccount2 {
    __typename
    id
    name
  }
  creditAmount1 {
    formatted
    currency
  }
  creditAmount2 {
    formatted
    currency
  }
  debitAmount1 {
    formatted
    currency
  }
  debitAmount2 {
    formatted
    currency
  }
  localCurrencyCreditAmount1 {
    formatted
    raw
  }
  localCurrencyCreditAmount2 {
    formatted
    raw
  }
  localCurrencyDebitAmount1 {
    formatted
    raw
  }
  localCurrencyDebitAmount2 {
    formatted
    raw
  }
  invoiceDate
  valueDate
  description
  reference
}
fragment ReportCommentaryTableFields on ReportCommentary {
  records {
    sortCode {
      id
      key
      name
    }
    amount {
      formatted
    }
    records {
      ...ReportSubCommentaryTableFields
    }
  }
}
fragment ReportSubCommentaryTableFields on ReportCommentarySubRecord {
  financialEntity {
    id
    name
  }
  amount {
    formatted
  }
  ledgerRecords {
    ...LedgerRecordsTableFields
  }
}`) as unknown as TypedDocumentString<TaxReportQuery, TaxReportQueryVariables>;
export const TrialBalanceReportDocument = new TypedDocumentString(`
    query TrialBalanceReport($filters: BusinessTransactionsFilter) {
  businessTransactionsSumFromLedgerRecords(filters: $filters) {
    ... on BusinessTransactionsSumFromLedgerRecordsSuccessfulResult {
      __typename
      ...TrialBalanceTableFields
    }
    ... on CommonError {
      __typename
    }
  }
}
    fragment TrialBalanceTableFields on BusinessTransactionsSumFromLedgerRecordsSuccessfulResult {
  businessTransactionsSum {
    business {
      id
      name
      sortCode {
        id
        key
        name
      }
    }
    credit {
      formatted
      raw
    }
    debit {
      formatted
      raw
    }
    total {
      formatted
      raw
    }
  }
}`) as unknown as TypedDocumentString<TrialBalanceReportQuery, TrialBalanceReportQueryVariables>;
export const ValidatePcn874ReportsDocument = new TypedDocumentString(`
    query ValidatePcn874Reports($businessId: UUID, $fromMonthDate: TimelessDate!, $toMonthDate: TimelessDate!) {
  pcnByDate(
    businessId: $businessId
    fromMonthDate: $fromMonthDate
    toMonthDate: $toMonthDate
  ) @stream {
    id
    business {
      id
      name
    }
    date
    content
    diffContent
  }
}
    `) as unknown as TypedDocumentString<ValidatePcn874ReportsQuery, ValidatePcn874ReportsQueryVariables>;
export const VatMonthlyReportDocument = new TypedDocumentString(`
    query VatMonthlyReport($filters: VatReportFilter) {
  vatReport(filters: $filters) {
    ...VatReportSummaryFields
    ...VatReportIncomeFields
    ...VatReportExpensesFields
    ...VatReportMissingInfoFields
    ...VatReportMiscTableFields
    ...VatReportBusinessTripsFields
  }
}
    fragment ChargeForChargesTableFields on Charge {
  id
  __typename
  minEventDate
  minDebitDate
  minDocumentsDate
  maxDebitDate
  maxEventDate
  maxDocumentsDate
  totalAmount {
    raw
    currency
  }
  vat {
    raw
  }
  counterparty {
    name
    id
  }
  userDescription
  tags {
    id
    name
    namePath
  }
  taxCategory {
    id
    name
  }
  ... on BusinessTripCharge {
    businessTrip {
      id
      name
    }
  }
  metadata {
    transactionsCount
    documentsCount
    ledgerCount
    miscExpensesCount
    ... on ChargeMetadata @defer {
      invalidLedger
    }
  }
  accountantApproval
  ... on CreditcardBankCharge {
    validCreditCardAmount
  }
  ... on Charge {
    validationData {
      missingInfo
    }
  }
  ... on Charge {
    missingInfoSuggestions {
      description
      tags {
        id
        name
        namePath
      }
    }
  }
}
fragment VatReportBusinessTripsFields on VatReportResult {
  businessTrips {
    id
    ...ChargeForChargesTableFields
  }
}
fragment VatReportAccountantApprovalFields on VatReportRecord {
  chargeId
  chargeAccountantStatus
}
fragment VatReportExpensesRowFields on VatReportRecord {
  ...VatReportAccountantApprovalFields
  business {
    id
    name
  }
  vatNumber
  image
  allocationNumber
  documentSerial
  documentDate
  chargeDate
  chargeId
  amount {
    formatted
    raw
  }
  localAmount {
    formatted
    raw
  }
  localVat {
    formatted
    raw
  }
  foreignVatAfterDeduction {
    formatted
    raw
  }
  localVatAfterDeduction {
    formatted
    raw
  }
  roundedLocalVatAfterDeduction {
    formatted
    raw
  }
  taxReducedLocalAmount {
    formatted
    raw
  }
  recordType
}
fragment VatReportExpensesFields on VatReportResult {
  expenses {
    ...VatReportExpensesRowFields
    roundedLocalVatAfterDeduction {
      raw
    }
    taxReducedLocalAmount {
      raw
    }
    recordType
  }
}
fragment VatReportIncomeRowFields on VatReportRecord {
  ...VatReportAccountantApprovalFields
  chargeId
  business {
    id
    name
  }
  vatNumber
  image
  allocationNumber
  documentSerial
  documentDate
  chargeDate
  taxReducedForeignAmount {
    formatted
    raw
  }
  taxReducedLocalAmount {
    formatted
    raw
  }
  recordType
}
fragment VatReportIncomeFields on VatReportResult {
  income {
    ...VatReportIncomeRowFields
    taxReducedLocalAmount {
      raw
    }
    recordType
  }
}
fragment VatReportMiscTableFields on VatReportResult {
  differentMonthDoc {
    id
    ...ChargeForChargesTableFields
  }
}
fragment VatReportMissingInfoFields on VatReportResult {
  missingInfo {
    id
    ...ChargeForChargesTableFields
  }
}
fragment VatReportSummaryFields on VatReportResult {
  expenses {
    roundedLocalVatAfterDeduction {
      raw
    }
    taxReducedLocalAmount {
      raw
    }
    recordType
    isProperty
  }
  income {
    roundedLocalVatAfterDeduction {
      raw
    }
    taxReducedLocalAmount {
      raw
    }
    recordType
  }
}`) as unknown as TypedDocumentString<VatMonthlyReportQuery, VatMonthlyReportQueryVariables>;
export const GeneratePcnDocument = new TypedDocumentString(`
    query GeneratePCN($monthDate: TimelessDate!, $financialEntityId: UUID!) {
  pcnFile(monthDate: $monthDate, financialEntityId: $financialEntityId) {
    reportContent
    fileName
  }
}
    `) as unknown as TypedDocumentString<GeneratePcnQuery, GeneratePcnQueryVariables>;
export const YearlyLedgerDocument = new TypedDocumentString(`
    query YearlyLedger($year: Int!) {
  yearlyLedgerReport(year: $year) {
    id
    year
    financialEntitiesInfo {
      entity {
        id
        name
        sortCode {
          id
          key
        }
      }
      openingBalance {
        raw
      }
      totalCredit {
        raw
      }
      totalDebit {
        raw
      }
      closingBalance {
        raw
      }
      records {
        id
        amount {
          raw
          formatted
        }
        invoiceDate
        valueDate
        description
        reference
        counterParty {
          id
          name
        }
        balance
      }
    }
    ...LedgerCsvFields
  }
}
    fragment LedgerCsvFields on YearlyLedgerReport {
  id
  year
  financialEntitiesInfo {
    entity {
      id
      name
      sortCode {
        id
        key
      }
    }
    openingBalance {
      raw
    }
    totalCredit {
      raw
    }
    totalDebit {
      raw
    }
    closingBalance {
      raw
    }
    records {
      id
      amount {
        raw
        formatted
      }
      invoiceDate
      valueDate
      description
      reference
      counterParty {
        id
        name
      }
      balance
    }
  }
}`) as unknown as TypedDocumentString<YearlyLedgerQuery, YearlyLedgerQueryVariables>;
export const SalaryScreenRecordsDocument = new TypedDocumentString(`
    query SalaryScreenRecords($fromDate: TimelessDate!, $toDate: TimelessDate!, $employeeIDs: [UUID!]) {
  salaryRecordsByDates(
    fromDate: $fromDate
    toDate: $toDate
    employeeIDs: $employeeIDs
  ) {
    month
    employee {
      id
    }
    ...SalariesTableFields
  }
}
    fragment SalariesRecordEmployeeFields on Salary {
  month
  employee {
    id
    name
  }
}
fragment SalariesRecordFundsFields on Salary {
  month
  employee {
    id
  }
  pensionFund {
    id
    name
  }
  pensionEmployeeAmount {
    formatted
    raw
  }
  pensionEmployeePercentage
  pensionEmployerAmount {
    formatted
    raw
  }
  pensionEmployerPercentage
  compensationsAmount {
    formatted
    raw
  }
  compensationsPercentage
  trainingFund {
    id
    name
  }
  trainingFundEmployeeAmount {
    formatted
    raw
  }
  trainingFundEmployeePercentage
  trainingFundEmployerAmount {
    formatted
    raw
  }
  trainingFundEmployerPercentage
}
fragment SalariesRecordInsurancesAndTaxesFields on Salary {
  month
  employee {
    id
  }
  healthInsuranceAmount {
    formatted
    raw
  }
  socialSecurityEmployeeAmount {
    formatted
    raw
  }
  socialSecurityEmployerAmount {
    formatted
    raw
  }
  incomeTaxAmount {
    formatted
    raw
  }
  notionalExpense {
    formatted
    raw
  }
}
fragment SalariesRecordMainSalaryFields on Salary {
  month
  employee {
    id
  }
  baseAmount {
    formatted
  }
  directAmount {
    formatted
  }
  globalAdditionalHoursAmount {
    formatted
  }
  bonus {
    formatted
    raw
  }
  gift {
    formatted
    raw
  }
  recovery {
    formatted
    raw
  }
  vacationTakeout {
    formatted
    raw
  }
}
fragment SalariesRecordWorkFrameFields on Salary {
  month
  employee {
    id
  }
  vacationDays {
    added
    taken
    balance
  }
  workDays
  sicknessDays {
    balance
  }
}
fragment SalariesMonthFields on Salary {
  month
  employee {
    id
  }
  ...SalariesRecordFields
}
fragment SalariesTableFields on Salary {
  month
  employee {
    id
  }
  ...SalariesMonthFields
}
fragment SalariesRecordFields on Salary {
  month
  employee {
    id
  }
  ...SalariesRecordEmployeeFields
  ...SalariesRecordMainSalaryFields
  ...SalariesRecordFundsFields
  ...SalariesRecordInsurancesAndTaxesFields
  ...SalariesRecordWorkFrameFields
}`) as unknown as TypedDocumentString<SalaryScreenRecordsQuery, SalaryScreenRecordsQueryVariables>;
export const AllDepositsDocument = new TypedDocumentString(`
    query AllDeposits {
  allDeposits {
    id
    name
    currency
    openDate
    closeDate
    isOpen
    metadata {
      id
      currentBalance {
        raw
        formatted
      }
      totalDeposit {
        raw
        formatted
      }
      totalInterest {
        raw
        formatted
      }
    }
  }
}
    `) as unknown as TypedDocumentString<AllDepositsQuery, AllDepositsQueryVariables>;
export const BusinessScreenDocument = new TypedDocumentString(`
    query BusinessScreen($businessId: UUID!) {
  business(id: $businessId) {
    id
    ...BusinessPage
  }
}
    fragment BusinessAdminSection on Business {
  __typename
  id
  ... on LtdFinancialEntity {
    adminInfo {
      id
      registrationDate
      withholdingTaxAnnualIds {
        id
        year
      }
      withholdingTaxCompanyId
      socialSecurityEmployerIds {
        id
        year
      }
      socialSecurityDeductionsId
      taxAdvancesAnnualIds {
        id
        year
      }
      taxAdvancesRates {
        date
        rate
      }
    }
  }
}
fragment BusinessHeader on Business {
  __typename
  id
  name
  createdAt
  isActive
  ... on LtdFinancialEntity {
    governmentId
    adminInfo {
      id
    }
    clientInfo {
      id
    }
  }
}
fragment ClientIntegrationsSection on LtdFinancialEntity {
  id
  clientInfo {
    id
    integrations {
      id
      greenInvoiceInfo {
        businessId
        greenInvoiceId
      }
      hiveId
      linearId
      slackChannelKey
      notionId
      workflowyUrl
    }
  }
}
fragment BusinessConfigurationSection on Business {
  __typename
  id
  pcn874RecordType
  irsCode
  isActive
  ownerId
  ... on LtdFinancialEntity {
    optionalVAT
    exemptDealer
    isReceiptEnough
    isDocumentsOptional
    sortCode {
      id
      key
      defaultIrsCode
    }
    taxCategory {
      id
    }
    suggestions {
      phrases
      emails
      tags {
        id
      }
      description
      emailListener {
        internalEmailLinks
        emailBody
        attachments
      }
    }
    clientInfo {
      id
    }
  }
}
fragment BusinessContactSection on Business {
  __typename
  id
  ... on LtdFinancialEntity {
    name
    hebrewName
    country {
      id
      code
    }
    governmentId
    address
    city
    zipCode
    email
    phoneNumber
    website
    clientInfo {
      id
      emails
    }
  }
}
fragment BusinessPage on Business {
  id
  ... on LtdFinancialEntity {
    clientInfo {
      id
    }
    adminInfo {
      id
    }
  }
  ...ClientIntegrationsSection
  ...BusinessHeader
  ...BusinessContactSection
  ...BusinessConfigurationSection
  ...BusinessAdminSection
}`) as unknown as TypedDocumentString<BusinessScreenQuery, BusinessScreenQueryVariables>;
export const ContractsScreenDocument = new TypedDocumentString(`
    query ContractsScreen($adminId: UUID!) {
  contractsByAdmin(adminId: $adminId) {
    id
    ...ContractForContractsTableFields
  }
}
    fragment ContractForContractsTableFields on Contract {
  id
  isActive
  client {
    id
    originalBusiness {
      id
      name
    }
  }
  purchaseOrders
  startDate
  endDate
  amount {
    raw
    formatted
  }
  billingCycle
  product
  plan
  operationsLimit
  msCloud
}`) as unknown as TypedDocumentString<ContractsScreenQuery, ContractsScreenQueryVariables>;
export const AllChargesDocument = new TypedDocumentString(`
    query AllCharges($page: Int, $limit: Int, $filters: ChargeFilter) {
  allCharges(page: $page, limit: $limit, filters: $filters) {
    nodes {
      id
      ...ChargeForChargesTableFields
    }
    pageInfo {
      totalPages
    }
  }
}
    fragment ChargeForChargesTableFields on Charge {
  id
  __typename
  minEventDate
  minDebitDate
  minDocumentsDate
  maxDebitDate
  maxEventDate
  maxDocumentsDate
  totalAmount {
    raw
    currency
  }
  vat {
    raw
  }
  counterparty {
    name
    id
  }
  userDescription
  tags {
    id
    name
    namePath
  }
  taxCategory {
    id
    name
  }
  ... on BusinessTripCharge {
    businessTrip {
      id
      name
    }
  }
  metadata {
    transactionsCount
    documentsCount
    ledgerCount
    miscExpensesCount
    ... on ChargeMetadata @defer {
      invalidLedger
    }
  }
  accountantApproval
  ... on CreditcardBankCharge {
    validCreditCardAmount
  }
  ... on Charge {
    validationData {
      missingInfo
    }
  }
  ... on Charge {
    missingInfoSuggestions {
      description
      tags {
        id
        name
        namePath
      }
    }
  }
}`) as unknown as TypedDocumentString<AllChargesQuery, AllChargesQueryVariables>;
export const ChargeScreenDocument = new TypedDocumentString(`
    query ChargeScreen($chargeId: UUID!) {
  charge(chargeId: $chargeId) {
    id
    ...ChargeForChargesTableFields
  }
}
    fragment ChargeForChargesTableFields on Charge {
  id
  __typename
  minEventDate
  minDebitDate
  minDocumentsDate
  maxDebitDate
  maxEventDate
  maxDocumentsDate
  totalAmount {
    raw
    currency
  }
  vat {
    raw
  }
  counterparty {
    name
    id
  }
  userDescription
  tags {
    id
    name
    namePath
  }
  taxCategory {
    id
    name
  }
  ... on BusinessTripCharge {
    businessTrip {
      id
      name
    }
  }
  metadata {
    transactionsCount
    documentsCount
    ledgerCount
    miscExpensesCount
    ... on ChargeMetadata @defer {
      invalidLedger
    }
  }
  accountantApproval
  ... on CreditcardBankCharge {
    validCreditCardAmount
  }
  ... on Charge {
    validationData {
      missingInfo
    }
  }
  ... on Charge {
    missingInfoSuggestions {
      description
      tags {
        id
        name
        namePath
      }
    }
  }
}`) as unknown as TypedDocumentString<ChargeScreenQuery, ChargeScreenQueryVariables>;
export const MissingInfoChargesDocument = new TypedDocumentString(`
    query MissingInfoCharges($page: Int, $limit: Int) {
  chargesWithMissingRequiredInfo(page: $page, limit: $limit) {
    nodes {
      id
      ...ChargeForChargesTableFields
    }
    pageInfo {
      totalPages
    }
  }
}
    fragment ChargeForChargesTableFields on Charge {
  id
  __typename
  minEventDate
  minDebitDate
  minDocumentsDate
  maxDebitDate
  maxEventDate
  maxDocumentsDate
  totalAmount {
    raw
    currency
  }
  vat {
    raw
  }
  counterparty {
    name
    id
  }
  userDescription
  tags {
    id
    name
    namePath
  }
  taxCategory {
    id
    name
  }
  ... on BusinessTripCharge {
    businessTrip {
      id
      name
    }
  }
  metadata {
    transactionsCount
    documentsCount
    ledgerCount
    miscExpensesCount
    ... on ChargeMetadata @defer {
      invalidLedger
    }
  }
  accountantApproval
  ... on CreditcardBankCharge {
    validCreditCardAmount
  }
  ... on Charge {
    validationData {
      missingInfo
    }
  }
  ... on Charge {
    missingInfoSuggestions {
      description
      tags {
        id
        name
        namePath
      }
    }
  }
}`) as unknown as TypedDocumentString<MissingInfoChargesQuery, MissingInfoChargesQueryVariables>;
export const DocumentsScreenDocument = new TypedDocumentString(`
    query DocumentsScreen($filters: DocumentsFilters!) {
  documentsByFilters(filters: $filters) {
    id
    image
    file
    charge {
      id
      userDescription
      __typename
      vat {
        formatted
        __typename
      }
      transactions {
        id
        eventDate
        sourceDescription
        effectiveDate
        amount {
          formatted
          __typename
        }
      }
    }
    __typename
    ... on FinancialDocument {
      creditor {
        id
        name
      }
      debtor {
        id
        name
      }
      vat {
        raw
        formatted
        currency
      }
      serialNumber
      date
      amount {
        raw
        formatted
        currency
      }
    }
  }
}
    `) as unknown as TypedDocumentString<DocumentsScreenQuery, DocumentsScreenQueryVariables>;
export const MonthlyDocumentDraftByClientDocument = new TypedDocumentString(`
    query MonthlyDocumentDraftByClient($clientId: UUID!, $issueMonth: TimelessDate!) {
  clientMonthlyChargeDraft(clientId: $clientId, issueMonth: $issueMonth) {
    ...NewDocumentDraft
  }
}
    fragment IssueDocumentClientFields on Client {
  id
  originalBusiness {
    id
    address
    city
    zipCode
    country {
      id
      code
    }
    governmentId
    name
    phoneNumber
  }
  emails
}
fragment NewDocumentDraft on DocumentDraft {
  description
  remarks
  footer
  type
  date
  dueDate
  language
  currency
  vatType
  discount {
    amount
    type
  }
  rounding
  signed
  maxPayments
  client {
    id
    originalBusiness {
      id
      name
    }
    integrations {
      id
    }
    emails
    ...IssueDocumentClientFields
  }
  income {
    currency
    currencyRate
    description
    itemId
    price
    quantity
    vatRate
    vatType
  }
  payment {
    currency
    currencyRate
    date
    price
    type
    bankName
    bankBranch
    bankAccount
    chequeNum
    accountId
    transactionId
    cardType
    cardNum
    numPayments
    firstPayment
  }
  linkedDocumentIds
  linkedPaymentId
}`) as unknown as TypedDocumentString<MonthlyDocumentDraftByClientQuery, MonthlyDocumentDraftByClientQueryVariables>;
export const MonthlyDocumentsDraftsDocument = new TypedDocumentString(`
    query MonthlyDocumentsDrafts($issueMonth: TimelessDate!) {
  periodicalDocumentDrafts(issueMonth: $issueMonth) {
    ...NewDocumentDraft
  }
}
    fragment IssueDocumentClientFields on Client {
  id
  originalBusiness {
    id
    address
    city
    zipCode
    country {
      id
      code
    }
    governmentId
    name
    phoneNumber
  }
  emails
}
fragment NewDocumentDraft on DocumentDraft {
  description
  remarks
  footer
  type
  date
  dueDate
  language
  currency
  vatType
  discount {
    amount
    type
  }
  rounding
  signed
  maxPayments
  client {
    id
    originalBusiness {
      id
      name
    }
    integrations {
      id
    }
    emails
    ...IssueDocumentClientFields
  }
  income {
    currency
    currencyRate
    description
    itemId
    price
    quantity
    vatRate
    vatType
  }
  payment {
    currency
    currencyRate
    date
    price
    type
    bankName
    bankBranch
    bankAccount
    chequeNum
    accountId
    transactionId
    cardType
    cardNum
    numPayments
    firstPayment
  }
  linkedDocumentIds
  linkedPaymentId
}`) as unknown as TypedDocumentString<MonthlyDocumentsDraftsQuery, MonthlyDocumentsDraftsQueryVariables>;
export const AllOpenContractsDocument = new TypedDocumentString(`
    query AllOpenContracts {
  allOpenContracts {
    id
    client {
      id
      originalBusiness {
        id
        name
      }
    }
    billingCycle
  }
}
    `) as unknown as TypedDocumentString<AllOpenContractsQuery, AllOpenContractsQueryVariables>;
export const AnnualAuditStepsStatusDocument = new TypedDocumentString(`
    query AnnualAuditStepsStatus($ownerId: UUID!, $year: Int!) {
  annualAuditStepStatuses(ownerId: $ownerId, year: $year) {
    id
    stepId
    status
    notes
  }
}
    `) as unknown as TypedDocumentString<AnnualAuditStepsStatusQuery, AnnualAuditStepsStatusQueryVariables>;
export const AccountantApprovalStatusDocument = new TypedDocumentString(`
    query AccountantApprovalStatus($fromDate: TimelessDate!, $toDate: TimelessDate!) {
  accountantApprovalStatus(from: $fromDate, to: $toDate) {
    totalCharges
    approvedCount
    pendingCount
    unapprovedCount
  }
}
    `) as unknown as TypedDocumentString<AccountantApprovalStatusQuery, AccountantApprovalStatusQueryVariables>;
export const LedgerValidationStatusDocument = new TypedDocumentString(`
    query LedgerValidationStatus($limit: Int, $filters: ChargeFilter) {
  chargesWithLedgerChanges(limit: $limit, filters: $filters) {
    charge {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<LedgerValidationStatusQuery, LedgerValidationStatusQueryVariables>;
export const AnnualAuditOpeningBalanceStatusDocument = new TypedDocumentString(`
    query AnnualAuditOpeningBalanceStatus($ownerId: UUID!, $year: Int!) {
  annualAuditOpeningBalanceStatus(ownerId: $ownerId, year: $year) {
    id
    userType
    balanceChargeId
    derivedStatus
    errorMessage
  }
}
    `) as unknown as TypedDocumentString<AnnualAuditOpeningBalanceStatusQuery, AnnualAuditOpeningBalanceStatusQueryVariables>;
export const AnnualFinancialChargesDocument = new TypedDocumentString(`
    query AnnualFinancialCharges($ownerId: UUID, $year: TimelessDate!) {
  annualFinancialCharges(ownerId: $ownerId, year: $year) {
    id
    revaluationCharge {
      id
    }
    taxExpensesCharge {
      id
    }
    depreciationCharge {
      id
    }
    recoveryReserveCharge {
      id
    }
    vacationReserveCharge {
      id
    }
    bankDepositsRevaluationCharge {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<AnnualFinancialChargesQuery, AnnualFinancialChargesQueryVariables>;
export const Step05PrevYearTemplateDocument = new TypedDocumentString(`
    query Step05PrevYearTemplate($ownerId: UUID!, $year: Int!) {
  annualAuditStepStatuses(ownerId: $ownerId, year: $year) {
    id
    stepId
    status
    evidence
  }
}
    `) as unknown as TypedDocumentString<Step05PrevYearTemplateQuery, Step05PrevYearTemplateQueryVariables>;
export const AdminLedgerLockDateDocument = new TypedDocumentString(`
    query AdminLedgerLockDate($ownerId: UUID) {
  adminContext(ownerId: $ownerId) {
    id
    ledgerLock
  }
}
    `) as unknown as TypedDocumentString<AdminLedgerLockDateQuery, AdminLedgerLockDateQueryVariables>;
export const Step09SaveTemplateStatusDocument = new TypedDocumentString(`
    query Step09SaveTemplateStatus($ownerId: UUID!, $year: Int!) {
  annualAuditStepStatuses(ownerId: $ownerId, year: $year) {
    id
    stepId
    status
    evidence
  }
}
    `) as unknown as TypedDocumentString<Step09SaveTemplateStatusQuery, Step09SaveTemplateStatusQueryVariables>;
export const AnnualRevenueReportScreenDocument = new TypedDocumentString(`
    query AnnualRevenueReportScreen($filters: AnnualRevenueReportFilter!) {
  annualRevenueReport(filters: $filters) {
    id
    year
    countries {
      id
      name
      revenueLocal {
        raw
        currency
      }
      revenueDefaultForeign {
        raw
        currency
      }
      clients {
        id
        name
        revenueLocal {
          raw
        }
        revenueDefaultForeign {
          raw
        }
        records {
          id
          date
          description
          reference
          chargeId
          revenueLocal {
            raw
          }
          revenueDefaultForeign {
            raw
          }
        }
      }
      ...AnnualRevenueReportCountry
    }
  }
}
    fragment AnnualRevenueReportClient on AnnualRevenueReportCountryClient {
  id
  name
  revenueLocal {
    raw
    formatted
    currency
  }
  revenueDefaultForeign {
    raw
    formatted
    currency
  }
  records {
    id
    date
    ...AnnualRevenueReportRecord
  }
}
fragment AnnualRevenueReportCountry on AnnualRevenueReportCountry {
  id
  code
  name
  revenueLocal {
    raw
    formatted
    currency
  }
  revenueDefaultForeign {
    raw
    formatted
    currency
  }
  clients {
    id
    revenueDefaultForeign {
      raw
    }
    ...AnnualRevenueReportClient
  }
}
fragment AnnualRevenueReportRecord on AnnualRevenueReportClientRecord {
  id
  revenueLocal {
    raw
    formatted
    currency
  }
  revenueDefaultForeign {
    raw
    formatted
    currency
  }
  revenueOriginal {
    raw
    formatted
    currency
  }
  chargeId
  date
  description
  reference
}`) as unknown as TypedDocumentString<AnnualRevenueReportScreenQuery, AnnualRevenueReportScreenQueryVariables>;
export const BalanceReportExtendedTransactionsDocument = new TypedDocumentString(`
    query BalanceReportExtendedTransactions($transactionIDs: [UUID!]!) {
  transactionsByIDs(transactionIDs: $transactionIDs) {
    id
    ...TransactionForTransactionsTableFields
    ...TransactionToDownloadForTransactionsTableFields
  }
}
    fragment TransactionForTransactionsTableFields on Transaction {
  id
  isFee
  chargeId
  eventDate
  effectiveDate
  sourceEffectiveDate
  amount {
    raw
    formatted
  }
  cryptoExchangeRate {
    rate
  }
  account {
    id
    name
    type
  }
  sourceDescription
  referenceKey
  counterparty {
    name
    id
  }
  missingInfoSuggestions {
    business {
      id
      name
    }
  }
}
fragment TransactionToDownloadForTransactionsTableFields on Transaction {
  id
  account {
    id
    name
    type
  }
  amount {
    currency
    raw
  }
  counterparty {
    id
    name
  }
  effectiveDate
  eventDate
  referenceKey
  sourceDescription
}`) as unknown as TypedDocumentString<BalanceReportExtendedTransactionsQuery, BalanceReportExtendedTransactionsQueryVariables>;
export const BalanceReportScreenDocument = new TypedDocumentString(`
    query BalanceReportScreen($fromDate: TimelessDate!, $toDate: TimelessDate!, $ownerId: UUID) {
  transactionsForBalanceReport(
    fromDate: $fromDate
    toDate: $toDate
    ownerId: $ownerId
  ) {
    id
    amountUsd {
      formatted
      raw
    }
    amount {
      currency
      raw
    }
    date
    month
    year
    counterparty {
      id
    }
    account {
      id
      name
    }
    isFee
    description
    charge {
      id
      tags {
        id
        name
      }
    }
  }
}
    `) as unknown as TypedDocumentString<BalanceReportScreenQuery, BalanceReportScreenQueryVariables>;
export const DepreciationReportScreenDocument = new TypedDocumentString(`
    query DepreciationReportScreen($filters: DepreciationReportFilter!) {
  depreciationReport(filters: $filters) {
    id
    year
    categories {
      id
      category {
        id
        name
        percentage
      }
      records {
        id
        chargeId
        description
        purchaseDate
        activationDate
        statutoryDepreciationRate
        claimedDepreciationRate
        ...DepreciationReportRecordCore
      }
      summary {
        id
        ...DepreciationReportRecordCore
      }
    }
    summary {
      id
      ...DepreciationReportRecordCore
    }
  }
}
    fragment DepreciationReportRecordCore on DepreciationCoreRecord {
  id
  originalCost
  reportYearDelta
  totalDepreciableCosts
  reportYearClaimedDepreciation
  pastYearsAccumulatedDepreciation
  totalDepreciation
  netValue
}`) as unknown as TypedDocumentString<DepreciationReportScreenQuery, DepreciationReportScreenQueryVariables>;
export const Shaam6111ReportScreenDocument = new TypedDocumentString(`
    query Shaam6111ReportScreen($year: Int!, $businessId: UUID) {
  shaam6111(year: $year, businessId: $businessId) {
    id
    year
    data {
      id
      ...Shaam6111DataContent
    }
    business {
      id
      ...Shaam6111DataContentHeaderBusiness
    }
  }
}
    fragment Shaam6111DataContentBalanceSheet on Shaam6111Data {
  id
  balanceSheet {
    code
    amount
    label
  }
}
fragment Shaam6111DataContentHeader on Shaam6111Data {
  id
  header {
    taxYear
    businessDescription
    taxFileNumber
    idNumber
    vatFileNumber
    withholdingTaxFileNumber
    businessType
    reportingMethod
    currencyType
    amountsInThousands
    accountingMethod
    accountingSystem
    softwareRegistrationNumber
    isPartnership
    partnershipCount
    partnershipProfitShare
    ifrsImplementationYear
    ifrsReportingOption
    includesProfitLoss
    includesTaxAdjustment
    includesBalanceSheet
    industryCode
    auditOpinionType
  }
}
fragment Shaam6111DataContentHeaderBusiness on Business {
  id
  name
}
fragment Shaam6111DataContentProfitLoss on Shaam6111Data {
  id
  profitAndLoss {
    code
    amount
    label
  }
}
fragment Shaam6111DataContent on Shaam6111Data {
  id
  ...Shaam6111DataContentHeader
  ...Shaam6111DataContentProfitLoss
  ...Shaam6111DataContentTaxAdjustment
  ...Shaam6111DataContentBalanceSheet
}
fragment Shaam6111DataContentTaxAdjustment on Shaam6111Data {
  id
  taxAdjustment {
    code
    amount
    label
  }
}`) as unknown as TypedDocumentString<Shaam6111ReportScreenQuery, Shaam6111ReportScreenQueryVariables>;
export const AllSortCodesForScreenDocument = new TypedDocumentString(`
    query AllSortCodesForScreen {
  allSortCodes {
    id
    ownerId
    key
    name
    defaultIrsCode
  }
}
    `) as unknown as TypedDocumentString<AllSortCodesForScreenQuery, AllSortCodesForScreenQueryVariables>;
export const AllTagsScreenDocument = new TypedDocumentString(`
    query AllTagsScreen {
  allTags {
    id
    name
    namePath
    parent {
      id
    }
    ...EditTagFields
  }
}
    fragment EditTagFields on Tag {
  id
  name
  parent {
    id
    name
  }
}`) as unknown as TypedDocumentString<AllTagsScreenQuery, AllTagsScreenQueryVariables>;
export const AllTaxCategoriesForScreenDocument = new TypedDocumentString(`
    query AllTaxCategoriesForScreen {
  taxCategories {
    id
    name
    sortCode {
      id
      key
      name
    }
  }
}
    `) as unknown as TypedDocumentString<AllTaxCategoriesForScreenQuery, AllTaxCategoriesForScreenQueryVariables>;
export const AcceptInvitationDocument = new TypedDocumentString(`
    mutation AcceptInvitation($token: String!) {
  acceptInvitation(token: $token) {
    success
    businessId
    roleId
  }
}
    `) as unknown as TypedDocumentString<AcceptInvitationMutation, AcceptInvitationMutationVariables>;
export const AddBusinessTripAccommodationsExpenseDocument = new TypedDocumentString(`
    mutation AddBusinessTripAccommodationsExpense($fields: AddBusinessTripAccommodationsExpenseInput!) {
  addBusinessTripAccommodationsExpense(fields: $fields)
}
    `) as unknown as TypedDocumentString<AddBusinessTripAccommodationsExpenseMutation, AddBusinessTripAccommodationsExpenseMutationVariables>;
export const AddBusinessTripCarRentalExpenseDocument = new TypedDocumentString(`
    mutation AddBusinessTripCarRentalExpense($fields: AddBusinessTripCarRentalExpenseInput!) {
  addBusinessTripCarRentalExpense(fields: $fields)
}
    `) as unknown as TypedDocumentString<AddBusinessTripCarRentalExpenseMutation, AddBusinessTripCarRentalExpenseMutationVariables>;
export const AddBusinessTripFlightsExpenseDocument = new TypedDocumentString(`
    mutation AddBusinessTripFlightsExpense($fields: AddBusinessTripFlightsExpenseInput!) {
  addBusinessTripFlightsExpense(fields: $fields)
}
    `) as unknown as TypedDocumentString<AddBusinessTripFlightsExpenseMutation, AddBusinessTripFlightsExpenseMutationVariables>;
export const AddBusinessTripOtherExpenseDocument = new TypedDocumentString(`
    mutation AddBusinessTripOtherExpense($fields: AddBusinessTripOtherExpenseInput!) {
  addBusinessTripOtherExpense(fields: $fields)
}
    `) as unknown as TypedDocumentString<AddBusinessTripOtherExpenseMutation, AddBusinessTripOtherExpenseMutationVariables>;
export const AddBusinessTripTravelAndSubsistenceExpenseDocument = new TypedDocumentString(`
    mutation AddBusinessTripTravelAndSubsistenceExpense($fields: AddBusinessTripTravelAndSubsistenceExpenseInput!) {
  addBusinessTripTravelAndSubsistenceExpense(fields: $fields)
}
    `) as unknown as TypedDocumentString<AddBusinessTripTravelAndSubsistenceExpenseMutation, AddBusinessTripTravelAndSubsistenceExpenseMutationVariables>;
export const AddDepreciationRecordDocument = new TypedDocumentString(`
    mutation AddDepreciationRecord($fields: InsertDepreciationRecordInput!) {
  insertDepreciationRecord(input: $fields) {
    __typename
    ... on CommonError {
      message
    }
    ... on DepreciationRecord {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<AddDepreciationRecordMutation, AddDepreciationRecordMutationVariables>;
export const AddSortCodeDocument = new TypedDocumentString(`
    mutation AddSortCode($key: Int!, $name: String!, $defaultIrsCode: Int) {
  addSortCode(key: $key, name: $name, defaultIrsCode: $defaultIrsCode)
}
    `) as unknown as TypedDocumentString<AddSortCodeMutation, AddSortCodeMutationVariables>;
export const AddTagDocument = new TypedDocumentString(`
    mutation AddTag($tagName: String!, $parentTag: UUID) {
  addTag(name: $tagName, parentId: $parentTag)
}
    `) as unknown as TypedDocumentString<AddTagMutation, AddTagMutationVariables>;
export const AnnualAuditStepStatusDocument = new TypedDocumentString(`
    query AnnualAuditStepStatus($ownerId: UUID!, $year: Int!) {
  annualAuditStepStatuses(ownerId: $ownerId, year: $year) {
    id
    stepId
    status
  }
}
    `) as unknown as TypedDocumentString<AnnualAuditStepStatusQuery, AnnualAuditStepStatusQueryVariables>;
export const AssignChargeToDepositDocument = new TypedDocumentString(`
    mutation AssignChargeToDeposit($chargeId: UUID!, $depositId: String!) {
  assignChargeToDeposit(chargeId: $chargeId, depositId: $depositId) {
    id
  }
}
    `) as unknown as TypedDocumentString<AssignChargeToDepositMutation, AssignChargeToDepositMutationVariables>;
export const GenerateBalanceChargeDocument = new TypedDocumentString(`
    mutation GenerateBalanceCharge($description: String!, $balanceRecords: [InsertMiscExpenseInput!]!) {
  generateBalanceCharge(
    description: $description
    balanceRecords: $balanceRecords
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<GenerateBalanceChargeMutation, GenerateBalanceChargeMutationVariables>;
export const BatchUpdateBusinessesDocument = new TypedDocumentString(`
    mutation BatchUpdateBusinesses($businessIds: [UUID!]!, $fields: BatchUpdateBusinessInput!) {
  batchUpdateBusinesses(businessIds: $businessIds, fields: $fields) {
    id
  }
}
    `) as unknown as TypedDocumentString<BatchUpdateBusinessesMutation, BatchUpdateBusinessesMutationVariables>;
export const BatchUpdateChargesDocument = new TypedDocumentString(`
    mutation BatchUpdateCharges($chargeIds: [UUID!]!, $fields: UpdateChargeInput!) {
  batchUpdateCharges(chargeIds: $chargeIds, fields: $fields) {
    __typename
    ... on BatchUpdateChargesSuccessfulResult {
      charges {
        id
      }
    }
    ... on CommonError {
      message
    }
  }
}
    `) as unknown as TypedDocumentString<BatchUpdateChargesMutation, BatchUpdateChargesMutationVariables>;
export const CategorizeBusinessTripExpenseDocument = new TypedDocumentString(`
    mutation CategorizeBusinessTripExpense($fields: CategorizeBusinessTripExpenseInput!) {
  categorizeBusinessTripExpense(fields: $fields)
}
    `) as unknown as TypedDocumentString<CategorizeBusinessTripExpenseMutation, CategorizeBusinessTripExpenseMutationVariables>;
export const CategorizeIntoExistingBusinessTripExpenseDocument = new TypedDocumentString(`
    mutation CategorizeIntoExistingBusinessTripExpense($fields: CategorizeIntoExistingBusinessTripExpenseInput!) {
  categorizeIntoExistingBusinessTripExpense(fields: $fields)
}
    `) as unknown as TypedDocumentString<CategorizeIntoExistingBusinessTripExpenseMutation, CategorizeIntoExistingBusinessTripExpenseMutationVariables>;
export const CloseDocumentDocument = new TypedDocumentString(`
    mutation CloseDocument($documentId: UUID!) {
  closeDocument(id: $documentId)
}
    `) as unknown as TypedDocumentString<CloseDocumentMutation, CloseDocumentMutationVariables>;
export const CreateContractDocument = new TypedDocumentString(`
    mutation CreateContract($input: CreateContractInput!) {
  createContract(input: $input) {
    id
  }
}
    `) as unknown as TypedDocumentString<CreateContractMutation, CreateContractMutationVariables>;
export const CreateDepositFromChargeDocument = new TypedDocumentString(`
    mutation CreateDepositFromCharge($chargeId: UUID!, $name: String!) {
  createDepositFromCharge(chargeId: $chargeId, name: $name) {
    id
    name
    currency
    isOpen
  }
}
    `) as unknown as TypedDocumentString<CreateDepositFromChargeMutation, CreateDepositFromChargeMutationVariables>;
export const CreateDepositDocument = new TypedDocumentString(`
    mutation CreateDeposit($name: String!, $currency: Currency!, $openDate: TimelessDate!, $accountId: UUID) {
  createDeposit(
    name: $name
    currency: $currency
    openDate: $openDate
    accountId: $accountId
  ) {
    id
    currency
    isOpen
  }
}
    `) as unknown as TypedDocumentString<CreateDepositMutation, CreateDepositMutationVariables>;
export const CreateFinancialAccountDocument = new TypedDocumentString(`
    mutation CreateFinancialAccount($input: CreateFinancialAccountInput!) {
  createFinancialAccount(input: $input) {
    id
  }
}
    `) as unknown as TypedDocumentString<CreateFinancialAccountMutation, CreateFinancialAccountMutationVariables>;
export const CreateInvitationDocument = new TypedDocumentString(`
    mutation CreateInvitation($email: String!, $roleId: String!) {
  createInvitation(email: $email, roleId: $roleId) {
    id
    email
    roleId
    expiresAt
  }
}
    `) as unknown as TypedDocumentString<CreateInvitationMutation, CreateInvitationMutationVariables>;
export const CreditShareholdersBusinessTripTravelAndSubsistenceDocument = new TypedDocumentString(`
    mutation CreditShareholdersBusinessTripTravelAndSubsistence($businessTripId: UUID!) {
  creditShareholdersBusinessTripTravelAndSubsistence(
    businessTripId: $businessTripId
  )
}
    `) as unknown as TypedDocumentString<CreditShareholdersBusinessTripTravelAndSubsistenceMutation, CreditShareholdersBusinessTripTravelAndSubsistenceMutationVariables>;
export const FlagForeignFeeTransactionsDocument = new TypedDocumentString(`
    mutation FlagForeignFeeTransactions {
  flagForeignFeeTransactions {
    success
    errors
  }
}
    `) as unknown as TypedDocumentString<FlagForeignFeeTransactionsMutation, FlagForeignFeeTransactionsMutationVariables>;
export const MergeChargesByTransactionReferenceDocument = new TypedDocumentString(`
    mutation MergeChargesByTransactionReference($dryRun: Boolean) {
  mergeChargesByTransactionReference(dryRun: $dryRun) {
    success
    errors
  }
}
    `) as unknown as TypedDocumentString<MergeChargesByTransactionReferenceMutation, MergeChargesByTransactionReferenceMutationVariables>;
export const CalculateCreditcardTransactionsDebitDateDocument = new TypedDocumentString(`
    mutation CalculateCreditcardTransactionsDebitDate {
  calculateCreditcardTransactionsDebitDate
}
    `) as unknown as TypedDocumentString<CalculateCreditcardTransactionsDebitDateMutation, CalculateCreditcardTransactionsDebitDateMutationVariables>;
export const DeleteBusinessTripAttendeeDocument = new TypedDocumentString(`
    mutation DeleteBusinessTripAttendee($fields: DeleteBusinessTripAttendeeInput!) {
  deleteBusinessTripAttendee(fields: $fields)
}
    `) as unknown as TypedDocumentString<DeleteBusinessTripAttendeeMutation, DeleteBusinessTripAttendeeMutationVariables>;
export const DeleteBusinessTripExpenseDocument = new TypedDocumentString(`
    mutation DeleteBusinessTripExpense($businessTripExpenseId: UUID!) {
  deleteBusinessTripExpense(businessTripExpenseId: $businessTripExpenseId)
}
    `) as unknown as TypedDocumentString<DeleteBusinessTripExpenseMutation, DeleteBusinessTripExpenseMutationVariables>;
export const DeleteBusinessDocument = new TypedDocumentString(`
    mutation DeleteBusiness($businessId: UUID!) {
  deleteBusiness(businessId: $businessId)
}
    `) as unknown as TypedDocumentString<DeleteBusinessMutation, DeleteBusinessMutationVariables>;
export const DeleteChargeDocument = new TypedDocumentString(`
    mutation DeleteCharge($chargeId: UUID!) {
  deleteCharge(chargeId: $chargeId)
}
    `) as unknown as TypedDocumentString<DeleteChargeMutation, DeleteChargeMutationVariables>;
export const DeleteContractDocument = new TypedDocumentString(`
    mutation DeleteContract($contractId: UUID!) {
  deleteContract(id: $contractId)
}
    `) as unknown as TypedDocumentString<DeleteContractMutation, DeleteContractMutationVariables>;
export const DeleteDepreciationRecordDocument = new TypedDocumentString(`
    mutation DeleteDepreciationRecord($depreciationRecordId: UUID!) {
  deleteDepreciationRecord(depreciationRecordId: $depreciationRecordId)
}
    `) as unknown as TypedDocumentString<DeleteDepreciationRecordMutation, DeleteDepreciationRecordMutationVariables>;
export const DeleteDocumentDocument = new TypedDocumentString(`
    mutation DeleteDocument($documentId: UUID!) {
  deleteDocument(documentId: $documentId)
}
    `) as unknown as TypedDocumentString<DeleteDocumentMutation, DeleteDocumentMutationVariables>;
export const DeleteDynamicReportTemplateDocument = new TypedDocumentString(`
    mutation DeleteDynamicReportTemplate($name: String!) {
  deleteDynamicReportTemplate(name: $name)
}
    `) as unknown as TypedDocumentString<DeleteDynamicReportTemplateMutation, DeleteDynamicReportTemplateMutationVariables>;
export const DeleteMiscExpenseDocument = new TypedDocumentString(`
    mutation DeleteMiscExpense($id: UUID!) {
  deleteMiscExpense(id: $id)
}
    `) as unknown as TypedDocumentString<DeleteMiscExpenseMutation, DeleteMiscExpenseMutationVariables>;
export const DeleteProviderCredentialsDocument = new TypedDocumentString(`
    mutation DeleteProviderCredentials($provider: ProviderKey!) {
  deleteProviderCredentials(provider: $provider) {
    ... on ProviderCredentialDeleteResult {
      id
      provider
      success
    }
    ... on CommonError {
      message
    }
  }
}
    `) as unknown as TypedDocumentString<DeleteProviderCredentialsMutation, DeleteProviderCredentialsMutationVariables>;
export const DeleteTagDocument = new TypedDocumentString(`
    mutation DeleteTag($tagId: UUID!) {
  deleteTag(id: $tagId)
}
    `) as unknown as TypedDocumentString<DeleteTagMutation, DeleteTagMutationVariables>;
export const FetchDeelDocumentsDocument = new TypedDocumentString(`
    mutation FetchDeelDocuments {
  fetchDeelDocuments {
    id
  }
}
    `) as unknown as TypedDocumentString<FetchDeelDocumentsMutation, FetchDeelDocumentsMutationVariables>;
export const GenerateApiKeyDocument = new TypedDocumentString(`
    mutation GenerateApiKey($name: String!, $roleId: String!) {
  generateApiKey(name: $name, roleId: $roleId) {
    apiKey
    record {
      id
      name
      roleId
      lastUsedAt
      createdAt
    }
  }
}
    `) as unknown as TypedDocumentString<GenerateApiKeyMutation, GenerateApiKeyMutationVariables>;
export const GenerateRevaluationChargeDocument = new TypedDocumentString(`
    mutation GenerateRevaluationCharge($ownerId: UUID!, $date: TimelessDate!) {
  generateRevaluationCharge(ownerId: $ownerId, date: $date) {
    id
  }
}
    `) as unknown as TypedDocumentString<GenerateRevaluationChargeMutation, GenerateRevaluationChargeMutationVariables>;
export const GenerateBankDepositsRevaluationChargeDocument = new TypedDocumentString(`
    mutation GenerateBankDepositsRevaluationCharge($ownerId: UUID!, $date: TimelessDate!) {
  generateBankDepositsRevaluationCharge(ownerId: $ownerId, date: $date) {
    id
  }
}
    `) as unknown as TypedDocumentString<GenerateBankDepositsRevaluationChargeMutation, GenerateBankDepositsRevaluationChargeMutationVariables>;
export const GenerateTaxExpensesChargeDocument = new TypedDocumentString(`
    mutation GenerateTaxExpensesCharge($ownerId: UUID!, $date: TimelessDate!) {
  generateTaxExpensesCharge(ownerId: $ownerId, year: $date) {
    id
  }
}
    `) as unknown as TypedDocumentString<GenerateTaxExpensesChargeMutation, GenerateTaxExpensesChargeMutationVariables>;
export const GenerateDepreciationChargeDocument = new TypedDocumentString(`
    mutation GenerateDepreciationCharge($ownerId: UUID!, $date: TimelessDate!) {
  generateDepreciationCharge(ownerId: $ownerId, year: $date) {
    id
  }
}
    `) as unknown as TypedDocumentString<GenerateDepreciationChargeMutation, GenerateDepreciationChargeMutationVariables>;
export const GenerateRecoveryReserveChargeDocument = new TypedDocumentString(`
    mutation GenerateRecoveryReserveCharge($ownerId: UUID!, $date: TimelessDate!) {
  generateRecoveryReserveCharge(ownerId: $ownerId, year: $date) {
    id
  }
}
    `) as unknown as TypedDocumentString<GenerateRecoveryReserveChargeMutation, GenerateRecoveryReserveChargeMutationVariables>;
export const GenerateVacationReserveChargeDocument = new TypedDocumentString(`
    mutation GenerateVacationReserveCharge($ownerId: UUID!, $date: TimelessDate!) {
  generateVacationReserveCharge(ownerId: $ownerId, year: $date) {
    id
  }
}
    `) as unknown as TypedDocumentString<GenerateVacationReserveChargeMutation, GenerateVacationReserveChargeMutationVariables>;
export const AllAdminBusinessesDocument = new TypedDocumentString(`
    query AllAdminBusinesses {
  allAdminBusinesses {
    id
    name
    governmentId
  }
}
    `) as unknown as TypedDocumentString<AllAdminBusinessesQuery, AllAdminBusinessesQueryVariables>;
export const AllClientsDocument = new TypedDocumentString(`
    query AllClients {
  allClients {
    id
    originalBusiness {
      id
      name
    }
  }
}
    `) as unknown as TypedDocumentString<AllClientsQuery, AllClientsQueryVariables>;
export const AllBusinessesDocument = new TypedDocumentString(`
    query AllBusinesses {
  allBusinesses {
    nodes {
      id
      name
    }
  }
}
    `) as unknown as TypedDocumentString<AllBusinessesQuery, AllBusinessesQueryVariables>;
export const AllCountriesDocument = new TypedDocumentString(`
    query AllCountries {
  allCountries {
    id
    name
    code
  }
}
    `) as unknown as TypedDocumentString<AllCountriesQuery, AllCountriesQueryVariables>;
export const AllFinancialAccountsDocument = new TypedDocumentString(`
    query AllFinancialAccounts {
  allFinancialAccounts {
    id
    name
  }
}
    `) as unknown as TypedDocumentString<AllFinancialAccountsQuery, AllFinancialAccountsQueryVariables>;
export const AllFinancialEntitiesDocument = new TypedDocumentString(`
    query AllFinancialEntities {
  allFinancialEntities {
    nodes {
      id
      name
    }
  }
}
    `) as unknown as TypedDocumentString<AllFinancialEntitiesQuery, AllFinancialEntitiesQueryVariables>;
export const AllSortCodesDocument = new TypedDocumentString(`
    query AllSortCodes($ownerId: String!) {
  allSortCodesByBusiness(ownerId: $ownerId) {
    id
    key
    name
    defaultIrsCode
  }
}
    `) as unknown as TypedDocumentString<AllSortCodesQuery, AllSortCodesQueryVariables>;
export const AllTagsDocument = new TypedDocumentString(`
    query AllTags {
  allTags {
    id
    name
    namePath
  }
}
    `) as unknown as TypedDocumentString<AllTagsQuery, AllTagsQueryVariables>;
export const AllTaxCategoriesDocument = new TypedDocumentString(`
    query AllTaxCategories {
  taxCategories {
    id
    name
  }
}
    `) as unknown as TypedDocumentString<AllTaxCategoriesQuery, AllTaxCategoriesQueryVariables>;
export const InsertBusinessTripAttendeeDocument = new TypedDocumentString(`
    mutation InsertBusinessTripAttendee($fields: InsertBusinessTripAttendeeInput!) {
  insertBusinessTripAttendee(fields: $fields)
}
    `) as unknown as TypedDocumentString<InsertBusinessTripAttendeeMutation, InsertBusinessTripAttendeeMutationVariables>;
export const InsertBusinessTripDocument = new TypedDocumentString(`
    mutation InsertBusinessTrip($fields: InsertBusinessTripInput!) {
  insertBusinessTrip(fields: $fields)
}
    `) as unknown as TypedDocumentString<InsertBusinessTripMutation, InsertBusinessTripMutationVariables>;
export const InsertBusinessDocument = new TypedDocumentString(`
    mutation InsertBusiness($fields: InsertNewBusinessInput!) {
  insertNewBusiness(fields: $fields) {
    __typename
    ... on LtdFinancialEntity {
      id
    }
    ... on CommonError {
      message
    }
  }
}
    `) as unknown as TypedDocumentString<InsertBusinessMutation, InsertBusinessMutationVariables>;
export const InsertClientDocument = new TypedDocumentString(`
    mutation InsertClient($fields: ClientInsertInput!) {
  insertClient(fields: $fields) {
    __typename
    ... on Client {
      id
    }
    ... on CommonError {
      message
    }
  }
}
    `) as unknown as TypedDocumentString<InsertClientMutation, InsertClientMutationVariables>;
export const InsertDocumentDocument = new TypedDocumentString(`
    mutation InsertDocument($record: InsertDocumentInput!) {
  insertDocument(record: $record) {
    __typename
    ... on InsertDocumentSuccessfulResult {
      document {
        id
      }
    }
    ... on CommonError {
      message
    }
  }
}
    `) as unknown as TypedDocumentString<InsertDocumentMutation, InsertDocumentMutationVariables>;
export const InsertDynamicReportTemplateDocument = new TypedDocumentString(`
    mutation InsertDynamicReportTemplate($name: String!, $template: String!) {
  insertDynamicReportTemplate(name: $name, template: $template) {
    id
    name
  }
}
    `) as unknown as TypedDocumentString<InsertDynamicReportTemplateMutation, InsertDynamicReportTemplateMutationVariables>;
export const InsertMiscExpenseDocument = new TypedDocumentString(`
    mutation InsertMiscExpense($chargeId: UUID!, $fields: InsertMiscExpenseInput!) {
  insertMiscExpense(chargeId: $chargeId, fields: $fields) {
    id
  }
}
    `) as unknown as TypedDocumentString<InsertMiscExpenseMutation, InsertMiscExpenseMutationVariables>;
export const InsertMiscExpensesDocument = new TypedDocumentString(`
    mutation InsertMiscExpenses($chargeId: UUID!, $expenses: [InsertMiscExpenseInput!]!) {
  insertMiscExpenses(chargeId: $chargeId, expenses: $expenses) {
    id
  }
}
    `) as unknown as TypedDocumentString<InsertMiscExpensesMutation, InsertMiscExpensesMutationVariables>;
export const InsertSalaryRecordDocument = new TypedDocumentString(`
    mutation InsertSalaryRecord($salaryRecords: [SalaryRecordInput!]!) {
  insertSalaryRecords(salaryRecords: $salaryRecords) {
    __typename
    ... on InsertSalaryRecordsSuccessfulResult {
      salaryRecords {
        month
        employee {
          id
        }
      }
    }
    ... on CommonError {
      message
    }
  }
}
    `) as unknown as TypedDocumentString<InsertSalaryRecordMutation, InsertSalaryRecordMutationVariables>;
export const InsertTaxCategoryDocument = new TypedDocumentString(`
    mutation InsertTaxCategory($fields: InsertTaxCategoryInput!) {
  insertTaxCategory(fields: $fields) {
    id
    name
  }
}
    `) as unknown as TypedDocumentString<InsertTaxCategoryMutation, InsertTaxCategoryMutationVariables>;
export const IssueGreenInvoiceDocumentDocument = new TypedDocumentString(`
    mutation IssueGreenInvoiceDocument($input: DocumentIssueInput!, $emailContent: String, $attachment: Boolean, $chargeId: UUID) {
  issueGreenInvoiceDocument(
    input: $input
    emailContent: $emailContent
    attachment: $attachment
    chargeId: $chargeId
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<IssueGreenInvoiceDocumentMutation, IssueGreenInvoiceDocumentMutationVariables>;
export const IssueMonthlyDocumentsDocument = new TypedDocumentString(`
    mutation IssueMonthlyDocuments($generateDocumentsInfo: [DocumentIssueInput!]!) {
  issueGreenInvoiceDocuments(generateDocumentsInfo: $generateDocumentsInfo) {
    success
    errors
  }
}
    `) as unknown as TypedDocumentString<IssueMonthlyDocumentsMutation, IssueMonthlyDocumentsMutationVariables>;
export const LedgerLockDocument = new TypedDocumentString(`
    mutation LedgerLock($date: TimelessDate!) {
  lockLedgerRecords(date: $date)
}
    `) as unknown as TypedDocumentString<LedgerLockMutation, LedgerLockMutationVariables>;
export const LockDynamicReportTemplateDocument = new TypedDocumentString(`
    mutation LockDynamicReportTemplate($name: String!) {
  lockDynamicReportTemplate(name: $name) {
    id
    name
    isLocked
    updated
  }
}
    `) as unknown as TypedDocumentString<LockDynamicReportTemplateMutation, LockDynamicReportTemplateMutationVariables>;
export const MergeBusinessesDocument = new TypedDocumentString(`
    mutation MergeBusinesses($targetBusinessId: UUID!, $businessIdsToMerge: [UUID!]!) {
  mergeBusinesses(
    targetBusinessId: $targetBusinessId
    businessIdsToMerge: $businessIdsToMerge
  ) {
    __typename
    id
  }
}
    `) as unknown as TypedDocumentString<MergeBusinessesMutation, MergeBusinessesMutationVariables>;
export const MergeChargesDocument = new TypedDocumentString(`
    mutation MergeCharges($baseChargeID: UUID!, $chargeIdsToMerge: [UUID!]!, $fields: UpdateChargeInput) {
  mergeCharges(
    baseChargeID: $baseChargeID
    chargeIdsToMerge: $chargeIdsToMerge
    fields: $fields
  ) {
    __typename
    ... on MergeChargeSuccessfulResult {
      charge {
        id
      }
    }
    ... on CommonError {
      message
    }
  }
}
    `) as unknown as TypedDocumentString<MergeChargesMutation, MergeChargesMutationVariables>;
export const PreviewDocumentDocument = new TypedDocumentString(`
    mutation PreviewDocument($input: DocumentIssueInput!) {
  previewDocument(input: $input)
}
    `) as unknown as TypedDocumentString<PreviewDocumentMutation, PreviewDocumentMutationVariables>;
export const ProviderCredentialsDocument = new TypedDocumentString(`
    query ProviderCredentials {
  providerCredentials {
    id
    provider
    configuredAt
  }
}
    `) as unknown as TypedDocumentString<ProviderCredentialsQuery, ProviderCredentialsQueryVariables>;
export const RegenerateLedgerDocument = new TypedDocumentString(`
    mutation RegenerateLedger($chargeId: UUID!) {
  regenerateLedgerRecords(chargeId: $chargeId) {
    __typename
    ... on Ledger {
      records {
        id
      }
    }
    ... on CommonError {
      message
    }
  }
}
    `) as unknown as TypedDocumentString<RegenerateLedgerMutation, RegenerateLedgerMutationVariables>;
export const RelevantDepositsForChargeDocument = new TypedDocumentString(`
    query RelevantDepositsForCharge($chargeId: UUID!) {
  relevantDepositsForCharge(chargeId: $chargeId) {
    id
    deposits {
      id
      name
      currency
      isOpen
    }
    error
  }
}
    `) as unknown as TypedDocumentString<RelevantDepositsForChargeQuery, RelevantDepositsForChargeQueryVariables>;
export const RemoveBusinessUserDocument = new TypedDocumentString(`
    mutation RemoveBusinessUser($userId: ID!) {
  removeBusinessUser(userId: $userId)
}
    `) as unknown as TypedDocumentString<RemoveBusinessUserMutation, RemoveBusinessUserMutationVariables>;
export const RevokeApiKeyDocument = new TypedDocumentString(`
    mutation RevokeApiKey($id: ID!) {
  revokeApiKey(id: $id)
}
    `) as unknown as TypedDocumentString<RevokeApiKeyMutation, RevokeApiKeyMutationVariables>;
export const RevokeInvitationDocument = new TypedDocumentString(`
    mutation RevokeInvitation($id: ID!) {
  revokeInvitation(id: $id)
}
    `) as unknown as TypedDocumentString<RevokeInvitationMutation, RevokeInvitationMutationVariables>;
export const SetAnnualAuditStepStatusDocument = new TypedDocumentString(`
    mutation SetAnnualAuditStepStatus($input: SetAnnualAuditStepStatusInput!) {
  setAnnualAuditStepStatus(input: $input) {
    id
    ownerId
    year
    stepId
    status
    notes
    evidence
    updatedAt
    completedAt
  }
}
    `) as unknown as TypedDocumentString<SetAnnualAuditStepStatusMutation, SetAnnualAuditStepStatusMutationVariables>;
export const SetAnnualAuditStep03StatusDocument = new TypedDocumentString(`
    mutation SetAnnualAuditStep03Status($input: SetAnnualAuditStep03StatusInput!) {
  setAnnualAuditStep03Status(input: $input) {
    id
    ownerId
    year
    stepId
    status
    notes
    updatedAt
    completedAt
  }
}
    `) as unknown as TypedDocumentString<SetAnnualAuditStep03StatusMutation, SetAnnualAuditStep03StatusMutationVariables>;
export const SetAnnualAuditStep09StatusDocument = new TypedDocumentString(`
    mutation SetAnnualAuditStep09Status($input: SetAnnualAuditStep09StatusInput!) {
  setAnnualAuditStep09Status(input: $input) {
    id
    ownerId
    year
    stepId
    status
    notes
    evidence
    updatedAt
    completedAt
  }
}
    `) as unknown as TypedDocumentString<SetAnnualAuditStep09StatusMutation, SetAnnualAuditStep09StatusMutationVariables>;
export const SetDeelCredentialsDocument = new TypedDocumentString(`
    mutation SetDeelCredentials($apiToken: String!) {
  setDeelCredentials(apiToken: $apiToken) {
    ... on ProviderCredentialResult {
      id
      provider
      configuredAt
    }
    ... on CommonError {
      message
    }
  }
}
    `) as unknown as TypedDocumentString<SetDeelCredentialsMutation, SetDeelCredentialsMutationVariables>;
export const SetGreenInvoiceCredentialsDocument = new TypedDocumentString(`
    mutation SetGreenInvoiceCredentials($id: String!, $secret: String!) {
  setGreenInvoiceCredentials(id: $id, secret: $secret) {
    ... on ProviderCredentialResult {
      id
      provider
      configuredAt
    }
    ... on CommonError {
      message
    }
  }
}
    `) as unknown as TypedDocumentString<SetGreenInvoiceCredentialsMutation, SetGreenInvoiceCredentialsMutationVariables>;
export const SyncGreenInvoiceDocumentsDocument = new TypedDocumentString(`
    mutation SyncGreenInvoiceDocuments($ownerId: UUID!) {
  syncGreenInvoiceDocuments(ownerId: $ownerId) {
    id
    ...NewFetchedDocumentFields
  }
}
    fragment NewFetchedDocumentFields on Document {
  id
  documentType
  charge {
    id
    userDescription
    counterparty {
      id
      name
    }
  }
}`) as unknown as TypedDocumentString<SyncGreenInvoiceDocumentsMutation, SyncGreenInvoiceDocumentsMutationVariables>;
export const UnlockDynamicReportTemplateDocument = new TypedDocumentString(`
    mutation UnlockDynamicReportTemplate($name: String!) {
  unlockDynamicReportTemplate(name: $name) {
    id
    name
    isLocked
    updated
  }
}
    `) as unknown as TypedDocumentString<UnlockDynamicReportTemplateMutation, UnlockDynamicReportTemplateMutationVariables>;
export const UpdateAdminBusinessDocument = new TypedDocumentString(`
    mutation UpdateAdminBusiness($adminBusinessId: UUID!, $fields: UpdateAdminBusinessInput!) {
  updateAdminBusiness(businessId: $adminBusinessId, fields: $fields) {
    id
  }
}
    `) as unknown as TypedDocumentString<UpdateAdminBusinessMutation, UpdateAdminBusinessMutationVariables>;
export const UpdateBusinessTripAccommodationsExpenseDocument = new TypedDocumentString(`
    mutation UpdateBusinessTripAccommodationsExpense($fields: UpdateBusinessTripAccommodationsExpenseInput!) {
  updateBusinessTripAccommodationsExpense(fields: $fields)
}
    `) as unknown as TypedDocumentString<UpdateBusinessTripAccommodationsExpenseMutation, UpdateBusinessTripAccommodationsExpenseMutationVariables>;
export const UpdateBusinessTripAccountantApprovalDocument = new TypedDocumentString(`
    mutation UpdateBusinessTripAccountantApproval($businessTripId: UUID!, $status: AccountantStatus!) {
  updateBusinessTripAccountantApproval(
    businessTripId: $businessTripId
    approvalStatus: $status
  )
}
    `) as unknown as TypedDocumentString<UpdateBusinessTripAccountantApprovalMutation, UpdateBusinessTripAccountantApprovalMutationVariables>;
export const UpdateBusinessTripAttendeeDocument = new TypedDocumentString(`
    mutation UpdateBusinessTripAttendee($fields: BusinessTripAttendeeUpdateInput!) {
  updateBusinessTripAttendee(fields: $fields)
}
    `) as unknown as TypedDocumentString<UpdateBusinessTripAttendeeMutation, UpdateBusinessTripAttendeeMutationVariables>;
export const UpdateBusinessTripCarRentalExpenseDocument = new TypedDocumentString(`
    mutation UpdateBusinessTripCarRentalExpense($fields: UpdateBusinessTripCarRentalExpenseInput!) {
  updateBusinessTripCarRentalExpense(fields: $fields)
}
    `) as unknown as TypedDocumentString<UpdateBusinessTripCarRentalExpenseMutation, UpdateBusinessTripCarRentalExpenseMutationVariables>;
export const UpdateBusinessTripFlightsExpenseDocument = new TypedDocumentString(`
    mutation UpdateBusinessTripFlightsExpense($fields: UpdateBusinessTripFlightsExpenseInput!) {
  updateBusinessTripFlightsExpense(fields: $fields)
}
    `) as unknown as TypedDocumentString<UpdateBusinessTripFlightsExpenseMutation, UpdateBusinessTripFlightsExpenseMutationVariables>;
export const UpdateBusinessTripOtherExpenseDocument = new TypedDocumentString(`
    mutation UpdateBusinessTripOtherExpense($fields: UpdateBusinessTripOtherExpenseInput!) {
  updateBusinessTripOtherExpense(fields: $fields)
}
    `) as unknown as TypedDocumentString<UpdateBusinessTripOtherExpenseMutation, UpdateBusinessTripOtherExpenseMutationVariables>;
export const UpdateBusinessTripTravelAndSubsistenceExpenseDocument = new TypedDocumentString(`
    mutation UpdateBusinessTripTravelAndSubsistenceExpense($fields: UpdateBusinessTripTravelAndSubsistenceExpenseInput!) {
  updateBusinessTripTravelAndSubsistenceExpense(fields: $fields)
}
    `) as unknown as TypedDocumentString<UpdateBusinessTripTravelAndSubsistenceExpenseMutation, UpdateBusinessTripTravelAndSubsistenceExpenseMutationVariables>;
export const UpdateBusinessDocument = new TypedDocumentString(`
    mutation UpdateBusiness($businessId: UUID!, $ownerId: UUID!, $fields: UpdateBusinessInput!) {
  updateBusiness(businessId: $businessId, ownerId: $ownerId, fields: $fields) {
    __typename
    ... on LtdFinancialEntity {
      id
      name
    }
    ... on CommonError {
      message
    }
  }
}
    `) as unknown as TypedDocumentString<UpdateBusinessMutation, UpdateBusinessMutationVariables>;
export const UpdateChargeAccountantApprovalDocument = new TypedDocumentString(`
    mutation UpdateChargeAccountantApproval($chargeId: UUID!, $status: AccountantStatus!) {
  updateChargeAccountantApproval(chargeId: $chargeId, approvalStatus: $status)
}
    `) as unknown as TypedDocumentString<UpdateChargeAccountantApprovalMutation, UpdateChargeAccountantApprovalMutationVariables>;
export const UpdateChargeDocument = new TypedDocumentString(`
    mutation UpdateCharge($chargeId: UUID!, $fields: UpdateChargeInput!) {
  updateCharge(chargeId: $chargeId, fields: $fields) {
    __typename
    ... on UpdateChargeSuccessfulResult {
      charge {
        id
      }
    }
    ... on CommonError {
      message
    }
  }
}
    `) as unknown as TypedDocumentString<UpdateChargeMutation, UpdateChargeMutationVariables>;
export const UpdateClientDocument = new TypedDocumentString(`
    mutation UpdateClient($businessId: UUID!, $fields: ClientUpdateInput!) {
  updateClient(businessId: $businessId, fields: $fields) {
    __typename
    ... on Client {
      id
    }
    ... on CommonError {
      message
    }
  }
}
    `) as unknown as TypedDocumentString<UpdateClientMutation, UpdateClientMutationVariables>;
export const UpdateContractDocument = new TypedDocumentString(`
    mutation UpdateContract($contractId: UUID!, $input: UpdateContractInput!) {
  updateContract(contractId: $contractId, input: $input) {
    id
  }
}
    `) as unknown as TypedDocumentString<UpdateContractMutation, UpdateContractMutationVariables>;
export const UpdateDepositDocument = new TypedDocumentString(`
    mutation UpdateDeposit($id: UUID!, $name: String, $openDate: TimelessDate, $closeDate: TimelessDate) {
  updateDeposit(id: $id, name: $name, openDate: $openDate, closeDate: $closeDate) {
    id
    name
    openDate
    closeDate
    isOpen
  }
}
    `) as unknown as TypedDocumentString<UpdateDepositMutation, UpdateDepositMutationVariables>;
export const UpdateDepreciationRecordDocument = new TypedDocumentString(`
    mutation UpdateDepreciationRecord($fields: UpdateDepreciationRecordInput!) {
  updateDepreciationRecord(input: $fields) {
    __typename
    ... on CommonError {
      message
    }
    ... on DepreciationRecord {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<UpdateDepreciationRecordMutation, UpdateDepreciationRecordMutationVariables>;
export const UpdateDocumentDocument = new TypedDocumentString(`
    mutation UpdateDocument($documentId: UUID!, $fields: UpdateDocumentFieldsInput!) {
  updateDocument(documentId: $documentId, fields: $fields) {
    __typename
    ... on CommonError {
      message
    }
    ... on UpdateDocumentSuccessfulResult {
      document {
        id
      }
    }
  }
}
    `) as unknown as TypedDocumentString<UpdateDocumentMutation, UpdateDocumentMutationVariables>;
export const UpdateDynamicReportTemplateNameDocument = new TypedDocumentString(`
    mutation UpdateDynamicReportTemplateName($name: String!, $newName: String!) {
  updateDynamicReportTemplateName(name: $name, newName: $newName) {
    id
    name
  }
}
    `) as unknown as TypedDocumentString<UpdateDynamicReportTemplateNameMutation, UpdateDynamicReportTemplateNameMutationVariables>;
export const UpdateDynamicReportTemplateDocument = new TypedDocumentString(`
    mutation UpdateDynamicReportTemplate($name: String!, $template: String!) {
  updateDynamicReportTemplate(name: $name, template: $template) {
    id
    name
  }
}
    `) as unknown as TypedDocumentString<UpdateDynamicReportTemplateMutation, UpdateDynamicReportTemplateMutationVariables>;
export const UpdateFinancialAccountDocument = new TypedDocumentString(`
    mutation UpdateFinancialAccount($financialAccountId: UUID!, $fields: UpdateFinancialAccountInput!) {
  updateFinancialAccount(id: $financialAccountId, fields: $fields) {
    id
  }
}
    `) as unknown as TypedDocumentString<UpdateFinancialAccountMutation, UpdateFinancialAccountMutationVariables>;
export const UpdateMiscExpenseDocument = new TypedDocumentString(`
    mutation UpdateMiscExpense($id: UUID!, $fields: UpdateMiscExpenseInput!) {
  updateMiscExpense(id: $id, fields: $fields) {
    id
  }
}
    `) as unknown as TypedDocumentString<UpdateMiscExpenseMutation, UpdateMiscExpenseMutationVariables>;
export const UpdateOrInsertSalaryRecordsDocument = new TypedDocumentString(`
    mutation UpdateOrInsertSalaryRecords($salaryRecords: [SalaryRecordInput!]!) {
  insertOrUpdateSalaryRecords(salaryRecords: $salaryRecords) {
    __typename
    ... on InsertSalaryRecordsSuccessfulResult {
      salaryRecords {
        month
        employee {
          id
        }
      }
    }
    ... on CommonError {
      message
    }
  }
}
    `) as unknown as TypedDocumentString<UpdateOrInsertSalaryRecordsMutation, UpdateOrInsertSalaryRecordsMutationVariables>;
export const UpdateSalaryRecordDocument = new TypedDocumentString(`
    mutation UpdateSalaryRecord($salaryRecord: SalaryRecordEditInput!) {
  updateSalaryRecord(salaryRecord: $salaryRecord) {
    __typename
    ... on UpdateSalaryRecordSuccessfulResult {
      salaryRecord {
        month
        employee {
          id
        }
      }
    }
    ... on CommonError {
      message
    }
  }
}
    `) as unknown as TypedDocumentString<UpdateSalaryRecordMutation, UpdateSalaryRecordMutationVariables>;
export const UpdateSortCodeDocument = new TypedDocumentString(`
    mutation UpdateSortCode($key: Int!, $fields: UpdateSortCodeFieldsInput!) {
  updateSortCode(key: $key, fields: $fields)
}
    `) as unknown as TypedDocumentString<UpdateSortCodeMutation, UpdateSortCodeMutationVariables>;
export const UpdateTagDocument = new TypedDocumentString(`
    mutation UpdateTag($tagId: UUID!, $fields: UpdateTagFieldsInput!) {
  updateTag(id: $tagId, fields: $fields)
}
    `) as unknown as TypedDocumentString<UpdateTagMutation, UpdateTagMutationVariables>;
export const UpdateTaxCategoryDocument = new TypedDocumentString(`
    mutation UpdateTaxCategory($taxCategoryId: UUID!, $fields: UpdateTaxCategoryInput!) {
  updateTaxCategory(taxCategoryId: $taxCategoryId, fields: $fields) {
    __typename
    ... on TaxCategory {
      id
      name
    }
    ... on CommonError {
      message
    }
  }
}
    `) as unknown as TypedDocumentString<UpdateTaxCategoryMutation, UpdateTaxCategoryMutationVariables>;
export const UpdateTransactionDocument = new TypedDocumentString(`
    mutation UpdateTransaction($transactionId: UUID!, $fields: UpdateTransactionInput!) {
  updateTransaction(transactionId: $transactionId, fields: $fields) {
    __typename
    ... on Transaction {
      id
    }
    ... on CommonError {
      message
    }
  }
}
    `) as unknown as TypedDocumentString<UpdateTransactionMutation, UpdateTransactionMutationVariables>;
export const UpdateTransactionsDocument = new TypedDocumentString(`
    mutation UpdateTransactions($transactionIds: [UUID!]!, $fields: UpdateTransactionInput!) {
  updateTransactions(transactionIds: $transactionIds, fields: $fields) {
    __typename
    ... on UpdatedTransactionsSuccessfulResult {
      transactions {
        ... on Transaction {
          id
        }
      }
    }
    ... on CommonError {
      message
    }
  }
}
    `) as unknown as TypedDocumentString<UpdateTransactionsMutation, UpdateTransactionsMutationVariables>;
export const UploadDocumentDocument = new TypedDocumentString(`
    mutation UploadDocument($file: FileScalar!, $chargeId: UUID) {
  uploadDocument(file: $file, chargeId: $chargeId) {
    __typename
    ... on UploadDocumentSuccessfulResult {
      document {
        id
        charge {
          id
        }
      }
    }
    ... on CommonError {
      message
    }
  }
}
    `) as unknown as TypedDocumentString<UploadDocumentMutation, UploadDocumentMutationVariables>;
export const UploadDocumentsFromGoogleDriveDocument = new TypedDocumentString(`
    mutation UploadDocumentsFromGoogleDrive($sharedFolderUrl: String!, $chargeId: UUID, $isSensitive: Boolean) {
  batchUploadDocumentsFromGoogleDrive(
    sharedFolderUrl: $sharedFolderUrl
    chargeId: $chargeId
    isSensitive: $isSensitive
  ) {
    ... on CommonError {
      message
    }
    ... on UploadDocumentSuccessfulResult {
      document {
        id
        ...NewFetchedDocumentFields
      }
    }
  }
}
    fragment NewFetchedDocumentFields on Document {
  id
  documentType
  charge {
    id
    userDescription
    counterparty {
      id
      name
    }
  }
}`) as unknown as TypedDocumentString<UploadDocumentsFromGoogleDriveMutation, UploadDocumentsFromGoogleDriveMutationVariables>;
export const UploadMultipleDocumentsDocument = new TypedDocumentString(`
    mutation UploadMultipleDocuments($documents: [FileScalar!]!, $chargeId: UUID, $isSensitive: Boolean) {
  batchUploadDocuments(
    documents: $documents
    chargeId: $chargeId
    isSensitive: $isSensitive
  ) {
    ... on CommonError {
      message
    }
    ... on UploadDocumentSuccessfulResult {
      document {
        id
        ...NewFetchedDocumentFields
      }
    }
  }
}
    fragment NewFetchedDocumentFields on Document {
  id
  documentType
  charge {
    id
    userDescription
    counterparty {
      id
      name
    }
  }
}`) as unknown as TypedDocumentString<UploadMultipleDocumentsMutation, UploadMultipleDocumentsMutationVariables>;
export const UploadPayrollFileDocument = new TypedDocumentString(`
    mutation UploadPayrollFile($file: FileScalar!, $chargeId: UUID!) {
  insertSalaryRecordsFromFile(file: $file, chargeId: $chargeId)
}
    `) as unknown as TypedDocumentString<UploadPayrollFileMutation, UploadPayrollFileMutationVariables>;
export const UserContextDocument = new TypedDocumentString(`
    query UserContext {
  userContext {
    memberships {
      businessId
      role
      businessName
    }
    activeReadScope
    defaultLocalCurrency
    defaultCryptoConversionFiatCurrency
    ledgerLock
    financialAccountsBusinessesIds
    locality
  }
}
    `) as unknown as TypedDocumentString<UserContextQuery, UserContextQueryVariables>;
export const RequestIngestControlDocument = new TypedDocumentString(`
    mutation RequestIngestControl($input: IngestControlInput!) {
  requestIngestControl(input: $input) {
    __typename
    ... on IngestControlDecision {
      id
      tenantId
      decisionId
      auditId
      grant {
        id
        jti
        tenantId
        action
        expiresAt
      }
      businessEmailConfig {
        businessId
        internalEmailLinks
        emailBody
        attachments
      }
    }
    ... on CommonError {
      message
    }
  }
}
    `) as unknown as TypedDocumentString<RequestIngestControlMutation, RequestIngestControlMutationVariables>;
export const IngestEmailDocument = new TypedDocumentString(`
    mutation IngestEmail($input: IngestEmailInput!) {
  ingestEmail(input: $input) {
    __typename
    ... on IngestEmailSuccess {
      outcome
      ingestId
      existingIngestId
      auditId
      reasonCode
    }
    ... on CommonError {
      message
    }
  }
}
    `) as unknown as TypedDocumentString<IngestEmailMutation, IngestEmailMutationVariables>;
export const BusinessEmailConfigDocument = new TypedDocumentString(`
    query BusinessEmailConfig($email: String!) {
  businessEmailConfig(email: $email) {
    businessId
    internalEmailLinks
    emailBody
    attachments
  }
}
    `) as unknown as TypedDocumentString<BusinessEmailConfigQuery, BusinessEmailConfigQueryVariables>;
export const InsertEmailDocumentsDocument = new TypedDocumentString(`
    mutation InsertEmailDocuments($documents: [FileScalar!]!, $userDescription: String!, $messageId: String, $businessId: UUID) {
  insertEmailDocuments(
    documents: $documents
    userDescription: $userDescription
    messageId: $messageId
    businessId: $businessId
  )
}
    `) as unknown as TypedDocumentString<InsertEmailDocumentsMutation, InsertEmailDocumentsMutationVariables>;
export const UploadPoalimIlsTransactionsDocument = new TypedDocumentString(`
    mutation UploadPoalimIlsTransactions($transactions: [PoalimIlsTransactionInput!]!) {
  uploadPoalimIlsTransactions(transactions: $transactions) {
    inserted
    skipped
    insertedIds
    insertedTransactions {
      id
      date
      description
      amount
      account
    }
    changedTransactions {
      id
      changedFields {
        field
        oldValue
        newValue
      }
    }
  }
}
    `) as unknown as TypedDocumentString<UploadPoalimIlsTransactionsMutation, UploadPoalimIlsTransactionsMutationVariables>;
export const UploadPoalimForeignTransactionsDocument = new TypedDocumentString(`
    mutation UploadPoalimForeignTransactions($transactions: [PoalimForeignTransactionInput!]!) {
  uploadPoalimForeignTransactions(transactions: $transactions) {
    inserted
    skipped
    insertedIds
    insertedTransactions {
      id
      date
      description
      amount
      account
    }
    changedTransactions {
      id
      changedFields {
        field
        oldValue
        newValue
      }
    }
  }
}
    `) as unknown as TypedDocumentString<UploadPoalimForeignTransactionsMutation, UploadPoalimForeignTransactionsMutationVariables>;
export const UploadPoalimSwiftTransactionsDocument = new TypedDocumentString(`
    mutation UploadPoalimSwiftTransactions($swifts: [PoalimSwiftTransactionInput!]!) {
  uploadPoalimSwiftTransactions(swifts: $swifts) {
    inserted
    skipped
    insertedIds
    insertedTransactions {
      id
      date
      description
      amount
      account
    }
    changedTransactions {
      id
      changedFields {
        field
        oldValue
        newValue
      }
    }
  }
}
    `) as unknown as TypedDocumentString<UploadPoalimSwiftTransactionsMutation, UploadPoalimSwiftTransactionsMutationVariables>;
export const UploadIsracardTransactionsDocument = new TypedDocumentString(`
    mutation UploadIsracardTransactions($transactions: [IsracardTransactionInput!]!) {
  uploadIsracardTransactions(transactions: $transactions) {
    inserted
    skipped
    insertedIds
    insertedTransactions {
      id
      date
      description
      amount
      account
    }
    changedTransactions {
      id
      changedFields {
        field
        oldValue
        newValue
      }
    }
  }
}
    `) as unknown as TypedDocumentString<UploadIsracardTransactionsMutation, UploadIsracardTransactionsMutationVariables>;
export const UploadAmexTransactionsDocument = new TypedDocumentString(`
    mutation UploadAmexTransactions($transactions: [AmexTransactionInput!]!) {
  uploadAmexTransactions(transactions: $transactions) {
    inserted
    skipped
    insertedIds
    insertedTransactions {
      id
      date
      description
      amount
      account
    }
    changedTransactions {
      id
      changedFields {
        field
        oldValue
        newValue
      }
    }
  }
}
    `) as unknown as TypedDocumentString<UploadAmexTransactionsMutation, UploadAmexTransactionsMutationVariables>;
export const UploadCalTransactionsDocument = new TypedDocumentString(`
    mutation UploadCalTransactions($transactions: [CalTransactionInput!]!) {
  uploadCalTransactions(transactions: $transactions) {
    inserted
    skipped
    insertedIds
    insertedTransactions {
      id
      date
      description
      amount
      account
    }
    changedTransactions {
      id
      changedFields {
        field
        oldValue
        newValue
      }
    }
  }
}
    `) as unknown as TypedDocumentString<UploadCalTransactionsMutation, UploadCalTransactionsMutationVariables>;
export const UploadDiscountTransactionsDocument = new TypedDocumentString(`
    mutation UploadDiscountTransactions($transactions: [DiscountTransactionInput!]!) {
  uploadDiscountTransactions(transactions: $transactions) {
    inserted
    skipped
    insertedIds
    insertedTransactions {
      id
      date
      description
      amount
      account
    }
    changedTransactions {
      id
      changedFields {
        field
        oldValue
        newValue
      }
    }
  }
}
    `) as unknown as TypedDocumentString<UploadDiscountTransactionsMutation, UploadDiscountTransactionsMutationVariables>;
export const UploadMaxTransactionsDocument = new TypedDocumentString(`
    mutation UploadMaxTransactions($transactions: [MaxTransactionInput!]!) {
  uploadMaxTransactions(transactions: $transactions) {
    inserted
    skipped
    insertedIds
    insertedTransactions {
      id
      date
      description
      amount
      account
    }
    changedTransactions {
      id
      changedFields {
        field
        oldValue
        newValue
      }
    }
  }
}
    `) as unknown as TypedDocumentString<UploadMaxTransactionsMutation, UploadMaxTransactionsMutationVariables>;
export const UploadCurrencyRatesDocument = new TypedDocumentString(`
    mutation UploadCurrencyRates($rates: [CurrencyRateInput!]!) {
  uploadCurrencyRates(rates: $rates) {
    inserted
    skipped
    insertedIds
    insertedTransactions {
      id
      date
      description
      amount
      account
    }
    changedTransactions {
      id
      changedFields {
        field
        oldValue
        newValue
      }
    }
  }
}
    `) as unknown as TypedDocumentString<UploadCurrencyRatesMutation, UploadCurrencyRatesMutationVariables>;
export const UploadOtsarHahayalIlsTransactionsDocument = new TypedDocumentString(`
    mutation UploadOtsarHahayalIlsTransactions($transactions: [OtsarHahayalIlsTransactionInput!]!) {
  uploadOtsarHahayalIlsTransactions(transactions: $transactions) {
    inserted
    skipped
    insertedIds
    insertedTransactions {
      id
      date
      description
      amount
      account
    }
    changedTransactions {
      id
      changedFields {
        field
        oldValue
        newValue
      }
    }
  }
}
    `) as unknown as TypedDocumentString<UploadOtsarHahayalIlsTransactionsMutation, UploadOtsarHahayalIlsTransactionsMutationVariables>;
export const UploadOtsarHahayalForeignTransactionsDocument = new TypedDocumentString(`
    mutation UploadOtsarHahayalForeignTransactions($transactions: [OtsarHahayalForeignTransactionInput!]!) {
  uploadOtsarHahayalForeignTransactions(transactions: $transactions) {
    inserted
    skipped
    insertedIds
    insertedTransactions {
      id
      date
      description
      amount
      account
    }
    changedTransactions {
      id
      changedFields {
        field
        oldValue
        newValue
      }
    }
  }
}
    `) as unknown as TypedDocumentString<UploadOtsarHahayalForeignTransactionsMutation, UploadOtsarHahayalForeignTransactionsMutationVariables>;
export const UploadOtsarHahayalCreditCardTransactionsDocument = new TypedDocumentString(`
    mutation UploadOtsarHahayalCreditCardTransactions($transactions: [OtsarHahayalCreditCardTransactionInput!]!) {
  uploadOtsarHahayalCreditCardTransactions(transactions: $transactions) {
    inserted
    skipped
    insertedIds
    insertedTransactions {
      id
      date
      description
      amount
      account
    }
    changedTransactions {
      id
      changedFields {
        field
        oldValue
        newValue
      }
    }
  }
}
    `) as unknown as TypedDocumentString<UploadOtsarHahayalCreditCardTransactionsMutation, UploadOtsarHahayalCreditCardTransactionsMutationVariables>;